import * as e from "react";
import t, { Children as n, createContext as r, forwardRef as i, memo as a, useCallback as o, useContext as s, useEffect as c, useId as l, useMemo as u, useRef as d, useState as f, useSyncExternalStore as p, version as m } from "react";
import { Badge as h, Button as g, ChatFilter as _, CheckboxMenuItem as v, ContextMenu as y, Field as b, H1 as x, IconButton as S, InlineSpinner as C, Link as w, Menu as T, MenuItem as E, MenuTitle as ee, RadioMenuItem as te, Root as ne, Separator as D, Submit as re, Text as O, TextControl as ie, ToggleMenuItem as ae, Tooltip as k, Unread as oe, UnreadCounter as se } from "@vector-im/compound-web";
import { Virtuoso as ce, VirtuosoMockContext as le } from "react-virtuoso";
import { Group as ue, Group as de, Panel as fe, Panel as pe, Separator as me, Separator as he, usePanelCallbackRef as ge } from "react-resizable-panels";
//#region \0rolldown/runtime.js
var _e = Object.create, ve = Object.defineProperty, ye = Object.getOwnPropertyDescriptor, be = Object.getOwnPropertyNames, xe = Object.getPrototypeOf, Se = Object.prototype.hasOwnProperty, A = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Ce = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = be(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Se.call(e, s) && s !== n && ve(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ye(t, s)) || r.enumerable
	});
	return e;
}, we = (e, t, n) => (n = e == null ? {} : _e(xe(e)), Ce(t || !e || !e.__esModule ? ve(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/internal.js
function Te(e, t, n, r, i) {
	return Ee(t, ((e, t) => {
		let n = e[t];
		if (n === void 0) throw TypeError(is(t));
		return n;
	})(e, t), n, r, i);
}
function Ee(e, t, n, r, i, a) {
	let o = Ge(t, n, r);
	if (i && t !== o) throw RangeError(ns(e, t, n, r, a));
	return o;
}
function De(e) {
	return e !== null && /object|function/.test(typeof e);
}
function Oe(e, t = Map) {
	let n = new t();
	return (t, ...r) => {
		if (n.has(t)) return n.get(t);
		let i = e(t, ...r);
		return n.set(t, i), i;
	};
}
function ke(e) {
	return Ae({ name: e }, 1);
}
function Ae(e, t) {
	return Pe(((e) => ({
		value: e,
		configurable: 1,
		writable: !t
	})), e);
}
function je(e) {
	return Pe(((e) => ({
		get: e,
		configurable: 1
	})), e);
}
function Me(e) {
	return { [Symbol.toStringTag]: {
		value: e,
		configurable: 1
	} };
}
function Ne(e, t) {
	let n = {}, r = e.length;
	for (let i of t) n[e[--r]] = i;
	return n;
}
function Pe(e, t, n) {
	let r = {};
	for (let i in t) r[i] = e(t[i], i, n);
	return r;
}
function Fe(e, t, n) {
	let r = {};
	for (let i = 0; i < t.length; i++) {
		let a = t[i];
		r[a] = e(a, i, n);
	}
	return r;
}
function Ie(e, t, n) {
	let r = {};
	for (let i = 0; i < e.length; i++) r[t[i]] = n[e[i]];
	return r;
}
function Le(e, t) {
	let n = Object.create(null);
	for (let r of e) n[r] = t[r];
	return n;
}
function Re(e, t) {
	for (let n of t) if (n in e) return 1;
	return 0;
}
function ze(e, t, n) {
	for (let r of e) if (t[r] !== n[r]) return 0;
	return 1;
}
function Be(e, t, n) {
	let r = { ...n };
	for (let n = 0; n < t; n++) r[e[n]] = 0;
	return r;
}
function j(e, ...t) {
	return (...n) => e(...t, ...n);
}
function Ve(e) {
	return e[0].toUpperCase() + e.substring(1);
}
function He(e) {
	return e.slice().sort();
}
function Ue(e, t) {
	return String(t).padStart(e, "0");
}
function We(e, t) {
	return Math.sign(e - t);
}
function Ge(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function Ke(e, t) {
	return [Math.floor(e / t), qe(e, t)];
}
function qe(e, t) {
	return (e % t + t) % t;
}
function Je(e, t) {
	return [Ye(e, t), Xe(e, t)];
}
function Ye(e, t) {
	return Math.trunc(e / t) || 0;
}
function Xe(e, t) {
	return e % t || 0;
}
function Ze(e) {
	return Math.abs(e % 1) === .5;
}
function Qe(e, t, n) {
	let r = 0, i = 0;
	for (let a = 0; a <= t; a++) {
		let t = e[n[a]], o = tc[a], [s, c] = Je(t, F / o);
		r += c * o, i += s;
	}
	let [a, o] = Je(r, F);
	return [i + a, o];
}
function $e(e, t, n) {
	let r = {};
	for (let i = t; i >= 0; i--) {
		let t = tc[i];
		r[n[i]] = Ye(e, t), e = Xe(e, t);
	}
	return r;
}
function et(e) {
	if (e !== void 0) return Ec(e);
}
function tt(e) {
	if (e !== void 0) return rt(e);
}
function nt(e) {
	if (e !== void 0) return it(e);
}
function rt(e) {
	return lt(it(e));
}
function it(e) {
	return ct(Oc(e));
}
function at(e, t) {
	if (t == null) throw RangeError(is(e));
	return t;
}
function ot(e) {
	if (!De(e)) throw TypeError(ts);
	return e;
}
function st(e, t, n = e) {
	if (typeof t !== e) throw TypeError(rs(n, t));
	return t;
}
function ct(e, t = "number") {
	if (!Number.isInteger(e)) throw RangeError(Yo(t, e));
	return e || 0;
}
function lt(e, t = "number") {
	if (e <= 0) throw RangeError(Xo(t, e));
	return e;
}
function ut(e) {
	if (typeof e == "symbol") throw TypeError(es);
	return String(e);
}
function dt(e, t) {
	return De(e) ? String(e) : Ec(e, t);
}
function ft(e) {
	if (typeof e == "string") return BigInt(e);
	if (typeof e != "bigint") throw TypeError($o(e));
	return e;
}
function pt(e, t = "number") {
	if (typeof e == "bigint") throw TypeError(Qo(t));
	if (e = Number(e), !Number.isFinite(e)) throw RangeError(Zo(t, e));
	return e;
}
function mt(e, t) {
	return Math.trunc(pt(e, t)) || 0;
}
function ht(e, t) {
	return ct(pt(e, t), t);
}
function gt(e, t) {
	return lt(mt(e, t), t);
}
function _t(e, t) {
	let [n, r] = Je(t, F), i = e + n, a = Math.sign(i);
	return a && a === -Math.sign(r) && (i -= a, r += a * F), [i, r];
}
function vt(e, t, n = 1) {
	return _t(e[0] + t[0] * n, e[1] + t[1] * n);
}
function yt(e, t) {
	return _t(e[0], e[1] + t);
}
function bt(e, t) {
	return vt(t, e, -1);
}
function xt(e, t) {
	return We(e[0], t[0]) || We(e[1], t[1]);
}
function St(e, t, n) {
	return xt(e, t) === -1 || xt(e, n) === 1;
}
function Ct(e, t = 1) {
	let n = BigInt(F / t);
	return [Number(e / n), Number(e % n) * t];
}
function wt(e, t = 1) {
	let [n, r] = Je(e, F / t);
	return [n, r * t];
}
function Tt(e, t = 1, n) {
	let [r, i] = e, [a, o] = Je(i, t);
	return F / t * r + (a + (n ? o / t : 0));
}
function Et(e, t, n = Ke) {
	let [r, i] = e, [a, o] = n(i, t);
	return [F / t * r + a, o];
}
function Dt(e) {
	return Te(e, "isoYear", Yc, Jc, 1), e.isoYear === Yc ? Te(e, "isoMonth", 4, 12, 1) : e.isoYear === Jc && Te(e, "isoMonth", 1, 9, 1), e;
}
function Ot(e) {
	return kt({
		...e,
		...Hc,
		isoHour: 12
	}), e;
}
function kt(e) {
	let t = Te(e, "isoYear", Yc, Jc, 1), n = t === Yc ? 1 : t === Jc ? -1 : 0;
	return n && At(M({
		...e,
		isoDay: e.isoDay + n,
		isoNanosecond: e.isoNanosecond - n
	})), e;
}
function At(e) {
	if (!e || St(e, qc, Kc)) throw RangeError(js);
	return e;
}
function jt(e) {
	return Qe(e, 5, Ic)[1];
}
function Mt(e) {
	let [t, n] = Ke(e, F);
	return [$e(n, 5, Ic), t];
}
function Nt(e) {
	return Et(e, Qs);
}
function Pt(e) {
	return Lt(e.isoYear, e.isoMonth, e.isoDay, e.isoHour, e.isoMinute, e.isoSecond, e.isoMillisecond);
}
function M(e) {
	let t = Pt(e);
	if (t !== void 0) {
		let [n, r] = Je(t, Js);
		return [n, r * Zs + (e.isoMicrosecond || 0) * Xs + (e.isoNanosecond || 0)];
	}
}
function Ft(e, t) {
	let [n, r] = Mt(jt(e) - t);
	return At(M({
		...e,
		isoDay: e.isoDay + r,
		...n
	}));
}
function It(...e) {
	return Lt(...e) / Ys;
}
function Lt(...e) {
	let [t, n] = Rt(...e), r = t.valueOf();
	if (!isNaN(r)) return r - n * Js;
}
function Rt(e, t = 1, n = 1, r = 0, i = 0, a = 0, o = 0) {
	let s = e === Yc ? 1 : e === Jc ? -1 : 0, c = /* @__PURE__ */ new Date();
	return c.setUTCHours(r, i, a, o), c.setUTCFullYear(e, t - 1, n + s), [c, s];
}
function zt(e, t) {
	let [n, r] = yt(e, t);
	r < 0 && (r += F, --n);
	let [i, a] = Ke(r, Zs), [o, s] = Ke(a, Xs);
	return Bt(n * Js + i, o, s);
}
function Bt(e, t = 0, n = 0) {
	let r = Math.ceil(Math.max(0, Math.abs(e) - Gc) / Js) * Math.sign(e), i = new Date(e - r * Js);
	return Ne(Rc, [
		i.getUTCFullYear(),
		i.getUTCMonth() + 1,
		i.getUTCDate() + r,
		i.getUTCHours(),
		i.getUTCMinutes(),
		i.getUTCSeconds(),
		i.getUTCMilliseconds(),
		t,
		n
	]);
}
function Vt(e, t) {
	if (t < -Gc) throw RangeError(js);
	let n = e.formatToParts(t), r = {};
	for (let e of n) r[e.type] = e.value;
	return r;
}
function Ht(e) {
	return [
		e.isoYear,
		e.isoMonth,
		e.isoDay
	];
}
function Ut(e, t) {
	return [t, 0];
}
function Wt() {
	return el;
}
function Gt(e, t) {
	switch (t) {
		case 2: return qt(e) ? 29 : 28;
		case 4:
		case 6:
		case 9:
		case 11: return 30;
	}
	return 31;
}
function Kt(e) {
	return qt(e) ? 366 : 365;
}
function qt(e) {
	return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
function Jt(e) {
	let [t, n] = Rt(e.isoYear, e.isoMonth, e.isoDay);
	return qe(t.getUTCDay() - n, 7) || 7;
}
function Yt(e) {
	return this.id === xc ? (({ isoYear: e }) => e < 1 ? ["gregory-inverse", 1 - e] : ["gregory", e])(e) : this.id === Sc ? nl(e) : [];
}
function Xt(e) {
	let t = Pt(e);
	if (t < tl) {
		let { isoYear: t } = e;
		return t < 1 ? ["japanese-inverse", 1 - t] : ["japanese", t];
	}
	let { era: n, eraYear: r } = Aa(Vt(fu(Sc), t), Sc);
	return [n, r];
}
function Zt(e) {
	return Qt(e), tn(e, 1), e;
}
function Qt(e) {
	return en(e, 1), e;
}
function $t(e) {
	return ze(Lc, e, en(e));
}
function en(e, t) {
	let { isoYear: n } = e, r = Te(e, "isoMonth", 1, Wt(), t);
	return {
		isoYear: n,
		isoMonth: r,
		isoDay: Te(e, "isoDay", 1, Gt(n, r), t)
	};
}
function tn(e, t) {
	return Ne(Ic, [
		Te(e, "isoHour", 0, 23, t),
		Te(e, "isoMinute", 0, 59, t),
		Te(e, "isoSecond", 0, 59, t),
		Te(e, "isoMillisecond", 0, 999, t),
		Te(e, "isoMicrosecond", 0, 999, t),
		Te(e, "isoNanosecond", 0, 999, t)
	]);
}
function N(e) {
	return e === void 0 ? 0 : xl(ot(e));
}
function nn(e, t = 0) {
	e = mn(e);
	let n = Sl(e), r = Cl(e, t);
	return [
		xl(e),
		r,
		n
	];
}
function rn(e, t, n, r = 9, i = 0, a = 4) {
	t = mn(t);
	let o = yl(t, r, i), s = dn(t), c = Dl(t, a), l = vl(t, r, i, 1);
	return o == null ? o = Math.max(n, l) : yn(o, l), s = fn(s, l, 1), e && (c = ((e) => e < 4 ? (e + 2) % 4 : e)(c)), [
		o,
		l,
		s,
		c
	];
}
function an(e, t = 6, n) {
	let r = dn(e = hn(e, rl)), i = Dl(e, 7), a = vl(e, t);
	return a = at(rl, a), r = fn(r, a, void 0, n), [
		a,
		r,
		i
	];
}
function on(e) {
	return wl(mn(e));
}
function sn(e, t) {
	return ln(mn(e), t);
}
function cn(e) {
	let t = vn(cl, _l, hn(e, cl), 0);
	if (!t) throw RangeError(rs(cl, t));
	return t;
}
function ln(e, t = 4) {
	let n = pn(e);
	return [Dl(e, 4), ...un(vl(e, t), n)];
}
function un(e, t) {
	return e == null ? [t === void 0 ? 1 : 10 ** (9 - t), t] : [tc[e], e < 4 ? 9 - 3 * e : -1];
}
function dn(e) {
	let t = e[al];
	return t === void 0 ? 1 : mt(t, al);
}
function fn(e, t, n, r) {
	let i = r ? F : tc[t + 1];
	if (i) {
		let n = tc[t];
		if (i % ((e = Ee(al, e, 1, i / n - (r ? 0 : 1), 1)) * n)) throw RangeError(rs(al, e));
	} else e = Ee(al, e, 1, n ? 10 ** 9 : 1, 1);
	return e;
}
function pn(e) {
	let t = e[ol];
	if (t !== void 0) {
		if (typeof t != "number") {
			if (ut(t) === "auto") return;
			throw RangeError(rs(ol, t));
		}
		t = Ee(ol, Math.floor(t), 0, 9, 1);
	}
	return t;
}
function mn(e) {
	return e === void 0 ? {} : ot(e);
}
function hn(e, t) {
	return typeof e == "string" ? { [t]: e } : ot(e);
}
function gn(e) {
	return { overflow: ul[e] };
}
function _n(e, t, n = 9, r = 0, i) {
	let a = t[e];
	if (a === void 0) return i ? r : void 0;
	if (a = ut(a), a === "auto") return i ? r : null;
	let o = Ks[a];
	if (o === void 0 && (o = Nc[a]), o === void 0) throw RangeError(ls(e, a, Ks));
	return Ee(e, o, r, n, 1, qs), o;
}
function vn(e, t, n, r = 0) {
	let i = n[e];
	if (i === void 0) return r;
	let a = ut(i), o = t[a];
	if (o === void 0) throw RangeError(ls(e, a, t));
	return o;
}
function yn(e, t) {
	if (t > e) throw RangeError(Ls);
}
function bn(e) {
	return {
		branding: Pl,
		epochNanoseconds: e
	};
}
function xn(e, t, n) {
	return {
		branding: Nl,
		calendar: n,
		timeZone: t,
		epochNanoseconds: e
	};
}
function Sn(e, t = e.calendar) {
	return {
		branding: jl,
		calendar: t,
		...Le(Vc, e)
	};
}
function Cn(e, t = e.calendar) {
	return {
		branding: Al,
		calendar: t,
		...Le(zc, e)
	};
}
function wn(e, t = e.calendar) {
	return {
		branding: Ol,
		calendar: t,
		...Le(zc, e)
	};
}
function Tn(e, t = e.calendar) {
	return {
		branding: kl,
		calendar: t,
		...Le(zc, e)
	};
}
function En(e) {
	return {
		branding: Ml,
		...Le(Bc, e)
	};
}
function P(e) {
	return {
		branding: Fl,
		sign: Zr(e),
		...Le(kc, e)
	};
}
function Dn(e) {
	return Et(e.epochNanoseconds, Zs)[0];
}
function On(e) {
	return ((e, t = 1) => {
		let [n, r] = e, i = Math.floor(r / t), a = F / t;
		return BigInt(n) * BigInt(a) + BigInt(i);
	})(e.epochNanoseconds);
}
function kn(e) {
	return e.epochNanoseconds;
}
function An(e, t, n, r, i) {
	let a = ii(r), [o, s] = ((e, t) => {
		let n = t((e = hn(e, il))[sl]), r = bl(e);
		return r = at(il, r), [r, n];
	})(i, e);
	if (!s && Wr(Math.max(o, a), s)) return jn(r, o);
	if (!s) throw RangeError(Ps);
	if (!r.sign) return 0;
	let [c, l, u] = zr(t, n, s), d = Br(u), f = Vr(u), p = Hr(u), m = f(l, c, r);
	Ur(s) || (kt(c), kt(m));
	let h = p(l, c, m, o);
	return Wr(o, s) ? jn(h, o) : ((e, t, n, r, i, a, o) => {
		let s = Zr(e), [c, l] = Mn(r, Fc(n, e), n, s, i, a, o), u = Nn(t, c, l);
		return e[I[n]] + u * s;
	})(h, d(m), o, l, c, d, f);
}
function jn(e, t) {
	return Tt(ei(e), tc[t], 1);
}
function Mn(e, t, n, r, i, a, o) {
	let s = I[n], c = {
		...t,
		[s]: t[s] + r
	}, l = o(e, i, t), u = o(e, i, c);
	return [a(l), a(u)];
}
function Nn(e, t, n) {
	let r = Tt(bt(t, n));
	if (!r) throw RangeError(xs);
	return Tt(bt(t, e)) / r;
}
function Pn(e, t) {
	let [n, r, i] = an(t, 5, 1);
	return bn(Yn(e.epochNanoseconds, n, r, i, 1));
}
function Fn(e, t, n) {
	let { epochNanoseconds: r, timeZone: i, calendar: a } = t, [o, s, c] = an(n);
	if (o === 0 && s === 1) return t;
	let l = e(i);
	if (o === 6) r = ((e, t, n, r) => {
		let [i, a] = e(Hl(n, t)), o = n.epochNanoseconds, s = Er(t, i), c = Er(t, a);
		if (St(o, s, c)) throw RangeError(xs);
		return Qn(Nn(o, s, c), r) ? c : s;
	})(Gn, l, t, c);
	else {
		let e = l.R(r);
		r = wr(l, Bn(zt(r, e), o, s, c), e, 2, 0, 1);
	}
	return xn(r, i, a);
}
function In(e, t) {
	return Sn(Bn(e, ...an(t)), e.calendar);
}
function Ln(e, t) {
	let [n, r, i] = an(t, 5);
	var a;
	return En((a = i, Hn(e, Wn(n, r), a)[0]));
}
function Rn(e, t) {
	let n = e(t.timeZone), [r, i] = Gn(Hl(t, n)), a = Tt(bt(Er(n, r), Er(n, i)), ec, 1);
	if (a <= 0) throw RangeError(xs);
	return a;
}
function zn(e, t) {
	let { timeZone: n, calendar: r } = t;
	return xn(((e, t, n) => Er(t, e(Hl(n, t))))(Kn, e(n), t), n, r);
}
function Bn(e, t, n, r) {
	return Vn(e, Wn(t, n), r);
}
function Vn(e, t, n) {
	let [r, i] = Hn(e, t, n);
	return kt({
		...Rr(e, i),
		...r
	});
}
function Hn(e, t, n) {
	return Mt(Zn(jt(e), t, n));
}
function Un(e) {
	return Zn(e, $s, 7);
}
function Wn(e, t) {
	return tc[e] * t;
}
function Gn(e) {
	let t = Kn(e);
	return [t, Rr(t, 1)];
}
function Kn(e) {
	return Uc(6, e);
}
function qn(e, t, n) {
	let r = Math.min(ii(e), 6);
	return ti(Xn(ei(e, r), t, n), r);
}
function Jn(e, t, n, r, i, a, o, s, c, l) {
	if (r === 0 && i === 1) return e;
	let [u, d, f] = (Wr(r, s) ? Ur(s) && r < 6 && n >= 6 ? er : $n : tr)(e, t, n, r, i, a, o, s, c, l);
	return f && r !== 7 && (u = ((e, t, n, r, i, a, o, s) => {
		let c = Zr(e);
		for (let l = r + 1; l <= n; l++) {
			if (l === 7 && n !== 7) continue;
			let r = Fc(l, e);
			r[I[l]] += c;
			let u = Tt(bt(o(s(i, a, r)), t));
			if (u && Math.sign(u) !== c) break;
			e = r;
		}
		return e;
	})(u, d, n, Math.max(6, r), o, s, c, l)), u;
}
function Yn(e, t, n, r, i) {
	return t === 6 ? [Zn(((e) => e[0] + e[1] / F)(e), n, r), 0] : Xn(e, Wn(t, n), r, i);
}
function Xn(e, t, n, r) {
	let [i, a] = e;
	r && a < 0 && (a += F, --i);
	let [o, s] = Ke(Zn(a, t, n), F);
	return _t(i + o, s);
}
function Zn(e, t, n) {
	return Qn(e / t, n) * t;
}
function Qn(e, t) {
	return Il[t](e);
}
function $n(e, t, n, r, i, a) {
	let o = Zr(e), s = ei(e), c = Yn(s, r, i, a), l = bt(s, c), u = Math.sign(c[0] - s[0]) === o, d = ti(c, Math.min(n, 6));
	return [
		{
			...e,
			...d
		},
		vt(t, l),
		u
	];
}
function er(e, t, n, r, i, a, o, s, c, l) {
	let u = Zr(e) || 1, d = Tt(ei(e, 5)), f = Wn(r, i), p = Zn(d, f, a), [m, h] = Mn(o, {
		...e,
		...Pc
	}, 6, u, s, c, l), g = p - Tt(bt(m, h)), _ = 0;
	g && Math.sign(g) !== u ? t = yt(m, p) : (_ += u, p = Zn(g, f, a), t = yt(h, p));
	let v = ni(p);
	return [
		{
			...e,
			...v,
			days: e.days + _
		},
		t,
		!!_
	];
}
function tr(e, t, n, r, i, a, o, s, c, l) {
	let u = Zr(e), d = I[r], f = Fc(r, e);
	r === 7 && (e = {
		...e,
		weeks: e.weeks + Math.trunc(e.days / 7)
	});
	let p = Ye(e[d], i) * i;
	f[d] = p;
	let [m, h] = Mn(o, f, r, i * u, s, c, l), g = p + Nn(t, m, h) * u * i, _ = Zn(g, i, a), v = Math.sign(_ - g) === u;
	return f[d] = _, [
		f,
		v ? h : m,
		v
	];
}
function nr(e, t, n, r) {
	let [i, a, o, s] = ((e) => {
		let t = ln(e = mn(e));
		return [e.timeZone, ...t];
	})(r), c = i !== void 0;
	return ((e, t, n, r, i, a) => {
		n = Xn(n, i, r, 1);
		let o = t.R(n);
		return fr(zt(n, o), a) + (e ? _r(Un(o)) : "Z");
	})(c, t(c ? e(i) : Ll), n.epochNanoseconds, a, o, s);
}
function rr(e, t, n) {
	let [r, i, a, o, s, c] = ((e) => {
		e = mn(e);
		let t = wl(e), n = pn(e), r = El(e), i = Dl(e, 4), a = vl(e, 4);
		return [
			t,
			Tl(e),
			r,
			i,
			...un(a, n)
		];
	})(n);
	return ((e, t, n, r, i, a, o, s, c, l) => {
		r = Xn(r, c, s, 1);
		let u = e(n).R(r);
		return fr(zt(r, u), l) + _r(Un(u), o) + ((e, t) => t === 1 ? "" : "[" + (t === 2 ? "!" : "") + e + "]")(n, a) + vr(t, i);
	})(e, t.calendar, t.timeZone, t.epochNanoseconds, r, i, a, o, s, c);
}
function ir(e, t) {
	let [n, r, i, a] = ((e) => (e = mn(e), [wl(e), ...ln(e)]))(t);
	return o = e.calendar, s = n, c = a, fr(Vn(e, i, r), c) + vr(o, s);
	var o, s, c;
}
function ar(e, t) {
	return n = e.calendar, r = e, i = on(t), pr(r) + vr(n, i);
	var n, r, i;
}
function or(e, t) {
	return ur(e.calendar, mr, e, on(t));
}
function sr(e, t) {
	return ur(e.calendar, hr, e, on(t));
}
function cr(e, t) {
	let [n, r, i] = sn(t);
	return a = i, gr(Hn(e, r, n)[0], a);
	var a;
}
function lr(e, t) {
	let [n, r, i] = sn(t, 3);
	return r > 1 && Qr(e = {
		...e,
		...qn(e, r, n)
	}), ((e, t) => {
		let { sign: n } = e, r = n === -1 ? Yr(e) : e, { hours: i, minutes: a } = r, [o, s] = Et(ei(r, 3), Qs, Je);
		$r(o);
		let c = br(s, t), l = t >= 0 || !n || c;
		return (n < 0 ? "-" : "") + "P" + dr({
			Y: Sr(r.years),
			M: Sr(r.months),
			W: Sr(r.weeks),
			D: Sr(r.days)
		}) + (i || a || o || l ? "T" + dr({
			H: Sr(i),
			M: Sr(a),
			S: Sr(o, l) + c
		}) : "");
	})(e, i);
}
function ur(e, t, n, r) {
	return r === 1 ? e === "iso8601" ? t(n) : pr(n) : r > 1 || r === 0 && e !== "iso8601" ? pr(n) + yr(e, r === 2) : t(n);
}
function dr(e) {
	let t = [];
	for (let n in e) {
		let r = e[n];
		r && t.push(r, n);
	}
	return t.join("");
}
function fr(e, t) {
	return pr(e) + "T" + gr(e, t);
}
function pr(e) {
	return mr(e) + "-" + Gs(e.isoDay);
}
function mr(e) {
	let { isoYear: t } = e;
	return (t < 0 || t > 9999 ? xr(t) + Ue(6, Math.abs(t)) : Ue(4, t)) + "-" + Gs(e.isoMonth);
}
function hr(e) {
	return Gs(e.isoMonth) + "-" + Gs(e.isoDay);
}
function gr(e, t) {
	let n = [Gs(e.isoHour), Gs(e.isoMinute)];
	return t !== -1 && n.push(Gs(e.isoSecond) + ((e, t, n, r) => br(e * 1e6 + t * Xs + n, r))(e.isoMillisecond, e.isoMicrosecond, e.isoNanosecond, t)), n.join(":");
}
function _r(e, t = 0) {
	if (t === 1) return "";
	let [n, r] = Ke(Math.abs(e), ec), [i, a] = Ke(r, $s), [o, s] = Ke(a, Qs);
	return xr(e) + Gs(n) + ":" + Gs(i) + (o || s ? ":" + Gs(o) + br(s) : "");
}
function vr(e, t) {
	return t !== 1 && (t > 1 || t === 0 && e !== "iso8601") ? yr(e, t === 2) : "";
}
function yr(e, t) {
	return "[" + (t ? "!" : "") + "u-ca=" + e + "]";
}
function br(e, t) {
	let n = Ue(9, e);
	return n = t === void 0 ? n.replace(Vl, "") : n.slice(0, t), n ? "." + n : "";
}
function xr(e) {
	return e < 0 ? "-" : "+";
}
function Sr(e, t) {
	return e || t ? e.toLocaleString("fullwide", { useGrouping: 0 }) : "";
}
function Cr(e, t) {
	let { epochNanoseconds: n } = e, r = (t.R ? t : t(e.timeZone)).R(n), i = zt(n, r);
	return {
		calendar: e.calendar,
		...i,
		offsetNanoseconds: r
	};
}
function wr(e, t, n, r = 0, i = 0, a, o) {
	if (n !== void 0 && r === 1 && (r === 1 || o)) return Ft(t, n);
	let s = e.I(t);
	if (n !== void 0 && r !== 3) {
		let e = ((e, t, n, r) => {
			let i = M(t);
			r && (n = Un(n));
			for (let t of e) {
				let e = Tt(bt(t, i));
				if (r && (e = Un(e)), e === n) return t;
			}
		})(s, t, n, a);
		if (e !== void 0) return e;
		if (r === 0) throw RangeError(ks);
	}
	return o ? M(t) : Tr(e, t, i, s);
}
function Tr(e, t, n = 0, r = e.I(t)) {
	if (r.length === 1) return r[0];
	if (n === 1) throw RangeError(As);
	if (r.length) return r[n === 3 ? 1 : 0];
	let i = M(t), a = ((e, t) => {
		let n = e.R(yt(t, -F));
		return ((e) => {
			if (e > F) throw RangeError(Os);
			return e;
		})(e.R(yt(t, F)) - n);
	})(e, i) * (n === 2 ? -1 : 1);
	return (r = e.I(zt(i, a)))[n === 2 ? 0 : r.length - 1];
}
function Er(e, t) {
	let n = e.I(t);
	if (n.length) return n[0];
	let r = yt(M(t), -F);
	return e.O(r, 1);
}
function Dr(e, t, n) {
	return bn(At(vt(t.epochNanoseconds, ((e) => {
		if (ri(e)) throw RangeError(Fs);
		return ei(e, 5);
	})(e ? Yr(n) : n))));
}
function Or(e, t, n, r, i, a = Object.create(null)) {
	let o = t(r.timeZone), s = e(r.calendar);
	return {
		...r,
		...Nr(o, s, r, n ? Yr(i) : i, a)
	};
}
function kr(e, t, n, r, i = Object.create(null)) {
	let { calendar: a } = n;
	return Sn(Pr(e(a), n, t ? Yr(r) : r, i), a);
}
function Ar(e, t, n, r, i) {
	let { calendar: a } = n;
	return Cn(Fr(e(a), n, t ? Yr(r) : r, i), a);
}
function jr(e, t, n, r, i) {
	let a = n.calendar, o = e(a), s = Ot(Ir(o, n));
	return t && (r = Jr(r)), r.sign < 0 && (s = o.P(s, {
		...L,
		months: 1
	}), s = Rr(s, -1)), wn(Ir(o, o.P(s, r, i)), a);
}
function Mr(e, t, n) {
	return En(Lr(t, e ? Yr(n) : n)[0]);
}
function Nr(e, t, n, r, i) {
	let a = ei(r, 5), o = n.epochNanoseconds;
	if (ri(r)) {
		let s = Hl(n, e);
		o = vt(Tr(e, {
			...Fr(t, s, {
				...r,
				...Pc
			}, i),
			...Le(Ic, s)
		}), a);
	} else o = vt(o, a), N(i);
	return { epochNanoseconds: At(o) };
}
function Pr(e, t, n, r) {
	let [i, a] = Lr(t, n);
	return kt({
		...Fr(e, t, {
			...n,
			...Pc,
			days: n.days + a
		}, r),
		...i
	});
}
function Fr(e, t, n, r) {
	if (n.years || n.months || n.weeks) return e.P(t, n, r);
	N(r);
	let i = n.days + ei(n, 5)[0];
	return i ? Ot(Rr(t, i)) : t;
}
function Ir(e, t, n = 1) {
	return Rr(t, n - e.day(t));
}
function Lr(e, t) {
	let [n, r] = ei(t, 5), [i, a] = Mt(jt(e) + r);
	return [i, n + a];
}
function Rr(e, t) {
	return t ? {
		...e,
		...Bt(Pt(e) + t * Js)
	} : e;
}
function zr(e, t, n) {
	let r = e(n.calendar);
	return Ur(n) ? [
		n,
		r,
		t(n.timeZone)
	] : [{
		...n,
		...Hc
	}, r];
}
function Br(e) {
	return e ? kn : M;
}
function Vr(e) {
	return e ? j(Nr, e) : Pr;
}
function Hr(e) {
	return e ? j(oa, e) : sa;
}
function Ur(e) {
	return e && e.epochNanoseconds;
}
function Wr(e, t) {
	return e <= 6 - (Ur(t) ? 1 : 0);
}
function Gr(e, t, n, r, i, a, o) {
	let s = e(mn(o).relativeTo), c = Math.max(ii(i), ii(a));
	if (Wr(c, s)) return P(Qr(((e, t, n, r) => {
		let i = vt(ei(e), ei(t), r ? -1 : 1);
		if (!Number.isFinite(i[0])) throw RangeError(js);
		return {
			...L,
			...ti(i, n)
		};
	})(i, a, c, r)));
	if (!s) throw RangeError(Ps);
	r && (a = Yr(a));
	let [l, u, d] = zr(t, n, s), f = Vr(d);
	return P(Hr(d)(u, l, f(u, f(u, l, i), a), c));
}
function Kr(e, t, n, r, i) {
	let a = ii(r), [o, s, c, l, u] = ((e, t, n) => {
		e = hn(e, rl);
		let r = yl(e), i = n(e[sl]), a = dn(e), o = Dl(e, 7), s = vl(e);
		if (r === void 0 && s === void 0) throw RangeError(Is);
		if (s ??= 0, r ??= Math.max(s, t), yn(r, s), a = fn(a, s, 1), a > 1 && s > 5 && r !== s) throw RangeError("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit");
		return [
			r,
			s,
			a,
			o,
			i
		];
	})(i, a, e);
	if (!u && Math.max(a, o) <= 6) return P(Qr(((e, t, n, r, i) => {
		let a = Yn(ei(e), n, r, i);
		return {
			...L,
			...ti(a, t)
		};
	})(r, o, s, c, l)));
	if (!Ur(u) && !r.sign) return r;
	if (!u) throw RangeError(Ps);
	let [d, f, p] = zr(t, n, u), m = Br(p), h = Vr(p), g = Hr(p), _ = h(f, d, r);
	Ur(u) || (kt(d), kt(_));
	let v = g(f, d, _, o), y = r.sign, b = Zr(v);
	if (y && b && y !== b) throw RangeError(xs);
	return v = Jn(v, m(_), o, s, c, l, f, d, m, h), P(v);
}
function qr(e) {
	return e.sign === -1 ? Jr(e) : e;
}
function Jr(e) {
	return P(Yr(e));
}
function Yr(e) {
	let t = {};
	for (let n of I) t[n] = -1 * e[n] || 0;
	return t;
}
function Xr(e) {
	return !e.sign;
}
function Zr(e, t = I) {
	let n = 0;
	for (let r of t) {
		let t = Math.sign(e[r]);
		if (t) {
			if (n && n !== t) throw RangeError(Ns);
			n = t;
		}
	}
	return n;
}
function Qr(e) {
	for (let t of Mc) Ee(t, e[t], -Ul, Ul, 1);
	return $r(Tt(ei(e), Qs)), e;
}
function $r(e) {
	if (!Number.isSafeInteger(e)) throw RangeError(Ms);
}
function ei(e, t = 6) {
	return Qe(e, t, I);
}
function ti(e, t = 6) {
	let [n, r] = e, i = $e(r, t, I);
	if (i[I[t]] += n * (F / tc[t]), !Number.isFinite(i[I[t]])) throw RangeError(js);
	return i;
}
function ni(e, t = 5) {
	return $e(e, t, I);
}
function ri(e) {
	return !!Zr(e, jc);
}
function ii(e) {
	let t = 9;
	for (; t > 0 && !e[I[t]]; t--);
	return t;
}
function ai(e, t) {
	return [e, t];
}
function oi(e) {
	let t = Math.floor(e / Rl) * Rl;
	return [t, t + Rl];
}
function si(e) {
	let t = wi(e = dt(e));
	if (!t) throw RangeError(Rs(e));
	let n;
	if (t.j) n = 0;
	else {
		if (!t.offset) throw RangeError(Rs(e));
		n = ui(t.offset);
	}
	return t.timeZone && Di(t.timeZone, 1), bn(Ft(Zt(t), n));
}
function ci(e) {
	let t = wi(Ec(e));
	if (!t) throw RangeError(Rs(e));
	if (t.timeZone) return bi(t, t.offset ? ui(t.offset) : void 0);
	if (t.j) throw RangeError(Rs(e));
	return Si(t);
}
function li(e, t) {
	let n = wi(Ec(e));
	if (!n || !n.timeZone) throw RangeError(Rs(e));
	let { offset: r } = n, i = r ? ui(r) : void 0, [, a, o] = nn(t);
	return bi(n, i, a, o);
}
function ui(e) {
	let t = Di(e);
	if (t === void 0) throw RangeError(Rs(e));
	return t;
}
function di(e) {
	let t = wi(Ec(e));
	if (!t || t.j) throw RangeError(Rs(e));
	return Sn(xi(t));
}
function fi(e, t, n) {
	let r = wi(Ec(e));
	if (!r || r.j) throw RangeError(Rs(e));
	return t ? r.calendar === "iso8601" && (r = r.isoYear === -271821 && r.isoMonth === 4 ? {
		...r,
		isoDay: 20,
		...Hc
	} : {
		...r,
		isoDay: 1,
		...Hc
	}) : n && r.calendar === "iso8601" && (r = {
		...r,
		isoYear: $c
	}), Cn(r.C ? xi(r) : Si(r));
}
function pi(e, t) {
	let n = Ti(Ec(t));
	if (n) return mi(n), wn(Dt(Qt(n)));
	let r = fi(t, 1);
	return wn(Ir(e(r.calendar), r));
}
function mi(e) {
	if (e.calendar !== "iso8601") throw RangeError(zs(e.calendar));
}
function hi(e, t) {
	let n = Ei(Ec(t));
	if (n) return mi(n), Tn(Qt(n));
	let r = fi(t, 0, 1), { calendar: i } = r, a = e(i), [o, s, c] = a.v(r), [l, u] = a.q(o, s), [d, f] = a.G(l, u, c);
	return Tn(Ot(a.V(d, f, c)), i);
}
function gi(e) {
	let t, n = ((e) => {
		let t = ru.exec(e);
		return t ? (Ai(t[10]), ki(t)) : void 0;
	})(Ec(e));
	if (!n) {
		if (n = wi(e), !n || !n.C) throw RangeError(Rs(e));
		if (n.j) throw RangeError(zs("Z"));
		mi(n);
	}
	if ((t = Ti(e)) && $t(t) || (t = Ei(e)) && $t(t)) throw RangeError(Rs(e));
	return En(tn(n, 1));
}
function _i(e) {
	let t = ((e) => {
		let t = ou.exec(e);
		return t ? ((e) => {
			function t(e, t, a) {
				let o = 0, s = 0;
				if (a && ([o, i] = Ke(i, tc[a])), e !== void 0) {
					if (r) throw RangeError(zs(e));
					s = ((e) => {
						let t = parseInt(e);
						if (!Number.isFinite(t)) throw RangeError(zs(e));
						return t;
					})(e), n = 1, t && (i = ji(t) * (tc[a] / Qs), r = 1);
				}
				return o + s;
			}
			let n = 0, r = 0, i = 0, a = {
				...Ne(I, [
					t(e[2]),
					t(e[3]),
					t(e[4]),
					t(e[5]),
					t(e[6], e[7], 5),
					t(e[8], e[9], 4),
					t(e[10], e[11], 3)
				]),
				...$e(i, 2, I)
			};
			if (!n) throw RangeError(ss(I));
			return Ni(e[1]) < 0 && (a = Yr(a)), a;
		})(t) : void 0;
	})(Ec(e));
	if (!t) throw RangeError(Rs(e));
	return P(Qr(t));
}
function vi(e) {
	let t = wi(e) || Ti(e) || Ei(e);
	return t ? t.calendar : e;
}
function yi(e) {
	let t = wi(e);
	return t && (t.timeZone || t.j && Ll || t.offset) || e;
}
function bi(e, t, n = 0, r = 0) {
	let i = Ii(e.timeZone), a = R(i), o;
	return Zt(e), o = e.C ? wr(a, e, t, n, r, !a.$, e.j) : Er(a, e), xn(o, i, Ha(e.calendar));
}
function xi(e) {
	return Ci(kt(Zt(e)));
}
function Si(e) {
	return Ci(Ot(Qt(e)));
}
function Ci(e) {
	return {
		...e,
		calendar: Ha(e.calendar)
	};
}
function wi(e) {
	let t = nu.exec(e);
	return t ? ((e) => {
		let t = e[10], n = (t || "").toUpperCase() === "Z";
		return {
			isoYear: Oi(e),
			isoMonth: parseInt(e[4]),
			isoDay: parseInt(e[5]),
			...ki(e.slice(5)),
			...Ai(e[16]),
			C: !!e[6],
			j: n,
			offset: n ? void 0 : t
		};
	})(t) : void 0;
}
function Ti(e) {
	let t = eu.exec(e);
	return t ? ((e) => ({
		isoYear: Oi(e),
		isoMonth: parseInt(e[4]),
		isoDay: 1,
		...Ai(e[5])
	}))(t) : void 0;
}
function Ei(e) {
	let t = tu.exec(e);
	return t ? ((e) => ({
		isoYear: $c,
		isoMonth: parseInt(e[1]),
		isoDay: parseInt(e[2]),
		...Ai(e[3])
	}))(t) : void 0;
}
function Di(e, t) {
	let n = iu.exec(e);
	return n ? ((e, t) => {
		let n = e[4] || e[5];
		if (t && n) throw RangeError(zs(n));
		return ((e) => {
			if (Math.abs(e) >= F) throw RangeError(Ds);
			return e;
		})((Pi(e[2]) * ec + Pi(e[3]) * $s + Pi(e[4]) * Qs + ji(e[5] || "")) * Ni(e[1]));
	})(n, t) : void 0;
}
function Oi(e) {
	let t = Ni(e[1]), n = parseInt(e[2] || e[3]);
	if (t < 0 && !n) throw RangeError(zs(-0));
	return t * n;
}
function ki(e) {
	let t = Pi(e[3]);
	return {
		...Mt(ji(e[4] || ""))[0],
		isoHour: Pi(e[1]),
		isoMinute: Pi(e[2]),
		isoSecond: t === 60 ? 59 : t
	};
}
function Ai(e) {
	let t, n, r = [];
	if (e.replace(au, ((e, i, a) => {
		let o = !!i, [s, c] = a.split("=").reverse();
		if (c) {
			if (c === "u-ca") r.push(s), t ||= o;
			else if (o || /[A-Z]/.test(c)) throw RangeError(zs(e));
		} else {
			if (n) throw RangeError(zs(e));
			n = s;
		}
		return "";
	})), r.length > 1 && t) throw RangeError(zs(e));
	return {
		timeZone: n,
		calendar: r[0] || "iso8601"
	};
}
function ji(e) {
	return parseInt(e.padEnd(9, "0"));
}
function Mi(e) {
	return RegExp(`^${e}$`, "i");
}
function Ni(e) {
	return e && e !== "+" ? -1 : 1;
}
function Pi(e) {
	return e === void 0 ? 0 : parseInt(e);
}
function Fi(e) {
	return Ii(Ec(e));
}
function Ii(e) {
	let t = Ri(e);
	return typeof t == "number" ? _r(t) : t ? ((e) => {
		if (lu.test(e)) throw RangeError(ws(e));
		if (cu.test(e)) throw RangeError(Es);
		return e.toLowerCase().split("/").map(((e, t) => (e.length <= 3 || /\d/.test(e)) && !/etc|yap/.test(e) ? e.toUpperCase() : e.replace(/baja|dumont|[a-z]+/g, ((e, n) => e.length <= 2 && !t || e === "in" || e === "chat" ? e.toUpperCase() : e.length > 2 || !n ? Ve(e).replace(/island|noronha|murdo|rivadavia|urville/, Ve) : e)))).join("/");
	})(e) : Ll;
}
function Li(e) {
	let t = Ri(e);
	return typeof t == "number" ? t : t ? t.resolvedOptions().timeZone : Ll;
}
function Ri(e) {
	let t = Di(e = e.toUpperCase(), 1);
	return t === void 0 ? e === Ll ? void 0 : su(e) : t;
}
function zi(e, t) {
	return xt(e.epochNanoseconds, t.epochNanoseconds);
}
function Bi(e, t) {
	return xt(e.epochNanoseconds, t.epochNanoseconds);
}
function Vi(e, t, n, r, i, a) {
	let o = e(mn(a).relativeTo), s = Math.max(ii(r), ii(i));
	if (ze(I, r, i)) return 0;
	if (Wr(s, o)) return xt(ei(r), ei(i));
	if (!o) throw RangeError(Ps);
	let [c, l, u] = zr(t, n, o), d = Br(u), f = Vr(u);
	return xt(d(f(l, c, r)), d(f(l, c, i)));
}
function Hi(e, t) {
	return Ui(e, t) || Wi(e, t);
}
function Ui(e, t) {
	return We(Pt(e), Pt(t));
}
function Wi(e, t) {
	return We(jt(e), jt(t));
}
function Gi(e, t) {
	return !zi(e, t);
}
function Ki(e, t) {
	return !Bi(e, t) && !!Qi(e.timeZone, t.timeZone) && e.calendar === t.calendar;
}
function qi(e, t) {
	return !Hi(e, t) && e.calendar === t.calendar;
}
function Ji(e, t) {
	return !Ui(e, t) && e.calendar === t.calendar;
}
function Yi(e, t) {
	return !Ui(e, t) && e.calendar === t.calendar;
}
function Xi(e, t) {
	return !Ui(e, t) && e.calendar === t.calendar;
}
function Zi(e, t) {
	return !Wi(e, t);
}
function Qi(e, t) {
	if (e === t) return 1;
	try {
		return Li(e) === Li(t);
	} catch {}
}
function $i(e, t, n, r) {
	let i = rn(e, r, 3, 5), a = ua(t.epochNanoseconds, n.epochNanoseconds, ...i);
	return P(e ? Yr(a) : a);
}
function ea(e, t, n, r, i, a) {
	let o = ha(r.calendar, i.calendar), [s, c, l, u] = rn(n, a, 5), d = r.epochNanoseconds, f = i.epochNanoseconds, p = xt(f, d), m;
	if (p) if (s < 6) m = ua(d, f, s, c, l, u);
	else {
		let n = t(((e, t) => {
			if (!Qi(e, t)) throw RangeError(Ts);
			return e;
		})(r.timeZone, i.timeZone)), d = e(o);
		m = ca(d, n, r, i, p, s, a), m = Jn(m, f, s, c, l, u, d, r, kn, j(Nr, n));
	}
	else m = L;
	return P(n ? Yr(m) : m);
}
function ta(e, t, n, r, i) {
	let a = ha(n.calendar, r.calendar), [o, s, c, l] = rn(t, i, 6), u = M(n), d = M(r), f = xt(d, u), p;
	if (f) if (o <= 6) p = ua(u, d, o, s, c, l);
	else {
		let t = e(a);
		p = la(t, n, r, f, o, i), p = Jn(p, d, o, s, c, l, t, n, M, Pr);
	}
	else p = L;
	return P(t ? Yr(p) : p);
}
function na(e, t, n, r, i) {
	let a = ha(n.calendar, r.calendar);
	return ia(t, (() => e(a)), n, r, ...rn(t, i, 6, 9, 6));
}
function ra(e, t, n, r, i) {
	let a = ha(n.calendar, r.calendar), o = rn(t, i, 9, 9, 8), s = e(a), c = Ir(s, n), l = Ir(s, r);
	return c.isoYear === l.isoYear && c.isoMonth === l.isoMonth && c.isoDay === l.isoDay ? P(L) : ia(t, (() => s), Ot(c), Ot(l), ...o, 8);
}
function ia(e, t, n, r, i, a, o, s, c = 6) {
	let l = M(n), u = M(r);
	if (l === void 0 || u === void 0) throw RangeError(js);
	let d;
	if (xt(u, l)) if (i === 6) d = ua(l, u, i, a, o, s);
	else {
		let e = t();
		d = e.N(n, r, i), a === c && o === 1 || (d = Jn(d, u, i, a, o, s, e, n, M, Fr));
	}
	else d = L;
	return P(e ? Yr(d) : d);
}
function aa(e, t, n, r) {
	let [i, a, o, s] = rn(e, r, 5, 5), c = Zn(ma(t, n), Wn(a, o), s), l = {
		...L,
		...ni(c, i)
	};
	return P(e ? Yr(l) : l);
}
function oa(e, t, n, r, i, a) {
	let o = xt(r.epochNanoseconds, n.epochNanoseconds);
	return o ? i < 6 ? da(n.epochNanoseconds, r.epochNanoseconds, i) : ca(t, e, n, r, o, i, a) : L;
}
function sa(e, t, n, r, i) {
	let a = M(t), o = M(n), s = xt(o, a);
	return s ? r <= 6 ? da(a, o, r) : la(e, t, n, s, r, i) : L;
}
function ca(e, t, n, r, i, a, o) {
	let [s, c, l] = ((e, t, n, r) => {
		function i() {
			return d = {
				...Rr(s, l++ * -r),
				...o
			}, f = Tr(e, d), xt(c, f) === -r;
		}
		let a = Hl(t, e), o = Le(Ic, a), s = Hl(n, e), c = n.epochNanoseconds, l = 0, u = ma(a, s), d, f;
		if (Math.sign(u) === -r && l++, i() && (r === -1 || i())) throw RangeError(xs);
		let p = Tt(bt(f, c));
		return [
			a,
			d,
			p
		];
	})(t, n, r, i);
	var u, d;
	return {
		...a === 6 ? (u = s, d = c, {
			...L,
			days: fa(u, d)
		}) : e.N(s, c, a, o),
		...ni(l)
	};
}
function la(e, t, n, r, i, a) {
	let [o, s, c] = ((e, t, n) => {
		let r = t, i = ma(e, t);
		return Math.sign(i) === -n && (r = Rr(t, -n), i += F * n), [
			e,
			r,
			i
		];
	})(t, n, r);
	return {
		...e.N(o, s, i, a),
		...ni(c)
	};
}
function ua(e, t, n, r, i, a) {
	return {
		...L,
		...ti(Yn(bt(e, t), r, i, a), n)
	};
}
function da(e, t, n) {
	return {
		...L,
		...ti(bt(e, t), n)
	};
}
function fa(e, t) {
	return pa(Pt(e), Pt(t));
}
function pa(e, t) {
	return Math.trunc((t - e) / Js);
}
function ma(e, t) {
	return jt(t) - jt(e);
}
function ha(e, t) {
	if (e !== t) throw RangeError(Cs);
	return e;
}
function ga(e) {
	return this.m(e)[0];
}
function _a(e) {
	return this.m(e)[1];
}
function va(e) {
	let [t] = this.v(e);
	return pa(this.p(t), Pt(e)) + 1;
}
function ya(e) {
	let t = uu.exec(e);
	if (!t) throw RangeError(_s(e));
	return [parseInt(t[1]), !!t[2]];
}
function ba(e, t) {
	return "M" + Gs(e) + (t ? "L" : "");
}
function xa(e, t, n) {
	return e + (t || n && e >= n ? 1 : 0);
}
function Sa(e, t) {
	return e - (t && e >= t ? 1 : 0);
}
function Ca(e, t) {
	return (t + e) * (Math.sign(t) || 1) || 0;
}
function wa(e) {
	return Cc[Ea(e)];
}
function Ta(e) {
	return Tc[Ea(e)];
}
function Ea(e) {
	return Ua(e.id || "iso8601");
}
function Da(e) {
	function t(e) {
		return ((e, t) => ({
			...Aa(e, t),
			o: e.month,
			day: parseInt(e.day)
		}))(Vt(n, e), r);
	}
	let n = fu(e), r = Ua(e);
	return {
		id: e,
		h: Oa(t),
		l: ka(t)
	};
}
function Oa(e) {
	return Oe(((t) => e(Pt(t))), WeakMap);
}
function ka(e) {
	let t = e(0).year - Qc;
	return Oe(((n) => {
		let r, i = Lt(n - t), a = 0, o = [], s = [];
		do
			i += 400 * Js;
		while ((r = e(i)).year <= n);
		do
			if (i += (1 - r.day) * Js, r.year === n && (o.push(i), s.push(r.o)), i -= Js, ++a > 100 || i < -Gc) throw RangeError(xs);
		while ((r = e(i)).year >= n);
		return {
			i: o.reverse(),
			u: Us(s.reverse())
		};
	}));
}
function Aa(e, t) {
	let n, r, i = ja(e);
	if (e.era) {
		let a = Cc[t], o = wc[t] || {};
		a !== void 0 && (n = t === "islamic" ? "ah" : e.era.normalize("NFD").toLowerCase().replace(/[^a-z0-9]/g, ""), n === "bc" || n === "b" ? n = "bce" : n === "ad" || n === "a" ? n = "ce" : n === "beforeroc" && (n = "broc"), n = o[n] || n, r = i, i = Ca(r, a[n] || 0));
	}
	return {
		era: n,
		eraYear: r,
		year: i
	};
}
function ja(e) {
	return parseInt(e.relatedYear || e.year);
}
function Ma(e) {
	let { year: t, o: n, day: r } = this.h(e), { u: i } = this.l(t);
	return [
		t,
		i[n] + 1,
		r
	];
}
function Na(e, t = 1, n = 1) {
	return this.l(e).i[t - 1] + (n - 1) * Js;
}
function Pa(e, t) {
	let n = Fa.call(this, e);
	return [Sa(t, n), n === t];
}
function Fa(e) {
	let t = Ba(this, e), n = Ba(this, e - 1), r = t.length;
	if (r > n.length) {
		let e = Ta(this);
		if (e < 0) return -e;
		for (let e = 0; e < r; e++) if (t[e] !== n[e]) return e + 1;
	}
}
function Ia(e) {
	return pa(Na.call(this, e), Na.call(this, e + 1));
}
function La(e, t) {
	let { i: n } = this.l(e), r = t + 1, i = n;
	return r > n.length && (r = 1, i = this.l(e + 1).i), pa(n[t - 1], i[r - 1]);
}
function Ra(e) {
	return this.l(e).i.length;
}
function za(e) {
	let t = this.h(e);
	return [t.era, t.eraYear];
}
function Ba(e, t) {
	return Object.keys(e.l(t).u);
}
function Va(e) {
	return Ha(Ec(e));
}
function Ha(e) {
	if ((e = e.toLowerCase()) !== "iso8601" && e !== xc) {
		let t = fu(e).resolvedOptions().calendar;
		if (Ua(e) !== Ua(t)) throw RangeError(Ss(e));
		return t;
	}
	return e;
}
function Ua(e) {
	return e === "islamicc" && (e = "islamic"), e.split("-")[0];
}
function Wa(e, t) {
	return (n) => n === "iso8601" ? e : n === xc || n === Sc ? Object.assign(Object.create(e), { id: n }) : Object.assign(Object.create(t), du(n));
}
function Ga(e, t, n, r) {
	let i = $a(n, r, gc, [], sc);
	if (i.timeZone !== void 0) {
		let r = n.F(i), a = to(i), o = e(i.timeZone);
		return {
			epochNanoseconds: wr(t(o), {
				...r,
				...a
			}, i.offset === void 0 ? void 0 : ui(i.offset)),
			timeZone: o
		};
	}
	return {
		...n.F(i),
		...Hc
	};
}
function Ka(e, t, n, r, i, a) {
	let o = $a(n, i, gc, ac, sc), s = e(o.timeZone), [c, l, u] = nn(a), d = n.F(o, gn(c)), f = to(o, c);
	return xn(wr(t(s), {
		...d,
		...f
	}, o.offset === void 0 ? void 0 : ui(o.offset), l, u), s, r);
}
function qa(e, t, n) {
	let r = $a(e, t, gc, [], nc), i = N(n);
	return Sn(kt({
		...e.F(r, gn(i)),
		...to(r, i)
	}));
}
function Ja(e, t, n, r = []) {
	let i = $a(e, t, gc, r);
	return e.F(i, n);
}
function Ya(e, t, n, r) {
	let i = $a(e, t, mc, r);
	return e.K(i, n);
}
function Xa(e, t, n, r) {
	let i = $a(e, n, gc, pc);
	return t && i.month !== void 0 && i.monthCode === void 0 && i.year === void 0 && (i.year = $c), e._(i, r);
}
function Za(e, t) {
	return En(to(eo(e, rc, [], 1), N(t)));
}
function Qa(e) {
	let t = eo(e, kc);
	return P(Qr({
		...L,
		...t
	}));
}
function $a(e, t, n, r = [], i = []) {
	return eo(t, [...e.fields(n), ...i].sort(), r);
}
function eo(e, t, n, r = !n) {
	let i = {}, a, o = 0;
	for (let r of t) {
		if (r === a) throw RangeError(os(r));
		if (r === "constructor" || r === "__proto__") throw RangeError(as(r));
		let t = e[r];
		if (t !== void 0) o = 1, yu[r] && (t = yu[r](t, r)), i[r] = t;
		else if (n) {
			if (n.includes(r)) throw TypeError(is(r));
			i[r] = yc[r];
		}
		a = r;
	}
	if (r && !o) throw TypeError(ss(t));
	return i;
}
function to(e, t) {
	return tn(bu({
		...yc,
		...e
	}), t);
}
function no(e, t, n, r, i) {
	let { calendar: a, timeZone: o } = n, s = e(a), c = t(o), l = [...s.fields(gc), ...oc].sort(), u = ((e) => {
		let t = Hl(e, R), n = _r(t.offsetNanoseconds), r = vu(e.calendar), [i, a, o] = r.v(t), [s, c] = r.q(i, a), l = ba(s, c);
		return {
			...xu(t),
			year: i,
			monthCode: l,
			day: o,
			offset: n
		};
	})(n), d = eo(r, l), f = s.k(u, d), p = {
		...u,
		...d
	}, [m, h, g] = nn(i, 2);
	return xn(wr(c, {
		...s.F(f, gn(m)),
		...tn(bu(p), m)
	}, ui(p.offset), h, g), o, a);
}
function ro(e, t, n, r) {
	let i = e(t.calendar), a = [...i.fields(gc), ...nc].sort(), o = {
		...ho(s = t),
		hour: s.isoHour,
		minute: s.isoMinute,
		second: s.isoSecond,
		millisecond: s.isoMillisecond,
		microsecond: s.isoMicrosecond,
		nanosecond: s.isoNanosecond
	};
	var s;
	let c = eo(n, a), l = N(r), u = i.k(o, c), d = {
		...o,
		...c
	};
	return Sn(kt({
		...i.F(u, gn(l)),
		...tn(bu(d), l)
	}));
}
function io(e, t, n, r) {
	let i = e(t.calendar), a = i.fields(gc).sort(), o = ho(t), s = eo(n, a), c = i.k(o, s);
	return i.F(c, r);
}
function ao(e, t, n, r) {
	let i = e(t.calendar), a = i.fields(mc).sort(), o = ((e) => {
		let t = vu(e.calendar), [n, r] = t.v(e), [i, a] = t.q(n, r);
		return {
			year: n,
			monthCode: ba(i, a)
		};
	})(t), s = eo(n, a), c = i.k(o, s);
	return i.K(c, r);
}
function oo(e, t, n, r) {
	let i = e(t.calendar), a = i.fields(gc).sort(), o = ((e) => {
		let t = vu(e.calendar), [n, r, i] = t.v(e), [a, o] = t.q(n, r);
		return {
			monthCode: ba(a, o),
			day: i
		};
	})(t), s = eo(n, a), c = i.k(o, s);
	return i._(c, r);
}
function so(e, t, n) {
	return En(((e, t, n) => to({
		...Le(rc, e),
		...eo(t, rc)
	}, N(n)))(e, t, n));
}
function co(e, t) {
	return P((n = e, r = t, Qr({
		...n,
		...eo(r, kc)
	})));
	var n, r;
}
function lo(e, t, n, r, i) {
	t = Le(n = e.fields(n), t), r = eo(r, i = e.fields(i), []);
	let a = e.k(t, r);
	return a = eo(a, [...n, ...i].sort(), []), e.F(a);
}
function uo(e, t) {
	let n = wa(e), r = wc[e.id || ""] || {}, { era: i, eraYear: a, year: o } = t;
	if (i !== void 0 || a !== void 0) {
		if (i === void 0 || a === void 0) throw TypeError(ps);
		if (!n) throw RangeError(fs);
		let e = n[r[i] || i];
		if (e === void 0) throw RangeError(hs(i));
		let t = Ca(a, e);
		if (o !== void 0 && o !== t) throw RangeError(ms);
		o = t;
	} else if (o === void 0) throw TypeError(gs(n));
	return o;
}
function fo(e, t, n, r) {
	let { month: i, monthCode: a } = t;
	if (a !== void 0) {
		let t = ((e, t, n, r) => {
			let i = e.L(n), [a, o] = ya(t), s = xa(a, o, i);
			if (o) {
				let t = Ta(e);
				if (t === void 0) throw RangeError(bs);
				if (t > 0) {
					if (s > t) throw RangeError(bs);
					if (i === void 0) {
						if (r === 1) throw RangeError(bs);
						s--;
					}
				} else if (s !== -t || i === void 0 && r === 1) throw RangeError(bs);
			}
			return s;
		})(e, a, n, r);
		if (i !== void 0 && i !== t) throw RangeError(vs);
		i = t, r = 1;
	} else if (i === void 0) throw TypeError(ys);
	return Ee("month", i, 1, e.B(n), r);
}
function po(e, t, n, r, i) {
	return Te(t, "day", 1, e.U(r, n), i);
}
function mo(e, t, n, r) {
	let i = 0, a = [];
	for (let e of n) t[e] === void 0 ? a.push(e) : i = 1;
	if (Object.assign(e, t), i) for (let t of r || a) delete e[t];
}
function ho(e) {
	let t = vu(e.calendar), [n, r, i] = t.v(e), [a, o] = t.q(n, r);
	return {
		year: n,
		monthCode: ba(a, o),
		day: i
	};
}
function go(e) {
	return bn(At(Ct(ft(e))));
}
function _o(e, t, n, r, i = bc) {
	return xn(At(Ct(ft(n))), t(r), e(i));
}
function vo(e, t, n, r, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0, u = bc) {
	return Sn(kt(Zt(Pe(mt, Ne(Rc, [
		t,
		n,
		r,
		i,
		a,
		o,
		s,
		c,
		l
	])))), e(u));
}
function yo(e, t, n, r, i = bc) {
	return Cn(Ot(Qt(Pe(mt, {
		isoYear: t,
		isoMonth: n,
		isoDay: r
	}))), e(i));
}
function bo(e, t, n, r = bc, i = 1) {
	let a = mt(t), o = mt(n), s = e(r);
	return wn(Dt(Qt({
		isoYear: a,
		isoMonth: o,
		isoDay: mt(i)
	})), s);
}
function xo(e, t, n, r = bc, i = $c) {
	let a = mt(t), o = mt(n), s = e(r);
	return Tn(Ot(Qt({
		isoYear: mt(i),
		isoMonth: a,
		isoDay: o
	})), s);
}
function So(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0) {
	return En(tn(Pe(mt, Ne(Ic, [
		e,
		t,
		n,
		r,
		i,
		a
	])), 1));
}
function Co(e = 0, t = 0, n = 0, r = 0, i = 0, a = 0, o = 0, s = 0, c = 0, l = 0) {
	return P(Qr(Pe(ht, Ne(I, [
		e,
		t,
		n,
		r,
		i,
		a,
		o,
		s,
		c,
		l
	]))));
}
function wo(e, t, n = bc) {
	return xn(e.epochNanoseconds, t, n);
}
function To(e) {
	return bn(e.epochNanoseconds);
}
function Eo(e, t) {
	return Sn(Hl(t, e));
}
function Do(e, t) {
	return Cn(Hl(t, e));
}
function Oo(e, t) {
	return En(Hl(t, e));
}
function ko(e, t, n, r) {
	return xn(At(((e, t, n, r) => {
		let i = ((e) => Sl(mn(e)))(r);
		return Tr(e(t), n, i);
	})(e, n, t, r)), n, t.calendar);
}
function Ao(e, t, n, r, i) {
	let a = e(i.timeZone), o = i.plainTime, s = o === void 0 ? void 0 : t(o), c = n(a), l;
	return l = s ? Tr(c, {
		...r,
		...s
	}) : Er(c, {
		...r,
		...Hc
	}), xn(l, a, r.calendar);
}
function jo(e, t = Hc) {
	return Sn(kt({
		...e,
		...t
	}));
}
function Mo(e, t, n) {
	return ((e, t) => {
		let n = $a(e, t, hc);
		return e.K(n, void 0);
	})(e(t.calendar), n);
}
function No(e, t, n) {
	return ((e, t) => {
		let n = $a(e, t, vc);
		return e._(n);
	})(e(t.calendar), n);
}
function Po(e, t, n, r) {
	return ((e, t, n) => lo(e, t, hc, ot(n), pc))(e(t.calendar), n, r);
}
function Fo(e, t, n, r) {
	return ((e, t, n) => lo(e, t, vc, ot(n), uc))(e(t.calendar), n, r);
}
function Io(e) {
	return bn(At(wt(ht(e), Zs)));
}
function Lo(e) {
	return bn(At(Ct(ft(e))));
}
function Ro(e, t, n) {
	let r = new Set(n);
	return (i, a) => {
		let o = n && Re(i, n);
		if (!Re(i = ((e, t) => {
			let n = {};
			for (let r in t) e.has(r) || (n[r] = t[r]);
			return n;
		})(r, i), e)) {
			if (a && o) throw TypeError("Invalid formatting options");
			i = {
				...t,
				...i
			};
		}
		return n && (i.timeZone = Ll, ["full", "long"].includes(i.J) && (i.J = "medium")), i;
	};
}
function zo(e, t = Bo, n = 0) {
	let [r, , , i] = e;
	return (a, o = Zu, ...s) => {
		let c = t(i && i(...s), a, o, r, n);
		return [c, ...Vo(e, c.resolvedOptions(), s)];
	};
}
function Bo(e, t, n, r, i) {
	if (n = r(n, i), e) {
		if (n.timeZone !== void 0) throw TypeError(Hs);
		n.timeZone = e;
	}
	return new Xc(t, n);
}
function Vo(e, t, n) {
	let [, r, i] = e;
	return n.map(((e) => (e.calendar && ((e, t, n) => {
		if ((n || e !== "iso8601") && e !== t) throw RangeError(Cs);
	})(e.calendar, t.calendar, i), r(e, t))));
}
function Ho(e, t, n) {
	let r = t.timeZone, i = e(r), a = {
		...Hl(t, i),
		...n || Hc
	}, o;
	return o = n ? wr(i, a, a.offsetNanoseconds, 2) : Er(i, a), xn(o, r, t.calendar);
}
function Uo(e, t = Hc) {
	return Sn(kt({
		...e,
		...t
	}));
}
function Wo(e, t) {
	return {
		...e,
		calendar: t
	};
}
function Go(e, t) {
	return {
		...e,
		timeZone: t
	};
}
function Ko(e) {
	let t = qo();
	return zt(t, e.R(t));
}
function qo() {
	return wt(Date.now(), Zs);
}
function Jo() {
	return od ||= new Xc().resolvedOptions().timeZone;
}
var Yo = (e, t) => `Non-integer ${e}: ${t}`, Xo = (e, t) => `Non-positive ${e}: ${t}`, Zo = (e, t) => `Non-finite ${e}: ${t}`, Qo = (e) => `Cannot convert bigint to ${e}`, $o = (e) => `Invalid bigint: ${e}`, es = "Cannot convert Symbol to string", ts = "Invalid object", ns = (e, t, n, r, i) => i ? ns(e, i[t], i[n], i[r]) : rs(e, t) + `; must be between ${n}-${r}`, rs = (e, t) => `Invalid ${e}: ${t}`, is = (e) => `Missing ${e}`, as = (e) => `Invalid field ${e}`, os = (e) => `Duplicate field ${e}`, ss = (e) => "No valid fields: " + e.join(), cs = "Invalid bag", ls = (e, t, n) => rs(e, t) + "; must be " + Object.keys(n).join(), us = "Cannot use valueOf", ds = "Invalid calling context", fs = "Forbidden era/eraYear", ps = "Mismatching era/eraYear", ms = "Mismatching year/eraYear", hs = (e) => `Invalid era: ${e}`, gs = (e) => "Missing year" + (e ? "/era/eraYear" : ""), _s = (e) => `Invalid monthCode: ${e}`, vs = "Mismatching month/monthCode", ys = "Missing month/monthCode", bs = "Invalid leap month", xs = "Invalid protocol results", Ss = (e) => rs("Calendar", e), Cs = "Mismatching Calendars", ws = (e) => rs("TimeZone", e), Ts = "Mismatching TimeZones", Es = "Forbidden ICU TimeZone", Ds = "Out-of-bounds offset", Os = "Out-of-bounds TimeZone gap", ks = "Invalid TimeZone offset", As = "Ambiguous offset", js = "Out-of-bounds date", Ms = "Out-of-bounds duration", Ns = "Cannot mix duration signs", Ps = "Missing relativeTo", Fs = "Cannot use large units", Is = "Required smallestUnit or largestUnit", Ls = "smallestUnit > largestUnit", Rs = (e) => `Cannot parse: ${e}`, zs = (e) => `Invalid substring: ${e}`, Bs = (e) => `Cannot format ${e}`, Vs = "Mismatching types for formatting", Hs = "Cannot specify TimeZone", Us = /* @__PURE__ */ j(Fe, ((e, t) => t)), Ws = /* @__PURE__ */ j(Fe, ((e, t, n) => n)), Gs = /* @__PURE__ */ j(Ue, 2), Ks = {
	nanosecond: 0,
	microsecond: 1,
	millisecond: 2,
	second: 3,
	minute: 4,
	hour: 5,
	day: 6,
	week: 7,
	month: 8,
	year: 9
}, qs = /* @__PURE__ */ Object.keys(Ks), Js = 864e5, Ys = 1e3, Xs = 1e3, Zs = 1e6, Qs = 1e9, $s = 6e10, ec = 36e11, F = 864e11, tc = [
	1,
	Xs,
	Zs,
	Qs,
	$s,
	ec,
	F
], nc = /* @__PURE__ */ qs.slice(0, 6), rc = /* @__PURE__ */ He(nc), ic = ["offset"], ac = ["timeZone"], oc = /* @__PURE__ */ nc.concat(ic), sc = /* @__PURE__ */ oc.concat(ac), cc = ["era", "eraYear"], lc = /* @__PURE__ */ cc.concat(["year"]), uc = ["year"], dc = ["monthCode"], fc = /* @__PURE__ */ ["month"].concat(dc), pc = ["day"], mc = /* @__PURE__ */ fc.concat(uc), hc = /* @__PURE__ */ dc.concat(uc), gc = /* @__PURE__ */ pc.concat(mc), _c = /* @__PURE__ */ pc.concat(fc), vc = /* @__PURE__ */ pc.concat(dc), yc = /* @__PURE__ */ Ws(nc, 0), bc = "iso8601", xc = "gregory", Sc = "japanese", Cc = {
	[xc]: {
		"gregory-inverse": -1,
		gregory: 0
	},
	[Sc]: {
		"japanese-inverse": -1,
		japanese: 0,
		meiji: 1867,
		taisho: 1911,
		showa: 1925,
		heisei: 1988,
		reiwa: 2018
	},
	ethiopic: {
		ethioaa: 0,
		ethiopic: 5500
	},
	coptic: {
		"coptic-inverse": -1,
		coptic: 0
	},
	roc: {
		"roc-inverse": -1,
		roc: 0
	},
	buddhist: { be: 0 },
	islamic: { ah: 0 },
	indian: { saka: 0 },
	persian: { ap: 0 }
}, wc = {
	[xc]: {
		bce: "gregory-inverse",
		ce: "gregory"
	},
	[Sc]: {
		bce: "japanese-inverse",
		ce: "japanese"
	},
	ethiopic: {
		era0: "ethioaa",
		era1: "ethiopic"
	},
	coptic: {
		era0: "coptic-inverse",
		era1: "coptic"
	},
	roc: {
		broc: "roc-inverse",
		minguo: "roc"
	}
}, Tc = {
	chinese: 13,
	dangi: 13,
	hebrew: -6
}, Ec = /* @__PURE__ */ j(st, "string"), Dc = /* @__PURE__ */ j(st, "boolean"), Oc = /* @__PURE__ */ j(st, "number"), I = /* @__PURE__ */ qs.map(((e) => e + "s")), kc = /* @__PURE__ */ He(I), Ac = /* @__PURE__ */ I.slice(0, 6), jc = /* @__PURE__ */ I.slice(6), Mc = /* @__PURE__ */ jc.slice(1), Nc = /* @__PURE__ */ Us(I), L = /* @__PURE__ */ Ws(I, 0), Pc = /* @__PURE__ */ Ws(Ac, 0), Fc = /* @__PURE__ */ j(Be, I), Ic = [
	"isoNanosecond",
	"isoMicrosecond",
	"isoMillisecond",
	"isoSecond",
	"isoMinute",
	"isoHour"
], Lc = [
	"isoDay",
	"isoMonth",
	"isoYear"
], Rc = /* @__PURE__ */ Ic.concat(Lc), zc = /* @__PURE__ */ He(Lc), Bc = /* @__PURE__ */ He(Ic), Vc = /* @__PURE__ */ He(Rc), Hc = /* @__PURE__ */ Ws(Bc, 0), Uc = /* @__PURE__ */ j(Be, Rc), Wc = 1e8, Gc = Wc * Js, Kc = [Wc, 0], qc = [-Wc, 0], Jc = 275760, Yc = -271821, Xc = Intl.DateTimeFormat, Zc = "en-GB", Qc = 1970, $c = 1972, el = 12, tl = /* @__PURE__ */ Lt(1868, 9, 8), nl = /* @__PURE__ */ Oe(Xt, WeakMap), rl = "smallestUnit", il = "unit", al = "roundingIncrement", ol = "fractionalSecondDigits", sl = "relativeTo", cl = "direction", ll = {
	constrain: 0,
	reject: 1
}, ul = /* @__PURE__ */ Object.keys(ll), dl = {
	compatible: 0,
	reject: 1,
	earlier: 2,
	later: 3
}, fl = {
	reject: 0,
	use: 1,
	prefer: 2,
	ignore: 3
}, pl = {
	auto: 0,
	never: 1,
	critical: 2,
	always: 3
}, ml = {
	auto: 0,
	never: 1,
	critical: 2
}, hl = {
	auto: 0,
	never: 1
}, gl = {
	floor: 0,
	halfFloor: 1,
	ceil: 2,
	halfCeil: 3,
	trunc: 4,
	halfTrunc: 5,
	expand: 6,
	halfExpand: 7,
	halfEven: 8
}, _l = {
	previous: -1,
	next: 1
}, vl = /* @__PURE__ */ j(_n, rl), yl = /* @__PURE__ */ j(_n, "largestUnit"), bl = /* @__PURE__ */ j(_n, il), xl = /* @__PURE__ */ j(vn, "overflow", ll), Sl = /* @__PURE__ */ j(vn, "disambiguation", dl), Cl = /* @__PURE__ */ j(vn, "offset", fl), wl = /* @__PURE__ */ j(vn, "calendarName", pl), Tl = /* @__PURE__ */ j(vn, "timeZoneName", ml), El = /* @__PURE__ */ j(vn, "offset", hl), Dl = /* @__PURE__ */ j(vn, "roundingMode", gl), Ol = "PlainYearMonth", kl = "PlainMonthDay", Al = "PlainDate", jl = "PlainDateTime", Ml = "PlainTime", Nl = "ZonedDateTime", Pl = "Instant", Fl = "Duration", Il = [
	Math.floor,
	(e) => Ze(e) ? Math.floor(e) : Math.round(e),
	Math.ceil,
	(e) => Ze(e) ? Math.ceil(e) : Math.round(e),
	Math.trunc,
	(e) => Ze(e) ? Math.trunc(e) || 0 : Math.round(e),
	(e) => e < 0 ? Math.floor(e) : Math.ceil(e),
	(e) => Math.sign(e) * Math.round(Math.abs(e)) || 0,
	(e) => Ze(e) ? (e = Math.trunc(e) || 0) + e % 2 : Math.round(e)
], Ll = "UTC", Rl = 5184e3, zl = /* @__PURE__ */ It(1847), Bl = /* @__PURE__ */ It(/* @__PURE__ */ (/* @__PURE__ */ new Date()).getUTCFullYear() + 10), Vl = /0+$/, Hl = /* @__PURE__ */ Oe(Cr, WeakMap), Ul = 2 ** 32 - 1, R = /* @__PURE__ */ Oe(((e) => {
	let t = Ri(e);
	return typeof t == "object" ? new Gl(t) : new Wl(t || 0);
})), Wl = class {
	constructor(e) {
		this.$ = e;
	}
	R() {
		return this.$;
	}
	I(e) {
		return ((e) => {
			let t = M({
				...e,
				...Hc
			});
			if (!t || Math.abs(t[0]) > 1e8) throw RangeError(js);
		})(e), [Ft(e, this.$)];
	}
	O() {}
}, Gl = class {
	constructor(e) {
		this.nn = ((e) => {
			function t(e) {
				let [t, s] = oi(Ge(e, a, o)), c = r(t), l = r(s);
				return c === l ? c : n(i(t, s), c, l, e);
			}
			function n(t, n, r, i) {
				let a, o;
				for (; (i === void 0 || (a = i < t[0] ? n : i >= t[1] ? r : void 0) === void 0) && (o = t[1] - t[0]);) {
					let n = t[0] + Math.floor(o / 2);
					e(n) === r ? t[1] = n : t[0] = n + 1;
				}
				return a;
			}
			let r = Oe(e), i = Oe(ai), a = zl, o = Bl;
			return {
				tn(e) {
					let n = t(e - 86400), r = t(e + 86400), i = e - n, a = e - r;
					if (n === r) return [i];
					let o = t(i);
					return o === t(a) ? [e - o] : n > r ? [i, a] : [];
				},
				rn: t,
				O(e, t) {
					let s = Ge(e, a, o), [c, l] = oi(s), u = Rl * t, d = t < 0 ? () => l > a || (a = s, 0) : () => c < o || (o = s, 0);
					for (; d();) {
						let a = r(c), o = r(l);
						if (a !== o) {
							let r = i(c, l);
							n(r, a, o);
							let s = r[0];
							if ((We(s, e) || 1) === t) return s;
						}
						c += u, l += u;
					}
				}
			};
		})(((e) => (t) => {
			let n = Vt(e, t * Ys);
			return It(ja(n), parseInt(n.month), parseInt(n.day), parseInt(n.hour), parseInt(n.minute), parseInt(n.second)) - t;
		})(e));
	}
	R(e) {
		return this.nn.rn(((e) => Nt(e)[0])(e)) * Qs;
	}
	I(e) {
		let [t, n] = [It((r = e).isoYear, r.isoMonth, r.isoDay, r.isoHour, r.isoMinute, r.isoSecond), r.isoMillisecond * Zs + r.isoMicrosecond * Xs + r.isoNanosecond];
		var r;
		return this.nn.tn(t).map(((e) => At(yt(wt(e, Qs), n))));
	}
	O(e, t) {
		let [n, r] = Nt(e), i = this.nn.O(n + (t > 0 || r ? 1 : 0), t);
		if (i !== void 0) return wt(i, Qs);
	}
}, Kl = "([+-])", ql = "(?:[.,](\\d{1,9}))?", Jl = `(?:(?:${Kl}(\\d{6}))|(\\d{4}))-?(\\d{2})`, Yl = "(\\d{2})(?::?(\\d{2})(?::?(\\d{2})" + ql + ")?)?", Xl = Kl + Yl, Zl = Jl + "-?(\\d{2})(?:[T ](\\d{2})(?::?(\\d{2})(?::?(\\d{2})(?:[.,](\\d{1,9}))?)?)?(Z|" + Xl + ")?)?", Ql = "\\[(!?)([^\\]]*)\\]", $l = `((?:${Ql}){0,9})`, eu = /* @__PURE__ */ Mi(Jl + $l), tu = /* @__PURE__ */ Mi("(?:--)?(\\d{2})-?(\\d{2})" + $l), nu = /* @__PURE__ */ Mi(Zl + $l), ru = /* @__PURE__ */ Mi("T?" + Yl + "(?:" + Xl + ")?" + $l), iu = /* @__PURE__ */ Mi(Xl), au = /* @__PURE__ */ new RegExp(Ql, "g"), ou = /* @__PURE__ */ Mi(`${Kl}?P(\\d+Y)?(\\d+M)?(\\d+W)?(\\d+D)?(?:T(?:(\\d+)${ql}H)?(?:(\\d+)${ql}M)?(?:(\\d+)${ql}S)?)?`), su = /* @__PURE__ */ Oe(((e) => new Xc(Zc, {
	timeZone: e,
	era: "short",
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
}))), cu = /^(AC|AE|AG|AR|AS|BE|BS|CA|CN|CS|CT|EA|EC|IE|IS|JS|MI|NE|NS|PL|PN|PR|PS|SS|VS)T$/, lu = /[^\w\/:+-]+/, uu = /^M(\d{2})(L?)$/, du = /* @__PURE__ */ Oe(Da), fu = /* @__PURE__ */ Oe(((e) => new Xc(Zc, {
	calendar: e,
	timeZone: Ll,
	era: "short",
	year: "numeric",
	month: "short",
	day: "numeric"
}))), pu = {
	P(e, t, n) {
		let r = N(n), i, { years: a, months: o, weeks: s, days: c } = t;
		if (c += ei(t, 5)[0], a || o) i = ((e, t, n, r, i) => {
			let [a, o, s] = e.v(t);
			if (n) {
				let [t, r] = e.q(a, o);
				a += n, o = xa(t, r, e.L(a)), o = Ee("month", o, 1, e.B(a), i);
			}
			return r && ([a, o] = e.un(a, o, r)), s = Ee("day", s, 1, e.U(a, o), i), e.p(a, o, s);
		})(this, e, a, o, r);
		else {
			if (!s && !c) return e;
			i = Pt(e);
		}
		if (i === void 0) throw RangeError(js);
		return i += (7 * s + c) * Js, Ot(Bt(i));
	},
	N(e, t, n) {
		if (n <= 7) {
			let r = 0, i = fa({
				...e,
				...Hc
			}, {
				...t,
				...Hc
			});
			return n === 7 && ([r, i] = Je(i, 7)), {
				...L,
				weeks: r,
				days: i
			};
		}
		let r = this.v(e), i = this.v(t), [a, o, s] = ((e, t, n, r, i, a, o) => {
			let s = i - t, c = a - n, l = o - r;
			if (s || c) {
				let u = Math.sign(s || c), d = e.U(i, a), f = 0;
				if (Math.sign(l) === -u) {
					let r = d;
					[i, a] = e.un(i, a, -u), s = i - t, c = a - n, d = e.U(i, a), f = u < 0 ? -r : d;
				}
				if (l = o - Math.min(r, d) + f, s) {
					let [r, o] = e.q(t, n), [l, d] = e.q(i, a);
					if (c = l - r || Number(d) - Number(o), Math.sign(c) === -u) {
						let n = u < 0 && -e.B(i);
						s = (i -= u) - t, c = a - xa(r, o, e.L(i)) + (n || e.B(i));
					}
				}
			}
			return [
				s,
				c,
				l
			];
		})(this, ...r, ...i);
		return n === 8 && (o += this.cn(a, r[0]), a = 0), {
			...L,
			years: a,
			months: o,
			days: s
		};
	},
	F(e, t) {
		let n = N(t), r = uo(this, e), i = fo(this, e, r, n), a = po(this, e, i, r, n);
		return Cn(Ot(this.V(r, i, a)), this.id || "iso8601");
	},
	K(e, t) {
		let n = N(t), r = uo(this, e), i = fo(this, e, r, n);
		return wn(Dt(this.V(r, i, 1)), this.id || "iso8601");
	},
	_(e, t) {
		let n = N(t), r, i, a, o = e.eraYear !== void 0 || e.year !== void 0 ? uo(this, e) : void 0, s = !this.id;
		if (o === void 0 && s && (o = $c), o !== void 0) {
			let t = fo(this, e, o, n);
			r = po(this, e, t, o, n);
			let s = this.L(o);
			i = Sa(t, s), a = t === s;
		} else {
			if (e.monthCode === void 0) throw TypeError(ys);
			if ([i, a] = ya(e.monthCode), this.id && this.id !== xc && this.id !== Sc) if (this.id && Ua(this.id) === "coptic" && n === 0) {
				let t = a || i !== 13 ? 30 : 6;
				r = e.day, r = Ge(r, 1, t);
			} else if (this.id && Ua(this.id) === "chinese" && n === 0) {
				let t = !a || i !== 1 && i !== 9 && i !== 10 && i !== 11 && i !== 12 ? 30 : 29;
				r = e.day, r = Ge(r, 1, t);
			} else r = e.day;
			else r = po(this, e, fo(this, e, $c, n), $c, n);
		}
		let c = this.G(i, a, r);
		if (!c) throw RangeError("Cannot guess year");
		let [l, u] = c;
		return Tn(Ot(this.V(l, u, r)), this.id || "iso8601");
	},
	fields(e) {
		return wa(this) && e.includes("year") ? [...e, ...cc] : e;
	},
	k(e, t) {
		let n = Object.assign(Object.create(null), e);
		return mo(n, t, fc), wa(this) && (mo(n, t, lc), this.id === Sc && mo(n, t, _c, cc)), n;
	},
	inLeapYear(e) {
		let [t] = this.v(e);
		return this.sn(t);
	},
	monthsInYear(e) {
		let [t] = this.v(e);
		return this.B(t);
	},
	daysInMonth(e) {
		let [t, n] = this.v(e);
		return this.U(t, n);
	},
	daysInYear(e) {
		let [t] = this.v(e);
		return this.fn(t);
	},
	dayOfYear: va,
	era(e) {
		return this.hn(e)[0];
	},
	eraYear(e) {
		return this.hn(e)[1];
	},
	monthCode(e) {
		let [t, n] = this.v(e), [r, i] = this.q(t, n);
		return ba(r, i);
	},
	dayOfWeek: Jt,
	daysInWeek() {
		return 7;
	}
}, mu = {
	v: Ht,
	hn: Yt,
	q: Ut
}, hu = /* @__PURE__ */ Object.assign({}, pu, /* @__PURE__ */ Object.assign({}, {
	dayOfYear: va,
	v: Ht,
	p: Lt
}, {
	weekOfYear: ga,
	yearOfWeek: _a,
	m(e) {
		function t(e) {
			return (7 - e < r ? 7 : 0) - e;
		}
		function n(e) {
			let n = Kt(f + e), r = e || 1;
			return u = (n + (t(qe(c + n * r, 7)) - l) * r) / 7;
		}
		let r = this.id ? 1 : 4, i = Jt(e), a = this.dayOfYear(e), o = qe(i - 1, 7), s = a - 1, c = qe(o - s, 7), l = t(c), u, d = Math.floor((s - l) / 7) + 1, f = e.isoYear;
		return d ? d > n(0) && (d = 1, f++) : (d = n(-1), f--), [
			d,
			f,
			u
		];
	}
}), {
	v: Ht,
	hn: Yt,
	q: Ut,
	G(e, t) {
		if (!t) return [$c, e];
	},
	sn: qt,
	L() {},
	B: Wt,
	cn: (e) => e * el,
	U: Gt,
	fn: Kt,
	V: (e, t, n) => ({
		isoYear: e,
		isoMonth: t,
		isoDay: n
	}),
	p: Lt,
	un: (e, t, n) => (e += Ye(n, el), (t += Xe(n, el)) < 1 ? (e--, t += el) : t > el && (e++, t -= el), [e, t]),
	year(e) {
		return e.isoYear;
	},
	month(e) {
		return e.isoMonth;
	},
	day: (e) => e.isoDay
}), gu = {
	v: Ma,
	hn: za,
	q: Pa
}, _u = /* @__PURE__ */ Object.assign({}, pu, {
	dayOfYear: va,
	v: Ma,
	p: Na,
	weekOfYear: ga,
	yearOfWeek: _a,
	m() {
		return [];
	}
}, {
	v: Ma,
	hn: za,
	q: Pa,
	G(e, t, n) {
		let r = this.id && Ua(this.id) === "chinese" ? ((e, t, n) => {
			if (t) switch (e) {
				case 1: return 1651;
				case 2: return n < 30 ? 1947 : 1765;
				case 3: return n < 30 ? 1966 : 1955;
				case 4: return n < 30 ? 1963 : 1944;
				case 5: return n < 30 ? 1971 : 1952;
				case 6: return n < 30 ? 1960 : 1941;
				case 7: return n < 30 ? 1968 : 1938;
				case 8: return n < 30 ? 1957 : 1718;
				case 9: return 1832;
				case 10: return 1870;
				case 11: return 1814;
				case 12: return 1890;
			}
			return 1972;
		})(e, t, n) : $c, [i, a, o] = Ma.call(this, {
			isoYear: r,
			isoMonth: el,
			isoDay: 31
		}), s = Fa.call(this, i), c = a === s;
		(We(e, Sa(a, s)) || We(Number(t), Number(c)) || We(n, o)) === 1 && i--;
		for (let r = 0; r < 100; r++) {
			let a = i - r, o = Fa.call(this, a), s = xa(e, t, o);
			if (t === (s === o) && n <= La.call(this, a, s)) return [a, s];
		}
	},
	sn(e) {
		let t = Ia.call(this, e);
		return t > Ia.call(this, e - 1) && t > Ia.call(this, e + 1);
	},
	L: Fa,
	B: Ra,
	cn(e, t) {
		let n = t + e, r = Math.sign(e), i = r < 0 ? -1 : 0, a = 0;
		for (let e = t; e !== n; e += r) a += Ra.call(this, e + i);
		return a;
	},
	U: La,
	fn: Ia,
	V(e, t, n) {
		return Bt(Na.call(this, e, t, n));
	},
	p: Na,
	un(e, t, n) {
		if (n) {
			if (t += n, !Number.isSafeInteger(t)) throw RangeError(js);
			if (n < 0) for (; t < 1;) t += Ra.call(this, --e);
			else {
				let n;
				for (; t > (n = Ra.call(this, e));) t -= n, e++;
			}
		}
		return [e, t];
	},
	year(e) {
		return this.h(e).year;
	},
	month(e) {
		let { year: t, o: n } = this.h(e), { u: r } = this.l(t);
		return r[n] + 1;
	},
	day(e) {
		return this.h(e).day;
	}
}), vu = /* @__PURE__ */ Wa(mu, gu), z = /* @__PURE__ */ Wa(hu, _u), yu = {
	era: dt,
	eraYear: mt,
	year: mt,
	month: gt,
	monthCode(e) {
		let t = dt(e);
		return ya(t), t;
	},
	day: gt,
	.../* @__PURE__ */ Ws(nc, mt),
	.../* @__PURE__ */ Ws(I, ht),
	offset(e) {
		let t = dt(e);
		return ui(t), t;
	}
}, bu = /* @__PURE__ */ j(Ie, nc, Ic), xu = /* @__PURE__ */ j(Ie, Ic, nc), Su = "numeric", Cu = ["timeZoneName"], wu = {
	month: Su,
	day: Su
}, Tu = {
	year: Su,
	month: Su
}, Eu = /* @__PURE__ */ Object.assign({}, Tu, { day: Su }), Du = {
	hour: Su,
	minute: Su,
	second: Su
}, Ou = /* @__PURE__ */ Object.assign({}, Eu, Du), ku = /* @__PURE__ */ Object.assign({}, Ou, { timeZoneName: "short" }), Au = /* @__PURE__ */ Object.keys(Tu), ju = /* @__PURE__ */ Object.keys(wu), Mu = /* @__PURE__ */ Object.keys(Eu), Nu = /* @__PURE__ */ Object.keys(Du), Pu = ["dateStyle"], Fu = /* @__PURE__ */ Au.concat(Pu), Iu = /* @__PURE__ */ ju.concat(Pu), Lu = /* @__PURE__ */ Mu.concat(Pu, ["weekday"]), Ru = /* @__PURE__ */ Nu.concat([
	"dayPeriod",
	"timeStyle",
	"fractionalSecondDigits"
]), zu = /* @__PURE__ */ Lu.concat(Ru), Bu = /* @__PURE__ */ Cu.concat(Ru), Vu = /* @__PURE__ */ Cu.concat(Lu), Hu = /* @__PURE__ */ Cu.concat(["day", "weekday"], Ru), Uu = /* @__PURE__ */ Cu.concat(["year", "weekday"], Ru), Wu = /* @__PURE__ */ Ro(zu, Ou), Gu = /* @__PURE__ */ Ro(zu, ku), Ku = /* @__PURE__ */ Ro(zu, Ou, Cu), qu = /* @__PURE__ */ Ro(Lu, Eu, Bu), Ju = /* @__PURE__ */ Ro(Ru, Du, Vu), Yu = /* @__PURE__ */ Ro(Fu, Tu, Hu), Xu = /* @__PURE__ */ Ro(Iu, wu, Uu), Zu = {}, Qu = new Xc(void 0, { calendar: bc }).resolvedOptions().calendar === bc, $u = [Wu, Dn], ed = [
	Gu,
	Dn,
	0,
	(e, t) => {
		let n = e.timeZone;
		if (t && t.timeZone !== n) throw RangeError(Ts);
		return n;
	}
], td = [Ku, Pt], nd = [qu, Pt], rd = [Ju, (e) => jt(e) / Zs], id = [
	Yu,
	Pt,
	Qu
], ad = [
	Xu,
	Pt,
	Qu
], od;
//#endregion
//#region ../../node_modules/temporal-polyfill/chunks/classApi.js
function sd(e, t, n, r, i) {
	function a(...e) {
		if (!(this instanceof a)) throw TypeError(ds);
		Md(this, t(...e));
	}
	function o(e, t) {
		return Object.defineProperties((function(...t) {
			return e.call(this, s(this), ...t);
		}), ke(t));
	}
	function s(t) {
		let n = jd(t);
		if (!n || n.branding !== e) throw TypeError(ds);
		return n;
	}
	return Object.defineProperties(a.prototype, {
		...je(Pe(o, n)),
		...Ae(Pe(o, r)),
		...Me("Temporal." + e)
	}), Object.defineProperties(a, {
		...Ae(i),
		...ke(e)
	}), [
		a,
		(e) => {
			let t = Object.create(a.prototype);
			return Md(t, e), t;
		},
		s
	];
}
function cd(e) {
	if (jd(e) || e.calendar !== void 0 || e.timeZone !== void 0) throw TypeError(cs);
	return e;
}
function ld(e) {
	return ud(e) || "iso8601";
}
function ud(e) {
	let { calendar: t } = e;
	if (t !== void 0) return dd(t);
}
function dd(e) {
	if (De(e)) {
		let { calendar: t } = jd(e) || {};
		if (!t) throw TypeError(Ss(e));
		return t;
	}
	return ((e) => Ha(vi(Ec(e))))(e);
}
function fd(e) {
	let t = {};
	for (let n in e) t[n] = (e) => {
		let { calendar: t } = e;
		return z(t)[n](e);
	};
	return t;
}
function pd() {
	throw TypeError(us);
}
function md(e) {
	if (De(e)) {
		let { timeZone: t } = jd(e) || {};
		if (!t) throw TypeError(ws(e));
		return t;
	}
	return ((e) => Ii(yi(Ec(e))))(e);
}
function B(e) {
	if (De(e)) {
		let t = jd(e);
		return t && t.branding === "Duration" ? t : Qa(e);
	}
	return _i(e);
}
function hd(e) {
	if (e !== void 0) {
		if (De(e)) {
			let t = jd(e) || {};
			switch (t.branding) {
				case Nl:
				case Al: return t;
				case jl: return Cn(t);
			}
			let n = ld(e);
			return {
				...Ga(md, R, z(n), e),
				calendar: n
			};
		}
		return ci(e);
	}
}
function gd(e, t) {
	if (De(e)) {
		let n = jd(e) || {};
		switch (n.branding) {
			case Ml: return N(t), n;
			case jl: return N(t), En(n);
			case Nl: return N(t), Oo(R, n);
		}
		return Za(e, t);
	}
	let n = gi(e);
	return N(t), n;
}
function _d(e) {
	return e === void 0 ? void 0 : gd(e);
}
function vd(e, t) {
	if (De(e)) {
		let n = jd(e) || {};
		switch (n.branding) {
			case jl: return N(t), n;
			case Al: return N(t), Sn({
				...n,
				...Hc
			});
			case Nl: return N(t), Eo(R, n);
		}
		return qa(z(ld(e)), e, t);
	}
	let n = di(e);
	return N(t), n;
}
function yd(e, t) {
	if (De(e)) {
		let n = jd(e);
		if (n && n.branding === "PlainMonthDay") return N(t), n;
		let r = ud(e);
		return Xa(z(r || "iso8601"), !r, e, t);
	}
	let n = hi(z, e);
	return N(t), n;
}
function bd(e, t) {
	if (De(e)) {
		let n = jd(e);
		return n && n.branding === "PlainYearMonth" ? (N(t), n) : Ya(z(ld(e)), e, t);
	}
	let n = pi(z, e);
	return N(t), n;
}
function xd(e, t) {
	if (De(e)) {
		let n = jd(e) || {};
		switch (n.branding) {
			case Al: return N(t), n;
			case jl: return N(t), Cn(n);
			case Nl: return N(t), Do(R, n);
		}
		return Ja(z(ld(e)), e, t);
	}
	let n = fi(e);
	return N(t), n;
}
function Sd(e, t) {
	if (De(e)) {
		let n = jd(e);
		if (n && n.branding === "ZonedDateTime") return nn(t), n;
		let r = ld(e);
		return Ka(md, R, z(r), r, e, t);
	}
	return li(e, t);
}
function Cd(e) {
	return Pe(((e) => (t) => e(wd(t))), e);
}
function wd(e) {
	return Hl(e, R);
}
function Td(e) {
	if (De(e)) {
		let t = jd(e);
		if (t) switch (t.branding) {
			case Pl: return t;
			case Nl: return bn(t.epochNanoseconds);
		}
	}
	return si(e);
}
function Ed() {
	function e(e, n) {
		return new t(e, n);
	}
	function t(e, t = Object.create(null)) {
		xf.set(this, ((e, t) => {
			let n = new Xc(e, t), r = n.resolvedOptions(), i = r.locale, a = Le(Object.keys(t), r), o = Oe(kd), s = (e, ...t) => {
				if (e) {
					if (t.length !== 2) throw TypeError(Vs);
					for (let e of t) if (e === void 0) throw TypeError(Vs);
				}
				e || t[0] !== void 0 || (t = []);
				let r = t.map(((e) => jd(e) || Number(e))), s, c = 0;
				for (let e of r) {
					let t = typeof e == "object" ? e.branding : void 0;
					if (c++ && t !== s) throw TypeError(Vs);
					s = t;
				}
				return s ? o(s)(i, a, ...r) : [n, ...r];
			};
			return s.X = n, s;
		})(e, t));
	}
	let n = Xc.prototype, r = Object.getOwnPropertyDescriptors(n), i = Object.getOwnPropertyDescriptors(Xc);
	for (let t in r) {
		let n = r[t], i = t.startsWith("format") && Dd(t);
		typeof n.value == "function" ? n.value = t === "constructor" ? e : i || Od(t) : i && (n.get = function() {
			if (!xf.has(this)) throw TypeError("Invalid calling context");
			return (...e) => i.apply(this, e);
		}, Object.defineProperties(n.get, ke(`get ${t}`)));
	}
	return i.prototype.value = t.prototype = Object.create({}, r), Object.defineProperties(e, i), e;
}
function Dd(e) {
	return Object.defineProperties((function(...t) {
		let [n, ...r] = xf.get(this)(e.includes("Range"), ...t);
		return n[e](...r);
	}), ke(e));
}
function Od(e) {
	return Object.defineProperties((function(...t) {
		return xf.get(this).X[e](...t);
	}), ke(e));
}
function kd(e) {
	let t = Gd[e];
	if (!t) throw TypeError(Bs(e));
	return zo(t, Oe(Bo), 1);
}
var Ad = /* @__PURE__ */ new WeakMap(), jd = /* @__PURE__ */ Ad.get.bind(Ad), Md = /* @__PURE__ */ Ad.set.bind(Ad), Nd = {
	era: et,
	eraYear: nt,
	year: it,
	month: rt,
	daysInMonth: rt,
	daysInYear: rt,
	inLeapYear: Dc,
	monthsInYear: rt
}, Pd = { monthCode: Ec }, Fd = { day: rt }, Id = /* @__PURE__ */ fd(/* @__PURE__ */ Object.assign({}, Nd, Pd, Fd, {
	dayOfWeek: rt,
	dayOfYear: rt,
	weekOfYear: tt,
	yearOfWeek: nt,
	daysInWeek: rt
})), Ld = /* @__PURE__ */ fd({
	...Nd,
	...Pd
}), Rd = /* @__PURE__ */ fd({
	...Pd,
	...Fd
}), zd = { calendarId: (e) => e.calendar }, Bd = /* @__PURE__ */ Fe(((e) => (t) => t[e]), I.concat("sign")), Vd = /* @__PURE__ */ Fe(((e, t) => (e) => e[Ic[t]]), nc), Hd = {
	epochMilliseconds: Dn,
	epochNanoseconds: On
}, [Ud, V, Wd] = sd(Fl, Co, {
	...Bd,
	blank: Xr
}, {
	with: (e, t) => V(co(e, t)),
	negated: (e) => V(Jr(e)),
	abs: (e) => V(qr(e)),
	add: (e, t, n) => V(Gr(hd, z, R, 0, e, B(t), n)),
	subtract: (e, t, n) => V(Gr(hd, z, R, 1, e, B(t), n)),
	round: (e, t) => V(Kr(hd, z, R, e, t)),
	total: (e, t) => An(hd, z, R, e, t),
	toLocaleString(e, t, n) {
		return Intl.DurationFormat ? new Intl.DurationFormat(t, n).format(this) : lr(e);
	},
	toString: lr,
	toJSON: (e) => lr(e),
	valueOf: pd
}, {
	from: (e) => V(B(e)),
	compare: (e, t, n) => Vi(hd, z, R, B(e), B(t), n)
}), Gd = {
	Instant: $u,
	PlainDateTime: td,
	PlainDate: nd,
	PlainTime: rd,
	PlainYearMonth: id,
	PlainMonthDay: ad
}, Kd = /* @__PURE__ */ zo($u), qd = /* @__PURE__ */ zo(ed), Jd = /* @__PURE__ */ zo(td), Yd = /* @__PURE__ */ zo(nd), Xd = /* @__PURE__ */ zo(rd), Zd = /* @__PURE__ */ zo(id), Qd = /* @__PURE__ */ zo(ad), [$d, ef] = sd(Ml, So, Vd, {
	with(e, t, n) {
		return ef(so(this, cd(t), n));
	},
	add: (e, t) => ef(Mr(0, e, B(t))),
	subtract: (e, t) => ef(Mr(1, e, B(t))),
	until: (e, t, n) => V(aa(0, e, gd(t), n)),
	since: (e, t, n) => V(aa(1, e, gd(t), n)),
	round: (e, t) => ef(Ln(e, t)),
	equals: (e, t) => Zi(e, gd(t)),
	toLocaleString(e, t, n) {
		let [r, i] = Xd(t, n, e);
		return r.format(i);
	},
	toString: cr,
	toJSON: (e) => cr(e),
	valueOf: pd
}, {
	from: (e, t) => ef(gd(e, t)),
	compare: (e, t) => Wi(gd(e), gd(t))
}), [tf, nf] = sd(jl, j(vo, Va), {
	...zd,
	...Id,
	...Vd
}, {
	with: (e, t, n) => nf(ro(z, e, cd(t), n)),
	withCalendar: (e, t) => nf(Wo(e, dd(t))),
	withPlainTime: (e, t) => nf(Uo(e, _d(t))),
	add: (e, t, n) => nf(kr(z, 0, e, B(t), n)),
	subtract: (e, t, n) => nf(kr(z, 1, e, B(t), n)),
	until: (e, t, n) => V(ta(z, 0, e, vd(t), n)),
	since: (e, t, n) => V(ta(z, 1, e, vd(t), n)),
	round: (e, t) => nf(In(e, t)),
	equals: (e, t) => qi(e, vd(t)),
	toZonedDateTime: (e, t, n) => mf(ko(R, e, md(t), n)),
	toPlainDate: (e) => df(Cn(e)),
	toPlainTime: (e) => ef(En(e)),
	toLocaleString(e, t, n) {
		let [r, i] = Jd(t, n, e);
		return r.format(i);
	},
	toString: ir,
	toJSON: (e) => ir(e),
	valueOf: pd
}, {
	from: (e, t) => nf(vd(e, t)),
	compare: (e, t) => Hi(vd(e), vd(t))
}), [rf, af, of] = sd(kl, j(xo, Va), {
	...zd,
	...Rd
}, {
	with: (e, t, n) => af(oo(z, e, cd(t), n)),
	equals: (e, t) => Xi(e, yd(t)),
	toPlainDate(e, t) {
		return df(Fo(z, e, this, t));
	},
	toLocaleString(e, t, n) {
		let [r, i] = Qd(t, n, e);
		return r.format(i);
	},
	toString: sr,
	toJSON: (e) => sr(e),
	valueOf: pd
}, { from: (e, t) => af(yd(e, t)) }), [sf, cf, lf] = sd(Ol, j(bo, Va), {
	...zd,
	...Ld
}, {
	with: (e, t, n) => cf(ao(z, e, cd(t), n)),
	add: (e, t, n) => cf(jr(z, 0, e, B(t), n)),
	subtract: (e, t, n) => cf(jr(z, 1, e, B(t), n)),
	until: (e, t, n) => V(ra(z, 0, e, bd(t), n)),
	since: (e, t, n) => V(ra(z, 1, e, bd(t), n)),
	equals: (e, t) => Yi(e, bd(t)),
	toPlainDate(e, t) {
		return df(Po(z, e, this, t));
	},
	toLocaleString(e, t, n) {
		let [r, i] = Zd(t, n, e);
		return r.format(i);
	},
	toString: or,
	toJSON: (e) => or(e),
	valueOf: pd
}, {
	from: (e, t) => cf(bd(e, t)),
	compare: (e, t) => Ui(bd(e), bd(t))
}), [uf, df, ff] = sd(Al, j(yo, Va), {
	...zd,
	...Id
}, {
	with: (e, t, n) => df(io(z, e, cd(t), n)),
	withCalendar: (e, t) => df(Wo(e, dd(t))),
	add: (e, t, n) => df(Ar(z, 0, e, B(t), n)),
	subtract: (e, t, n) => df(Ar(z, 1, e, B(t), n)),
	until: (e, t, n) => V(na(z, 0, e, xd(t), n)),
	since: (e, t, n) => V(na(z, 1, e, xd(t), n)),
	equals: (e, t) => Ji(e, xd(t)),
	toZonedDateTime(e, t) {
		return mf(Ao(md, gd, R, e, De(t) ? t : { timeZone: t }));
	},
	toPlainDateTime: (e, t) => nf(jo(e, _d(t))),
	toPlainYearMonth(e) {
		return cf(Mo(z, e, this));
	},
	toPlainMonthDay(e) {
		return af(No(z, e, this));
	},
	toLocaleString(e, t, n) {
		let [r, i] = Yd(t, n, e);
		return r.format(i);
	},
	toString: ar,
	toJSON: (e) => ar(e),
	valueOf: pd
}, {
	from: (e, t) => df(xd(e, t)),
	compare: (e, t) => Ui(xd(e), xd(t))
}), [pf, mf] = sd(Nl, j(_o, Va, Fi), {
	...Hd,
	...zd,
	...Cd(Id),
	...Cd(Vd),
	offset: (e) => _r(wd(e).offsetNanoseconds),
	offsetNanoseconds: (e) => wd(e).offsetNanoseconds,
	timeZoneId: (e) => e.timeZone,
	hoursInDay: (e) => Rn(R, e)
}, {
	with: (e, t, n) => mf(no(z, R, e, cd(t), n)),
	withCalendar: (e, t) => mf(Wo(e, dd(t))),
	withTimeZone: (e, t) => mf(Go(e, md(t))),
	withPlainTime: (e, t) => mf(Ho(R, e, _d(t))),
	add: (e, t, n) => mf(Or(z, R, 0, e, B(t), n)),
	subtract: (e, t, n) => mf(Or(z, R, 1, e, B(t), n)),
	until: (e, t, n) => V(P(ea(z, R, 0, e, Sd(t), n))),
	since: (e, t, n) => V(P(ea(z, R, 1, e, Sd(t), n))),
	round: (e, t) => mf(Fn(R, e, t)),
	startOfDay: (e) => mf(zn(R, e)),
	equals: (e, t) => Ki(e, Sd(t)),
	toInstant: (e) => gf(To(e)),
	toPlainDateTime: (e) => nf(Eo(R, e)),
	toPlainDate: (e) => df(Do(R, e)),
	toPlainTime: (e) => ef(Oo(R, e)),
	toLocaleString(e, t, n = {}) {
		let [r, i] = qd(t, n, e);
		return r.format(i);
	},
	toString: (e, t) => rr(R, e, t),
	toJSON: (e) => rr(R, e),
	valueOf: pd,
	getTimeZoneTransition(e, t) {
		let { timeZone: n, epochNanoseconds: r } = e, i = cn(t), a = R(n).O(r, i);
		return a ? mf({
			...e,
			epochNanoseconds: a
		}) : null;
	}
}, {
	from: (e, t) => mf(Sd(e, t)),
	compare: (e, t) => Bi(Sd(e), Sd(t))
}), [hf, gf, _f] = sd(Pl, go, Hd, {
	add: (e, t) => gf(Dr(0, e, B(t))),
	subtract: (e, t) => gf(Dr(1, e, B(t))),
	until: (e, t, n) => V($i(0, e, Td(t), n)),
	since: (e, t, n) => V($i(1, e, Td(t), n)),
	round: (e, t) => gf(Pn(e, t)),
	equals: (e, t) => Gi(e, Td(t)),
	toZonedDateTimeISO: (e, t) => mf(wo(e, md(t))),
	toLocaleString(e, t, n) {
		let [r, i] = Kd(t, n, e);
		return r.format(i);
	},
	toString: (e, t) => nr(md, R, e, t),
	toJSON: (e) => nr(md, R, e),
	valueOf: pd
}, {
	from: (e) => gf(Td(e)),
	fromEpochMilliseconds: (e) => gf(Io(e)),
	fromEpochNanoseconds: (e) => gf(Lo(e)),
	compare: (e, t) => zi(Td(e), Td(t))
}), vf = /* @__PURE__ */ Object.defineProperties({}, {
	...Me("Temporal.Now"),
	...Ae({
		timeZoneId: () => Jo(),
		instant: () => gf(bn(qo())),
		zonedDateTimeISO: (e = Jo()) => mf(xn(qo(), md(e), bc)),
		plainDateTimeISO: (e = Jo()) => nf(Sn(Ko(R(md(e))), bc)),
		plainDateISO: (e = Jo()) => df(Cn(Ko(R(md(e))), bc)),
		plainTimeISO: (e = Jo()) => ef(En(Ko(R(md(e)))))
	})
}), yf = /* @__PURE__ */ Object.defineProperties({}, {
	...Me("Temporal"),
	...Ae({
		PlainYearMonth: sf,
		PlainMonthDay: rf,
		PlainDate: uf,
		PlainTime: $d,
		PlainDateTime: tf,
		ZonedDateTime: pf,
		Instant: hf,
		Duration: Ud,
		Now: vf
	})
}), bf = /* @__PURE__ */ Ed(), xf = /* @__PURE__ */ new WeakMap();
Ae({ DateTimeFormat: bf });
//#endregion
//#region src/core/utils/DateUtils.ts
var H = /* @__PURE__ */ we((/* @__PURE__ */ A(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))(), 1);
function Sf(e) {
	let t = e < 0;
	e = Math.abs(e);
	let n = Math.floor(e / 3600).toFixed(0).padStart(2, "0"), r = Math.floor(e % 3600 / 60).toFixed(0).padStart(2, "0"), i = Math.floor(e % 3600 % 60).toFixed(0).padStart(2, "0"), a = "";
	return n !== "00" && (a += `${n}:`), a += `${r}:${i}`, t && (a = "-" + a), a;
}
function Cf(e) {
	return `${`${e.getFullYear()}`.padStart(4, "0")}-${`${e.getMonth() + 1}`.padStart(2, "0")}-${`${e.getDate()}`.padStart(2, "0")}`;
}
//#endregion
//#region src/audio/Clock/Clock.tsx
function wf({ seconds: e, className: n, ...r }) {
	let i = u(() => Math.floor(e), [e]), a = u(() => Tf(i), [i]);
	return /* @__PURE__ */ t.createElement("time", {
		dateTime: a,
		className: (0, H.default)("mx_Clock", n),
		...r
	}, Sf(e));
}
function Tf(e) {
	if (!isNaN(e)) return new yf.Duration(0, 0, 0, 0, 0, 0, Math.round(e)).round({
		smallestUnit: "seconds",
		largestUnit: "hours"
	}).toString();
}
//#endregion
//#region ../../node_modules/react/cjs/react-jsx-runtime.production.js
var Ef = /* @__PURE__ */ A(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), Df = /* @__PURE__ */ A(((t, n) => {
	n.exports = { ...e };
})), Of = /* @__PURE__ */ A(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === te ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case _: return "Fragment";
				case y: return "Profiler";
				case v: return "StrictMode";
				case C: return "Suspense";
				case w: return "SuspenseList";
				case ee: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case g: return "Portal";
				case x: return e.displayName || "Context";
				case b: return (e._context.displayName || "Context") + ".Consumer";
				case S:
					var n = e.render;
					return e = e.displayName, e ||= (e = n.displayName || n.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case T: return n = e.displayName || null, n === null ? t(e.type) || "Memo" : n;
				case E:
					n = e._payload, e = e._init;
					try {
						return t(e(n));
					} catch {}
			}
			return null;
		}
		function n(e) {
			return "" + e;
		}
		function r(e) {
			try {
				n(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var r = t.error, i = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return r.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", i), n(e);
			}
		}
		function i(e) {
			if (e === _) return "<>";
			if (typeof e == "object" && e && e.$$typeof === E) return "<...>";
			try {
				var n = t(e);
				return n ? "<" + n + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function a() {
			var e = ne.A;
			return e === null ? null : e.getOwner();
		}
		function o() {
			return Error("react-stack-top-frame");
		}
		function s(e) {
			if (D.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function c(e, t) {
			function n() {
				ie || (ie = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function l() {
			var e = t(this.type);
			return ae[e] || (ae[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function u(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: h,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: l
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function d(e, n, i, o, l, d) {
			var p = n.children;
			if (p !== void 0) if (o) if (re(p)) {
				for (o = 0; o < p.length; o++) f(p[o]);
				Object.freeze && Object.freeze(p);
			} else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
			else f(p);
			if (D.call(n, "key")) {
				p = t(e);
				var m = Object.keys(n).filter(function(e) {
					return e !== "key";
				});
				o = 0 < m.length ? "{key: someKey, " + m.join(": ..., ") + ": ...}" : "{key: someKey}", se[p + o] || (m = 0 < m.length ? "{" + m.join(": ..., ") + ": ...}" : "{}", console.error("A props object containing a \"key\" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />", o, p, m, p), se[p + o] = !0);
			}
			if (p = null, i !== void 0 && (r(i), p = "" + i), s(n) && (r(n.key), p = "" + n.key), "key" in n) for (var h in i = {}, n) h !== "key" && (i[h] = n[h]);
			else i = n;
			return p && c(i, typeof e == "function" ? e.displayName || e.name || "Unknown" : e), u(e, p, i, a(), l, d);
		}
		function f(e) {
			p(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === E && (e._payload.status === "fulfilled" ? p(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function p(e) {
			return typeof e == "object" && !!e && e.$$typeof === h;
		}
		var m = Df(), h = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), _ = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), y = Symbol.for("react.profiler"), b = Symbol.for("react.consumer"), x = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), ee = Symbol.for("react.activity"), te = Symbol.for("react.client.reference"), ne = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, D = Object.prototype.hasOwnProperty, re = Array.isArray, O = console.createTask ? console.createTask : function() {
			return null;
		};
		m = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var ie, ae = {}, k = m.react_stack_bottom_frame.bind(m, o)(), oe = O(i(o)), se = {};
		e.Fragment = _, e.jsx = function(e, t, n) {
			var r = 1e4 > ne.recentlyCreatedOwnerStacks++;
			return d(e, t, n, !1, r ? Error("react-stack-top-frame") : k, r ? O(i(e)) : oe);
		}, e.jsxs = function(e, t, n) {
			var r = 1e4 > ne.recentlyCreatedOwnerStacks++;
			return d(e, t, n, !0, r ? Error("react-stack-top-frame") : k, r ? O(i(e)) : oe);
		};
	})();
})), U = (/* @__PURE__ */ A(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Ef() : t.exports = Of();
})))();
function kf(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m8.98 4.677 9.921 5.58c1.36.764 1.36 2.722 0 3.486l-9.92 5.58C7.647 20.073 6 19.11 6 17.58V6.42c0-1.53 1.647-2.493 2.98-1.743" })
	});
}
kf.displayName = "PlaySolidIcon";
var Af = i(kf);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/pause-solid.js
function jf(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M8 4a2 2 0 0 0-2 2v12a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2m8 0a2 2 0 0 0-2 2v12a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2" })
	});
}
jf.displayName = "PauseSolidIcon";
var Mf = i(jf), Nf = { button: "_button_yfjla_8" }, Pf = r(null);
Pf.displayName = "I18nContext";
function W() {
	let e = s(Pf);
	if (!e) throw Error("useI18n must be used within an I18nContext.Provider");
	return e;
}
//#endregion
//#region src/audio/PlayPauseButton/PlayPauseButton.tsx
function Ff({ disabled: e = !1, playing: n = !1, togglePlay: r, ...i }) {
	let { translate: a } = W(), o = a(n ? "action|pause" : "action|play");
	return /* @__PURE__ */ t.createElement(S, {
		size: "32px",
		"aria-label": o,
		tooltip: o,
		onClick: r,
		className: Nf.button,
		disabled: e,
		...i
	}, n ? /* @__PURE__ */ t.createElement(Mf, null) : /* @__PURE__ */ t.createElement(Af, null));
}
//#endregion
//#region node_modules/lodash/_freeGlobal.js
var If = typeof global == "object" && global && global.Object === Object && global, Lf = typeof self == "object" && self && self.Object === Object && self, Rf = If || Lf || Function("return this")(), zf = Rf.Symbol, Bf = Object.prototype, Vf = Bf.hasOwnProperty, Hf = Bf.toString, Uf = zf ? zf.toStringTag : void 0;
function Wf(e) {
	var t = Vf.call(e, Uf), n = e[Uf];
	try {
		e[Uf] = void 0;
		var r = !0;
	} catch {}
	var i = Hf.call(e);
	return r && (t ? e[Uf] = n : delete e[Uf]), i;
}
//#endregion
//#region node_modules/lodash/_objectToString.js
var Gf = Object.prototype.toString;
function Kf(e) {
	return Gf.call(e);
}
//#endregion
//#region node_modules/lodash/_baseGetTag.js
var qf = "[object Null]", Jf = "[object Undefined]", Yf = zf ? zf.toStringTag : void 0;
function Xf(e) {
	return e == null ? e === void 0 ? Jf : qf : Yf && Yf in Object(e) ? Wf(e) : Kf(e);
}
//#endregion
//#region node_modules/lodash/isObjectLike.js
function Zf(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region node_modules/lodash/isSymbol.js
var Qf = "[object Symbol]";
function $f(e) {
	return typeof e == "symbol" || Zf(e) && Xf(e) == Qf;
}
//#endregion
//#region node_modules/lodash/_arrayMap.js
function ep(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region node_modules/lodash/isArray.js
var tp = Array.isArray, np = Infinity, rp = zf ? zf.prototype : void 0, ip = rp ? rp.toString : void 0;
function ap(e) {
	if (typeof e == "string") return e;
	if (tp(e)) return ep(e, ap) + "";
	if ($f(e)) return ip ? ip.call(e) : "";
	var t = e + "";
	return t == "0" && 1 / e == -np ? "-0" : t;
}
//#endregion
//#region node_modules/lodash/_trimmedEndIndex.js
var op = /\s/;
function sp(e) {
	for (var t = e.length; t-- && op.test(e.charAt(t)););
	return t;
}
//#endregion
//#region node_modules/lodash/_baseTrim.js
var cp = /^\s+/;
function lp(e) {
	return e && e.slice(0, sp(e) + 1).replace(cp, "");
}
//#endregion
//#region node_modules/lodash/isObject.js
function up(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region node_modules/lodash/toNumber.js
var dp = NaN, fp = /^[-+]0x[0-9a-f]+$/i, pp = /^0b[01]+$/i, mp = /^0o[0-7]+$/i, hp = parseInt;
function gp(e) {
	if (typeof e == "number") return e;
	if ($f(e)) return dp;
	if (up(e)) {
		var t = typeof e.valueOf == "function" ? e.valueOf() : e;
		e = up(t) ? t + "" : t;
	}
	if (typeof e != "string") return e === 0 ? e : +e;
	e = lp(e);
	var n = pp.test(e);
	return n || mp.test(e) ? hp(e.slice(2), n ? 2 : 8) : fp.test(e) ? dp : +e;
}
//#endregion
//#region node_modules/lodash/identity.js
function _p(e) {
	return e;
}
//#endregion
//#region node_modules/lodash/isFunction.js
var vp = "[object AsyncFunction]", yp = "[object Function]", bp = "[object GeneratorFunction]", xp = "[object Proxy]";
function Sp(e) {
	if (!up(e)) return !1;
	var t = Xf(e);
	return t == yp || t == bp || t == vp || t == xp;
}
//#endregion
//#region node_modules/lodash/_coreJsData.js
var Cp = Rf["__core-js_shared__"], wp = function() {
	var e = /[^.]+$/.exec(Cp && Cp.keys && Cp.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function Tp(e) {
	return !!wp && wp in e;
}
//#endregion
//#region node_modules/lodash/_toSource.js
var Ep = Function.prototype.toString;
function Dp(e) {
	if (e != null) {
		try {
			return Ep.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region node_modules/lodash/_baseIsNative.js
var Op = /[\\^$.*+?()[\]{}|]/g, kp = /^\[object .+?Constructor\]$/, Ap = Function.prototype, jp = Object.prototype, Mp = Ap.toString, Np = jp.hasOwnProperty, Pp = RegExp("^" + Mp.call(Np).replace(Op, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Fp(e) {
	return !up(e) || Tp(e) ? !1 : (Sp(e) ? Pp : kp).test(Dp(e));
}
//#endregion
//#region node_modules/lodash/_getValue.js
function Ip(e, t) {
	return e?.[t];
}
//#endregion
//#region node_modules/lodash/_getNative.js
function Lp(e, t) {
	var n = Ip(e, t);
	return Fp(n) ? n : void 0;
}
//#endregion
//#region node_modules/lodash/_WeakMap.js
var Rp = Lp(Rf, "WeakMap"), zp = Object.create, Bp = function() {
	function e() {}
	return function(t) {
		if (!up(t)) return {};
		if (zp) return zp(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region node_modules/lodash/_apply.js
function Vp(e, t, n) {
	switch (n.length) {
		case 0: return e.call(t);
		case 1: return e.call(t, n[0]);
		case 2: return e.call(t, n[0], n[1]);
		case 3: return e.call(t, n[0], n[1], n[2]);
	}
	return e.apply(t, n);
}
//#endregion
//#region node_modules/lodash/_copyArray.js
function Hp(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region node_modules/lodash/_shortOut.js
var Up = 800, Wp = 16, Gp = Date.now;
function Kp(e) {
	var t = 0, n = 0;
	return function() {
		var r = Gp(), i = Wp - (r - n);
		if (n = r, i > 0) {
			if (++t >= Up) return arguments[0];
		} else t = 0;
		return e.apply(void 0, arguments);
	};
}
//#endregion
//#region node_modules/lodash/constant.js
function qp(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region node_modules/lodash/_defineProperty.js
var Jp = function() {
	try {
		var e = Lp(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}(), Yp = Kp(Jp ? function(e, t) {
	return Jp(e, "toString", {
		configurable: !0,
		enumerable: !1,
		value: qp(t),
		writable: !0
	});
} : _p);
//#endregion
//#region node_modules/lodash/_arrayEach.js
function Xp(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region node_modules/lodash/_isIndex.js
var Zp = 9007199254740991, Qp = /^(?:0|[1-9]\d*)$/;
function $p(e, t) {
	var n = typeof e;
	return t ??= Zp, !!t && (n == "number" || n != "symbol" && Qp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region node_modules/lodash/_baseAssignValue.js
function em(e, t, n) {
	t == "__proto__" && Jp ? Jp(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region node_modules/lodash/eq.js
function tm(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region node_modules/lodash/_assignValue.js
var nm = Object.prototype.hasOwnProperty;
function rm(e, t, n) {
	var r = e[t];
	(!(nm.call(e, t) && tm(r, n)) || n === void 0 && !(t in e)) && em(e, t, n);
}
//#endregion
//#region node_modules/lodash/_copyObject.js
function im(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? em(n, s, c) : rm(n, s, c);
	}
	return n;
}
//#endregion
//#region node_modules/lodash/_overRest.js
var am = Math.max;
function om(e, t, n) {
	return t = am(t === void 0 ? e.length - 1 : t, 0), function() {
		for (var r = arguments, i = -1, a = am(r.length - t, 0), o = Array(a); ++i < a;) o[i] = r[t + i];
		i = -1;
		for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
		return s[t] = n(o), Vp(e, this, s);
	};
}
//#endregion
//#region node_modules/lodash/isLength.js
var sm = 9007199254740991;
function cm(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= sm;
}
//#endregion
//#region node_modules/lodash/isArrayLike.js
function lm(e) {
	return e != null && cm(e.length) && !Sp(e);
}
//#endregion
//#region node_modules/lodash/_isPrototype.js
var um = Object.prototype;
function dm(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || um);
}
//#endregion
//#region node_modules/lodash/_baseTimes.js
function fm(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region node_modules/lodash/_baseIsArguments.js
var pm = "[object Arguments]";
function mm(e) {
	return Zf(e) && Xf(e) == pm;
}
//#endregion
//#region node_modules/lodash/isArguments.js
var hm = Object.prototype, gm = hm.hasOwnProperty, _m = hm.propertyIsEnumerable, vm = mm(function() {
	return arguments;
}()) ? mm : function(e) {
	return Zf(e) && gm.call(e, "callee") && !_m.call(e, "callee");
};
//#endregion
//#region node_modules/lodash/stubFalse.js
function ym() {
	return !1;
}
//#endregion
//#region node_modules/lodash/isBuffer.js
var bm = typeof exports == "object" && exports && !exports.nodeType && exports, xm = bm && typeof module == "object" && module && !module.nodeType && module, Sm = xm && xm.exports === bm ? Rf.Buffer : void 0, Cm = (Sm ? Sm.isBuffer : void 0) || ym, wm = "[object Arguments]", Tm = "[object Array]", Em = "[object Boolean]", Dm = "[object Date]", Om = "[object Error]", km = "[object Function]", Am = "[object Map]", jm = "[object Number]", Mm = "[object Object]", Nm = "[object RegExp]", Pm = "[object Set]", Fm = "[object String]", Im = "[object WeakMap]", Lm = "[object ArrayBuffer]", Rm = "[object DataView]", zm = "[object Float32Array]", Bm = "[object Float64Array]", Vm = "[object Int8Array]", Hm = "[object Int16Array]", Um = "[object Int32Array]", Wm = "[object Uint8Array]", Gm = "[object Uint8ClampedArray]", Km = "[object Uint16Array]", qm = "[object Uint32Array]", G = {};
G[zm] = G[Bm] = G[Vm] = G[Hm] = G[Um] = G[Wm] = G[Gm] = G[Km] = G[qm] = !0, G[wm] = G[Tm] = G[Lm] = G[Em] = G[Rm] = G[Dm] = G[Om] = G[km] = G[Am] = G[jm] = G[Mm] = G[Nm] = G[Pm] = G[Fm] = G[Im] = !1;
function Jm(e) {
	return Zf(e) && cm(e.length) && !!G[Xf(e)];
}
//#endregion
//#region node_modules/lodash/_baseUnary.js
function Ym(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region node_modules/lodash/_nodeUtil.js
var Xm = typeof exports == "object" && exports && !exports.nodeType && exports, Zm = Xm && typeof module == "object" && module && !module.nodeType && module, Qm = Zm && Zm.exports === Xm && If.process, $m = function() {
	try {
		return Zm && Zm.require && Zm.require("util").types || Qm && Qm.binding && Qm.binding("util");
	} catch {}
}(), eh = $m && $m.isTypedArray, th = eh ? Ym(eh) : Jm, nh = Object.prototype.hasOwnProperty;
function rh(e, t) {
	var n = tp(e), r = !n && vm(e), i = !n && !r && Cm(e), a = !n && !r && !i && th(e), o = n || r || i || a, s = o ? fm(e.length, String) : [], c = s.length;
	for (var l in e) (t || nh.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || $p(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region node_modules/lodash/_overArg.js
function ih(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region node_modules/lodash/_nativeKeys.js
var ah = ih(Object.keys, Object), oh = Object.prototype.hasOwnProperty;
function sh(e) {
	if (!dm(e)) return ah(e);
	var t = [];
	for (var n in Object(e)) oh.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region node_modules/lodash/keys.js
function ch(e) {
	return lm(e) ? rh(e) : sh(e);
}
//#endregion
//#region node_modules/lodash/_nativeKeysIn.js
function lh(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region node_modules/lodash/_baseKeysIn.js
var uh = Object.prototype.hasOwnProperty;
function dh(e) {
	if (!up(e)) return lh(e);
	var t = dm(e), n = [];
	for (var r in e) r == "constructor" && (t || !uh.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region node_modules/lodash/keysIn.js
function fh(e) {
	return lm(e) ? rh(e, !0) : dh(e);
}
//#endregion
//#region node_modules/lodash/_isKey.js
var ph = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, mh = /^\w*$/;
function hh(e, t) {
	if (tp(e)) return !1;
	var n = typeof e;
	return n == "number" || n == "symbol" || n == "boolean" || e == null || $f(e) ? !0 : mh.test(e) || !ph.test(e) || t != null && e in Object(t);
}
//#endregion
//#region node_modules/lodash/_nativeCreate.js
var gh = Lp(Object, "create");
//#endregion
//#region node_modules/lodash/_hashClear.js
function _h() {
	this.__data__ = gh ? gh(null) : {}, this.size = 0;
}
//#endregion
//#region node_modules/lodash/_hashDelete.js
function vh(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= t ? 1 : 0, t;
}
//#endregion
//#region node_modules/lodash/_hashGet.js
var yh = "__lodash_hash_undefined__", bh = Object.prototype.hasOwnProperty;
function xh(e) {
	var t = this.__data__;
	if (gh) {
		var n = t[e];
		return n === yh ? void 0 : n;
	}
	return bh.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region node_modules/lodash/_hashHas.js
var Sh = Object.prototype.hasOwnProperty;
function Ch(e) {
	var t = this.__data__;
	return gh ? t[e] !== void 0 : Sh.call(t, e);
}
//#endregion
//#region node_modules/lodash/_hashSet.js
var wh = "__lodash_hash_undefined__";
function Th(e, t) {
	var n = this.__data__;
	return this.size += this.has(e) ? 0 : 1, n[e] = gh && t === void 0 ? wh : t, this;
}
//#endregion
//#region node_modules/lodash/_Hash.js
function Eh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Eh.prototype.clear = _h, Eh.prototype.delete = vh, Eh.prototype.get = xh, Eh.prototype.has = Ch, Eh.prototype.set = Th;
//#endregion
//#region node_modules/lodash/_listCacheClear.js
function Dh() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region node_modules/lodash/_assocIndexOf.js
function Oh(e, t) {
	for (var n = e.length; n--;) if (tm(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region node_modules/lodash/_listCacheDelete.js
var kh = Array.prototype.splice;
function Ah(e) {
	var t = this.__data__, n = Oh(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : kh.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region node_modules/lodash/_listCacheGet.js
function jh(e) {
	var t = this.__data__, n = Oh(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region node_modules/lodash/_listCacheHas.js
function Mh(e) {
	return Oh(this.__data__, e) > -1;
}
//#endregion
//#region node_modules/lodash/_listCacheSet.js
function Nh(e, t) {
	var n = this.__data__, r = Oh(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region node_modules/lodash/_ListCache.js
function Ph(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Ph.prototype.clear = Dh, Ph.prototype.delete = Ah, Ph.prototype.get = jh, Ph.prototype.has = Mh, Ph.prototype.set = Nh;
//#endregion
//#region node_modules/lodash/_Map.js
var Fh = Lp(Rf, "Map");
//#endregion
//#region node_modules/lodash/_mapCacheClear.js
function Ih() {
	this.size = 0, this.__data__ = {
		hash: new Eh(),
		map: new (Fh || Ph)(),
		string: new Eh()
	};
}
//#endregion
//#region node_modules/lodash/_isKeyable.js
function Lh(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region node_modules/lodash/_getMapData.js
function Rh(e, t) {
	var n = e.__data__;
	return Lh(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region node_modules/lodash/_mapCacheDelete.js
function zh(e) {
	var t = Rh(this, e).delete(e);
	return this.size -= t ? 1 : 0, t;
}
//#endregion
//#region node_modules/lodash/_mapCacheGet.js
function Bh(e) {
	return Rh(this, e).get(e);
}
//#endregion
//#region node_modules/lodash/_mapCacheHas.js
function Vh(e) {
	return Rh(this, e).has(e);
}
//#endregion
//#region node_modules/lodash/_mapCacheSet.js
function Hh(e, t) {
	var n = Rh(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region node_modules/lodash/_MapCache.js
function Uh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Uh.prototype.clear = Ih, Uh.prototype.delete = zh, Uh.prototype.get = Bh, Uh.prototype.has = Vh, Uh.prototype.set = Hh;
//#endregion
//#region node_modules/lodash/memoize.js
var Wh = "Expected a function";
function Gh(e, t) {
	if (typeof e != "function" || t != null && typeof t != "function") throw TypeError(Wh);
	var n = function() {
		var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
		if (a.has(i)) return a.get(i);
		var o = e.apply(this, r);
		return n.cache = a.set(i, o) || a, o;
	};
	return n.cache = new (Gh.Cache || Uh)(), n;
}
Gh.Cache = Uh;
//#endregion
//#region node_modules/lodash/_memoizeCapped.js
var Kh = 500;
function qh(e) {
	var t = Gh(e, function(e) {
		return n.size === Kh && n.clear(), e;
	}), n = t.cache;
	return t;
}
//#endregion
//#region node_modules/lodash/_stringToPath.js
var Jh = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Yh = /\\(\\)?/g, Xh = qh(function(e) {
	var t = [];
	return e.charCodeAt(0) === 46 && t.push(""), e.replace(Jh, function(e, n, r, i) {
		t.push(r ? i.replace(Yh, "$1") : n || e);
	}), t;
});
//#endregion
//#region node_modules/lodash/toString.js
function Zh(e) {
	return e == null ? "" : ap(e);
}
//#endregion
//#region node_modules/lodash/_castPath.js
function Qh(e, t) {
	return tp(e) ? e : hh(e, t) ? [e] : Xh(Zh(e));
}
//#endregion
//#region node_modules/lodash/_toKey.js
var $h = Infinity;
function eg(e) {
	if (typeof e == "string" || $f(e)) return e;
	var t = e + "";
	return t == "0" && 1 / e == -$h ? "-0" : t;
}
//#endregion
//#region node_modules/lodash/_baseGet.js
function tg(e, t) {
	t = Qh(t, e);
	for (var n = 0, r = t.length; e != null && n < r;) e = e[eg(t[n++])];
	return n && n == r ? e : void 0;
}
//#endregion
//#region node_modules/lodash/_arrayPush.js
function ng(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region node_modules/lodash/_isFlattenable.js
var rg = zf ? zf.isConcatSpreadable : void 0;
function ig(e) {
	return tp(e) || vm(e) || !!(rg && e && e[rg]);
}
//#endregion
//#region node_modules/lodash/_baseFlatten.js
function ag(e, t, n, r, i) {
	var a = -1, o = e.length;
	for (n ||= ig, i ||= []; ++a < o;) {
		var s = e[a];
		t > 0 && n(s) ? t > 1 ? ag(s, t - 1, n, r, i) : ng(i, s) : r || (i[i.length] = s);
	}
	return i;
}
//#endregion
//#region node_modules/lodash/flatten.js
function og(e) {
	return e != null && e.length ? ag(e, 1) : [];
}
//#endregion
//#region node_modules/lodash/_flatRest.js
function sg(e) {
	return Yp(om(e, void 0, og), e + "");
}
//#endregion
//#region node_modules/lodash/_getPrototype.js
var cg = ih(Object.getPrototypeOf, Object), lg = "[object Object]", ug = Function.prototype, dg = Object.prototype, fg = ug.toString, pg = dg.hasOwnProperty, mg = fg.call(Object);
function hg(e) {
	if (!Zf(e) || Xf(e) != lg) return !1;
	var t = cg(e);
	if (t === null) return !0;
	var n = pg.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n instanceof n && fg.call(n) == mg;
}
//#endregion
//#region node_modules/lodash/_baseSlice.js
function gg(e, t, n) {
	var r = -1, i = e.length;
	t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
	for (var a = Array(i); ++r < i;) a[r] = e[r + t];
	return a;
}
//#endregion
//#region node_modules/lodash/_castSlice.js
function _g(e, t, n) {
	var r = e.length;
	return n = n === void 0 ? r : n, !t && n >= r ? e : gg(e, t, n);
}
//#endregion
//#region node_modules/lodash/_hasUnicode.js
var vg = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
function yg(e) {
	return vg.test(e);
}
//#endregion
//#region node_modules/lodash/_asciiToArray.js
function bg(e) {
	return e.split("");
}
//#endregion
//#region node_modules/lodash/_unicodeToArray.js
var xg = "\\ud800-\\udfff", Sg = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Cg = "\\ufe0e\\ufe0f", wg = "[" + xg + "]", Tg = "[" + Sg + "]", Eg = "\\ud83c[\\udffb-\\udfff]", Dg = "(?:" + Tg + "|" + Eg + ")", Og = "[^" + xg + "]", kg = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ag = "[\\ud800-\\udbff][\\udc00-\\udfff]", jg = "\\u200d", Mg = Dg + "?", Ng = "[" + Cg + "]?", Pg = "(?:" + jg + "(?:" + [
	Og,
	kg,
	Ag
].join("|") + ")" + Ng + Mg + ")*", Fg = Ng + Mg + Pg, Ig = "(?:" + [
	Og + Tg + "?",
	Tg,
	kg,
	Ag,
	wg
].join("|") + ")", Lg = RegExp(Eg + "(?=" + Eg + ")|" + Ig + Fg, "g");
function Rg(e) {
	return e.match(Lg) || [];
}
//#endregion
//#region node_modules/lodash/_stringToArray.js
function zg(e) {
	return yg(e) ? Rg(e) : bg(e);
}
//#endregion
//#region node_modules/lodash/_createCaseFirst.js
function Bg(e) {
	return function(t) {
		t = Zh(t);
		var n = yg(t) ? zg(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? _g(n, 1).join("") : t.slice(1);
		return r[e]() + i;
	};
}
//#endregion
//#region node_modules/lodash/upperFirst.js
var Vg = Bg("toUpperCase");
//#endregion
//#region node_modules/lodash/capitalize.js
function Hg(e) {
	return Vg(Zh(e).toLowerCase());
}
//#endregion
//#region node_modules/lodash/_stackClear.js
function Ug() {
	this.__data__ = new Ph(), this.size = 0;
}
//#endregion
//#region node_modules/lodash/_stackDelete.js
function Wg(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region node_modules/lodash/_stackGet.js
function Gg(e) {
	return this.__data__.get(e);
}
//#endregion
//#region node_modules/lodash/_stackHas.js
function Kg(e) {
	return this.__data__.has(e);
}
//#endregion
//#region node_modules/lodash/_stackSet.js
var qg = 200;
function Jg(e, t) {
	var n = this.__data__;
	if (n instanceof Ph) {
		var r = n.__data__;
		if (!Fh || r.length < qg - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Uh(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region node_modules/lodash/_Stack.js
function Yg(e) {
	this.size = (this.__data__ = new Ph(e)).size;
}
Yg.prototype.clear = Ug, Yg.prototype.delete = Wg, Yg.prototype.get = Gg, Yg.prototype.has = Kg, Yg.prototype.set = Jg;
//#endregion
//#region node_modules/lodash/_baseAssign.js
function Xg(e, t) {
	return e && im(t, ch(t), e);
}
//#endregion
//#region node_modules/lodash/_baseAssignIn.js
function Zg(e, t) {
	return e && im(t, fh(t), e);
}
//#endregion
//#region node_modules/lodash/_cloneBuffer.js
var Qg = typeof exports == "object" && exports && !exports.nodeType && exports, $g = Qg && typeof module == "object" && module && !module.nodeType && module, e_ = $g && $g.exports === Qg ? Rf.Buffer : void 0, t_ = e_ ? e_.allocUnsafe : void 0;
function n_(e, t) {
	if (t) return e.slice();
	var n = e.length, r = t_ ? t_(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region node_modules/lodash/_arrayFilter.js
function r_(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region node_modules/lodash/stubArray.js
function i_() {
	return [];
}
//#endregion
//#region node_modules/lodash/_getSymbols.js
var a_ = Object.prototype.propertyIsEnumerable, o_ = Object.getOwnPropertySymbols, s_ = o_ ? function(e) {
	return e == null ? [] : (e = Object(e), r_(o_(e), function(t) {
		return a_.call(e, t);
	}));
} : i_;
//#endregion
//#region node_modules/lodash/_copySymbols.js
function c_(e, t) {
	return im(e, s_(e), t);
}
//#endregion
//#region node_modules/lodash/_getSymbolsIn.js
var l_ = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) ng(t, s_(e)), e = cg(e);
	return t;
} : i_;
//#endregion
//#region node_modules/lodash/_copySymbolsIn.js
function u_(e, t) {
	return im(e, l_(e), t);
}
//#endregion
//#region node_modules/lodash/_baseGetAllKeys.js
function d_(e, t, n) {
	var r = t(e);
	return tp(e) ? r : ng(r, n(e));
}
//#endregion
//#region node_modules/lodash/_getAllKeys.js
function f_(e) {
	return d_(e, ch, s_);
}
//#endregion
//#region node_modules/lodash/_getAllKeysIn.js
function p_(e) {
	return d_(e, fh, l_);
}
//#endregion
//#region node_modules/lodash/_DataView.js
var m_ = Lp(Rf, "DataView"), h_ = Lp(Rf, "Promise"), g_ = Lp(Rf, "Set"), __ = "[object Map]", v_ = "[object Object]", y_ = "[object Promise]", b_ = "[object Set]", x_ = "[object WeakMap]", S_ = "[object DataView]", C_ = Dp(m_), w_ = Dp(Fh), T_ = Dp(h_), E_ = Dp(g_), D_ = Dp(Rp), O_ = Xf;
(m_ && O_(new m_(/* @__PURE__ */ new ArrayBuffer(1))) != S_ || Fh && O_(new Fh()) != __ || h_ && O_(h_.resolve()) != y_ || g_ && O_(new g_()) != b_ || Rp && O_(new Rp()) != x_) && (O_ = function(e) {
	var t = Xf(e), n = t == v_ ? e.constructor : void 0, r = n ? Dp(n) : "";
	if (r) switch (r) {
		case C_: return S_;
		case w_: return __;
		case T_: return y_;
		case E_: return b_;
		case D_: return x_;
	}
	return t;
});
var k_ = O_, A_ = Object.prototype.hasOwnProperty;
function j_(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && A_.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region node_modules/lodash/_Uint8Array.js
var M_ = Rf.Uint8Array;
//#endregion
//#region node_modules/lodash/_cloneArrayBuffer.js
function N_(e) {
	var t = new e.constructor(e.byteLength);
	return new M_(t).set(new M_(e)), t;
}
//#endregion
//#region node_modules/lodash/_cloneDataView.js
function P_(e, t) {
	var n = t ? N_(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region node_modules/lodash/_cloneRegExp.js
var F_ = /\w*$/;
function I_(e) {
	var t = new e.constructor(e.source, F_.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region node_modules/lodash/_cloneSymbol.js
var L_ = zf ? zf.prototype : void 0, R_ = L_ ? L_.valueOf : void 0;
function z_(e) {
	return R_ ? Object(R_.call(e)) : {};
}
//#endregion
//#region node_modules/lodash/_cloneTypedArray.js
function B_(e, t) {
	var n = t ? N_(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region node_modules/lodash/_initCloneByTag.js
var V_ = "[object Boolean]", H_ = "[object Date]", U_ = "[object Map]", W_ = "[object Number]", G_ = "[object RegExp]", K_ = "[object Set]", q_ = "[object String]", J_ = "[object Symbol]", Y_ = "[object ArrayBuffer]", X_ = "[object DataView]", Z_ = "[object Float32Array]", Q_ = "[object Float64Array]", $_ = "[object Int8Array]", ev = "[object Int16Array]", tv = "[object Int32Array]", nv = "[object Uint8Array]", rv = "[object Uint8ClampedArray]", iv = "[object Uint16Array]", av = "[object Uint32Array]";
function ov(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case Y_: return N_(e);
		case V_:
		case H_: return new r(+e);
		case X_: return P_(e, n);
		case Z_:
		case Q_:
		case $_:
		case ev:
		case tv:
		case nv:
		case rv:
		case iv:
		case av: return B_(e, n);
		case U_: return new r();
		case W_:
		case q_: return new r(e);
		case G_: return I_(e);
		case K_: return new r();
		case J_: return z_(e);
	}
}
//#endregion
//#region node_modules/lodash/_initCloneObject.js
function sv(e) {
	return typeof e.constructor == "function" && !dm(e) ? Bp(cg(e)) : {};
}
//#endregion
//#region node_modules/lodash/_baseIsMap.js
var cv = "[object Map]";
function lv(e) {
	return Zf(e) && k_(e) == cv;
}
//#endregion
//#region node_modules/lodash/isMap.js
var uv = $m && $m.isMap, dv = uv ? Ym(uv) : lv, fv = "[object Set]";
function pv(e) {
	return Zf(e) && k_(e) == fv;
}
//#endregion
//#region node_modules/lodash/isSet.js
var mv = $m && $m.isSet, hv = mv ? Ym(mv) : pv, gv = 1, _v = 2, vv = 4, yv = "[object Arguments]", bv = "[object Array]", xv = "[object Boolean]", Sv = "[object Date]", Cv = "[object Error]", wv = "[object Function]", Tv = "[object GeneratorFunction]", Ev = "[object Map]", Dv = "[object Number]", Ov = "[object Object]", kv = "[object RegExp]", Av = "[object Set]", jv = "[object String]", Mv = "[object Symbol]", Nv = "[object WeakMap]", Pv = "[object ArrayBuffer]", Fv = "[object DataView]", Iv = "[object Float32Array]", Lv = "[object Float64Array]", Rv = "[object Int8Array]", zv = "[object Int16Array]", Bv = "[object Int32Array]", Vv = "[object Uint8Array]", Hv = "[object Uint8ClampedArray]", Uv = "[object Uint16Array]", Wv = "[object Uint32Array]", K = {};
K[yv] = K[bv] = K[Pv] = K[Fv] = K[xv] = K[Sv] = K[Iv] = K[Lv] = K[Rv] = K[zv] = K[Bv] = K[Ev] = K[Dv] = K[Ov] = K[kv] = K[Av] = K[jv] = K[Mv] = K[Vv] = K[Hv] = K[Uv] = K[Wv] = !0, K[Cv] = K[wv] = K[Nv] = !1;
function Gv(e, t, n, r, i, a) {
	var o, s = t & gv, c = t & _v, l = t & vv;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!up(e)) return e;
	var u = tp(e);
	if (u) {
		if (o = j_(e), !s) return Hp(e, o);
	} else {
		var d = k_(e), f = d == wv || d == Tv;
		if (Cm(e)) return n_(e, s);
		if (d == Ov || d == yv || f && !i) {
			if (o = c || f ? {} : sv(e), !s) return c ? u_(e, Zg(o, e)) : c_(e, Xg(o, e));
		} else {
			if (!K[d]) return i ? e : {};
			o = ov(e, d, s);
		}
	}
	a ||= new Yg();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), hv(e) ? e.forEach(function(r) {
		o.add(Gv(r, t, n, r, e, a));
	}) : dv(e) && e.forEach(function(r, i) {
		o.set(i, Gv(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? p_ : f_ : c ? fh : ch)(e);
	return Xp(m || e, function(r, i) {
		m && (i = r, r = e[i]), rm(o, i, Gv(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region node_modules/lodash/_setCacheAdd.js
var Kv = "__lodash_hash_undefined__";
function qv(e) {
	return this.__data__.set(e, Kv), this;
}
//#endregion
//#region node_modules/lodash/_setCacheHas.js
function Jv(e) {
	return this.__data__.has(e);
}
//#endregion
//#region node_modules/lodash/_SetCache.js
function Yv(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.__data__ = new Uh(); ++t < n;) this.add(e[t]);
}
Yv.prototype.add = Yv.prototype.push = qv, Yv.prototype.has = Jv;
//#endregion
//#region node_modules/lodash/_arraySome.js
function Xv(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
	return !1;
}
//#endregion
//#region node_modules/lodash/_cacheHas.js
function Zv(e, t) {
	return e.has(t);
}
//#endregion
//#region node_modules/lodash/_equalArrays.js
var Qv = 1, $v = 2;
function ey(e, t, n, r, i, a) {
	var o = n & Qv, s = e.length, c = t.length;
	if (s != c && !(o && c > s)) return !1;
	var l = a.get(e), u = a.get(t);
	if (l && u) return l == t && u == e;
	var d = -1, f = !0, p = n & $v ? new Yv() : void 0;
	for (a.set(e, t), a.set(t, e); ++d < s;) {
		var m = e[d], h = t[d];
		if (r) var g = o ? r(h, m, d, t, e, a) : r(m, h, d, e, t, a);
		if (g !== void 0) {
			if (g) continue;
			f = !1;
			break;
		}
		if (p) {
			if (!Xv(t, function(e, t) {
				if (!Zv(p, t) && (m === e || i(m, e, n, r, a))) return p.push(t);
			})) {
				f = !1;
				break;
			}
		} else if (!(m === h || i(m, h, n, r, a))) {
			f = !1;
			break;
		}
	}
	return a.delete(e), a.delete(t), f;
}
//#endregion
//#region node_modules/lodash/_mapToArray.js
function ty(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e, r) {
		n[++t] = [r, e];
	}), n;
}
//#endregion
//#region node_modules/lodash/_setToArray.js
function ny(e) {
	var t = -1, n = Array(e.size);
	return e.forEach(function(e) {
		n[++t] = e;
	}), n;
}
//#endregion
//#region node_modules/lodash/_equalByTag.js
var ry = 1, iy = 2, ay = "[object Boolean]", oy = "[object Date]", sy = "[object Error]", cy = "[object Map]", ly = "[object Number]", uy = "[object RegExp]", dy = "[object Set]", fy = "[object String]", py = "[object Symbol]", my = "[object ArrayBuffer]", hy = "[object DataView]", gy = zf ? zf.prototype : void 0, _y = gy ? gy.valueOf : void 0;
function vy(e, t, n, r, i, a, o) {
	switch (n) {
		case hy:
			if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
			e = e.buffer, t = t.buffer;
		case my: return !(e.byteLength != t.byteLength || !a(new M_(e), new M_(t)));
		case ay:
		case oy:
		case ly: return tm(+e, +t);
		case sy: return e.name == t.name && e.message == t.message;
		case uy:
		case fy: return e == t + "";
		case cy: var s = ty;
		case dy:
			var c = r & ry;
			if (s ||= ny, e.size != t.size && !c) return !1;
			var l = o.get(e);
			if (l) return l == t;
			r |= iy, o.set(e, t);
			var u = ey(s(e), s(t), r, i, a, o);
			return o.delete(e), u;
		case py: if (_y) return _y.call(e) == _y.call(t);
	}
	return !1;
}
//#endregion
//#region node_modules/lodash/_equalObjects.js
var yy = 1, by = Object.prototype.hasOwnProperty;
function xy(e, t, n, r, i, a) {
	var o = n & yy, s = f_(e), c = s.length;
	if (c != f_(t).length && !o) return !1;
	for (var l = c; l--;) {
		var u = s[l];
		if (!(o ? u in t : by.call(t, u))) return !1;
	}
	var d = a.get(e), f = a.get(t);
	if (d && f) return d == t && f == e;
	var p = !0;
	a.set(e, t), a.set(t, e);
	for (var m = o; ++l < c;) {
		u = s[l];
		var h = e[u], g = t[u];
		if (r) var _ = o ? r(g, h, u, t, e, a) : r(h, g, u, e, t, a);
		if (!(_ === void 0 ? h === g || i(h, g, n, r, a) : _)) {
			p = !1;
			break;
		}
		m ||= u == "constructor";
	}
	if (p && !m) {
		var v = e.constructor, y = t.constructor;
		v != y && "constructor" in e && "constructor" in t && !(typeof v == "function" && v instanceof v && typeof y == "function" && y instanceof y) && (p = !1);
	}
	return a.delete(e), a.delete(t), p;
}
//#endregion
//#region node_modules/lodash/_baseIsEqualDeep.js
var Sy = 1, Cy = "[object Arguments]", wy = "[object Array]", Ty = "[object Object]", Ey = Object.prototype.hasOwnProperty;
function Dy(e, t, n, r, i, a) {
	var o = tp(e), s = tp(t), c = o ? wy : k_(e), l = s ? wy : k_(t);
	c = c == Cy ? Ty : c, l = l == Cy ? Ty : l;
	var u = c == Ty, d = l == Ty, f = c == l;
	if (f && Cm(e)) {
		if (!Cm(t)) return !1;
		o = !0, u = !1;
	}
	if (f && !u) return a ||= new Yg(), o || th(e) ? ey(e, t, n, r, i, a) : vy(e, t, c, n, r, i, a);
	if (!(n & Sy)) {
		var p = u && Ey.call(e, "__wrapped__"), m = d && Ey.call(t, "__wrapped__");
		if (p || m) {
			var h = p ? e.value() : e, g = m ? t.value() : t;
			return a ||= new Yg(), i(h, g, n, r, a);
		}
	}
	return f ? (a ||= new Yg(), xy(e, t, n, r, i, a)) : !1;
}
//#endregion
//#region node_modules/lodash/_baseIsEqual.js
function Oy(e, t, n, r, i) {
	return e === t ? !0 : e == null || t == null || !Zf(e) && !Zf(t) ? e !== e && t !== t : Dy(e, t, n, r, Oy, i);
}
//#endregion
//#region node_modules/lodash/now.js
var ky = function() {
	return Rf.Date.now();
}, Ay = "Expected a function", jy = Math.max, My = Math.min;
function Ny(e, t, n) {
	var r, i, a, o, s, c, l = 0, u = !1, d = !1, f = !0;
	if (typeof e != "function") throw TypeError(Ay);
	t = gp(t) || 0, up(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? jy(gp(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
	function p(t) {
		var n = r, a = i;
		return r = i = void 0, l = t, o = e.apply(a, n), o;
	}
	function m(e) {
		return l = e, s = setTimeout(_, t), u ? p(e) : o;
	}
	function h(e) {
		var n = e - c, r = e - l, i = t - n;
		return d ? My(i, a - r) : i;
	}
	function g(e) {
		var n = e - c, r = e - l;
		return c === void 0 || n >= t || n < 0 || d && r >= a;
	}
	function _() {
		var e = ky();
		if (g(e)) return v(e);
		s = setTimeout(_, h(e));
	}
	function v(e) {
		return s = void 0, f && r ? p(e) : (r = i = void 0, o);
	}
	function y() {
		s !== void 0 && clearTimeout(s), l = 0, r = c = i = s = void 0;
	}
	function b() {
		return s === void 0 ? o : v(ky());
	}
	function x() {
		var e = ky(), n = g(e);
		if (r = arguments, i = this, c = e, n) {
			if (s === void 0) return m(c);
			if (d) return clearTimeout(s), s = setTimeout(_, t), p(c);
		}
		return s === void 0 && (s = setTimeout(_, t)), o;
	}
	return x.cancel = y, x.flush = b, x;
}
//#endregion
//#region node_modules/lodash/last.js
function Py(e) {
	var t = e == null ? 0 : e.length;
	return t ? e[t - 1] : void 0;
}
//#endregion
//#region node_modules/lodash/_parent.js
function Fy(e, t) {
	return t.length < 2 ? e : tg(e, gg(t, 0, -1));
}
//#endregion
//#region node_modules/lodash/isEqual.js
function Iy(e, t) {
	return Oy(e, t);
}
//#endregion
//#region node_modules/lodash/_baseUnset.js
var Ly = Object.prototype.hasOwnProperty;
function Ry(e, t) {
	t = Qh(t, e);
	var n = -1, r = t.length;
	if (!r) return !0;
	for (var i = e == null || typeof e != "object" && typeof e != "function"; ++n < r;) {
		var a = t[n];
		if (typeof a == "string") {
			if (a === "__proto__" && !Ly.call(e, "__proto__")) return !1;
			if (a === "constructor" && n + 1 < r && typeof t[n + 1] == "string" && t[n + 1] === "prototype") {
				if (i && n === 0) continue;
				return !1;
			}
		}
	}
	var o = Fy(e, t);
	return o == null || delete o[eg(Py(t))];
}
//#endregion
//#region node_modules/lodash/_customOmitClone.js
function zy(e) {
	return hg(e) ? void 0 : e;
}
//#endregion
//#region node_modules/lodash/omit.js
var By = 1, Vy = 2, Hy = 4, Uy = sg(function(e, t) {
	var n = {};
	if (e == null) return n;
	var r = !1;
	t = ep(t, function(t) {
		return t = Qh(t, e), r ||= t.length > 1, t;
	}), im(e, p_(e), n), r && (n = Gv(n, By | Vy | Hy, zy));
	for (var i = t.length; i--;) Ry(n, t[i]);
	return n;
}), Wy = "Expected a function";
function Gy(e, t, n) {
	var r = !0, i = !0;
	if (typeof e != "function") throw TypeError(Wy);
	return up(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Ny(e, t, {
		leading: r,
		maxWait: t,
		trailing: i
	});
}
var Ky = { seekBar: "_seekBar_16dv7_14" };
//#endregion
//#region src/audio/SeekBar/SeekBar.tsx
function qy({ value: e = 0, className: n, ...r }) {
	let { translate: i } = W(), [a, o] = f(e), s = u(() => Gy(o, 10), []);
	return c(() => {
		s(e);
	}, [e, s]), /* @__PURE__ */ t.createElement("input", {
		type: "range",
		className: (0, H.default)(Ky.seekBar, n),
		onMouseDown: (e) => e.stopPropagation(),
		min: 0,
		max: 100,
		value: a,
		step: 1,
		style: { "--fillTo": a / 100 },
		"aria-label": i("a11y|seek_bar_label"),
		...r
	});
}
var Jy = {
	avatarWithDetails: "_avatarWithDetails_7ga8t_8",
	title: "_title_7ga8t_17",
	details: "_details_7ga8t_28"
}, Yy = { flex: "_flex_4dswl_9" };
//#endregion
//#region src/core/utils/Flex/Flex.tsx
function q({ as: e = "div", display: n = "flex", direction: r = "row", align: i = "start", justify: a = "start", gap: o = "0", wrap: s = "nowrap", className: c, children: l, ...d }) {
	let f = u(() => ({
		"--mx-flex-display": n,
		"--mx-flex-direction": r,
		"--mx-flex-align": i,
		"--mx-flex-justify": a,
		"--mx-flex-gap": o,
		"--mx-flex-wrap": s
	}), [
		i,
		r,
		n,
		o,
		a,
		s
	]);
	return t.createElement(e, {
		...d,
		className: (0, H.default)(Yy.flex, c),
		style: f
	}, l);
}
//#endregion
//#region src/core/avatar/AvatarWithDetails/AvatarWithDetails.tsx
function Xy({ as: e, className: n, details: r, avatar: i, title: a, ...o }) {
	let s = e || "div";
	return /* @__PURE__ */ t.createElement(s, {
		className: (0, H.default)(Jy.avatarWithDetails, n),
		...o
	}, i, /* @__PURE__ */ t.createElement(q, { direction: "column" }, /* @__PURE__ */ t.createElement("span", { className: Jy.title }, a), /* @__PURE__ */ t.createElement("span", { className: Jy.details }, r)));
}
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/check-circle.js
function Zy(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m10.6 13.8-2.15-2.15a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275zM12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20" })
	});
}
Zy.displayName = "CheckCircleIcon";
var Qy = i(Zy);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/error.js
function $y(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 17q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m0 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20" })
	});
}
$y.displayName = "ErrorIcon";
var eb = i($y);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/info.js
function tb(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M11.288 7.288A.97.97 0 0 1 12 7q.424 0 .713.287Q13 7.576 13 8t-.287.713A.97.97 0 0 1 12 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 8q0-.424.287-.713m.001 4.001A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713v4q0 .424-.287.712A.97.97 0 0 1 12 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 16v-4q0-.424.287-.713" }), /* @__PURE__ */ (0, U.jsx)("path", {
			fillRule: "evenodd",
			d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
			clipRule: "evenodd"
		})]
	});
}
tb.displayName = "InfoIcon";
var nb = i(tb), rb = {
	banner: "_banner_193k4_8",
	content: "_content_193k4_38",
	icon: "_icon_193k4_50",
	actions: "_actions_193k4_60"
};
//#endregion
//#region ../../node_modules/matrix-web-i18n/lib/utils.js
function ib(e) {
	return e.toLowerCase().replace("_", "-");
}
function ab(e) {
	let t = [], n = ib(e), r = n.split("-");
	return r.length === 2 && r[0] === r[1] ? t.push(r[0]) : (t.push(n), r.length === 2 && t.push(r[0])), t;
}
//#endregion
//#region ../../node_modules/matrix-web-i18n/lib/index.js
var ob = "|", sb = /* @__PURE__ */ A(((e, t) => {
	var n = Object.prototype.hasOwnProperty, r = Object.prototype.toString, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = function(e) {
		return typeof Array.isArray == "function" ? Array.isArray(e) : r.call(e) === "[object Array]";
	}, s = function(e) {
		if (!e || r.call(e) !== "[object Object]") return !1;
		var t = n.call(e, "constructor"), i = e.constructor && e.constructor.prototype && n.call(e.constructor.prototype, "isPrototypeOf");
		if (e.constructor && !t && !i) return !1;
		for (var a in e);
		return a === void 0 || n.call(e, a);
	}, c = function(e, t) {
		i && t.name === "__proto__" ? i(e, t.name, {
			enumerable: !0,
			configurable: !0,
			value: t.newValue,
			writable: !0
		}) : e[t.name] = t.newValue;
	}, l = function(e, t) {
		if (t === "__proto__") {
			if (!n.call(e, t)) return;
			if (a) return a(e, t).value;
		}
		return e[t];
	};
	t.exports = function e() {
		var t, n, r, i, a, u, d = arguments[0], f = 1, p = arguments.length, m = !1;
		for (typeof d == "boolean" && (m = d, d = arguments[1] || {}, f = 2), (d == null || typeof d != "object" && typeof d != "function") && (d = {}); f < p; ++f) if (t = arguments[f], t != null) for (n in t) r = l(d, n), i = l(t, n), d !== i && (m && i && (s(i) || (a = o(i))) ? (a ? (a = !1, u = r && o(r) ? r : []) : u = r && s(r) ? r : {}, c(d, {
			name: n,
			newValue: e(m, u, i)
		})) : i !== void 0 && c(d, {
			name: n,
			newValue: i
		}));
		return d;
	};
})), cb = /* @__PURE__ */ A(((e, t) => {
	t.exports = function() {
		if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
		if (typeof Symbol.iterator == "symbol") return !0;
		var e = {}, t = Symbol("test"), n = Object(t);
		if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]") return !1;
		var r = 42;
		for (var i in e[t] = r, e) return !1;
		if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0) return !1;
		var a = Object.getOwnPropertySymbols(e);
		if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
		if (typeof Object.getOwnPropertyDescriptor == "function") {
			var o = Object.getOwnPropertyDescriptor(e, t);
			if (o.value !== r || o.enumerable !== !0) return !1;
		}
		return !0;
	};
})), lb = /* @__PURE__ */ A(((e, t) => {
	var n = cb();
	t.exports = function() {
		return n() && !!Symbol.toStringTag;
	};
})), ub = /* @__PURE__ */ A(((e, t) => {
	t.exports = Object;
})), db = /* @__PURE__ */ A(((e, t) => {
	t.exports = Error;
})), fb = /* @__PURE__ */ A(((e, t) => {
	t.exports = EvalError;
})), pb = /* @__PURE__ */ A(((e, t) => {
	t.exports = RangeError;
})), mb = /* @__PURE__ */ A(((e, t) => {
	t.exports = ReferenceError;
})), hb = /* @__PURE__ */ A(((e, t) => {
	t.exports = SyntaxError;
})), gb = /* @__PURE__ */ A(((e, t) => {
	t.exports = TypeError;
})), _b = /* @__PURE__ */ A(((e, t) => {
	t.exports = URIError;
})), vb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.abs;
})), yb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.floor;
})), bb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.max;
})), xb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.min;
})), Sb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.pow;
})), Cb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Math.round;
})), wb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Number.isNaN || function(e) {
		return e !== e;
	};
})), Tb = /* @__PURE__ */ A(((e, t) => {
	var n = wb();
	t.exports = function(e) {
		return n(e) || e === 0 ? e : e < 0 ? -1 : 1;
	};
})), Eb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Object.getOwnPropertyDescriptor;
})), Db = /* @__PURE__ */ A(((e, t) => {
	var n = Eb();
	if (n) try {
		n([], "length");
	} catch {
		n = null;
	}
	t.exports = n;
})), Ob = /* @__PURE__ */ A(((e, t) => {
	var n = Object.defineProperty || !1;
	if (n) try {
		n({}, "a", { value: 1 });
	} catch {
		n = !1;
	}
	t.exports = n;
})), kb = /* @__PURE__ */ A(((e, t) => {
	var n = typeof Symbol < "u" && Symbol, r = cb();
	t.exports = function() {
		return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : r();
	};
})), Ab = /* @__PURE__ */ A(((e, t) => {
	t.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
})), jb = /* @__PURE__ */ A(((e, t) => {
	t.exports = ub().getPrototypeOf || null;
})), Mb = /* @__PURE__ */ A(((e, t) => {
	var n = "Function.prototype.bind called on incompatible ", r = Object.prototype.toString, i = Math.max, a = "[object Function]", o = function(e, t) {
		for (var n = [], r = 0; r < e.length; r += 1) n[r] = e[r];
		for (var i = 0; i < t.length; i += 1) n[i + e.length] = t[i];
		return n;
	}, s = function(e, t) {
		for (var n = [], r = t || 0, i = 0; r < e.length; r += 1, i += 1) n[i] = e[r];
		return n;
	}, c = function(e, t) {
		for (var n = "", r = 0; r < e.length; r += 1) n += e[r], r + 1 < e.length && (n += t);
		return n;
	};
	t.exports = function(e) {
		var t = this;
		if (typeof t != "function" || r.apply(t) !== a) throw TypeError(n + t);
		for (var l = s(arguments, 1), u, d = function() {
			if (this instanceof u) {
				var n = t.apply(this, o(l, arguments));
				return Object(n) === n ? n : this;
			}
			return t.apply(e, o(l, arguments));
		}, f = i(0, t.length - l.length), p = [], m = 0; m < f; m++) p[m] = "$" + m;
		if (u = Function("binder", "return function (" + c(p, ",") + "){ return binder.apply(this,arguments); }")(d), t.prototype) {
			var h = function() {};
			h.prototype = t.prototype, u.prototype = new h(), h.prototype = null;
		}
		return u;
	};
})), Nb = /* @__PURE__ */ A(((e, t) => {
	var n = Mb();
	t.exports = Function.prototype.bind || n;
})), Pb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Function.prototype.call;
})), Fb = /* @__PURE__ */ A(((e, t) => {
	t.exports = Function.prototype.apply;
})), Ib = /* @__PURE__ */ A(((e, t) => {
	t.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
})), Lb = /* @__PURE__ */ A(((e, t) => {
	var n = Nb(), r = Fb(), i = Pb();
	t.exports = Ib() || n.call(i, r);
})), Rb = /* @__PURE__ */ A(((e, t) => {
	var n = Nb(), r = gb(), i = Pb(), a = Lb();
	t.exports = function(e) {
		if (e.length < 1 || typeof e[0] != "function") throw new r("a function is required");
		return a(n, i, e);
	};
})), zb = /* @__PURE__ */ A(((e, t) => {
	var n = Rb(), r = Db(), i;
	try {
		i = [].__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e != "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") throw e;
	}
	var a = !!i && r && r(Object.prototype, "__proto__"), o = Object, s = o.getPrototypeOf;
	t.exports = a && typeof a.get == "function" ? n([a.get]) : typeof s == "function" ? function(e) {
		return s(e == null ? e : o(e));
	} : !1;
})), Bb = /* @__PURE__ */ A(((e, t) => {
	var n = Ab(), r = jb(), i = zb();
	t.exports = n ? function(e) {
		return n(e);
	} : r ? function(e) {
		if (!e || typeof e != "object" && typeof e != "function") throw TypeError("getProto: not an object");
		return r(e);
	} : i ? function(e) {
		return i(e);
	} : null;
})), Vb = /* @__PURE__ */ A(((e, t) => {
	var n = Function.prototype.call, r = Object.prototype.hasOwnProperty;
	t.exports = Nb().call(n, r);
})), Hb = /* @__PURE__ */ A(((e, t) => {
	var n, r = ub(), i = db(), a = fb(), o = pb(), s = mb(), c = hb(), l = gb(), u = _b(), d = vb(), f = yb(), p = bb(), m = xb(), h = Sb(), g = Cb(), _ = Tb(), v = Function, y = function(e) {
		try {
			return v("\"use strict\"; return (" + e + ").constructor;")();
		} catch {}
	}, b = Db(), x = Ob(), S = function() {
		throw new l();
	}, C = b ? function() {
		try {
			return arguments.callee, S;
		} catch {
			try {
				return b(arguments, "callee").get;
			} catch {
				return S;
			}
		}
	}() : S, w = kb()(), T = Bb(), E = jb(), ee = Ab(), te = Fb(), ne = Pb(), D = {}, re = typeof Uint8Array > "u" || !T ? n : T(Uint8Array), O = {
		__proto__: null,
		"%AggregateError%": typeof AggregateError > "u" ? n : AggregateError,
		"%Array%": Array,
		"%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer,
		"%ArrayIteratorPrototype%": w && T ? T([][Symbol.iterator]()) : n,
		"%AsyncFromSyncIteratorPrototype%": n,
		"%AsyncFunction%": D,
		"%AsyncGenerator%": D,
		"%AsyncGeneratorFunction%": D,
		"%AsyncIteratorPrototype%": D,
		"%Atomics%": typeof Atomics > "u" ? n : Atomics,
		"%BigInt%": typeof BigInt > "u" ? n : BigInt,
		"%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array,
		"%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array,
		"%Boolean%": Boolean,
		"%DataView%": typeof DataView > "u" ? n : DataView,
		"%Date%": Date,
		"%decodeURI%": decodeURI,
		"%decodeURIComponent%": decodeURIComponent,
		"%encodeURI%": encodeURI,
		"%encodeURIComponent%": encodeURIComponent,
		"%Error%": i,
		"%eval%": eval,
		"%EvalError%": a,
		"%Float16Array%": typeof Float16Array > "u" ? n : Float16Array,
		"%Float32Array%": typeof Float32Array > "u" ? n : Float32Array,
		"%Float64Array%": typeof Float64Array > "u" ? n : Float64Array,
		"%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry,
		"%Function%": v,
		"%GeneratorFunction%": D,
		"%Int8Array%": typeof Int8Array > "u" ? n : Int8Array,
		"%Int16Array%": typeof Int16Array > "u" ? n : Int16Array,
		"%Int32Array%": typeof Int32Array > "u" ? n : Int32Array,
		"%isFinite%": isFinite,
		"%isNaN%": isNaN,
		"%IteratorPrototype%": w && T ? T(T([][Symbol.iterator]())) : n,
		"%JSON%": typeof JSON == "object" ? JSON : n,
		"%Map%": typeof Map > "u" ? n : Map,
		"%MapIteratorPrototype%": typeof Map > "u" || !w || !T ? n : T((/* @__PURE__ */ new Map())[Symbol.iterator]()),
		"%Math%": Math,
		"%Number%": Number,
		"%Object%": r,
		"%Object.getOwnPropertyDescriptor%": b,
		"%parseFloat%": parseFloat,
		"%parseInt%": parseInt,
		"%Promise%": typeof Promise > "u" ? n : Promise,
		"%Proxy%": typeof Proxy > "u" ? n : Proxy,
		"%RangeError%": o,
		"%ReferenceError%": s,
		"%Reflect%": typeof Reflect > "u" ? n : Reflect,
		"%RegExp%": RegExp,
		"%Set%": typeof Set > "u" ? n : Set,
		"%SetIteratorPrototype%": typeof Set > "u" || !w || !T ? n : T((/* @__PURE__ */ new Set())[Symbol.iterator]()),
		"%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer,
		"%String%": String,
		"%StringIteratorPrototype%": w && T ? T(""[Symbol.iterator]()) : n,
		"%Symbol%": w ? Symbol : n,
		"%SyntaxError%": c,
		"%ThrowTypeError%": C,
		"%TypedArray%": re,
		"%TypeError%": l,
		"%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array,
		"%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray,
		"%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array,
		"%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array,
		"%URIError%": u,
		"%WeakMap%": typeof WeakMap > "u" ? n : WeakMap,
		"%WeakRef%": typeof WeakRef > "u" ? n : WeakRef,
		"%WeakSet%": typeof WeakSet > "u" ? n : WeakSet,
		"%Function.prototype.call%": ne,
		"%Function.prototype.apply%": te,
		"%Object.defineProperty%": x,
		"%Object.getPrototypeOf%": E,
		"%Math.abs%": d,
		"%Math.floor%": f,
		"%Math.max%": p,
		"%Math.min%": m,
		"%Math.pow%": h,
		"%Math.round%": g,
		"%Math.sign%": _,
		"%Reflect.getPrototypeOf%": ee
	};
	if (T) try {
		null.error;
	} catch (e) {
		O["%Error.prototype%"] = T(T(e));
	}
	var ie = function e(t) {
		var n;
		if (t === "%AsyncFunction%") n = y("async function () {}");
		else if (t === "%GeneratorFunction%") n = y("function* () {}");
		else if (t === "%AsyncGeneratorFunction%") n = y("async function* () {}");
		else if (t === "%AsyncGenerator%") {
			var r = e("%AsyncGeneratorFunction%");
			r && (n = r.prototype);
		} else if (t === "%AsyncIteratorPrototype%") {
			var i = e("%AsyncGenerator%");
			i && T && (n = T(i.prototype));
		}
		return O[t] = n, n;
	}, ae = {
		__proto__: null,
		"%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
		"%ArrayPrototype%": ["Array", "prototype"],
		"%ArrayProto_entries%": [
			"Array",
			"prototype",
			"entries"
		],
		"%ArrayProto_forEach%": [
			"Array",
			"prototype",
			"forEach"
		],
		"%ArrayProto_keys%": [
			"Array",
			"prototype",
			"keys"
		],
		"%ArrayProto_values%": [
			"Array",
			"prototype",
			"values"
		],
		"%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
		"%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
		"%AsyncGeneratorPrototype%": [
			"AsyncGeneratorFunction",
			"prototype",
			"prototype"
		],
		"%BooleanPrototype%": ["Boolean", "prototype"],
		"%DataViewPrototype%": ["DataView", "prototype"],
		"%DatePrototype%": ["Date", "prototype"],
		"%ErrorPrototype%": ["Error", "prototype"],
		"%EvalErrorPrototype%": ["EvalError", "prototype"],
		"%Float32ArrayPrototype%": ["Float32Array", "prototype"],
		"%Float64ArrayPrototype%": ["Float64Array", "prototype"],
		"%FunctionPrototype%": ["Function", "prototype"],
		"%Generator%": ["GeneratorFunction", "prototype"],
		"%GeneratorPrototype%": [
			"GeneratorFunction",
			"prototype",
			"prototype"
		],
		"%Int8ArrayPrototype%": ["Int8Array", "prototype"],
		"%Int16ArrayPrototype%": ["Int16Array", "prototype"],
		"%Int32ArrayPrototype%": ["Int32Array", "prototype"],
		"%JSONParse%": ["JSON", "parse"],
		"%JSONStringify%": ["JSON", "stringify"],
		"%MapPrototype%": ["Map", "prototype"],
		"%NumberPrototype%": ["Number", "prototype"],
		"%ObjectPrototype%": ["Object", "prototype"],
		"%ObjProto_toString%": [
			"Object",
			"prototype",
			"toString"
		],
		"%ObjProto_valueOf%": [
			"Object",
			"prototype",
			"valueOf"
		],
		"%PromisePrototype%": ["Promise", "prototype"],
		"%PromiseProto_then%": [
			"Promise",
			"prototype",
			"then"
		],
		"%Promise_all%": ["Promise", "all"],
		"%Promise_reject%": ["Promise", "reject"],
		"%Promise_resolve%": ["Promise", "resolve"],
		"%RangeErrorPrototype%": ["RangeError", "prototype"],
		"%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
		"%RegExpPrototype%": ["RegExp", "prototype"],
		"%SetPrototype%": ["Set", "prototype"],
		"%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
		"%StringPrototype%": ["String", "prototype"],
		"%SymbolPrototype%": ["Symbol", "prototype"],
		"%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
		"%TypedArrayPrototype%": ["TypedArray", "prototype"],
		"%TypeErrorPrototype%": ["TypeError", "prototype"],
		"%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
		"%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
		"%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
		"%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
		"%URIErrorPrototype%": ["URIError", "prototype"],
		"%WeakMapPrototype%": ["WeakMap", "prototype"],
		"%WeakSetPrototype%": ["WeakSet", "prototype"]
	}, k = Nb(), oe = Vb(), se = k.call(ne, Array.prototype.concat), ce = k.call(te, Array.prototype.splice), le = k.call(ne, String.prototype.replace), ue = k.call(ne, String.prototype.slice), de = k.call(ne, RegExp.prototype.exec), fe = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, pe = /\\(\\)?/g, me = function(e) {
		var t = ue(e, 0, 1), n = ue(e, -1);
		if (t === "%" && n !== "%") throw new c("invalid intrinsic syntax, expected closing `%`");
		if (n === "%" && t !== "%") throw new c("invalid intrinsic syntax, expected opening `%`");
		var r = [];
		return le(e, fe, function(e, t, n, i) {
			r[r.length] = n ? le(i, pe, "$1") : t || e;
		}), r;
	}, he = function(e, t) {
		var n = e, r;
		if (oe(ae, n) && (r = ae[n], n = "%" + r[0] + "%"), oe(O, n)) {
			var i = O[n];
			if (i === D && (i = ie(n)), i === void 0 && !t) throw new l("intrinsic " + e + " exists, but is not available. Please file an issue!");
			return {
				alias: r,
				name: n,
				value: i
			};
		}
		throw new c("intrinsic " + e + " does not exist!");
	};
	t.exports = function(e, t) {
		if (typeof e != "string" || e.length === 0) throw new l("intrinsic name must be a non-empty string");
		if (arguments.length > 1 && typeof t != "boolean") throw new l("\"allowMissing\" argument must be a boolean");
		if (de(/^%?[^%]*%?$/, e) === null) throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
		var n = me(e), r = n.length > 0 ? n[0] : "", i = he("%" + r + "%", t), a = i.name, o = i.value, s = !1, u = i.alias;
		u && (r = u[0], ce(n, se([0, 1], u)));
		for (var d = 1, f = !0; d < n.length; d += 1) {
			var p = n[d], m = ue(p, 0, 1), h = ue(p, -1);
			if ((m === "\"" || m === "'" || m === "`" || h === "\"" || h === "'" || h === "`") && m !== h) throw new c("property names with quotes must have matching quotes");
			if ((p === "constructor" || !f) && (s = !0), r += "." + p, a = "%" + r + "%", oe(O, a)) o = O[a];
			else if (o != null) {
				if (!(p in o)) {
					if (!t) throw new l("base intrinsic for " + e + " exists, but the property is not available.");
					return;
				}
				if (b && d + 1 >= n.length) {
					var g = b(o, p);
					f = !!g, o = f && "get" in g && !("originalValue" in g.get) ? g.get : o[p];
				} else f = oe(o, p), o = o[p];
				f && !s && (O[a] = o);
			}
		}
		return o;
	};
})), Ub = /* @__PURE__ */ A(((e, t) => {
	var n = Hb(), r = Rb(), i = r([n("%String.prototype.indexOf%")]);
	t.exports = function(e, t) {
		var a = n(e, !!t);
		return typeof a == "function" && i(e, ".prototype.") > -1 ? r([a]) : a;
	};
})), Wb = /* @__PURE__ */ A(((e, t) => {
	var n = lb()(), r = Ub()("Object.prototype.toString"), i = function(e) {
		return n && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : r(e) === "[object Arguments]";
	}, a = function(e) {
		return i(e) ? !0 : typeof e == "object" && !!e && "length" in e && typeof e.length == "number" && e.length >= 0 && r(e) !== "[object Array]" && "callee" in e && r(e.callee) === "[object Function]";
	}, o = function() {
		return i(arguments);
	}();
	i.isLegacyArguments = a, t.exports = o ? i : a;
})), Gb = /* @__PURE__ */ A(((e, t) => {
	var n = Ub(), r = lb()(), i = Vb(), a = Db(), o;
	if (r) {
		var s = n("RegExp.prototype.exec"), c = {}, l = function() {
			throw c;
		}, u = {
			toString: l,
			valueOf: l
		};
		typeof Symbol.toPrimitive == "symbol" && (u[Symbol.toPrimitive] = l), o = function(e) {
			if (!e || typeof e != "object") return !1;
			var t = a(e, "lastIndex");
			if (!(t && i(t, "value"))) return !1;
			try {
				s(e, u);
			} catch (e) {
				return e === c;
			}
		};
	} else {
		var d = n("Object.prototype.toString"), f = "[object RegExp]";
		o = function(e) {
			return !e || typeof e != "object" && typeof e != "function" ? !1 : d(e) === f;
		};
	}
	t.exports = o;
})), Kb = /* @__PURE__ */ A(((e, t) => {
	var n = Ub(), r = Gb(), i = n("RegExp.prototype.exec"), a = gb();
	t.exports = function(e) {
		if (!r(e)) throw new a("`regex` must be a RegExp");
		return function(t) {
			return i(e, t) !== null;
		};
	};
})), qb = /* @__PURE__ */ A(((e, t) => {
	var n = function* () {}.constructor;
	t.exports = () => n;
})), Jb = /* @__PURE__ */ A(((e, t) => {
	var n = Ub(), r = Kb()(/^\s*(?:function)?\*/), i = lb()(), a = Bb(), o = n("Object.prototype.toString"), s = n("Function.prototype.toString"), c = qb();
	t.exports = function(e) {
		if (typeof e != "function") return !1;
		if (r(s(e))) return !0;
		if (!i) return o(e) === "[object GeneratorFunction]";
		if (!a) return !1;
		var t = c();
		return t && a(e) === t.prototype;
	};
})), Yb = /* @__PURE__ */ A(((e, t) => {
	var n = Function.prototype.toString, r = typeof Reflect == "object" && Reflect !== null && Reflect.apply, i, a;
	if (typeof r == "function" && typeof Object.defineProperty == "function") try {
		i = Object.defineProperty({}, "length", { get: function() {
			throw a;
		} }), a = {}, r(function() {
			throw 42;
		}, null, i);
	} catch (e) {
		e !== a && (r = null);
	}
	else r = null;
	var o = /^\s*class\b/, s = function(e) {
		try {
			var t = n.call(e);
			return o.test(t);
		} catch {
			return !1;
		}
	}, c = function(e) {
		try {
			return s(e) ? !1 : (n.call(e), !0);
		} catch {
			return !1;
		}
	}, l = Object.prototype.toString, u = "[object Object]", d = "[object Function]", f = "[object GeneratorFunction]", p = "[object HTMLAllCollection]", m = "[object HTML document.all class]", h = "[object HTMLCollection]", g = typeof Symbol == "function" && !!Symbol.toStringTag, _ = !(0 in [,]), v = function() {
		return !1;
	};
	if (typeof document == "object") {
		var y = document.all;
		l.call(y) === l.call(document.all) && (v = function(e) {
			if ((_ || !e) && (e === void 0 || typeof e == "object")) try {
				var t = l.call(e);
				return (t === p || t === m || t === h || t === u) && e("") == null;
			} catch {}
			return !1;
		});
	}
	t.exports = r ? function(e) {
		if (v(e)) return !0;
		if (!e || typeof e != "function" && typeof e != "object") return !1;
		try {
			r(e, null, i);
		} catch (e) {
			if (e !== a) return !1;
		}
		return !s(e) && c(e);
	} : function(e) {
		if (v(e)) return !0;
		if (!e || typeof e != "function" && typeof e != "object") return !1;
		if (g) return c(e);
		if (s(e)) return !1;
		var t = l.call(e);
		return t !== d && t !== f && !/^\[object HTML/.test(t) ? !1 : c(e);
	};
})), Xb = /* @__PURE__ */ A(((e, t) => {
	var n = Yb(), r = Object.prototype.toString, i = Object.prototype.hasOwnProperty, a = function(e, t, n) {
		for (var r = 0, a = e.length; r < a; r++) i.call(e, r) && (n == null ? t(e[r], r, e) : t.call(n, e[r], r, e));
	}, o = function(e, t, n) {
		for (var r = 0, i = e.length; r < i; r++) n == null ? t(e.charAt(r), r, e) : t.call(n, e.charAt(r), r, e);
	}, s = function(e, t, n) {
		for (var r in e) i.call(e, r) && (n == null ? t(e[r], r, e) : t.call(n, e[r], r, e));
	};
	function c(e) {
		return r.call(e) === "[object Array]";
	}
	t.exports = function(e, t, r) {
		if (!n(t)) throw TypeError("iterator must be a function");
		var i;
		arguments.length >= 3 && (i = r), c(e) ? a(e, t, i) : typeof e == "string" ? o(e, t, i) : s(e, t, i);
	};
})), Zb = /* @__PURE__ */ A(((e, t) => {
	t.exports = [
		"Float16Array",
		"Float32Array",
		"Float64Array",
		"Int8Array",
		"Int16Array",
		"Int32Array",
		"Uint8Array",
		"Uint8ClampedArray",
		"Uint16Array",
		"Uint32Array",
		"BigInt64Array",
		"BigUint64Array"
	];
})), Qb = /* @__PURE__ */ A(((e, t) => {
	var n = Zb(), r = typeof globalThis > "u" ? global : globalThis;
	t.exports = function() {
		for (var e = [], t = 0; t < n.length; t++) typeof r[n[t]] == "function" && (e[e.length] = n[t]);
		return e;
	};
})), $b = /* @__PURE__ */ A(((e, t) => {
	var n = Ob(), r = hb(), i = gb(), a = Db();
	t.exports = function(e, t, o) {
		if (!e || typeof e != "object" && typeof e != "function") throw new i("`obj` must be an object or a function`");
		if (typeof t != "string" && typeof t != "symbol") throw new i("`property` must be a string or a symbol`");
		if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new i("`nonEnumerable`, if provided, must be a boolean or null");
		if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new i("`nonWritable`, if provided, must be a boolean or null");
		if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new i("`nonConfigurable`, if provided, must be a boolean or null");
		if (arguments.length > 6 && typeof arguments[6] != "boolean") throw new i("`loose`, if provided, must be a boolean");
		var s = arguments.length > 3 ? arguments[3] : null, c = arguments.length > 4 ? arguments[4] : null, l = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 ? arguments[6] : !1, d = !!a && a(e, t);
		if (n) n(e, t, {
			configurable: l === null && d ? d.configurable : !l,
			enumerable: s === null && d ? d.enumerable : !s,
			value: o,
			writable: c === null && d ? d.writable : !c
		});
		else if (u || !s && !c && !l) e[t] = o;
		else throw new r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
	};
})), ex = /* @__PURE__ */ A(((e, t) => {
	var n = Ob(), r = function() {
		return !!n;
	};
	r.hasArrayLengthDefineBug = function() {
		if (!n) return null;
		try {
			return n([], "length", { value: 1 }).length !== 1;
		} catch {
			return !0;
		}
	}, t.exports = r;
})), tx = /* @__PURE__ */ A(((e, t) => {
	var n = Hb(), r = $b(), i = ex()(), a = Db(), o = gb(), s = n("%Math.floor%");
	t.exports = function(e, t) {
		if (typeof e != "function") throw new o("`fn` is not a function");
		if (typeof t != "number" || t < 0 || t > 4294967295 || s(t) !== t) throw new o("`length` must be a positive 32-bit integer");
		var n = arguments.length > 2 && !!arguments[2], c = !0, l = !0;
		if ("length" in e && a) {
			var u = a(e, "length");
			u && !u.configurable && (c = !1), u && !u.writable && (l = !1);
		}
		return (c || l || !n) && (i ? r(e, "length", t, !0, !0) : r(e, "length", t)), e;
	};
})), nx = /* @__PURE__ */ A(((e, t) => {
	var n = Nb(), r = Fb(), i = Lb();
	t.exports = function() {
		return i(n, r, arguments);
	};
})), rx = /* @__PURE__ */ A(((e, t) => {
	var n = tx(), r = Ob(), i = Rb(), a = nx();
	t.exports = function(e) {
		var t = i(arguments), r = e.length - (arguments.length - 1);
		return n(t, 1 + (r > 0 ? r : 0), !0);
	}, r ? r(t.exports, "apply", { value: a }) : t.exports.apply = a;
})), ix = /* @__PURE__ */ A(((e, t) => {
	var n = Xb(), r = Qb(), i = rx(), a = Ub(), o = Db(), s = Bb(), c = a("Object.prototype.toString"), l = lb()(), u = typeof globalThis > "u" ? global : globalThis, d = r(), f = a("String.prototype.slice"), p = a("Array.prototype.indexOf", !0) || function(e, t) {
		for (var n = 0; n < e.length; n += 1) if (e[n] === t) return n;
		return -1;
	}, m = { __proto__: null };
	l && o && s ? n(d, function(e) {
		var t = new u[e]();
		if (Symbol.toStringTag in t && s) {
			var n = s(t), r = o(n, Symbol.toStringTag);
			if (!r && n && (r = o(s(n), Symbol.toStringTag)), r && r.get) {
				var a = i(r.get);
				m["$" + e] = a;
			}
		}
	}) : n(d, function(e) {
		var t = new u[e](), n = t.slice || t.set;
		if (n) {
			var r = i(n);
			m["$" + e] = r;
		}
	});
	var h = function(e) {
		var t = !1;
		return n(m, function(n, r) {
			if (!t) try {
				"$" + n(e) === r && (t = f(r, 1));
			} catch {}
		}), t;
	}, g = function(e) {
		var t = !1;
		return n(m, function(n, r) {
			if (!t) try {
				n(e), t = f(r, 1);
			} catch {}
		}), t;
	};
	t.exports = function(e) {
		if (!e || typeof e != "object") return !1;
		if (!l) {
			var t = f(c(e), 8, -1);
			return p(d, t) > -1 ? t : t === "Object" ? g(e) : !1;
		}
		return o ? h(e) : null;
	};
})), ax = /* @__PURE__ */ A(((e, t) => {
	var n = ix();
	t.exports = function(e) {
		return !!n(e);
	};
})), ox = /* @__PURE__ */ A(((e) => {
	var t = Wb(), n = Jb(), r = ix(), i = ax();
	function a(e) {
		return e.call.bind(e);
	}
	var o = typeof BigInt < "u", s = typeof Symbol < "u", c = a(Object.prototype.toString), l = a(Number.prototype.valueOf), u = a(String.prototype.valueOf), d = a(Boolean.prototype.valueOf);
	if (o) var f = a(BigInt.prototype.valueOf);
	if (s) var p = a(Symbol.prototype.valueOf);
	function m(e, t) {
		if (typeof e != "object") return !1;
		try {
			return t(e), !0;
		} catch {
			return !1;
		}
	}
	e.isArgumentsObject = t, e.isGeneratorFunction = n, e.isTypedArray = i;
	function h(e) {
		return typeof Promise < "u" && e instanceof Promise || typeof e == "object" && !!e && typeof e.then == "function" && typeof e.catch == "function";
	}
	e.isPromise = h;
	function g(e) {
		return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : i(e) || le(e);
	}
	e.isArrayBufferView = g;
	function _(e) {
		return r(e) === "Uint8Array";
	}
	e.isUint8Array = _;
	function v(e) {
		return r(e) === "Uint8ClampedArray";
	}
	e.isUint8ClampedArray = v;
	function y(e) {
		return r(e) === "Uint16Array";
	}
	e.isUint16Array = y;
	function b(e) {
		return r(e) === "Uint32Array";
	}
	e.isUint32Array = b;
	function x(e) {
		return r(e) === "Int8Array";
	}
	e.isInt8Array = x;
	function S(e) {
		return r(e) === "Int16Array";
	}
	e.isInt16Array = S;
	function C(e) {
		return r(e) === "Int32Array";
	}
	e.isInt32Array = C;
	function w(e) {
		return r(e) === "Float32Array";
	}
	e.isFloat32Array = w;
	function T(e) {
		return r(e) === "Float64Array";
	}
	e.isFloat64Array = T;
	function E(e) {
		return r(e) === "BigInt64Array";
	}
	e.isBigInt64Array = E;
	function ee(e) {
		return r(e) === "BigUint64Array";
	}
	e.isBigUint64Array = ee;
	function te(e) {
		return c(e) === "[object Map]";
	}
	te.working = typeof Map < "u" && te(/* @__PURE__ */ new Map());
	function ne(e) {
		return typeof Map > "u" ? !1 : te.working ? te(e) : e instanceof Map;
	}
	e.isMap = ne;
	function D(e) {
		return c(e) === "[object Set]";
	}
	D.working = typeof Set < "u" && D(/* @__PURE__ */ new Set());
	function re(e) {
		return typeof Set > "u" ? !1 : D.working ? D(e) : e instanceof Set;
	}
	e.isSet = re;
	function O(e) {
		return c(e) === "[object WeakMap]";
	}
	O.working = typeof WeakMap < "u" && O(/* @__PURE__ */ new WeakMap());
	function ie(e) {
		return typeof WeakMap > "u" ? !1 : O.working ? O(e) : e instanceof WeakMap;
	}
	e.isWeakMap = ie;
	function ae(e) {
		return c(e) === "[object WeakSet]";
	}
	ae.working = typeof WeakSet < "u" && ae(/* @__PURE__ */ new WeakSet());
	function k(e) {
		return ae(e);
	}
	e.isWeakSet = k;
	function oe(e) {
		return c(e) === "[object ArrayBuffer]";
	}
	oe.working = typeof ArrayBuffer < "u" && oe(/* @__PURE__ */ new ArrayBuffer());
	function se(e) {
		return typeof ArrayBuffer > "u" ? !1 : oe.working ? oe(e) : e instanceof ArrayBuffer;
	}
	e.isArrayBuffer = se;
	function ce(e) {
		return c(e) === "[object DataView]";
	}
	ce.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && ce(new DataView(/* @__PURE__ */ new ArrayBuffer(1), 0, 1));
	function le(e) {
		return typeof DataView > "u" ? !1 : ce.working ? ce(e) : e instanceof DataView;
	}
	e.isDataView = le;
	var ue = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
	function de(e) {
		return c(e) === "[object SharedArrayBuffer]";
	}
	function fe(e) {
		return ue === void 0 ? !1 : (de.working === void 0 && (de.working = de(new ue())), de.working ? de(e) : e instanceof ue);
	}
	e.isSharedArrayBuffer = fe;
	function pe(e) {
		return c(e) === "[object AsyncFunction]";
	}
	e.isAsyncFunction = pe;
	function me(e) {
		return c(e) === "[object Map Iterator]";
	}
	e.isMapIterator = me;
	function he(e) {
		return c(e) === "[object Set Iterator]";
	}
	e.isSetIterator = he;
	function ge(e) {
		return c(e) === "[object Generator]";
	}
	e.isGeneratorObject = ge;
	function _e(e) {
		return c(e) === "[object WebAssembly.Module]";
	}
	e.isWebAssemblyCompiledModule = _e;
	function ve(e) {
		return m(e, l);
	}
	e.isNumberObject = ve;
	function ye(e) {
		return m(e, u);
	}
	e.isStringObject = ye;
	function be(e) {
		return m(e, d);
	}
	e.isBooleanObject = be;
	function xe(e) {
		return o && m(e, f);
	}
	e.isBigIntObject = xe;
	function Se(e) {
		return s && m(e, p);
	}
	e.isSymbolObject = Se;
	function A(e) {
		return ve(e) || ye(e) || be(e) || xe(e) || Se(e);
	}
	e.isBoxedPrimitive = A;
	function Ce(e) {
		return typeof Uint8Array < "u" && (se(e) || fe(e));
	}
	e.isAnyArrayBuffer = Ce, [
		"isProxy",
		"isExternal",
		"isModuleNamespaceObject"
	].forEach(function(t) {
		Object.defineProperty(e, t, {
			enumerable: !1,
			value: function() {
				throw Error(t + " is not supported in userland");
			}
		});
	});
})), sx = /* @__PURE__ */ A(((e, t) => {
	t.exports = function(e) {
		return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
	};
})), cx = /* @__PURE__ */ A(((e, t) => {
	typeof Object.create == "function" ? t.exports = function(e, t) {
		t && (e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
			value: e,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }));
	} : t.exports = function(e, t) {
		if (t) {
			e.super_ = t;
			var n = function() {};
			n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
		}
	};
})), lx = /* @__PURE__ */ A(((e) => {
	var t = Object.getOwnPropertyDescriptors || function(e) {
		for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
		return n;
	}, n = /%[sdj%]/g;
	e.format = function(e) {
		if (!x(e)) {
			for (var t = [], r = 0; r < arguments.length; r++) t.push(o(arguments[r]));
			return t.join(" ");
		}
		for (var r = 1, i = arguments, a = i.length, s = String(e).replace(n, function(e) {
			if (e === "%%") return "%";
			if (r >= a) return e;
			switch (e) {
				case "%s": return String(i[r++]);
				case "%d": return Number(i[r++]);
				case "%j": try {
					return JSON.stringify(i[r++]);
				} catch {
					return "[Circular]";
				}
				default: return e;
			}
		}), c = i[r]; r < a; c = i[++r]) v(c) || !T(c) ? s += " " + c : s += " " + o(c);
		return s;
	}, e.deprecate = function(t, n) {
		if (typeof process < "u" && process.noDeprecation === !0) return t;
		if (typeof process > "u") return function() {
			return e.deprecate(t, n).apply(this, arguments);
		};
		var r = !1;
		function i() {
			if (!r) {
				if (process.throwDeprecation) throw Error(n);
				process.traceDeprecation ? console.trace(n) : console.error(n), r = !0;
			}
			return t.apply(this, arguments);
		}
		return i;
	};
	var r = {}, i = /^$/;
	if (process.env.NODE_DEBUG) {
		var a = process.env.NODE_DEBUG;
		a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = RegExp("^" + a + "$", "i");
	}
	e.debuglog = function(t) {
		if (t = t.toUpperCase(), !r[t]) if (i.test(t)) {
			var n = process.pid;
			r[t] = function() {
				var r = e.format.apply(e, arguments);
				console.error("%s %d: %s", t, n, r);
			};
		} else r[t] = function() {};
		return r[t];
	};
	function o(t, n) {
		var r = {
			seen: [],
			stylize: c
		};
		return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), _(n) ? r.showHidden = n : n && e._extend(r, n), C(r.showHidden) && (r.showHidden = !1), C(r.depth) && (r.depth = 2), C(r.colors) && (r.colors = !1), C(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = s), u(r, t, r.depth);
	}
	e.inspect = o, o.colors = {
		bold: [1, 22],
		italic: [3, 23],
		underline: [4, 24],
		inverse: [7, 27],
		white: [37, 39],
		grey: [90, 39],
		black: [30, 39],
		blue: [34, 39],
		cyan: [36, 39],
		green: [32, 39],
		magenta: [35, 39],
		red: [31, 39],
		yellow: [33, 39]
	}, o.styles = {
		special: "cyan",
		number: "yellow",
		boolean: "yellow",
		undefined: "grey",
		null: "bold",
		string: "green",
		date: "magenta",
		regexp: "red"
	};
	function s(e, t) {
		var n = o.styles[t];
		return n ? "\x1B[" + o.colors[n][0] + "m" + e + "\x1B[" + o.colors[n][1] + "m" : e;
	}
	function c(e, t) {
		return e;
	}
	function l(e) {
		var t = {};
		return e.forEach(function(e, n) {
			t[e] = !0;
		}), t;
	}
	function u(t, n, r) {
		if (t.customInspect && n && te(n.inspect) && n.inspect !== e.inspect && !(n.constructor && n.constructor.prototype === n)) {
			var i = n.inspect(r, t);
			return x(i) || (i = u(t, i, r)), i;
		}
		var a = d(t, n);
		if (a) return a;
		var o = Object.keys(n), s = l(o);
		if (t.showHidden && (o = Object.getOwnPropertyNames(n)), ee(n) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return f(n);
		if (o.length === 0) {
			if (te(n)) {
				var c = n.name ? ": " + n.name : "";
				return t.stylize("[Function" + c + "]", "special");
			}
			if (w(n)) return t.stylize(RegExp.prototype.toString.call(n), "regexp");
			if (E(n)) return t.stylize(Date.prototype.toString.call(n), "date");
			if (ee(n)) return f(n);
		}
		var _ = "", v = !1, y = ["{", "}"];
		if (g(n) && (v = !0, y = ["[", "]"]), te(n) && (_ = " [Function" + (n.name ? ": " + n.name : "") + "]"), w(n) && (_ = " " + RegExp.prototype.toString.call(n)), E(n) && (_ = " " + Date.prototype.toUTCString.call(n)), ee(n) && (_ = " " + f(n)), o.length === 0 && (!v || n.length == 0)) return y[0] + _ + y[1];
		if (r < 0) return w(n) ? t.stylize(RegExp.prototype.toString.call(n), "regexp") : t.stylize("[Object]", "special");
		t.seen.push(n);
		var b = v ? p(t, n, r, s, o) : o.map(function(e) {
			return m(t, n, r, s, e, v);
		});
		return t.seen.pop(), h(b, _, y);
	}
	function d(e, t) {
		if (C(t)) return e.stylize("undefined", "undefined");
		if (x(t)) {
			var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\"") + "'";
			return e.stylize(n, "string");
		}
		if (b(t)) return e.stylize("" + t, "number");
		if (_(t)) return e.stylize("" + t, "boolean");
		if (v(t)) return e.stylize("null", "null");
	}
	function f(e) {
		return "[" + Error.prototype.toString.call(e) + "]";
	}
	function p(e, t, n, r, i) {
		for (var a = [], o = 0, s = t.length; o < s; ++o) ae(t, String(o)) ? a.push(m(e, t, n, r, String(o), !0)) : a.push("");
		return i.forEach(function(i) {
			i.match(/^\d+$/) || a.push(m(e, t, n, r, i, !0));
		}), a;
	}
	function m(e, t, n, r, i, a) {
		var o, s, c = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] };
		if (c.get ? s = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), ae(r, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(c.value) < 0 ? (s = v(n) ? u(e, c.value, null) : u(e, c.value, n - 1), s.indexOf("\n") > -1 && (s = a ? s.split("\n").map(function(e) {
			return "  " + e;
		}).join("\n").slice(2) : "\n" + s.split("\n").map(function(e) {
			return "   " + e;
		}).join("\n"))) : s = e.stylize("[Circular]", "special")), C(o)) {
			if (a && i.match(/^\d+$/)) return s;
			o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.slice(1, -1), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, "\"").replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
		}
		return o + ": " + s;
	}
	function h(e, t, n) {
		var r = 0;
		return e.reduce(function(e, t) {
			return r++, t.indexOf("\n") >= 0 && r++, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
		}, 0) > 60 ? n[0] + (t === "" ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1] : n[0] + t + " " + e.join(", ") + " " + n[1];
	}
	e.types = ox();
	function g(e) {
		return Array.isArray(e);
	}
	e.isArray = g;
	function _(e) {
		return typeof e == "boolean";
	}
	e.isBoolean = _;
	function v(e) {
		return e === null;
	}
	e.isNull = v;
	function y(e) {
		return e == null;
	}
	e.isNullOrUndefined = y;
	function b(e) {
		return typeof e == "number";
	}
	e.isNumber = b;
	function x(e) {
		return typeof e == "string";
	}
	e.isString = x;
	function S(e) {
		return typeof e == "symbol";
	}
	e.isSymbol = S;
	function C(e) {
		return e === void 0;
	}
	e.isUndefined = C;
	function w(e) {
		return T(e) && D(e) === "[object RegExp]";
	}
	e.isRegExp = w, e.types.isRegExp = w;
	function T(e) {
		return typeof e == "object" && !!e;
	}
	e.isObject = T;
	function E(e) {
		return T(e) && D(e) === "[object Date]";
	}
	e.isDate = E, e.types.isDate = E;
	function ee(e) {
		return T(e) && (D(e) === "[object Error]" || e instanceof Error);
	}
	e.isError = ee, e.types.isNativeError = ee;
	function te(e) {
		return typeof e == "function";
	}
	e.isFunction = te;
	function ne(e) {
		return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || e === void 0;
	}
	e.isPrimitive = ne, e.isBuffer = sx();
	function D(e) {
		return Object.prototype.toString.call(e);
	}
	function re(e) {
		return e < 10 ? "0" + e.toString(10) : e.toString(10);
	}
	var O = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	];
	function ie() {
		var e = /* @__PURE__ */ new Date(), t = [
			re(e.getHours()),
			re(e.getMinutes()),
			re(e.getSeconds())
		].join(":");
		return [
			e.getDate(),
			O[e.getMonth()],
			t
		].join(" ");
	}
	e.log = function() {
		console.log("%s - %s", ie(), e.format.apply(e, arguments));
	}, e.inherits = cx(), e._extend = function(e, t) {
		if (!t || !T(t)) return e;
		for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
		return e;
	};
	function ae(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t);
	}
	var k = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
	e.promisify = function(e) {
		if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
		if (k && e[k]) {
			var n = e[k];
			if (typeof n != "function") throw TypeError("The \"util.promisify.custom\" argument must be of type Function");
			return Object.defineProperty(n, k, {
				value: n,
				enumerable: !1,
				writable: !1,
				configurable: !0
			}), n;
		}
		function n() {
			for (var t, n, r = new Promise(function(e, r) {
				t = e, n = r;
			}), i = [], a = 0; a < arguments.length; a++) i.push(arguments[a]);
			i.push(function(e, r) {
				e ? n(e) : t(r);
			});
			try {
				e.apply(this, i);
			} catch (e) {
				n(e);
			}
			return r;
		}
		return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), k && Object.defineProperty(n, k, {
			value: n,
			enumerable: !1,
			writable: !1,
			configurable: !0
		}), Object.defineProperties(n, t(e));
	}, e.promisify.custom = k;
	function oe(e, t) {
		if (!e) {
			var n = /* @__PURE__ */ Error("Promise was rejected with a falsy value");
			n.reason = e, e = n;
		}
		return t(e);
	}
	function se(e) {
		if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
		function n() {
			for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n]);
			var r = t.pop();
			if (typeof r != "function") throw TypeError("The last argument must be of type Function");
			var i = this, a = function() {
				return r.apply(i, arguments);
			};
			e.apply(this, t).then(function(e) {
				process.nextTick(a.bind(null, null, e));
			}, function(e) {
				process.nextTick(oe.bind(null, e, a));
			});
		}
		return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), Object.defineProperties(n, t(e)), n;
	}
	e.callbackify = se;
})), ux = /* @__PURE__ */ A(((e) => {
	(function() {
		var t = {
			not_string: /[^s]/,
			not_bool: /[^t]/,
			not_type: /[^T]/,
			not_primitive: /[^v]/,
			number: /[diefg]/,
			numeric_arg: /[bcdiefguxX]/,
			json: /[j]/,
			not_json: /[^j]/,
			text: /^[^\x25]+/,
			modulo: /^\x25{2}/,
			placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
			key: /^([a-z_][a-z_\d]*)/i,
			key_access: /^\.([a-z_][a-z_\d]*)/i,
			index_access: /^\[(\d+)\]/,
			sign: /^[+-]/
		};
		function n(e) {
			return i(o(e), arguments);
		}
		function r(e, t) {
			return n.apply(null, [e].concat(t || []));
		}
		function i(e, r) {
			var i = 1, a = e.length, o, s = "", c, l, u, d, f, p, m, h;
			for (c = 0; c < a; c++) if (typeof e[c] == "string") s += e[c];
			else if (typeof e[c] == "object") {
				if (u = e[c], u.keys) for (o = r[i], l = 0; l < u.keys.length; l++) {
					if (o == null) throw Error(n("[sprintf] Cannot access property \"%s\" of undefined value \"%s\"", u.keys[l], u.keys[l - 1]));
					o = o[u.keys[l]];
				}
				else o = u.param_no ? r[u.param_no] : r[i++];
				if (t.not_type.test(u.type) && t.not_primitive.test(u.type) && o instanceof Function && (o = o()), t.numeric_arg.test(u.type) && typeof o != "number" && isNaN(o)) throw TypeError(n("[sprintf] expecting number but found %T", o));
				switch (t.number.test(u.type) && (m = o >= 0), u.type) {
					case "b":
						o = parseInt(o, 10).toString(2);
						break;
					case "c":
						o = String.fromCharCode(parseInt(o, 10));
						break;
					case "d":
					case "i":
						o = parseInt(o, 10);
						break;
					case "j":
						o = JSON.stringify(o, null, u.width ? parseInt(u.width) : 0);
						break;
					case "e":
						o = u.precision ? parseFloat(o).toExponential(u.precision) : parseFloat(o).toExponential();
						break;
					case "f":
						o = u.precision ? parseFloat(o).toFixed(u.precision) : parseFloat(o);
						break;
					case "g":
						o = u.precision ? String(Number(o.toPrecision(u.precision))) : parseFloat(o);
						break;
					case "o":
						o = (parseInt(o, 10) >>> 0).toString(8);
						break;
					case "s":
						o = String(o), o = u.precision ? o.substring(0, u.precision) : o;
						break;
					case "t":
						o = String(!!o), o = u.precision ? o.substring(0, u.precision) : o;
						break;
					case "T":
						o = Object.prototype.toString.call(o).slice(8, -1).toLowerCase(), o = u.precision ? o.substring(0, u.precision) : o;
						break;
					case "u":
						o = parseInt(o, 10) >>> 0;
						break;
					case "v":
						o = o.valueOf(), o = u.precision ? o.substring(0, u.precision) : o;
						break;
					case "x":
						o = (parseInt(o, 10) >>> 0).toString(16);
						break;
					case "X":
						o = (parseInt(o, 10) >>> 0).toString(16).toUpperCase();
						break;
				}
				t.json.test(u.type) ? s += o : (t.number.test(u.type) && (!m || u.sign) ? (h = m ? "+" : "-", o = o.toString().replace(t.sign, "")) : h = "", f = u.pad_char ? u.pad_char === "0" ? "0" : u.pad_char.charAt(1) : " ", p = u.width - (h + o).length, d = u.width && p > 0 ? f.repeat(p) : "", s += u.align ? h + o + d : f === "0" ? h + d + o : d + h + o);
			}
			return s;
		}
		var a = Object.create(null);
		function o(e) {
			if (a[e]) return a[e];
			for (var n = e, r, i = [], o = 0; n;) {
				if ((r = t.text.exec(n)) !== null) i.push(r[0]);
				else if ((r = t.modulo.exec(n)) !== null) i.push("%");
				else if ((r = t.placeholder.exec(n)) !== null) {
					if (r[2]) {
						o |= 1;
						var s = [], c = r[2], l = [];
						if ((l = t.key.exec(c)) !== null) for (s.push(l[1]); (c = c.substring(l[0].length)) !== "";) if ((l = t.key_access.exec(c)) !== null) s.push(l[1]);
						else if ((l = t.index_access.exec(c)) !== null) s.push(l[1]);
						else throw SyntaxError("[sprintf] failed to parse named argument key");
						else throw SyntaxError("[sprintf] failed to parse named argument key");
						r[2] = s;
					} else o |= 2;
					if (o === 3) throw Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
					i.push({
						placeholder: r[0],
						param_no: r[1],
						keys: r[2],
						sign: r[3],
						pad_char: r[4],
						align: r[5],
						width: r[6],
						precision: r[7],
						type: r[8]
					});
				} else throw SyntaxError("[sprintf] unexpected placeholder");
				n = n.substring(r[0].length);
			}
			return a[e] = i;
		}
		e !== void 0 && (e.sprintf = n, e.vsprintf = r), typeof window < "u" && (window.sprintf = n, window.vsprintf = r, typeof define == "function" && define.amd && define(function() {
			return {
				sprintf: n,
				vsprintf: r
			};
		}));
	})();
})), dx = /* @__PURE__ */ A(((e, t) => {
	var n = typeof Reflect == "object" ? Reflect : null, r = n && typeof n.apply == "function" ? n.apply : function(e, t, n) {
		return Function.prototype.apply.call(e, t, n);
	}, i = n && typeof n.ownKeys == "function" ? n.ownKeys : Object.getOwnPropertySymbols ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : function(e) {
		return Object.getOwnPropertyNames(e);
	};
	function a(e) {
		console && console.warn && console.warn(e);
	}
	var o = Number.isNaN || function(e) {
		return e !== e;
	};
	function s() {
		s.init.call(this);
	}
	t.exports = s, t.exports.once = y, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
	var c = 10;
	function l(e) {
		if (typeof e != "function") throw TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
	}
	Object.defineProperty(s, "defaultMaxListeners", {
		enumerable: !0,
		get: function() {
			return c;
		},
		set: function(e) {
			if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + e + ".");
			c = e;
		}
	}), s.init = function() {
		(this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	}, s.prototype.setMaxListeners = function(e) {
		if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + e + ".");
		return this._maxListeners = e, this;
	};
	function u(e) {
		return e._maxListeners === void 0 ? s.defaultMaxListeners : e._maxListeners;
	}
	s.prototype.getMaxListeners = function() {
		return u(this);
	}, s.prototype.emit = function(e) {
		for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
		var i = e === "error", a = this._events;
		if (a !== void 0) i &&= a.error === void 0;
		else if (!i) return !1;
		if (i) {
			var o;
			if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
			var s = /* @__PURE__ */ Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
			throw s.context = o, s;
		}
		var c = a[e];
		if (c === void 0) return !1;
		if (typeof c == "function") r(c, this, t);
		else for (var l = c.length, u = g(c, l), n = 0; n < l; ++n) r(u[n], this, t);
		return !0;
	};
	function d(e, t, n, r) {
		var i, o, s;
		if (l(n), o = e._events, o === void 0 ? (o = e._events = Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), s === void 0) s = o[t] = n, ++e._eventsCount;
		else if (typeof s == "function" ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), i = u(e), i > 0 && s.length > i && !s.warned) {
			s.warned = !0;
			var c = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
			c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = s.length, a(c);
		}
		return e;
	}
	s.prototype.addListener = function(e, t) {
		return d(this, e, t, !1);
	}, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(e, t) {
		return d(this, e, t, !0);
	};
	function f() {
		if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	}
	function p(e, t, n) {
		var r = {
			fired: !1,
			wrapFn: void 0,
			target: e,
			type: t,
			listener: n
		}, i = f.bind(r);
		return i.listener = n, r.wrapFn = i, i;
	}
	s.prototype.once = function(e, t) {
		return l(t), this.on(e, p(this, e, t)), this;
	}, s.prototype.prependOnceListener = function(e, t) {
		return l(t), this.prependListener(e, p(this, e, t)), this;
	}, s.prototype.removeListener = function(e, t) {
		var n, r, i, a, o;
		if (l(t), r = this._events, r === void 0 || (n = r[e], n === void 0)) return this;
		if (n === t || n.listener === t) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
		else if (typeof n != "function") {
			for (i = -1, a = n.length - 1; a >= 0; a--) if (n[a] === t || n[a].listener === t) {
				o = n[a].listener, i = a;
				break;
			}
			if (i < 0) return this;
			i === 0 ? n.shift() : _(n, i), n.length === 1 && (r[e] = n[0]), r.removeListener !== void 0 && this.emit("removeListener", e, o || t);
		}
		return this;
	}, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(e) {
		var t, n = this._events, r;
		if (n === void 0) return this;
		if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete n[e]), this;
		if (arguments.length === 0) {
			var i = Object.keys(n), a;
			for (r = 0; r < i.length; ++r) a = i[r], a !== "removeListener" && this.removeAllListeners(a);
			return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
		}
		if (t = n[e], typeof t == "function") this.removeListener(e, t);
		else if (t !== void 0) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
		return this;
	};
	function m(e, t, n) {
		var r = e._events;
		if (r === void 0) return [];
		var i = r[t];
		return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? v(i) : g(i, i.length);
	}
	s.prototype.listeners = function(e) {
		return m(this, e, !0);
	}, s.prototype.rawListeners = function(e) {
		return m(this, e, !1);
	}, s.listenerCount = function(e, t) {
		return typeof e.listenerCount == "function" ? e.listenerCount(t) : h.call(e, t);
	}, s.prototype.listenerCount = h;
	function h(e) {
		var t = this._events;
		if (t !== void 0) {
			var n = t[e];
			if (typeof n == "function") return 1;
			if (n !== void 0) return n.length;
		}
		return 0;
	}
	s.prototype.eventNames = function() {
		return this._eventsCount > 0 ? i(this._events) : [];
	};
	function g(e, t) {
		for (var n = Array(t), r = 0; r < t; ++r) n[r] = e[r];
		return n;
	}
	function _(e, t) {
		for (; t + 1 < e.length; t++) e[t] = e[t + 1];
		e.pop();
	}
	function v(e) {
		for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
		return t;
	}
	function y(e, t) {
		return new Promise(function(n, r) {
			function i(n) {
				e.removeListener(t, a), r(n);
			}
			function a() {
				typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
			}
			x(e, t, a, { once: !0 }), t !== "error" && b(e, i, { once: !0 });
		});
	}
	function b(e, t, n) {
		typeof e.on == "function" && x(e, "error", t, n);
	}
	function x(e, t, n, r) {
		if (typeof e.on == "function") r.once ? e.once(t, n) : e.on(t, n);
		else if (typeof e.addEventListener == "function") e.addEventListener(t, function i(a) {
			r.once && e.removeEventListener(t, i), n(a);
		});
		else throw TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof e);
	}
})), fx = /* @__PURE__ */ A(((e, t) => {
	var n = [].indexOf;
	t.exports = function(e, t) {
		if (n) return e.indexOf(t);
		for (var r = 0; r < e.length; ++r) if (e[r] === t) return r;
		return -1;
	};
})), px = /* @__PURE__ */ A(((e, t) => {
	var n = Array.prototype, r = n.concat, i = n.slice, a = fx();
	function o(e) {
		var t = {}, o = r.apply(n, i.call(arguments, 1));
		for (var s in e) a(o, s) === -1 && (t[s] = e[s]);
		return t;
	}
	t.exports = o;
})), mx = /* @__PURE__ */ A(((e, t) => {
	t.exports = {
		__locale: "en",
		days: [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday"
		],
		abbreviated_days: [
			"Sun",
			"Mon",
			"Tue",
			"Wed",
			"Thu",
			"Fri",
			"Sat"
		],
		months: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		],
		abbreviated_months: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		am: "AM",
		pm: "PM"
	};
})), hx = /* @__PURE__ */ A(((e, t) => {
	t.exports = mx();
})), gx = /* @__PURE__ */ A(((e, t) => {
	var n = hx();
	function r(e, t, c) {
		var l = e.getTime();
		return c ||= n, t.replace(/%([-_0]?.)/g, function(t, n) {
			var u = null;
			if (n.length == 2) {
				switch (n[0]) {
					case "-":
						u = "";
						break;
					case "_":
						u = " ";
						break;
					case "0":
						u = "0";
						break;
					default: return t;
				}
				n = n[1];
			}
			switch (n) {
				case "A": return c.days[e.getDay()];
				case "a": return c.abbreviated_days[e.getDay()];
				case "B": return c.months[e.getMonth()];
				case "b": return c.abbreviated_months[e.getMonth()];
				case "C": return i(Math.floor(e.getFullYear() / 100), u);
				case "D": return r(e, "%m/%d/%y");
				case "d": return i(e.getDate(), u);
				case "e": return e.getDate();
				case "F": return r(e, "%Y-%m-%d");
				case "H": return i(e.getHours(), u);
				case "h": return c.abbreviated_months[e.getMonth()];
				case "I": return i(a(e), u);
				case "j": return i(Math.ceil((e.getTime() - new Date(e.getFullYear(), 0, 1).getTime()) / (1e3 * 60 * 60 * 24)), 3);
				case "k": return i(e.getHours(), u === null ? " " : u);
				case "L": return i(Math.floor(l % 1e3), 3);
				case "l": return i(a(e), u === null ? " " : u);
				case "M": return i(e.getMinutes(), u);
				case "m": return i(e.getMonth() + 1, u);
				case "n": return "\n";
				case "o": return String(e.getDate()) + o(e.getDate());
				case "P": return e.getHours() < 12 ? c.am.toLowerCase() : c.pm.toLowerCase();
				case "p": return e.getHours() < 12 ? c.am.toUpperCase() : c.pm.toUpperCase();
				case "R": return r(e, "%H:%M");
				case "r": return r(e, "%I:%M:%S %p");
				case "S": return i(e.getSeconds(), u);
				case "s": return Math.floor(l / 1e3);
				case "T": return r(e, "%H:%M:%S");
				case "t": return "	";
				case "U": return i(s(e, "sunday"), u);
				case "u": return e.getDay() === 0 ? 7 : e.getDay();
				case "v": return r(e, "%e-%b-%Y");
				case "W": return i(s(e, "monday"), u);
				case "w": return e.getDay();
				case "Y": return e.getFullYear();
				case "y":
					var d = String(e.getFullYear());
					return d.slice(d.length - 2);
				case "Z":
					var f = e.toString().match(/\((\w+)\)/);
					return f && f[1] || "";
				case "z":
					var p = e.getTimezoneOffset();
					return (p > 0 ? "-" : "+") + i(Math.round(Math.abs(p / 60)), 2) + ":" + i(p % 60, 2);
				default: return n;
			}
		});
	}
	function i(e, t, n) {
		typeof t == "number" && (n = t, t = "0"), t === null && (t = "0"), n ||= 2;
		var r = String(e);
		if (t) for (; r.length < n;) r = t + r;
		return r;
	}
	function a(e) {
		var t = e.getHours();
		return t === 0 ? t = 12 : t > 12 && (t -= 12), t;
	}
	function o(e) {
		var t = e % 10, n = e % 100;
		if (n >= 11 && n <= 13 || t === 0 || t >= 4) return "th";
		switch (t) {
			case 1: return "st";
			case 2: return "nd";
			case 3: return "rd";
		}
	}
	function s(e, t) {
		t ||= "sunday";
		var n = e.getDay();
		t == "monday" && (n === 0 ? n = 6 : n--);
		var r = ((e - new Date(e.getFullYear(), 0, 1)) / 864e5 + 7 - n) / 7;
		return Math.floor(r);
	}
	t.exports = r;
})), _x = /* @__PURE__ */ A(((e, t) => {
	t.exports = function(e, t) {
		var n;
		return t === 0 && "zero" in e && (n = "zero"), n ||= t === 1 ? "one" : "other", e[n];
	};
})), vx = /* @__PURE__ */ A(((e, t) => {
	t.exports = { counterpart: {
		names: mx(),
		pluralize: _x(),
		formats: {
			date: {
				default: "%a, %e %b %Y",
				long: "%A, %B %o, %Y",
				short: "%b %e"
			},
			time: {
				default: "%H:%M",
				long: "%H:%M:%S %z",
				short: "%H:%M"
			},
			datetime: {
				default: "%a, %e %b %Y %H:%M",
				long: "%A, %B %o, %Y %H:%M:%S %z",
				short: "%e %b %H:%M"
			}
		}
	} };
})), yx = /* @__PURE__ */ we((/* @__PURE__ */ A(((e, t) => {
	var n = sb(), r = lx().isArray, i = lx().isDate, a = ux().sprintf, o = dx(), s = px(), c = gx(), l = "counterpart";
	function u(e) {
		return typeof e == "string" || Object.prototype.toString.call(e) === "[object String]";
	}
	function d(e) {
		return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
	}
	function f(e) {
		return e === null ? !1 : Object.prototype.toString.call(e) === "[object Object]";
	}
	function p(e) {
		return u(e) && e[0] === ":";
	}
	function m(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t);
	}
	function h(e, t) {
		return t.reduce(function(e, t) {
			return f(e) && m(e, t) ? e[t] : null;
		}, e);
	}
	function g() {
		o.EventEmitter.apply(this), this._registry = {
			locale: "en",
			interpolate: !0,
			fallbackLocales: [],
			scope: null,
			translations: {},
			interpolations: {},
			normalizedKeys: {},
			separator: ".",
			keepTrailingDot: !1,
			keyTransformer: function(e) {
				return e;
			},
			generateMissingEntry: function(e) {
				return "missing translation: " + e;
			}
		}, this.registerTranslations("en", vx()), this.setMaxListeners(0);
	}
	g.prototype = o.EventEmitter.prototype, g.prototype.constructor = o.EventEmitter, g.prototype.getLocale = function() {
		return this._registry.locale;
	}, g.prototype.setLocale = function(e) {
		var t = this._registry.locale;
		return t != e && (this._registry.locale = e, this.emit("localechange", e, t)), t;
	}, g.prototype.getFallbackLocale = function() {
		return this._registry.fallbackLocales;
	}, g.prototype.setFallbackLocale = function(e) {
		var t = this._registry.fallbackLocales;
		return this._registry.fallbackLocales = [].concat(e || []), t;
	}, g.prototype.getAvailableLocales = function() {
		return this._registry.availableLocales || Object.keys(this._registry.translations);
	}, g.prototype.setAvailableLocales = function(e) {
		var t = this.getAvailableLocales();
		return this._registry.availableLocales = e, t;
	}, g.prototype.getSeparator = function() {
		return this._registry.separator;
	}, g.prototype.setSeparator = function(e) {
		var t = this._registry.separator;
		return this._registry.separator = e, t;
	}, g.prototype.setInterpolate = function(e) {
		var t = this._registry.interpolate;
		return this._registry.interpolate = e, t;
	}, g.prototype.getInterpolate = function() {
		return this._registry.interpolate;
	}, g.prototype.setKeyTransformer = function(e) {
		var t = this._registry.keyTransformer;
		return this._registry.keyTransformer = e, t;
	}, g.prototype.getKeyTransformer = function() {
		return this._registry.keyTransformer;
	}, g.prototype.setMissingEntryGenerator = function(e) {
		var t = this._registry.generateMissingEntry;
		return this._registry.generateMissingEntry = e, t;
	}, g.prototype.getMissingEntryGenerator = function() {
		return this._registry.generateMissingEntry;
	}, g.prototype.registerTranslations = function(e, t) {
		var r = {};
		return r[e] = t, n(!0, this._registry.translations, r), r;
	}, g.prototype.registerInterpolations = function(e) {
		return n(!0, this._registry.interpolations, e);
	}, g.prototype.onLocaleChange = g.prototype.addLocaleChangeListener = function(e) {
		this.addListener("localechange", e);
	}, g.prototype.offLocaleChange = g.prototype.removeLocaleChangeListener = function(e) {
		this.removeListener("localechange", e);
	}, g.prototype.onTranslationNotFound = g.prototype.addTranslationNotFoundListener = function(e) {
		this.addListener("translationnotfound", e);
	}, g.prototype.offTranslationNotFound = g.prototype.removeTranslationNotFoundListener = function(e) {
		this.removeListener("translationnotfound", e);
	}, g.prototype.onError = g.prototype.addErrorListener = function(e) {
		this.addListener("error", e);
	}, g.prototype.offError = g.prototype.removeErrorListener = function(e) {
		this.removeListener("error", e);
	}, g.prototype.translate = function(e, t) {
		if (!r(e) && !u(e) || !e.length) throw Error("invalid argument: key");
		p(e) && (e = e.substr(1)), e = this._registry.keyTransformer(e, t), t = n(!0, {}, t);
		var i = t.locale || this._registry.locale;
		delete t.locale;
		var a = t.scope || this._registry.scope;
		delete t.scope;
		var o = t.separator || this._registry.separator;
		delete t.separator;
		var s = [].concat(t.fallbackLocale || this._registry.fallbackLocales);
		delete t.fallbackLocale;
		var c = this._normalizeKeys(i, a, e, o), l = h(this._registry.translations, c);
		if (l === null && (this.emit("translationnotfound", i, e, t.fallback, a), t.fallback && (l = this._fallback(i, a, e, t.fallback, t))), l === null && s.length > 0 && s.indexOf(i) === -1) for (var d = 0, f = s.length; d < f; d++) {
			var m = s[d], g = this._normalizeKeys(m, a, e, o);
			if (l = h(this._registry.translations, g), l) {
				i = m;
				break;
			}
		}
		return l === null && (l = this._registry.generateMissingEntry(c.join(o))), l = this._pluralize(i, l, t.count), this._registry.interpolate !== !1 && t.interpolate !== !1 && (l = this._interpolate(l, t)), l;
	}, g.prototype.localize = function(e, t) {
		if (!i(e)) throw Error("invalid argument: object must be a date");
		t = n(!0, {}, t);
		var r = t.locale || this._registry.locale, a = t.scope || l, o = t.type || "datetime", s = t.format || "default";
		return t = {
			locale: r,
			scope: a,
			interpolate: !1
		}, s = this.translate([
			"formats",
			o,
			s
		], n(!0, {}, t)), c(e, s, this.translate("names", t));
	}, g.prototype._pluralize = function(e, t, n) {
		if (typeof t != "object" || !t || typeof n != "number") return t;
		var r = this.translate("pluralize", {
			locale: e,
			scope: l
		});
		return Object.prototype.toString.call(r) === "[object Function]" ? r(t, n) : r;
	}, g.prototype.withLocale = function(e, t, n) {
		var r = this._registry.locale;
		this._registry.locale = e;
		var i = t.call(n);
		return this._registry.locale = r, i;
	}, g.prototype.withScope = function(e, t, n) {
		var r = this._registry.scope;
		this._registry.scope = e;
		var i = t.call(n);
		return this._registry.scope = r, i;
	}, g.prototype.withSeparator = function(e, t, n) {
		var r = this.setSeparator(e), i = t.call(n);
		return this.setSeparator(r), i;
	}, g.prototype._normalizeKeys = function(e, t, n, r) {
		var i = [];
		return i = i.concat(this._normalizeKey(e, r)), i = i.concat(this._normalizeKey(t, r)), i = i.concat(this._normalizeKey(n, r)), i;
	}, g.prototype._normalizeKey = function(e, t) {
		return this._registry.normalizedKeys[t] = this._registry.normalizedKeys[t] || {}, this._registry.normalizedKeys[t][e] = this._registry.normalizedKeys[t][e] || function(e) {
			if (r(e)) {
				var n = e.map(function(e) {
					return this._normalizeKey(e, t);
				}.bind(this));
				return [].concat.apply([], n);
			} else {
				if (e == null) return [];
				for (var i = e.split(t), a = i.length - 1; a >= 0; a--) i[a] === "" && (i.splice(a, 1), this._registry.keepTrailingDot === !0 && a == i.length && (i[i.length - 1] += "" + t));
				return i;
			}
		}.bind(this)(e), this._registry.normalizedKeys[t][e];
	}, g.prototype._interpolate = function(e, t) {
		if (typeof e != "string") return e;
		try {
			return a(e, n({}, this._registry.interpolations, t));
		} catch (n) {
			if (this.listenerCount("error") > 0) this.emit("error", n, e, t);
			else throw n;
			return null;
		}
	}, g.prototype._resolve = function(e, t, r, i, a) {
		if (a ||= {}, a.resolve === !1) return i;
		var o;
		if (p(i)) o = this.translate(i, n({}, a, {
			locale: e,
			scope: t
		}));
		else if (d(i)) {
			var s;
			a.object ? (s = a.object, delete a.object) : s = r, o = this._resolve(e, t, r, i(s, a));
		} else o = i;
		return /^missing translation:/.test(o) ? null : o;
	}, g.prototype._fallback = function(e, t, n, i, a) {
		if (a = s(a, "fallback"), r(i)) {
			for (var o = 0, c = i.length; o < c; o++) {
				var l = this._resolve(e, t, n, i[o], a);
				if (l) return l;
			}
			return null;
		} else return this._resolve(e, t, n, i, a);
	};
	var _ = new g();
	function v() {
		return _.translate.apply(_, arguments);
	}
	n(v, _, {
		Instance: g,
		Translator: g
	}), t.exports = v;
})))(), 1), bx = "i18n/";
yx.default.setSeparator("|");
var xx = "en";
yx.default.setFallbackLocale(xx);
function Sx(e, t) {
	yx.default.registerTranslations(e, t);
}
function Cx(e) {
	yx.default.setMissingEntryGenerator(e);
}
function wx() {
	return yx.default.getLocale();
}
function Tx(e) {
	return yx.default.setLocale(e);
}
function Ex(e) {
	return e;
}
function Dx(e) {
	return typeof e == "string" && !e.startsWith("missing translation:");
}
var Ox = (e, t) => {
	let n = yx.default.translate(e, {
		...t,
		fallbackLocale: yx.default.getLocale()
	});
	if (Dx(n)) return { translated: n };
	let r = yx.default.translate(e, {
		...t,
		locale: xx
	});
	return Dx(r) ? {
		translated: r,
		isFallback: !0
	} : {
		translated: e,
		isFallback: !0
	};
};
function kx(e, t) {
	let n = {
		...t,
		interpolate: !1
	};
	return n && typeof n == "object" && Object.keys(n).forEach((e) => {
		n[e] === void 0 && (console.warn("safeCounterpartTranslate called with undefined interpolation name: " + e), n[e] = "undefined"), n[e] === null && (console.warn("safeCounterpartTranslate called with null interpolation name: " + e), n[e] = "null");
	}), Ox(e, n);
}
var Ax = (e, t) => e;
function J(e, t, n) {
	let { translated: r } = kx(e, t);
	return Ax(Px(r, t, n), e);
}
function jx(e) {
	return kx(e, {}).translated;
}
function Mx(e, n, r) {
	let { translated: i, isFallback: a } = kx(e, n), o = Px(i, n, r);
	return Ax(a ? /* @__PURE__ */ t.createElement("span", { lang: "en" }, o) : o, e);
}
function Nx(e) {
	return e.replace(/%\(([^)]*)\)/g, "%\xA0($1)");
}
function Px(e, t, n) {
	let r = e;
	if (t !== void 0) {
		let e = {};
		for (let n in t) e[`%\\(${n}\\)s`] = t[n];
		r = Fx(r, e);
	}
	if (n !== void 0) {
		let e = {};
		for (let t in n) e[`(<${t}>(.*?)<\\/${t}>|<${t}>|<${t}\\s*\\/>)`] = n[t];
		r = Fx(r, e);
	}
	return r;
}
function Fx(e, n) {
	let r = [e], i = !1;
	for (let t in n) {
		let a = new RegExp(t, "g"), o = !1;
		for (let e = 0; e < r.length; e++) {
			let s = r[e];
			if (typeof s != "string") continue;
			let c = a.exec(s);
			if (!c) continue;
			o = !0;
			let l = s.slice(0, c.index), u = [], d;
			for (; c;) {
				d = c;
				let e = c.slice(2), r;
				r = n[t] instanceof Function ? n[t](...e) : n[t], typeof r == "object" && (i = !0), (typeof r != "string" || r !== "") && u.push(r), c = a.exec(s);
				let o;
				if (c) {
					let e = d.index + d[0].length;
					o = s.slice(e, c.index);
				} else o = s.slice(d.index + d[0].length);
				o && u.push(o);
			}
			r.splice(e, 1, ...u), l !== "" && r.splice(e, 0, l);
		}
		o || t !== "%\\(count\\)s" && t !== "%\\(locale\\)s" && console.log(`Could not find ${a} in ${e}`);
	}
	return i ? t.createElement("span", null, ...r) : r.join("");
}
async function Ix(e) {
	let t = await Rx(), n = e in t ? e : "en", r = await Lx(bx + t[n]);
	yx.default.registerTranslations(n, r), yx.default.setLocale(n);
}
async function Lx(e) {
	console.log("Loading language from", e);
	let t = await fetch(e, { method: "GET" });
	if (!t.ok) throw Error(`Failed to load ${e}, got ${t.status}`);
	return t.json();
}
async function Rx() {
	let e = bx + "languages.json", t = await fetch(e, { method: "GET" });
	if (!t.ok) throw Error(`Failed to load ${e}, got ${t.status}`);
	return t.json();
}
//#endregion
//#region src/composer/Banner/Banner.tsx
function zx({ type: e, children: n, avatar: r, className: i, actions: a, onClose: o, ...s }) {
	let c = (0, H.default)(rb.banner, i), l = u(() => {
		switch (e) {
			case "critical": return /* @__PURE__ */ t.createElement(eb, { fontSize: 24 });
			case "info": return /* @__PURE__ */ t.createElement(nb, { fontSize: 24 });
			case "success": return /* @__PURE__ */ t.createElement(Qy, { fontSize: 24 });
			default: return /* @__PURE__ */ t.createElement(nb, { fontSize: 24 });
		}
	}, [e]);
	return /* @__PURE__ */ t.createElement("div", {
		...s,
		className: c,
		"data-type": e
	}, /* @__PURE__ */ t.createElement("div", { className: rb.icon }, r ?? l), /* @__PURE__ */ t.createElement("div", { className: rb.content }, n), /* @__PURE__ */ t.createElement("div", { className: rb.actions }, a, o && /* @__PURE__ */ t.createElement(g, {
		kind: "secondary",
		size: "sm",
		onClick: o
	}, J("action|dismiss"))));
}
//#endregion
//#region src/crypto/SasEmoji/SasEmojiTranslate.ts
var Bx = new Map((/* @__PURE__ */ JSON.parse("[{\"number\":0,\"emoji\":\"🐶\",\"description\":\"Dog\",\"unicode\":\"U+1F436\",\"translated_descriptions\":{\"ar\":\"كلب\",\"bg\":\"Куче\",\"ca\":\"Gos\",\"cs\":\"Pes\",\"de\":\"Hund\",\"eo\":\"Hundo\",\"es\":\"Perro\",\"et\":\"Koer\",\"fa\":\"سگ\",\"fi\":\"Koira\",\"fr\":\"Chien\",\"hr\":\"pas\",\"hu\":\"Kutya\",\"id\":\"Anjing\",\"it\":\"Cane\",\"ja\":\"犬\",\"nb_NO\":\"Hund\",\"nl\":\"Hond\",\"pt\":\"Cão\",\"pt_BR\":\"Cachorro\",\"ru\":\"Собака\",\"si\":\"බල්ලා\",\"sk\":\"Pes\",\"sq\":\"Qen\",\"sr\":\"пас\",\"sv\":\"Hund\",\"szl\":null,\"tzm\":\"Aydi\",\"uk\":\"Пес\",\"vi\":\"Chó\",\"zh_Hans\":\"狗\",\"zh_Hant\":\"狗\"}},{\"number\":1,\"emoji\":\"🐱\",\"description\":\"Cat\",\"unicode\":\"U+1F431\",\"translated_descriptions\":{\"ar\":\"هِرَّة\",\"bg\":\"Котка\",\"ca\":\"Gat\",\"cs\":\"Kočka\",\"de\":\"Katze\",\"eo\":\"Kato\",\"es\":\"Gato\",\"et\":\"Kass\",\"fa\":\"گربه\",\"fi\":\"Kissa\",\"fr\":\"Chat\",\"hr\":\"mačka\",\"hu\":\"Macska\",\"id\":\"Kucing\",\"it\":\"Gatto\",\"ja\":\"猫\",\"nb_NO\":\"Katt\",\"nl\":\"Kat\",\"pt\":\"Gato\",\"pt_BR\":\"Gato\",\"ru\":\"Кошка\",\"si\":\"පූසා\",\"sk\":\"Mačka\",\"sq\":\"Mace\",\"sr\":\"мачка\",\"sv\":\"Katt\",\"szl\":null,\"tzm\":\"Amuc\",\"uk\":\"Кіт\",\"vi\":\"Mèo\",\"zh_Hans\":\"猫\",\"zh_Hant\":\"貓\"}},{\"number\":2,\"emoji\":\"🦁\",\"description\":\"Lion\",\"unicode\":\"U+1F981\",\"translated_descriptions\":{\"ar\":\"أَسَد\",\"bg\":\"Лъв\",\"ca\":\"Lleó\",\"cs\":\"Lev\",\"de\":\"Löwe\",\"eo\":\"Leono\",\"es\":\"León\",\"et\":\"Lõvi\",\"fa\":\"شیر\",\"fi\":\"Leijona\",\"fr\":\"Lion\",\"hr\":\"lav\",\"hu\":\"Oroszlán\",\"id\":\"Singa\",\"it\":\"Leone\",\"ja\":\"ライオン\",\"nb_NO\":\"Løve\",\"nl\":\"Leeuw\",\"pt\":\"Leão\",\"pt_BR\":\"Leão\",\"ru\":\"Лев\",\"si\":\"සිංහයා\",\"sk\":\"Lev\",\"sq\":\"Luan\",\"sr\":\"лав\",\"sv\":\"Lejon\",\"szl\":null,\"tzm\":\"Izem\",\"uk\":\"Лев\",\"vi\":\"Sư tử\",\"zh_Hans\":\"狮子\",\"zh_Hant\":\"獅子\"}},{\"number\":3,\"emoji\":\"🐎\",\"description\":\"Horse\",\"unicode\":\"U+1F40E\",\"translated_descriptions\":{\"ar\":\"حِصَان\",\"bg\":\"Кон\",\"ca\":\"Cavall\",\"cs\":\"Kůň\",\"de\":\"Pferd\",\"eo\":\"Ĉevalo\",\"es\":\"Caballo\",\"et\":\"Hobune\",\"fa\":\"اسب\",\"fi\":\"Hevonen\",\"fr\":\"Cheval\",\"hr\":\"konj\",\"hu\":\"Ló\",\"id\":\"Kuda\",\"it\":\"Cavallo\",\"ja\":\"馬\",\"nb_NO\":\"Hest\",\"nl\":\"Paard\",\"pt\":\"Cavalo\",\"pt_BR\":\"Cavalo\",\"ru\":\"Лошадь\",\"si\":\"අශ්වයා\",\"sk\":\"Kôň\",\"sq\":\"Kalë\",\"sr\":\"коњ\",\"sv\":\"Häst\",\"szl\":null,\"tzm\":\"Ayyis\",\"uk\":\"Кінь\",\"vi\":\"Ngựa\",\"zh_Hans\":\"马\",\"zh_Hant\":\"馬\"}},{\"number\":4,\"emoji\":\"🦄\",\"description\":\"Unicorn\",\"unicode\":\"U+1F984\",\"translated_descriptions\":{\"ar\":\"حصان وحيد القرن\",\"bg\":\"Еднорог\",\"ca\":\"Unicorn\",\"cs\":\"Jednorožec\",\"de\":\"Einhorn\",\"eo\":\"Unukorno\",\"es\":\"Unicornio\",\"et\":\"Ükssarvik\",\"fa\":\"تک شاخ\",\"fi\":\"Yksisarvinen\",\"fr\":\"Licorne\",\"hr\":\"jednorog\",\"hu\":\"Egyszarvú\",\"id\":\"Unicorn\",\"it\":\"Unicorno\",\"ja\":\"ユニコーン\",\"nb_NO\":\"Enhjørning\",\"nl\":\"Eenhoorn\",\"pt\":\"Unicórnio\",\"pt_BR\":\"Unicórnio\",\"ru\":\"Единорог\",\"si\":null,\"sk\":\"Jednorožec\",\"sq\":\"Njëbrirësh\",\"sr\":\"једнорог\",\"sv\":\"Enhörning\",\"szl\":null,\"tzm\":null,\"uk\":\"Єдиноріг\",\"vi\":\"Kỳ lân\",\"zh_Hans\":\"独角兽\",\"zh_Hant\":\"獨角獸\"}},{\"number\":5,\"emoji\":\"🐷\",\"description\":\"Pig\",\"unicode\":\"U+1F437\",\"translated_descriptions\":{\"ar\":\"خِنزِير\",\"bg\":\"Прасе\",\"ca\":\"Porc\",\"cs\":\"Prase\",\"de\":\"Schwein\",\"eo\":\"Porko\",\"es\":\"Cerdo\",\"et\":\"Siga\",\"fa\":\"خوک\",\"fi\":\"Sika\",\"fr\":\"Cochon\",\"hr\":\"svinja\",\"hu\":\"Malac\",\"id\":\"Babi\",\"it\":\"Maiale\",\"ja\":\"ブタ\",\"nb_NO\":\"Gris\",\"nl\":\"Varken\",\"pt\":\"Porco\",\"pt_BR\":\"Porco\",\"ru\":\"Свинья\",\"si\":null,\"sk\":\"Prasa\",\"sq\":\"Derr\",\"sr\":\"прасе\",\"sv\":\"Gris\",\"szl\":null,\"tzm\":\"Ilef\",\"uk\":\"Свиня\",\"vi\":\"Heo\",\"zh_Hans\":\"猪\",\"zh_Hant\":\"豬\"}},{\"number\":6,\"emoji\":\"🐘\",\"description\":\"Elephant\",\"unicode\":\"U+1F418\",\"translated_descriptions\":{\"ar\":\"فِيل\",\"bg\":\"Слон\",\"ca\":\"Elefant\",\"cs\":\"Slon\",\"de\":\"Elefant\",\"eo\":\"Elefanto\",\"es\":\"Elefante\",\"et\":\"Elevant\",\"fa\":\"فیل\",\"fi\":\"Norsu\",\"fr\":\"Éléphant\",\"hr\":\"slon\",\"hu\":\"Elefánt\",\"id\":\"Gajah\",\"it\":\"Elefante\",\"ja\":\"ゾウ\",\"nb_NO\":\"Elefant\",\"nl\":\"Olifant\",\"pt\":\"Elefante\",\"pt_BR\":\"Elefante\",\"ru\":\"Слон\",\"si\":null,\"sk\":\"Slon\",\"sq\":\"Elefant\",\"sr\":\"слон\",\"sv\":\"Elefant\",\"szl\":null,\"tzm\":\"Ilu\",\"uk\":\"Слон\",\"vi\":\"Voi\",\"zh_Hans\":\"大象\",\"zh_Hant\":\"大象\"}},{\"number\":7,\"emoji\":\"🐰\",\"description\":\"Rabbit\",\"unicode\":\"U+1F430\",\"translated_descriptions\":{\"ar\":\"أَرنَب\",\"bg\":\"Заек\",\"ca\":\"Conill\",\"cs\":\"Králík\",\"de\":\"Hase\",\"eo\":\"Kuniklo\",\"es\":\"Conejo\",\"et\":\"Jänes\",\"fa\":\"خرگوش\",\"fi\":\"Kani\",\"fr\":\"Lapin\",\"hr\":\"zec\",\"hu\":\"Nyúl\",\"id\":\"Kelinci\",\"it\":\"Coniglio\",\"ja\":\"うさぎ\",\"nb_NO\":\"Kanin\",\"nl\":\"Konijn\",\"pt\":\"Coelho\",\"pt_BR\":\"Coelho\",\"ru\":\"Кролик\",\"si\":null,\"sk\":\"Zajac\",\"sq\":\"Lepur\",\"sr\":\"зец\",\"sv\":\"Kanin\",\"szl\":null,\"tzm\":\"Agnin\",\"uk\":\"Кріль\",\"vi\":\"Thỏ\",\"zh_Hans\":\"兔子\",\"zh_Hant\":\"兔子\"}},{\"number\":8,\"emoji\":\"🐼\",\"description\":\"Panda\",\"unicode\":\"U+1F43C\",\"translated_descriptions\":{\"ar\":\"باندَا\",\"bg\":\"Панда\",\"ca\":\"Panda\",\"cs\":\"Panda\",\"de\":\"Panda\",\"eo\":\"Pando\",\"es\":\"Panda\",\"et\":\"Panda\",\"fa\":\"پاندا\",\"fi\":\"Panda\",\"fr\":\"Panda\",\"hr\":\"panda\",\"hu\":\"Panda\",\"id\":\"Panda\",\"it\":\"Panda\",\"ja\":\"パンダ\",\"nb_NO\":\"Panda\",\"nl\":\"Panda\",\"pt\":\"Panda\",\"pt_BR\":\"Panda\",\"ru\":\"Панда\",\"si\":null,\"sk\":\"Panda\",\"sq\":\"Panda\",\"sr\":\"панда\",\"sv\":\"Panda\",\"szl\":null,\"tzm\":null,\"uk\":\"Панда\",\"vi\":\"Gấu trúc\",\"zh_Hans\":\"熊猫\",\"zh_Hant\":\"熊貓\"}},{\"number\":9,\"emoji\":\"🐓\",\"description\":\"Rooster\",\"unicode\":\"U+1F413\",\"translated_descriptions\":{\"ar\":\"دِيك\",\"bg\":\"Петел\",\"ca\":\"Gall\",\"cs\":\"Kohout\",\"de\":\"Hahn\",\"eo\":\"Virkoko\",\"es\":\"Gallo\",\"et\":\"Kukk\",\"fa\":\"خروس\",\"fi\":\"Kukko\",\"fr\":\"Coq\",\"hr\":\"kokot\",\"hu\":\"Kakas\",\"id\":\"Ayam\",\"it\":\"Gallo\",\"ja\":\"ニワトリ\",\"nb_NO\":\"Hane\",\"nl\":\"Haan\",\"pt\":\"Galo\",\"pt_BR\":\"Galo\",\"ru\":\"Петух\",\"si\":null,\"sk\":\"Kohút\",\"sq\":\"Këndes\",\"sr\":\"петао\",\"sv\":\"Tupp\",\"szl\":null,\"tzm\":\"Ayaẓiḍ\",\"uk\":\"Когут\",\"vi\":\"Gà trống\",\"zh_Hans\":\"公鸡\",\"zh_Hant\":\"公雞\"}},{\"number\":10,\"emoji\":\"🐧\",\"description\":\"Penguin\",\"unicode\":\"U+1F427\",\"translated_descriptions\":{\"ar\":\"بطريق\",\"bg\":\"Пингвин\",\"ca\":\"Pingüí\",\"cs\":\"Tučňák\",\"de\":\"Pinguin\",\"eo\":\"Pingveno\",\"es\":\"Pingüino\",\"et\":\"Pingviin\",\"fa\":\"پنگوئن\",\"fi\":\"Pingviini\",\"fr\":\"Manchot\",\"hr\":\"pingvin\",\"hu\":\"Pingvin\",\"id\":\"Penguin\",\"it\":\"Pinguino\",\"ja\":\"ペンギン\",\"nb_NO\":\"Pingvin\",\"nl\":\"Pinguïn\",\"pt\":\"Pinguim\",\"pt_BR\":\"Pinguim\",\"ru\":\"Пингвин\",\"si\":null,\"sk\":\"Tučniak\",\"sq\":\"Pinguin\",\"sr\":\"пингвин\",\"sv\":\"Pingvin\",\"szl\":null,\"tzm\":null,\"uk\":\"Пінгвін\",\"vi\":\"Chim cánh cụt\",\"zh_Hans\":\"企鹅\",\"zh_Hant\":\"企鵝\"}},{\"number\":11,\"emoji\":\"🐢\",\"description\":\"Turtle\",\"unicode\":\"U+1F422\",\"translated_descriptions\":{\"ar\":\"سُلحفاة\",\"bg\":\"Костенурка\",\"ca\":\"Tortuga\",\"cs\":\"Želva\",\"de\":\"Schildkröte\",\"eo\":\"Testudo\",\"es\":\"Tortuga\",\"et\":\"Kilpkonn\",\"fa\":\"لاک‌پشت\",\"fi\":\"Kilpikonna\",\"fr\":\"Tortue\",\"hr\":\"kornjača\",\"hu\":\"Teknős\",\"id\":\"Kura-Kura\",\"it\":\"Tartaruga\",\"ja\":\"亀\",\"nb_NO\":\"Skilpadde\",\"nl\":\"Schildpad\",\"pt\":\"Tartaruga\",\"pt_BR\":\"Tartaruga\",\"ru\":\"Черепаха\",\"si\":null,\"sk\":\"Korytnačka\",\"sq\":\"Breshkë\",\"sr\":\"корњача\",\"sv\":\"Sköldpadda\",\"szl\":null,\"tzm\":\"Ifker\",\"uk\":\"Черепаха\",\"vi\":\"Rùa\",\"zh_Hans\":\"乌龟\",\"zh_Hant\":\"烏龜\"}},{\"number\":12,\"emoji\":\"🐟\",\"description\":\"Fish\",\"unicode\":\"U+1F41F\",\"translated_descriptions\":{\"ar\":\"سَمَكة\",\"bg\":\"Риба\",\"ca\":\"Peix\",\"cs\":\"Ryba\",\"de\":\"Fisch\",\"eo\":\"Fiŝo\",\"es\":\"Pez\",\"et\":\"Kala\",\"fa\":\"ماهی\",\"fi\":\"Kala\",\"fr\":\"Poisson\",\"hr\":\"riba\",\"hu\":\"Hal\",\"id\":\"Ikan\",\"it\":\"Pesce\",\"ja\":\"魚\",\"nb_NO\":\"Fisk\",\"nl\":\"Vis\",\"pt\":\"Peixe\",\"pt_BR\":\"Peixe\",\"ru\":\"Рыба\",\"si\":null,\"sk\":\"Ryba\",\"sq\":\"Peshk\",\"sr\":\"риба\",\"sv\":\"Fisk\",\"szl\":null,\"tzm\":\"Aselm\",\"uk\":\"Риба\",\"vi\":\"Cá\",\"zh_Hans\":\"鱼\",\"zh_Hant\":\"魚\"}},{\"number\":13,\"emoji\":\"🐙\",\"description\":\"Octopus\",\"unicode\":\"U+1F419\",\"translated_descriptions\":{\"ar\":\"أُخطُبُوط\",\"bg\":\"Октопод\",\"ca\":\"Pop\",\"cs\":\"Chobotnice\",\"de\":\"Oktopus\",\"eo\":\"Polpo\",\"es\":\"Pulpo\",\"et\":\"Kaheksajalg\",\"fa\":\"اختاپوس\",\"fi\":\"Tursas\",\"fr\":\"Poulpe\",\"hr\":\"hobotnica\",\"hu\":\"Polip\",\"id\":\"Gurita\",\"it\":\"Polpo\",\"ja\":\"たこ\",\"nb_NO\":\"Blekksprut\",\"nl\":\"Octopus\",\"pt\":\"Polvo\",\"pt_BR\":\"Polvo\",\"ru\":\"Осьминог\",\"si\":null,\"sk\":\"Chobotnica\",\"sq\":\"Oktapod\",\"sr\":\"октопод\",\"sv\":\"Bläckfisk\",\"szl\":null,\"tzm\":null,\"uk\":\"Восьминіг\",\"vi\":\"Bạch tuộc\",\"zh_Hans\":\"章鱼\",\"zh_Hant\":\"章魚\"}},{\"number\":14,\"emoji\":\"🦋\",\"description\":\"Butterfly\",\"unicode\":\"U+1F98B\",\"translated_descriptions\":{\"ar\":\"فَرَاشَة\",\"bg\":\"Пеперуда\",\"ca\":\"Papallona\",\"cs\":\"Motýl\",\"de\":\"Schmetterling\",\"eo\":\"Papilio\",\"es\":\"Mariposa\",\"et\":\"Liblikas\",\"fa\":\"پروانه\",\"fi\":\"Perhonen\",\"fr\":\"Papillon\",\"hr\":\"leptir\",\"hu\":\"Pillangó\",\"id\":\"Kupu-Kupu\",\"it\":\"Farfalla\",\"ja\":\"ちょうちょ\",\"nb_NO\":\"Sommerfugl\",\"nl\":\"Vlinder\",\"pt\":\"Borboleta\",\"pt_BR\":\"Borboleta\",\"ru\":\"Бабочка\",\"si\":null,\"sk\":\"Motýľ\",\"sq\":\"Flutur\",\"sr\":\"лептир\",\"sv\":\"Fjäril\",\"szl\":null,\"tzm\":null,\"uk\":\"Метелик\",\"vi\":\"Bướm\",\"zh_Hans\":\"蝴蝶\",\"zh_Hant\":\"蝴蝶\"}},{\"number\":15,\"emoji\":\"🌷\",\"description\":\"Flower\",\"unicode\":\"U+1F337\",\"translated_descriptions\":{\"ar\":\"زَهرَة\",\"bg\":\"Цвете\",\"ca\":\"Flor\",\"cs\":\"Květina\",\"de\":\"Blume\",\"eo\":\"Floro\",\"es\":\"Flor\",\"et\":\"Lill\",\"fa\":\"گل\",\"fi\":\"Kukka\",\"fr\":\"Fleur\",\"hr\":\"svijet\",\"hu\":\"Virág\",\"id\":\"Bunga\",\"it\":\"Fiore\",\"ja\":\"花\",\"nb_NO\":\"Blomst\",\"nl\":\"Bloem\",\"pt\":\"Flor\",\"pt_BR\":\"Flor\",\"ru\":\"Цветок\",\"si\":null,\"sk\":\"Kvet\",\"sq\":\"Lule\",\"sr\":\"цвет\",\"sv\":\"Blomma\",\"szl\":null,\"tzm\":null,\"uk\":\"Квітка\",\"vi\":\"Hoa\",\"zh_Hans\":\"花\",\"zh_Hant\":\"花\"}},{\"number\":16,\"emoji\":\"🌳\",\"description\":\"Tree\",\"unicode\":\"U+1F333\",\"translated_descriptions\":{\"ar\":\"شَجَرَة\",\"bg\":\"Дърво\",\"ca\":\"Arbre\",\"cs\":\"Strom\",\"de\":\"Baum\",\"eo\":\"Arbo\",\"es\":\"Árbol\",\"et\":\"Puu\",\"fa\":\"درخت\",\"fi\":\"Puu\",\"fr\":\"Arbre\",\"hr\":\"drvo\",\"hu\":\"Fa\",\"id\":\"Pohon\",\"it\":\"Albero\",\"ja\":\"木\",\"nb_NO\":\"Tre\",\"nl\":\"Boom\",\"pt\":\"Árvore\",\"pt_BR\":\"Árvore\",\"ru\":\"Дерево\",\"si\":null,\"sk\":\"Strom\",\"sq\":\"Pemë\",\"sr\":\"дрво\",\"sv\":\"Träd\",\"szl\":null,\"tzm\":\"Aseklu\",\"uk\":\"Дерево\",\"vi\":\"Cây\",\"zh_Hans\":\"树\",\"zh_Hant\":\"樹\"}},{\"number\":17,\"emoji\":\"🌵\",\"description\":\"Cactus\",\"unicode\":\"U+1F335\",\"translated_descriptions\":{\"ar\":\"صبار\",\"bg\":\"Кактус\",\"ca\":\"Cactus\",\"cs\":\"Kaktus\",\"de\":\"Kaktus\",\"eo\":\"Kakto\",\"es\":\"Cactus\",\"et\":\"Kaktus\",\"fa\":\"کاکتوس\",\"fi\":\"Kaktus\",\"fr\":\"Cactus\",\"hr\":\"kaktus\",\"hu\":\"Kaktusz\",\"id\":\"Kaktus\",\"it\":\"Cactus\",\"ja\":\"サボテン\",\"nb_NO\":\"Kaktus\",\"nl\":\"Cactus\",\"pt\":\"Cato\",\"pt_BR\":\"Cacto\",\"ru\":\"Кактус\",\"si\":null,\"sk\":\"Kaktus\",\"sq\":\"Kaktus\",\"sr\":\"кактус\",\"sv\":\"Kaktus\",\"szl\":null,\"tzm\":null,\"uk\":\"Кактус\",\"vi\":\"Xương rồng\",\"zh_Hans\":\"仙人掌\",\"zh_Hant\":\"仙人掌\"}},{\"number\":18,\"emoji\":\"🍄\",\"description\":\"Mushroom\",\"unicode\":\"U+1F344\",\"translated_descriptions\":{\"ar\":\"فُطر\",\"bg\":\"Гъба\",\"ca\":\"Bolet\",\"cs\":\"Houba\",\"de\":\"Pilz\",\"eo\":\"Fungo\",\"es\":\"Seta\",\"et\":\"Seen\",\"fa\":\"قارچ\",\"fi\":\"Sieni\",\"fr\":\"Champignon\",\"hr\":\"gljiva\",\"hu\":\"Gomba\",\"id\":\"Jamur\",\"it\":\"Fungo\",\"ja\":\"きのこ\",\"nb_NO\":\"Sopp\",\"nl\":\"Paddenstoel\",\"pt\":\"Cogumelo\",\"pt_BR\":\"Cogumelo\",\"ru\":\"Гриб\",\"si\":null,\"sk\":\"Huba\",\"sq\":\"Kërpudhë\",\"sr\":\"печурка\",\"sv\":\"Svamp\",\"szl\":null,\"tzm\":\"Agursel\",\"uk\":\"Гриб\",\"vi\":\"Nấm\",\"zh_Hans\":\"蘑菇\",\"zh_Hant\":\"蘑菇\"}},{\"number\":19,\"emoji\":\"🌏\",\"description\":\"Globe\",\"unicode\":\"U+1F30F\",\"translated_descriptions\":{\"ar\":\"كُرَةٌ أرضِيَّة\",\"bg\":\"Глобус\",\"ca\":\"Globus terraqüi\",\"cs\":\"Zeměkoule\",\"de\":\"Globus\",\"eo\":\"Globo\",\"es\":\"Globo\",\"et\":\"Maakera\",\"fa\":\"زمین\",\"fi\":\"Maapallo\",\"fr\":\"Globe\",\"hr\":\"Globus\",\"hu\":\"Földgömb\",\"id\":\"Bola Dunia\",\"it\":\"Globo\",\"ja\":\"地球\",\"nb_NO\":\"Globus\",\"nl\":\"Wereldbol\",\"pt\":\"Globo\",\"pt_BR\":\"Globo\",\"ru\":\"Глобус\",\"si\":null,\"sk\":\"Zemeguľa\",\"sq\":\"Rruzull\",\"sr\":\"глобус\",\"sv\":\"Jordklot\",\"szl\":null,\"tzm\":null,\"uk\":\"Глобус\",\"vi\":\"Địa cầu\",\"zh_Hans\":\"地球\",\"zh_Hant\":\"地球\"}},{\"number\":20,\"emoji\":\"🌙\",\"description\":\"Moon\",\"unicode\":\"U+1F319\",\"translated_descriptions\":{\"ar\":\"قَمَر\",\"bg\":\"Луна\",\"ca\":\"Lluna\",\"cs\":\"Měsíc\",\"de\":\"Mond\",\"eo\":\"Luno\",\"es\":\"Luna\",\"et\":\"Kuu\",\"fa\":\"ماه\",\"fi\":\"Kuu\",\"fr\":\"Lune\",\"hr\":\"mjesec\",\"hu\":\"Hold\",\"id\":\"Bulan\",\"it\":\"Luna\",\"ja\":\"月\",\"nb_NO\":\"Måne\",\"nl\":\"Maan\",\"pt\":\"Lua\",\"pt_BR\":\"Lua\",\"ru\":\"Луна\",\"si\":null,\"sk\":\"Mesiac\",\"sq\":\"Hënë\",\"sr\":\"месец\",\"sv\":\"Måne\",\"szl\":null,\"tzm\":\"Ayyur\",\"uk\":\"Місяць\",\"vi\":\"Mặt trăng\",\"zh_Hans\":\"月亮\",\"zh_Hant\":\"月亮\"}},{\"number\":21,\"emoji\":\"☁️\",\"description\":\"Cloud\",\"unicode\":\"U+2601U+FE0F\",\"translated_descriptions\":{\"ar\":\"سَحابَة\",\"bg\":\"Облак\",\"ca\":\"Núvol\",\"cs\":\"Mrak\",\"de\":\"Wolke\",\"eo\":\"Nubo\",\"es\":\"Nube\",\"et\":\"Pilv\",\"fa\":\"ابر\",\"fi\":\"Pilvi\",\"fr\":\"Nuage\",\"hr\":\"oblak\",\"hu\":\"Felhő\",\"id\":\"Awan\",\"it\":\"Nuvola\",\"ja\":\"雲\",\"nb_NO\":\"Sky\",\"nl\":\"Wolk\",\"pt\":\"Nuvem\",\"pt_BR\":\"Nuvem\",\"ru\":\"Облако\",\"si\":null,\"sk\":\"Oblak\",\"sq\":\"Re\",\"sr\":\"облак\",\"sv\":\"Moln\",\"szl\":null,\"tzm\":null,\"uk\":\"Хмара\",\"vi\":\"Mây\",\"zh_Hans\":\"云\",\"zh_Hant\":\"雲朵\"}},{\"number\":22,\"emoji\":\"🔥\",\"description\":\"Fire\",\"unicode\":\"U+1F525\",\"translated_descriptions\":{\"ar\":\"نار\",\"bg\":\"Огън\",\"ca\":\"Foc\",\"cs\":\"Oheň\",\"de\":\"Feuer\",\"eo\":\"Fajro\",\"es\":\"Fuego\",\"et\":\"Tuli\",\"fa\":\"آتش\",\"fi\":\"Tuli\",\"fr\":\"Feu\",\"hr\":\"vatra\",\"hu\":\"Tűz\",\"id\":\"Api\",\"it\":\"Fuoco\",\"ja\":\"炎\",\"nb_NO\":\"Flamme\",\"nl\":\"Vuur\",\"pt\":\"Fogo\",\"pt_BR\":\"Fogo\",\"ru\":\"Огонь\",\"si\":null,\"sk\":\"Oheň\",\"sq\":\"Zjarr\",\"sr\":\"ватра\",\"sv\":\"Eld\",\"szl\":null,\"tzm\":\"Timessi\",\"uk\":\"Вогонь\",\"vi\":\"Lửa\",\"zh_Hans\":\"火\",\"zh_Hant\":\"火\"}},{\"number\":23,\"emoji\":\"🍌\",\"description\":\"Banana\",\"unicode\":\"U+1F34C\",\"translated_descriptions\":{\"ar\":\"مَوزَة\",\"bg\":\"Банан\",\"ca\":\"Plàtan\",\"cs\":\"Banán\",\"de\":\"Banane\",\"eo\":\"Banano\",\"es\":\"Plátano\",\"et\":\"Banaan\",\"fa\":\"موز\",\"fi\":\"Banaani\",\"fr\":\"Banane\",\"hr\":\"banana\",\"hu\":\"Banán\",\"id\":\"Pisang\",\"it\":\"Banana\",\"ja\":\"バナナ\",\"nb_NO\":\"Banan\",\"nl\":\"Banaan\",\"pt\":\"Banana\",\"pt_BR\":\"Banana\",\"ru\":\"Банан\",\"si\":null,\"sk\":\"Banán\",\"sq\":\"Banane\",\"sr\":\"банана\",\"sv\":\"Banan\",\"szl\":null,\"tzm\":\"Tabanant\",\"uk\":\"Банан\",\"vi\":\"Chuối\",\"zh_Hans\":\"香蕉\",\"zh_Hant\":\"香蕉\"}},{\"number\":24,\"emoji\":\"🍎\",\"description\":\"Apple\",\"unicode\":\"U+1F34E\",\"translated_descriptions\":{\"ar\":\"تُفَّاحَة\",\"bg\":\"Ябълка\",\"ca\":\"Poma\",\"cs\":\"Jablko\",\"de\":\"Apfel\",\"eo\":\"Pomo\",\"es\":\"Manzana\",\"et\":\"Õun\",\"fa\":\"سیب\",\"fi\":\"Omena\",\"fr\":\"Pomme\",\"hr\":\"jabuka\",\"hu\":\"Alma\",\"id\":\"Apel\",\"it\":\"Mela\",\"ja\":\"リンゴ\",\"nb_NO\":\"Eple\",\"nl\":\"Appel\",\"pt\":\"Maçã\",\"pt_BR\":\"Maçã\",\"ru\":\"Яблоко\",\"si\":null,\"sk\":\"Jablko\",\"sq\":\"Mollë\",\"sr\":\"јабука\",\"sv\":\"Äpple\",\"szl\":null,\"tzm\":\"Tadeffuyt\",\"uk\":\"Яблуко\",\"vi\":\"Táo\",\"zh_Hans\":\"苹果\",\"zh_Hant\":\"蘋果\"}},{\"number\":25,\"emoji\":\"🍓\",\"description\":\"Strawberry\",\"unicode\":\"U+1F353\",\"translated_descriptions\":{\"ar\":\"فَراوِلَة\",\"bg\":\"Ягода\",\"ca\":\"Maduixa\",\"cs\":\"Jahoda\",\"de\":\"Erdbeere\",\"eo\":\"Frago\",\"es\":\"Fresa\",\"et\":\"Maasikas\",\"fa\":\"توت فرنگی\",\"fi\":\"Mansikka\",\"fr\":\"Fraise\",\"hr\":\"jagoda\",\"hu\":\"Eper\",\"id\":\"Stroberi\",\"it\":\"Fragola\",\"ja\":\"いちご\",\"nb_NO\":\"Jordbær\",\"nl\":\"Aardbei\",\"pt\":\"Morango\",\"pt_BR\":\"Morango\",\"ru\":\"Клубника\",\"si\":null,\"sk\":\"Jahoda\",\"sq\":\"Luleshtrydhe\",\"sr\":\"јагода\",\"sv\":\"Jordgubbe\",\"szl\":null,\"tzm\":null,\"uk\":\"Полуниця\",\"vi\":\"Dâu tây\",\"zh_Hans\":\"草莓\",\"zh_Hant\":\"草莓\"}},{\"number\":26,\"emoji\":\"🌽\",\"description\":\"Corn\",\"unicode\":\"U+1F33D\",\"translated_descriptions\":{\"ar\":\"ذُرَة\",\"bg\":\"Царевица\",\"ca\":\"Blat de moro\",\"cs\":\"Kukuřice\",\"de\":\"Mais\",\"eo\":\"Maizo\",\"es\":\"Maíz\",\"et\":\"Mais\",\"fa\":\"ذرت\",\"fi\":\"Maissi\",\"fr\":\"Maïs\",\"hr\":\"kukuruza\",\"hu\":\"Kukorica\",\"id\":\"Jagung\",\"it\":\"Mais\",\"ja\":\"とうもろこし\",\"nb_NO\":\"Mais\",\"nl\":\"Maïs\",\"pt\":\"Milho\",\"pt_BR\":\"Milho\",\"ru\":\"Кукуруза\",\"si\":null,\"sk\":\"Kukurica\",\"sq\":\"Misër\",\"sr\":\"кукуруз\",\"sv\":\"Majs\",\"szl\":null,\"tzm\":null,\"uk\":\"Кукурудза\",\"vi\":\"Bắp\",\"zh_Hans\":\"玉米\",\"zh_Hant\":\"玉米\"}},{\"number\":27,\"emoji\":\"🍕\",\"description\":\"Pizza\",\"unicode\":\"U+1F355\",\"translated_descriptions\":{\"ar\":\"بِيتزا\",\"bg\":\"Пица\",\"ca\":\"Pizza\",\"cs\":\"Pizza\",\"de\":\"Pizza\",\"eo\":\"Pico\",\"es\":\"Pizza\",\"et\":\"Pitsa\",\"fa\":\"پیتزا\",\"fi\":\"Pizza\",\"fr\":\"Pizza\",\"hr\":\"pizza\",\"hu\":\"Pizza\",\"id\":\"Pizza\",\"it\":\"Pizza\",\"ja\":\"ピザ\",\"nb_NO\":\"Pizza\",\"nl\":\"Pizza\",\"pt\":\"Piza\",\"pt_BR\":\"Pizza\",\"ru\":\"Пицца\",\"si\":null,\"sk\":\"Pizza\",\"sq\":\"Picë\",\"sr\":\"пица\",\"sv\":\"Pizza\",\"szl\":null,\"tzm\":null,\"uk\":\"Піца\",\"vi\":\"Pizza\",\"zh_Hans\":\"披萨\",\"zh_Hant\":\"披薩\"}},{\"number\":28,\"emoji\":\"🎂\",\"description\":\"Cake\",\"unicode\":\"U+1F382\",\"translated_descriptions\":{\"ar\":\"كَعكَة\",\"bg\":\"Торта\",\"ca\":\"Pastís\",\"cs\":\"Dort\",\"de\":\"Kuchen\",\"eo\":\"Torto\",\"es\":\"Tarta\",\"et\":\"Kook\",\"fa\":\"کیک\",\"fi\":\"Kakku\",\"fr\":\"Gâteau\",\"hr\":\"torta\",\"hu\":\"Süti\",\"id\":\"Kue\",\"it\":\"Torta\",\"ja\":\"ケーキ\",\"nb_NO\":\"Kake\",\"nl\":\"Taart\",\"pt\":\"Bolo\",\"pt_BR\":\"Bolo\",\"ru\":\"Торт\",\"si\":null,\"sk\":\"Torta\",\"sq\":\"Tortë\",\"sr\":\"торта\",\"sv\":\"Tårta\",\"szl\":null,\"tzm\":null,\"uk\":\"Пиріг\",\"vi\":\"Bánh\",\"zh_Hans\":\"蛋糕\",\"zh_Hant\":\"蛋糕\"}},{\"number\":29,\"emoji\":\"❤️\",\"description\":\"Heart\",\"unicode\":\"U+2764U+FE0F\",\"translated_descriptions\":{\"ar\":\"قَلب\",\"bg\":\"Сърце\",\"ca\":\"Cor\",\"cs\":\"Srdce\",\"de\":\"Herz\",\"eo\":\"Koro\",\"es\":\"Corazón\",\"et\":\"Süda\",\"fa\":\"قلب\",\"fi\":\"Sydän\",\"fr\":\"Cœur\",\"hr\":\"srca\",\"hu\":\"Szív\",\"id\":\"Hati\",\"it\":\"Cuore\",\"ja\":\"ハート\",\"nb_NO\":\"Hjerte\",\"nl\":\"Hart\",\"pt\":\"Coração\",\"pt_BR\":\"Coração\",\"ru\":\"Сердце\",\"si\":null,\"sk\":\"Srdce\",\"sq\":\"Zemër\",\"sr\":\"срце\",\"sv\":\"Hjärta\",\"szl\":null,\"tzm\":\"Ul\",\"uk\":\"Серце\",\"vi\":\"Tim\",\"zh_Hans\":\"心\",\"zh_Hant\":\"愛心\"}},{\"number\":30,\"emoji\":\"😀\",\"description\":\"Smiley\",\"unicode\":\"U+1F600\",\"translated_descriptions\":{\"ar\":\"اِبتِسَامَة\",\"bg\":\"Усмивка\",\"ca\":\"Somrient\",\"cs\":\"Smajlík\",\"de\":\"Lächeln\",\"eo\":\"Rideto\",\"es\":\"Emoticono\",\"et\":\"Smaili\",\"fa\":\"خنده\",\"fi\":\"Hymynaama\",\"fr\":\"Sourire\",\"hr\":\"smajlića\",\"hu\":\"Mosoly\",\"id\":\"Senyuman\",\"it\":\"Faccina sorridente\",\"ja\":\"スマイル\",\"nb_NO\":\"Smilefjes\",\"nl\":\"Smiley\",\"pt\":\"Sorriso\",\"pt_BR\":\"Sorriso\",\"ru\":\"Улыбка\",\"si\":null,\"sk\":\"Smajlík\",\"sq\":\"Emotikon\",\"sr\":\"смајли\",\"sv\":\"Smiley\",\"szl\":null,\"tzm\":null,\"uk\":\"Посмішка\",\"vi\":\"Mặt cười\",\"zh_Hans\":\"笑脸\",\"zh_Hant\":\"笑臉\"}},{\"number\":31,\"emoji\":\"🤖\",\"description\":\"Robot\",\"unicode\":\"U+1F916\",\"translated_descriptions\":{\"ar\":\"رُوبُوت\",\"bg\":\"Робот\",\"ca\":\"Robot\",\"cs\":\"Robot\",\"de\":\"Roboter\",\"eo\":\"Roboto\",\"es\":\"Robot\",\"et\":\"Robot\",\"fa\":\"ربات\",\"fi\":\"Robotti\",\"fr\":\"Robot\",\"hr\":\"robot\",\"hu\":\"Robot\",\"id\":\"Robot\",\"it\":\"Robot\",\"ja\":\"ロボット\",\"nb_NO\":\"Robot\",\"nl\":\"Robot\",\"pt\":\"Robô\",\"pt_BR\":\"Robô\",\"ru\":\"Робот\",\"si\":null,\"sk\":\"Robot\",\"sq\":\"Robot\",\"sr\":\"робот\",\"sv\":\"Robot\",\"szl\":null,\"tzm\":\"Aṛubu\",\"uk\":\"Робот\",\"vi\":\"Rô-bô\",\"zh_Hans\":\"机器人\",\"zh_Hant\":\"機器人\"}},{\"number\":32,\"emoji\":\"🎩\",\"description\":\"Hat\",\"unicode\":\"U+1F3A9\",\"translated_descriptions\":{\"ar\":\"قُبَّعَة\",\"bg\":\"Шапка\",\"ca\":\"Barret\",\"cs\":\"Klobouk\",\"de\":\"Hut\",\"eo\":\"Ĉapelo\",\"es\":\"Sombrero\",\"et\":\"Kübar\",\"fa\":\"کلاه\",\"fi\":\"Hattu\",\"fr\":\"Chapeau\",\"hr\":\"kapa\",\"hu\":\"Kalap\",\"id\":\"Topi\",\"it\":\"Cappello\",\"ja\":\"帽子\",\"nb_NO\":\"Hatt\",\"nl\":\"Hoed\",\"pt\":\"Chapéu\",\"pt_BR\":\"Chapéu\",\"ru\":\"Шляпа\",\"si\":null,\"sk\":\"Klobúk\",\"sq\":\"Kapë\",\"sr\":\"шешир\",\"sv\":\"Hatt\",\"szl\":null,\"tzm\":\"Taraza\",\"uk\":\"Капелюх\",\"vi\":\"Mũ\",\"zh_Hans\":\"帽子\",\"zh_Hant\":\"帽子\"}},{\"number\":33,\"emoji\":\"👓\",\"description\":\"Glasses\",\"unicode\":\"U+1F453\",\"translated_descriptions\":{\"ar\":\"نَظَّارَة\",\"bg\":\"Очила\",\"ca\":\"Ulleres\",\"cs\":\"Brýle\",\"de\":\"Brille\",\"eo\":\"Okulvitroj\",\"es\":\"Gafas\",\"et\":\"Prillid\",\"fa\":\"عینک\",\"fi\":\"Silmälasit\",\"fr\":\"Lunettes\",\"hr\":\"naočale\",\"hu\":\"Szemüveg\",\"id\":\"Kacamata\",\"it\":\"Occhiali\",\"ja\":\"めがね\",\"nb_NO\":\"Briller\",\"nl\":\"Bril\",\"pt\":\"Óculos\",\"pt_BR\":\"Óculos\",\"ru\":\"Очки\",\"si\":null,\"sk\":\"Okuliare\",\"sq\":\"Syze\",\"sr\":\"наочаре\",\"sv\":\"Glasögon\",\"szl\":null,\"tzm\":null,\"uk\":\"Окуляри\",\"vi\":\"Kính mắt\",\"zh_Hans\":\"眼镜\",\"zh_Hant\":\"眼鏡\"}},{\"number\":34,\"emoji\":\"🔧\",\"description\":\"Spanner\",\"unicode\":\"U+1F527\",\"translated_descriptions\":{\"ar\":\"مِفتَاحُ رَبط\",\"bg\":\"Гаечен ключ\",\"ca\":\"Clau anglesa\",\"cs\":\"Klíč\",\"de\":\"Schraubenschlüssel\",\"eo\":\"Ŝraŭbŝlosilo\",\"es\":\"Llave inglesa\",\"et\":\"Mutrivõti\",\"fa\":\"آچار\",\"fi\":\"Kiintoavain\",\"fr\":\"Clé à molette\",\"hr\":\"ključ\",\"hu\":\"Csavarkulcs\",\"id\":\"Kunci Bengkel\",\"it\":\"Chiave inglese\",\"ja\":\"スパナ\",\"nb_NO\":\"Fastnøkkel\",\"nl\":\"Moersleutel\",\"pt\":\"Chave inglesa\",\"pt_BR\":\"Chave inglesa\",\"ru\":\"Ключ\",\"si\":null,\"sk\":\"Vidlicový kľúč\",\"sq\":\"Çelës\",\"sr\":\"кључ\",\"sv\":\"Skruvnyckel\",\"szl\":null,\"tzm\":null,\"uk\":\"Гайковий ключ\",\"vi\":\"Cờ-lê\",\"zh_Hans\":\"扳手\",\"zh_Hant\":\"扳手\"}},{\"number\":35,\"emoji\":\"🎅\",\"description\":\"Santa\",\"unicode\":\"U+1F385\",\"translated_descriptions\":{\"ar\":\"سانتا\",\"bg\":\"Дядо Коледа\",\"ca\":\"Pare Noél\",\"cs\":\"Mikuláš\",\"de\":\"Weihnachtsmann\",\"eo\":\"Kristnaska viro\",\"es\":\"Papá Noel\",\"et\":\"Jõuluvana\",\"fa\":\"بابا نوئل\",\"fi\":\"Joulupukki\",\"fr\":\"Père Noël\",\"hr\":\"deda Mraz\",\"hu\":\"Télapó\",\"id\":\"Santa\",\"it\":\"Babbo Natale\",\"ja\":\"サンタ\",\"nb_NO\":\"Julenisse\",\"nl\":\"Kerstman\",\"pt\":\"Pai Natal\",\"pt_BR\":\"Papai-noel\",\"ru\":\"Санта\",\"si\":null,\"sk\":\"Mikuláš\",\"sq\":\"Babagjyshi i Vitit të Ri\",\"sr\":\"деда Мраз\",\"sv\":\"Tomte\",\"szl\":null,\"tzm\":null,\"uk\":\"Санта Клаус\",\"vi\":\"ông già Nô-en\",\"zh_Hans\":\"圣诞老人\",\"zh_Hant\":\"聖誕老人\"}},{\"number\":36,\"emoji\":\"👍\",\"description\":\"Thumbs Up\",\"unicode\":\"U+1F44D\",\"translated_descriptions\":{\"ar\":\"رَفعُ إِبهَام\",\"bg\":\"Палец нагоре\",\"ca\":\"Polzes amunt\",\"cs\":\"Palec nahoru\",\"de\":\"Daumen Hoch\",\"eo\":\"Dikfingro supren\",\"es\":\"Pulgar arriba\",\"et\":\"Pöidlad püsti\",\"fa\":\"لایک\",\"fi\":\"Peukalo ylös\",\"fr\":\"Pouce en l’air\",\"hr\":\"palac gore\",\"hu\":\"Hüvelykujj fel\",\"id\":\"Jempol\",\"it\":\"Pollice alzato\",\"ja\":\"いいね\",\"nb_NO\":\"Tommel Opp\",\"nl\":\"Duim omhoog\",\"pt\":\"Polegar para cima\",\"pt_BR\":\"Joinha\",\"ru\":\"Большой палец вверх\",\"si\":null,\"sk\":\"Palec nahor\",\"sq\":null,\"sr\":\"палчић горе\",\"sv\":\"Tummen upp\",\"szl\":null,\"tzm\":null,\"uk\":\"Великий палець вгору\",\"vi\":\"Thích\",\"zh_Hans\":\"赞\",\"zh_Hant\":\"讚\"}},{\"number\":37,\"emoji\":\"☂️\",\"description\":\"Umbrella\",\"unicode\":\"U+2602U+FE0F\",\"translated_descriptions\":{\"ar\":\"مِظَلَّة\",\"bg\":\"Чадър\",\"ca\":\"Paraigües\",\"cs\":\"Deštník\",\"de\":\"Regenschirm\",\"eo\":\"Ombrelo\",\"es\":\"Paraguas\",\"et\":\"Vihmavari\",\"fa\":\"چتر\",\"fi\":\"Sateenvarjo\",\"fr\":\"Parapluie\",\"hr\":\"kišobran\",\"hu\":\"Esernyő\",\"id\":\"Payung\",\"it\":\"Ombrello\",\"ja\":\"傘\",\"nb_NO\":\"Paraply\",\"nl\":\"Paraplu\",\"pt\":\"Guarda-chuva\",\"pt_BR\":\"Guarda-chuva\",\"ru\":\"Зонт\",\"si\":null,\"sk\":\"Dáždnik\",\"sq\":\"Ombrellë\",\"sr\":\"кишобран\",\"sv\":\"Paraply\",\"szl\":null,\"tzm\":null,\"uk\":\"Парасолька\",\"vi\":\"Cái ô\",\"zh_Hans\":\"伞\",\"zh_Hant\":\"雨傘\"}},{\"number\":38,\"emoji\":\"⌛\",\"description\":\"Hourglass\",\"unicode\":\"U+231B\",\"translated_descriptions\":{\"ar\":\"سَاعَةٌ رَملِيَّة\",\"bg\":\"Пясъчен часовник\",\"ca\":\"Rellotge de sorra\",\"cs\":\"Přesýpací hodiny\",\"de\":\"Sanduhr\",\"eo\":\"Sablohorloĝo\",\"es\":\"Reloj de arena\",\"et\":\"Liivakell\",\"fa\":\"ساعت شنی\",\"fi\":\"Tiimalasi\",\"fr\":\"Sablier\",\"hr\":\"pješčani sat\",\"hu\":\"Homokóra\",\"id\":\"Jam Pasir\",\"it\":\"Clessidra\",\"ja\":\"砂時計\",\"nb_NO\":\"Timeglass\",\"nl\":\"Zandloper\",\"pt\":\"Ampulheta\",\"pt_BR\":\"Ampulheta\",\"ru\":\"Песочные часы\",\"si\":null,\"sk\":\"Presýpacie hodiny\",\"sq\":\"Klepsidër\",\"sr\":\"пешчаник\",\"sv\":\"Timglas\",\"szl\":null,\"tzm\":null,\"uk\":\"Пісковий годинник\",\"vi\":\"Đồng hồ cát\",\"zh_Hans\":\"沙漏\",\"zh_Hant\":\"沙漏\"}},{\"number\":39,\"emoji\":\"⏰\",\"description\":\"Clock\",\"unicode\":\"U+23F0\",\"translated_descriptions\":{\"ar\":\"سَاعَة\",\"bg\":\"Часовник\",\"ca\":\"Rellotge\",\"cs\":\"Hodiny\",\"de\":\"Uhr\",\"eo\":\"Horloĝo\",\"es\":\"Reloj\",\"et\":\"Kell\",\"fa\":\"ساعت\",\"fi\":\"Pöytäkello\",\"fr\":\"Réveil\",\"hr\":\"sat\",\"hu\":\"Óra\",\"id\":\"Jam\",\"it\":\"Orologio\",\"ja\":\"時計\",\"nb_NO\":\"Klokke\",\"nl\":\"Wekker\",\"pt\":\"Relógio\",\"pt_BR\":\"Relógio\",\"ru\":\"Часы\",\"si\":null,\"sk\":\"Budík\",\"sq\":\"Sahat\",\"sr\":\"сат\",\"sv\":\"Klocka\",\"szl\":null,\"tzm\":null,\"uk\":\"Годинник\",\"vi\":\"Đồng hồ\",\"zh_Hans\":\"时钟\",\"zh_Hant\":\"時鐘\"}},{\"number\":40,\"emoji\":\"🎁\",\"description\":\"Gift\",\"unicode\":\"U+1F381\",\"translated_descriptions\":{\"ar\":\"هَدِيَّة\",\"bg\":\"Подарък\",\"ca\":\"Regal\",\"cs\":\"Dárek\",\"de\":\"Geschenk\",\"eo\":\"Donaco\",\"es\":\"Regalo\",\"et\":\"Kingitus\",\"fa\":\"هدیه\",\"fi\":\"Lahja\",\"fr\":\"Cadeau\",\"hr\":\"poklon\",\"hu\":\"Ajándék\",\"id\":\"Kado\",\"it\":\"Regalo\",\"ja\":\"ギフト\",\"nb_NO\":\"Gave\",\"nl\":\"Geschenk\",\"pt\":\"Presente\",\"pt_BR\":\"Presente\",\"ru\":\"Подарок\",\"si\":null,\"sk\":\"Darček\",\"sq\":\"Dhuratë\",\"sr\":\"поклон\",\"sv\":\"Present\",\"szl\":null,\"tzm\":null,\"uk\":\"Подарунок\",\"vi\":\"Quà tặng\",\"zh_Hans\":\"礼物\",\"zh_Hant\":\"禮物\"}},{\"number\":41,\"emoji\":\"💡\",\"description\":\"Light Bulb\",\"unicode\":\"U+1F4A1\",\"translated_descriptions\":{\"ar\":\"مِصبَاح\",\"bg\":\"Лампа\",\"ca\":\"Bombeta\",\"cs\":\"Žárovka\",\"de\":\"Glühbirne\",\"eo\":\"Lampo\",\"es\":\"Bombilla\",\"et\":\"Lambipirn\",\"fa\":\"لامپ\",\"fi\":\"Hehkulamppu\",\"fr\":\"Ampoule\",\"hr\":\"žarulja\",\"hu\":\"Égő\",\"id\":\"Bohlam Lampu\",\"it\":\"Lampadina\",\"ja\":\"電球\",\"nb_NO\":\"Lyspære\",\"nl\":\"Gloeilamp\",\"pt\":\"Lâmpada\",\"pt_BR\":\"Lâmpada\",\"ru\":\"Лампочка\",\"si\":null,\"sk\":\"Žiarovka\",\"sq\":\"Llambë\",\"sr\":\"сијалица\",\"sv\":\"Lampa\",\"szl\":null,\"tzm\":null,\"uk\":\"Лампочка\",\"vi\":\"Bóng đèn tròn\",\"zh_Hans\":\"灯泡\",\"zh_Hant\":\"燈泡\"}},{\"number\":42,\"emoji\":\"📕\",\"description\":\"Book\",\"unicode\":\"U+1F4D5\",\"translated_descriptions\":{\"ar\":\"كِتَاب\",\"bg\":\"Книга\",\"ca\":\"Llibre\",\"cs\":\"Kniha\",\"de\":\"Buch\",\"eo\":\"Libro\",\"es\":\"Libro\",\"et\":\"Raamat\",\"fa\":\"کتاب\",\"fi\":\"Kirja\",\"fr\":\"Livre\",\"hr\":\"knjiga\",\"hu\":\"Könyv\",\"id\":\"Buku\",\"it\":\"Libro\",\"ja\":\"本\",\"nb_NO\":\"Bok\",\"nl\":\"Boek\",\"pt\":\"Livro\",\"pt_BR\":\"Livro\",\"ru\":\"Книга\",\"si\":null,\"sk\":\"Kniha\",\"sq\":\"Libër\",\"sr\":\"књига\",\"sv\":\"Bok\",\"szl\":null,\"tzm\":\"Adlis\",\"uk\":\"Книга\",\"vi\":\"Sách\",\"zh_Hans\":\"书\",\"zh_Hant\":\"書\"}},{\"number\":43,\"emoji\":\"✏️\",\"description\":\"Pencil\",\"unicode\":\"U+270FU+FE0F\",\"translated_descriptions\":{\"ar\":\"قَلَمُ رَصاص\",\"bg\":\"Молив\",\"ca\":\"Llapis\",\"cs\":\"Tužka\",\"de\":\"Bleistift\",\"eo\":\"Krajono\",\"es\":\"Lápiz\",\"et\":\"Pliiats\",\"fa\":\"مداد\",\"fi\":\"Lyijykynä\",\"fr\":\"Crayon\",\"hr\":\"olovka\",\"hu\":\"Ceruza\",\"id\":\"Pensil\",\"it\":\"Matita\",\"ja\":\"鉛筆\",\"nb_NO\":\"Blyant\",\"nl\":\"Potlood\",\"pt\":\"Lápis\",\"pt_BR\":\"Lápis\",\"ru\":\"Карандаш\",\"si\":null,\"sk\":\"Ceruzka\",\"sq\":\"Laps\",\"sr\":\"оловка\",\"sv\":\"Penna\",\"szl\":null,\"tzm\":null,\"uk\":\"Олівець\",\"vi\":\"Viết chì\",\"zh_Hans\":\"铅笔\",\"zh_Hant\":\"鉛筆\"}},{\"number\":44,\"emoji\":\"📎\",\"description\":\"Paperclip\",\"unicode\":\"U+1F4CE\",\"translated_descriptions\":{\"ar\":\"مِشبَكُ وَرَق\",\"bg\":\"Кламер\",\"ca\":\"Clip\",\"cs\":\"Sponka\",\"de\":\"Büroklammer\",\"eo\":\"Paperkuntenilo\",\"es\":\"Clip\",\"et\":\"Kirjaklamber\",\"fa\":\"گیره کاغذ\",\"fi\":\"Paperiliitin\",\"fr\":\"Trombone\",\"hr\":\"spajalica\",\"hu\":\"Gémkapocs\",\"id\":\"Klip Kertas\",\"it\":\"Graffetta\",\"ja\":\"クリップ\",\"nb_NO\":\"BInders\",\"nl\":\"Papierklemmetje\",\"pt\":\"Clipe\",\"pt_BR\":\"Clipe de papel\",\"ru\":\"Скрепка\",\"si\":null,\"sk\":\"Kancelárska sponka\",\"sq\":\"Kapëse\",\"sr\":\"спајалица\",\"sv\":\"Gem\",\"szl\":null,\"tzm\":null,\"uk\":\"Спиначка\",\"vi\":\"Kẹp giấy\",\"zh_Hans\":\"回形针\",\"zh_Hant\":\"迴紋針\"}},{\"number\":45,\"emoji\":\"✂️\",\"description\":\"Scissors\",\"unicode\":\"U+2702U+FE0F\",\"translated_descriptions\":{\"ar\":\"مِقَصّ\",\"bg\":\"Ножици\",\"ca\":\"Tisores\",\"cs\":\"Nůžky\",\"de\":\"Schere\",\"eo\":\"Tondilo\",\"es\":\"Tijeras\",\"et\":\"Käärid\",\"fa\":\"قیچی\",\"fi\":\"Sakset\",\"fr\":\"Ciseaux\",\"hr\":\"škare\",\"hu\":\"Olló\",\"id\":\"Gunting\",\"it\":\"Forbici\",\"ja\":\"はさみ\",\"nb_NO\":\"Saks\",\"nl\":\"Schaar\",\"pt\":\"Tesoura\",\"pt_BR\":\"Tesoura\",\"ru\":\"Ножницы\",\"si\":null,\"sk\":\"Nožnice\",\"sq\":\"Gërshërë\",\"sr\":\"маказе\",\"sv\":\"Sax\",\"szl\":null,\"tzm\":null,\"uk\":\"Ножиці\",\"vi\":\"Cái kéo\",\"zh_Hans\":\"剪刀\",\"zh_Hant\":\"剪刀\"}},{\"number\":46,\"emoji\":\"🔒\",\"description\":\"Lock\",\"unicode\":\"U+1F512\",\"translated_descriptions\":{\"ar\":\"قُفل\",\"bg\":\"Катинар\",\"ca\":\"Cadenat\",\"cs\":\"Zámek\",\"de\":\"Schloss\",\"eo\":\"Seruro\",\"es\":\"Candado\",\"et\":\"Lukk\",\"fa\":\"قفل\",\"fi\":\"Lukko\",\"fr\":\"Cadenas\",\"hr\":\"zaključati\",\"hu\":\"Lakat\",\"id\":\"Gembok\",\"it\":\"Lucchetto\",\"ja\":\"錠前\",\"nb_NO\":\"Lås\",\"nl\":\"Slot\",\"pt\":\"Cadeado\",\"pt_BR\":\"Cadeado\",\"ru\":\"Замок\",\"si\":null,\"sk\":\"Zámka\",\"sq\":\"Dry\",\"sr\":\"катанац\",\"sv\":\"Lås\",\"szl\":null,\"tzm\":null,\"uk\":\"Замок\",\"vi\":\"Ổ khóa\",\"zh_Hans\":\"锁\",\"zh_Hant\":\"鎖頭\"}},{\"number\":47,\"emoji\":\"🔑\",\"description\":\"Key\",\"unicode\":\"U+1F511\",\"translated_descriptions\":{\"ar\":\"مِفتَاح\",\"bg\":\"Ключ\",\"ca\":\"Clau\",\"cs\":\"Klíč ke dveřím\",\"de\":\"Schlüssel\",\"eo\":\"Ŝlosilo\",\"es\":\"Llave\",\"et\":\"Võti\",\"fa\":\"کلید\",\"fi\":\"Avain\",\"fr\":\"Clé\",\"hr\":\"ključ\",\"hu\":\"Kulcs\",\"id\":\"Kunci\",\"it\":\"Chiave\",\"ja\":\"鍵\",\"nb_NO\":\"Nøkkel\",\"nl\":\"Sleutel\",\"pt\":\"Chave\",\"pt_BR\":\"Chave\",\"ru\":\"Ключ\",\"si\":null,\"sk\":\"Kľúč\",\"sq\":\"Çelës\",\"sr\":\"кључ\",\"sv\":\"Nyckel\",\"szl\":null,\"tzm\":\"Tasarut\",\"uk\":\"Ключ\",\"vi\":\"Chìa khóa\",\"zh_Hans\":\"钥匙\",\"zh_Hant\":\"鑰匙\"}},{\"number\":48,\"emoji\":\"🔨\",\"description\":\"Hammer\",\"unicode\":\"U+1F528\",\"translated_descriptions\":{\"ar\":\"مِطرَقَة\",\"bg\":\"Чук\",\"ca\":\"Martell\",\"cs\":\"Kladivo\",\"de\":\"Hammer\",\"eo\":\"Martelo\",\"es\":\"Martillo\",\"et\":\"Haamer\",\"fa\":\"چکش\",\"fi\":\"Vasara\",\"fr\":\"Marteau\",\"hr\":\"čekić\",\"hu\":\"Kalapács\",\"id\":\"Palu\",\"it\":\"Martello\",\"ja\":\"金槌\",\"nb_NO\":\"Hammer\",\"nl\":\"Hamer\",\"pt\":\"Martelo\",\"pt_BR\":\"Martelo\",\"ru\":\"Молоток\",\"si\":null,\"sk\":\"Kladivo\",\"sq\":\"Çekiç\",\"sr\":\"чекић\",\"sv\":\"Hammare\",\"szl\":null,\"tzm\":null,\"uk\":\"Молоток\",\"vi\":\"Búa\",\"zh_Hans\":\"锤子\",\"zh_Hant\":\"鎚子\"}},{\"number\":49,\"emoji\":\"☎️\",\"description\":\"Telephone\",\"unicode\":\"U+260EU+FE0F\",\"translated_descriptions\":{\"ar\":\"تِلِفُون\",\"bg\":\"Телефон\",\"ca\":\"Telèfon\",\"cs\":\"Telefon\",\"de\":\"Telefon\",\"eo\":\"Telefono\",\"es\":\"Teléfono\",\"et\":\"Telefon\",\"fa\":\"تلفن\",\"fi\":\"Puhelin\",\"fr\":\"Téléphone\",\"hr\":\"telefon\",\"hu\":\"Telefon\",\"id\":\"Telepon\",\"it\":\"Telefono\",\"ja\":\"電話機\",\"nb_NO\":\"Telefon\",\"nl\":\"Telefoon\",\"pt\":\"Telefone\",\"pt_BR\":\"Telefone\",\"ru\":\"Телефон\",\"si\":null,\"sk\":\"Telefón\",\"sq\":\"Telefon\",\"sr\":\"телефон\",\"sv\":\"Telefon\",\"szl\":null,\"tzm\":\"Atilifun\",\"uk\":\"Телефон\",\"vi\":\"Điện thoại\",\"zh_Hans\":\"电话\",\"zh_Hant\":\"電話\"}},{\"number\":50,\"emoji\":\"🏁\",\"description\":\"Flag\",\"unicode\":\"U+1F3C1\",\"translated_descriptions\":{\"ar\":\"عَلَم\",\"bg\":\"Флаг\",\"ca\":\"Bandera\",\"cs\":\"Vlajka\",\"de\":\"Flagge\",\"eo\":\"Flago\",\"es\":\"Bandera\",\"et\":\"Lipp\",\"fa\":\"پرچم\",\"fi\":\"Lippu\",\"fr\":\"Drapeau\",\"hr\":\"zastava\",\"hu\":\"Zászló\",\"id\":\"Bendera\",\"it\":\"Bandiera\",\"ja\":\"旗\",\"nb_NO\":\"Flagg\",\"nl\":\"Vlag\",\"pt\":\"Bandeira\",\"pt_BR\":\"Bandeira\",\"ru\":\"Флаг\",\"si\":null,\"sk\":\"Zástava\",\"sq\":\"Flamur\",\"sr\":\"застава\",\"sv\":\"Flagga\",\"szl\":null,\"tzm\":\"Acenyal\",\"uk\":\"Прапор\",\"vi\":\"Lá cờ\",\"zh_Hans\":\"旗帜\",\"zh_Hant\":\"旗幟\"}},{\"number\":51,\"emoji\":\"🚂\",\"description\":\"Train\",\"unicode\":\"U+1F682\",\"translated_descriptions\":{\"ar\":\"قِطَار\",\"bg\":\"Влак\",\"ca\":\"Tren\",\"cs\":\"Vlak\",\"de\":\"Zug\",\"eo\":\"Vagonaro\",\"es\":\"Tren\",\"et\":\"Rong\",\"fa\":\"قطار\",\"fi\":\"Juna\",\"fr\":\"Train\",\"hr\":\"vlak\",\"hu\":\"Vonat\",\"id\":\"Kereta Api\",\"it\":\"Treno\",\"ja\":\"電車\",\"nb_NO\":\"Tog\",\"nl\":\"Trein\",\"pt\":\"Comboio\",\"pt_BR\":\"Trem\",\"ru\":\"Поезд\",\"si\":null,\"sk\":\"Vlak\",\"sq\":\"Tren\",\"sr\":\"воз\",\"sv\":\"Tåg\",\"szl\":null,\"tzm\":null,\"uk\":\"Потяг\",\"vi\":\"Xe lửa\",\"zh_Hans\":\"火车\",\"zh_Hant\":\"火車\"}},{\"number\":52,\"emoji\":\"🚲\",\"description\":\"Bicycle\",\"unicode\":\"U+1F6B2\",\"translated_descriptions\":{\"ar\":\"دَرّاجَة\",\"bg\":\"Колело\",\"ca\":\"Bicicleta\",\"cs\":\"Kolo\",\"de\":\"Fahrrad\",\"eo\":\"Biciklo\",\"es\":\"Bicicleta\",\"et\":\"Jalgratas\",\"fa\":\"دوچرخه\",\"fi\":\"Polkupyörä\",\"fr\":\"Vélo\",\"hr\":\"bicikl\",\"hu\":\"Kerékpár\",\"id\":\"Sepeda\",\"it\":\"Bicicletta\",\"ja\":\"自転車\",\"nb_NO\":\"Sykkel\",\"nl\":\"Fiets\",\"pt\":\"Bicicleta\",\"pt_BR\":\"Bicicleta\",\"ru\":\"Велосипед\",\"si\":null,\"sk\":\"Bicykel\",\"sq\":\"Biçikletë\",\"sr\":\"бицикл\",\"sv\":\"Cykel\",\"szl\":null,\"tzm\":null,\"uk\":\"Велосипед\",\"vi\":\"Xe đạp\",\"zh_Hans\":\"自行车\",\"zh_Hant\":\"腳踏車\"}},{\"number\":53,\"emoji\":\"✈️\",\"description\":\"Aeroplane\",\"unicode\":\"U+2708U+FE0F\",\"translated_descriptions\":{\"ar\":\"طَائِرة\",\"bg\":\"Самолет\",\"ca\":\"Avió\",\"cs\":\"Letadlo\",\"de\":\"Flugzeug\",\"eo\":\"Aviadilo\",\"es\":\"Avión\",\"et\":\"Lennuk\",\"fa\":\"هواپیما\",\"fi\":\"Lentokone\",\"fr\":\"Avion\",\"hr\":\"avion\",\"hu\":\"Repülő\",\"id\":\"Pesawat\",\"it\":\"Aeroplano\",\"ja\":\"飛行機\",\"nb_NO\":\"Fly\",\"nl\":\"Vliegtuig\",\"pt\":\"Avião\",\"pt_BR\":\"Avião\",\"ru\":\"Самолет\",\"si\":null,\"sk\":\"Lietadlo\",\"sq\":\"Avion\",\"sr\":\"авион\",\"sv\":\"Flygplan\",\"szl\":null,\"tzm\":null,\"uk\":\"Літак\",\"vi\":\"Máy bay\",\"zh_Hans\":\"飞机\",\"zh_Hant\":\"飛機\"}},{\"number\":54,\"emoji\":\"🚀\",\"description\":\"Rocket\",\"unicode\":\"U+1F680\",\"translated_descriptions\":{\"ar\":\"صَارُوخ\",\"bg\":\"Ракета\",\"ca\":\"Coet\",\"cs\":\"Raketa\",\"de\":\"Rakete\",\"eo\":\"Raketo\",\"es\":\"Cohete\",\"et\":\"Rakett\",\"fa\":\"موشک\",\"fi\":\"Raketti\",\"fr\":\"Fusée\",\"hr\":\"raketa\",\"hu\":\"Rakáta\",\"id\":\"Roket\",\"it\":\"Razzo\",\"ja\":\"ロケット\",\"nb_NO\":\"Rakett\",\"nl\":\"Raket\",\"pt\":\"Foguetão\",\"pt_BR\":\"Foguete\",\"ru\":\"Ракета\",\"si\":null,\"sk\":\"Raketa\",\"sq\":\"Raketë\",\"sr\":\"ракета\",\"sv\":\"Raket\",\"szl\":null,\"tzm\":null,\"uk\":\"Ракета\",\"vi\":\"Tên lửa\",\"zh_Hans\":\"火箭\",\"zh_Hant\":\"火箭\"}},{\"number\":55,\"emoji\":\"🏆\",\"description\":\"Trophy\",\"unicode\":\"U+1F3C6\",\"translated_descriptions\":{\"ar\":\"كَأسُ النَّصر\",\"bg\":\"Трофей\",\"ca\":\"Trofeu\",\"cs\":\"Pohár\",\"de\":\"Pokal\",\"eo\":\"Trofeo\",\"es\":\"Trofeo\",\"et\":\"Auhind\",\"fa\":\"جام\",\"fi\":\"Palkinto\",\"fr\":\"Trophée\",\"hr\":\"trofej\",\"hu\":\"Trófea\",\"id\":\"Piala\",\"it\":\"Trofeo\",\"ja\":\"トロフィー\",\"nb_NO\":\"Pokal\",\"nl\":\"Trofee\",\"pt\":\"Troféu\",\"pt_BR\":\"Troféu\",\"ru\":\"Кубок\",\"si\":null,\"sk\":\"Trofej\",\"sq\":\"Trofe\",\"sr\":\"пехар\",\"sv\":\"Trofé\",\"szl\":null,\"tzm\":null,\"uk\":\"Приз\",\"vi\":\"Cúp\",\"zh_Hans\":\"奖杯\",\"zh_Hant\":\"獎盃\"}},{\"number\":56,\"emoji\":\"⚽\",\"description\":\"Ball\",\"unicode\":\"U+26BD\",\"translated_descriptions\":{\"ar\":\"كُرَة\",\"bg\":\"Топка\",\"ca\":\"Pilota\",\"cs\":\"Míč\",\"de\":\"Ball\",\"eo\":\"Pilko\",\"es\":\"Bola\",\"et\":\"Pall\",\"fa\":\"توپ\",\"fi\":\"Pallo\",\"fr\":\"Ballon\",\"hr\":\"lopta\",\"hu\":\"Labda\",\"id\":\"Bola\",\"it\":\"Palla\",\"ja\":\"ボール\",\"nb_NO\":\"Ball\",\"nl\":\"Bal\",\"pt\":\"Bola\",\"pt_BR\":\"Bola\",\"ru\":\"Мяч\",\"si\":null,\"sk\":\"Lopta\",\"sq\":\"Top\",\"sr\":\"лопта\",\"sv\":\"Boll\",\"szl\":null,\"tzm\":\"Tcama\",\"uk\":\"М'яч\",\"vi\":\"Banh\",\"zh_Hans\":\"球\",\"zh_Hant\":\"足球\"}},{\"number\":57,\"emoji\":\"🎸\",\"description\":\"Guitar\",\"unicode\":\"U+1F3B8\",\"translated_descriptions\":{\"ar\":\"غيتار\",\"bg\":\"Китара\",\"ca\":\"Guitarra\",\"cs\":\"Kytara\",\"de\":\"Gitarre\",\"eo\":\"Gitaro\",\"es\":\"Guitarra\",\"et\":\"Kitarr\",\"fa\":\"گیتار\",\"fi\":\"Kitara\",\"fr\":\"Guitare\",\"hr\":\"gitara\",\"hu\":\"Gitár\",\"id\":\"Gitar\",\"it\":\"Chitarra\",\"ja\":\"ギター\",\"nb_NO\":\"Gitar\",\"nl\":\"Gitaar\",\"pt\":\"Guitarra\",\"pt_BR\":\"Guitarra\",\"ru\":\"Гитара\",\"si\":null,\"sk\":\"Gitara\",\"sq\":\"Kitarë\",\"sr\":\"гитара\",\"sv\":\"Gitarr\",\"szl\":null,\"tzm\":\"Agiṭaṛ\",\"uk\":\"Гітара\",\"vi\":\"Ghi-ta\",\"zh_Hans\":\"吉他\",\"zh_Hant\":\"吉他\"}},{\"number\":58,\"emoji\":\"🎺\",\"description\":\"Trumpet\",\"unicode\":\"U+1F3BA\",\"translated_descriptions\":{\"ar\":\"بُوق\",\"bg\":\"Тромпет\",\"ca\":\"Trompeta\",\"cs\":\"Trumpeta\",\"de\":\"Trompete\",\"eo\":\"Trumpeto\",\"es\":\"Trompeta\",\"et\":\"Trompet\",\"fa\":\"شیپور\",\"fi\":\"Trumpetti\",\"fr\":\"Trompette\",\"hr\":\"truba\",\"hu\":\"Trombita\",\"id\":\"Terompet\",\"it\":\"Trombetta\",\"ja\":\"トランペット\",\"nb_NO\":\"Trompet\",\"nl\":\"Trompet\",\"pt\":\"Trompete\",\"pt_BR\":\"Trombeta\",\"ru\":\"Труба\",\"si\":null,\"sk\":\"Trúbka\",\"sq\":\"Trombë\",\"sr\":\"труба\",\"sv\":\"Trumpet\",\"szl\":null,\"tzm\":null,\"uk\":\"Труба\",\"vi\":\"Kèn\",\"zh_Hans\":\"喇叭\",\"zh_Hant\":\"喇叭\"}},{\"number\":59,\"emoji\":\"🔔\",\"description\":\"Bell\",\"unicode\":\"U+1F514\",\"translated_descriptions\":{\"ar\":\"جَرَس\",\"bg\":\"Звънец\",\"ca\":\"Campana\",\"cs\":\"Zvonek\",\"de\":\"Glocke\",\"eo\":\"Sonorilo\",\"es\":\"Campana\",\"et\":\"Kelluke\",\"fa\":\"زنگ\",\"fi\":\"Soittokello\",\"fr\":\"Cloche\",\"hr\":\"zvono\",\"hu\":\"Harang\",\"id\":\"Lonceng\",\"it\":\"Campana\",\"ja\":\"ベル\",\"nb_NO\":\"Bjelle\",\"nl\":\"Bel\",\"pt\":\"Sino\",\"pt_BR\":\"Sino\",\"ru\":\"Колокол\",\"si\":null,\"sk\":\"Zvonec\",\"sq\":\"Kambanë\",\"sr\":\"звоно\",\"sv\":\"Bjällra\",\"szl\":null,\"tzm\":null,\"uk\":\"Дзвін\",\"vi\":\"Chuông\",\"zh_Hans\":\"铃铛\",\"zh_Hant\":\"鈴鐺\"}},{\"number\":60,\"emoji\":\"⚓\",\"description\":\"Anchor\",\"unicode\":\"U+2693\",\"translated_descriptions\":{\"ar\":\"مِرسَاة\",\"bg\":\"Котва\",\"ca\":\"Àncora\",\"cs\":\"Kotva\",\"de\":\"Anker\",\"eo\":\"Ankro\",\"es\":\"Ancla\",\"et\":\"Ankur\",\"fa\":\"لنگر\",\"fi\":\"Ankkuri\",\"fr\":\"Ancre\",\"hr\":\"sidro\",\"hu\":\"Horgony\",\"id\":\"Jangkar\",\"it\":\"Ancora\",\"ja\":\"いかり\",\"nb_NO\":\"Anker\",\"nl\":\"Anker\",\"pt\":\"Âncora\",\"pt_BR\":\"Âncora\",\"ru\":\"Якорь\",\"si\":null,\"sk\":\"Kotva\",\"sq\":\"Spirancë\",\"sr\":\"сидро\",\"sv\":\"Ankare\",\"szl\":null,\"tzm\":null,\"uk\":\"Якір\",\"vi\":\"Mỏ neo\",\"zh_Hans\":\"锚\",\"zh_Hant\":\"船錨\"}},{\"number\":61,\"emoji\":\"🎧\",\"description\":\"Headphones\",\"unicode\":\"U+1F3A7\",\"translated_descriptions\":{\"ar\":\"سَمّاعَة رَأس\",\"bg\":\"Слушалки\",\"ca\":\"Auriculars\",\"cs\":\"Sluchátka\",\"de\":\"Kopfhörer\",\"eo\":\"Kapaŭdilo\",\"es\":\"Cascos\",\"et\":\"Kõrvaklapid\",\"fa\":\"هدفون\",\"fi\":\"Kuulokkeet\",\"fr\":\"Casque audio\",\"hr\":\"slušalice\",\"hu\":\"Fejhallgató\",\"id\":\"Headphone\",\"it\":\"Cuffie\",\"ja\":\"ヘッドホン\",\"nb_NO\":\"Hodetelefoner\",\"nl\":\"Koptelefoon\",\"pt\":\"Fones\",\"pt_BR\":\"Fones de ouvido\",\"ru\":\"Наушники\",\"si\":null,\"sk\":\"Slúchadlá\",\"sq\":\"Kufje\",\"sr\":\"слушалице\",\"sv\":\"Hörlurar\",\"szl\":null,\"tzm\":null,\"uk\":\"Навушники\",\"vi\":\"Tai nghe\",\"zh_Hans\":\"耳机\",\"zh_Hant\":\"耳機\"}},{\"number\":62,\"emoji\":\"📁\",\"description\":\"Folder\",\"unicode\":\"U+1F4C1\",\"translated_descriptions\":{\"ar\":\"مُجَلَّد\",\"bg\":\"Папка\",\"ca\":\"Carpeta\",\"cs\":\"Složka\",\"de\":\"Ordner\",\"eo\":\"Dosierujo\",\"es\":\"Carpeta\",\"et\":\"Kaust\",\"fa\":\"پوشه\",\"fi\":\"Kansio\",\"fr\":\"Dossier\",\"hr\":\"mapu\",\"hu\":\"Mappa\",\"id\":\"Map\",\"it\":\"Cartella\",\"ja\":\"フォルダー\",\"nb_NO\":\"Mappe\",\"nl\":\"Map\",\"pt\":\"Pasta\",\"pt_BR\":\"Pasta\",\"ru\":\"Папка\",\"si\":null,\"sk\":\"Fascikel\",\"sq\":\"Dosje\",\"sr\":\"фасцикла\",\"sv\":\"Mapp\",\"szl\":null,\"tzm\":\"Asdaw\",\"uk\":\"Тека\",\"vi\":\"Thư mục\",\"zh_Hans\":\"文件夹\",\"zh_Hant\":\"資料夾\"}},{\"number\":63,\"emoji\":\"📌\",\"description\":\"Pin\",\"unicode\":\"U+1F4CC\",\"translated_descriptions\":{\"ar\":\"دَبُّوس\",\"bg\":\"Кабърче\",\"ca\":\"Xinxeta\",\"cs\":\"Špendlík\",\"de\":\"Stecknadel\",\"eo\":\"Pinglo\",\"es\":\"Alfiler\",\"et\":\"Nööpnõel\",\"fa\":\"سنجاق\",\"fi\":\"Nuppineula\",\"fr\":\"Punaise\",\"hr\":\"pribadača\",\"hu\":\"Rajszeg\",\"id\":\"Pin\",\"it\":\"Puntina\",\"ja\":\"ピン\",\"nb_NO\":\"Tegnestift\",\"nl\":\"Duimspijker\",\"pt\":\"Pionés\",\"pt_BR\":\"Alfinete\",\"ru\":\"Булавка\",\"si\":null,\"sk\":\"Špendlík\",\"sq\":\"Karficë\",\"sr\":\"чиода\",\"sv\":\"Häftstift\",\"szl\":null,\"tzm\":null,\"uk\":\"Кнопка\",\"vi\":\"Ghim\",\"zh_Hans\":\"图钉\",\"zh_Hant\":\"圖釘\"}}]")).map(({ emoji: e, description: t, translated_descriptions: n }) => [e, [t, Object.keys(n).reduce((e, t) => {
	for (let r of ab(t)) e[r] = n[t];
	return e;
}, {})]]));
function Vx(e, t) {
	let n = Bx.get(e);
	if (!n) throw Error(`Emoji mapping not found for emoji ${e}`);
	let [r, i] = n;
	for (let e of ab(t)) if (i[e]) return i[e];
	return r;
}
var Hx = {
	container: "_container_1lqqy_8",
	segment: "_segment_1lqqy_15",
	emoji: "_emoji_1lqqy_23",
	label: "_label_1lqqy_29"
};
//#endregion
//#region src/crypto/SasEmoji/SasEmoji.tsx
function Ux({ emoji: e, className: n }) {
	let { language: r } = W(), i = e.map((e, n) => /* @__PURE__ */ t.createElement("div", {
		className: Hx.segment,
		key: n
	}, /* @__PURE__ */ t.createElement("div", {
		className: Hx.emoji,
		"aria-hidden": !0
	}, e), /* @__PURE__ */ t.createElement("div", { className: Hx.label }, Vx(e, r))));
	return /* @__PURE__ */ t.createElement("div", { className: (0, H.default)(Hx.container, n) }, i);
}
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/close.js
function Wx(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M6.293 6.293a1 1 0 0 1 1.414 0L12 10.586l4.293-4.293a1 1 0 1 1 1.414 1.414L13.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414L12 13.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L10.586 12 6.293 7.707a1 1 0 0 1 0-1.414" })
	});
}
Wx.displayName = "CloseIcon";
var Gx = i(Wx), Kx = class {
	disposables = [];
	_isDisposed = !1;
	dispose() {
		if (!this.isDisposed) {
			this._isDisposed = !0;
			for (let e of this.disposables) typeof e == "function" ? e() : e.dispose();
		}
	}
	track(e) {
		return this.throwIfDisposed(), this.disposables.push(e), e;
	}
	trackListener(e, t, n) {
		this.throwIfDisposed(), e.on(t, n), this.track(() => {
			e.off(t, n);
		});
	}
	throwIfDisposed() {
		if (this.isDisposed) throw Error("Disposable is already disposed");
	}
	get isDisposed() {
		return this._isDisposed;
	}
}, qx = class {
	constructor(e, t) {
		this.snapshot = e, this.emit = t;
	}
	set(e) {
		this.snapshot = e, this.emit();
	}
	merge(e) {
		Object.keys(e).some((t) => !Object.is(e[t], this.snapshot[t])) && (this.snapshot = {
			...this.snapshot,
			...e
		}, this.emit());
	}
	get current() {
		return this.snapshot;
	}
}, Jx = class {
	listeners = /* @__PURE__ */ new Set();
	add = (e) => (this.listeners.add(e), () => {
		this.listeners.delete(e);
	});
	emit = () => {
		for (let e of this.listeners) e();
	};
}, Yx = class {
	subs;
	snapshot;
	props;
	disposables = new Kx();
	constructor(e, t) {
		this.props = e, this.subs = new Jx(), this.snapshot = new qx(t, () => {
			this.subs.emit();
		});
	}
	subscribe = (e) => this.subs.add(e);
	getSnapshot = () => this.snapshot.current;
	dispose() {
		this.disposables.dispose();
	}
	get isDisposed() {
		return this.disposables.isDisposed;
	}
}, Xx = class {
	constructor(e) {
		this.snapshot = e;
	}
	getSnapshot = () => this.snapshot;
	subscribe(e) {
		return () => void 0;
	}
};
//#endregion
//#region src/core/viewmodel/useCreateAutoDisposedViewModel.ts
function Zx(e) {
	let [t, n] = f(e);
	return c(() => {
		let r = t;
		if (t.isDisposed) {
			let t = e();
			r = t, n(t);
		}
		return () => {
			r.dispose();
		};
	}, []), t;
}
//#endregion
//#region src/core/viewmodel/useMockedViewModel.ts
function Qx(e, t) {
	return u(() => {
		let n = new Xx(e);
		return Object.assign(n, t), n;
	}, [e, t]);
}
//#endregion
//#region src/core/viewmodel/useViewModel.ts
function Y(e) {
	return p(e.subscribe, e.getSnapshot, e.getSnapshot);
}
var $x = {
	thumbnail: "_thumbnail_irnbt_8",
	link: "_link_irnbt_16",
	container: "_container_irnbt_21",
	wrapImageCaption: "_wrapImageCaption_irnbt_28",
	image: "_image_irnbt_36",
	caption: "_caption_irnbt_37",
	title: "_title_irnbt_59",
	description: "_description_irnbt_60"
}, eS = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", tS = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", nS = "numeric", rS = "ascii", iS = "alpha", aS = "asciinumeric", oS = "alphanumeric", sS = "domain", cS = "emoji", lS = "scheme", uS = "slashscheme", dS = "whitespace";
function fS(e, t) {
	return e in t || (t[e] = []), t[e];
}
function pS(e, t, n) {
	t[nS] && (t[aS] = !0, t[oS] = !0), t[rS] && (t[aS] = !0, t[iS] = !0), t[aS] && (t[oS] = !0), t[iS] && (t[oS] = !0), t[oS] && (t[sS] = !0), t[cS] && (t[sS] = !0);
	for (let r in t) {
		let t = fS(r, n);
		t.indexOf(e) < 0 && t.push(e);
	}
}
function mS(e, t) {
	let n = {};
	for (let r in t) t[r].indexOf(e) >= 0 && (n[r] = !0);
	return n;
}
function hS(e = null) {
	this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
hS.groups = {}, hS.prototype = {
	accepts() {
		return !!this.t;
	},
	go(e) {
		let t = this, n = t.j[e];
		if (n) return n;
		for (let n = 0; n < t.jr.length; n++) {
			let r = t.jr[n][0], i = t.jr[n][1];
			if (i && r.test(e)) return i;
		}
		return t.jd;
	},
	has(e, t = !1) {
		return t ? e in this.j : !!this.go(e);
	},
	ta(e, t, n, r) {
		for (let i = 0; i < e.length; i++) this.tt(e[i], t, n, r);
	},
	tr(e, t, n, r) {
		r ||= hS.groups;
		let i;
		return t && t.j ? i = t : (i = new hS(t), n && r && pS(t, n, r)), this.jr.push([e, i]), i;
	},
	ts(e, t, n, r) {
		let i = this, a = e.length;
		if (!a) return i;
		for (let t = 0; t < a - 1; t++) i = i.tt(e[t]);
		return i.tt(e[a - 1], t, n, r);
	},
	tt(e, t, n, r) {
		r ||= hS.groups;
		let i = this;
		if (t && t.j) return i.j[e] = t, t;
		let a = t, o, s = i.go(e);
		return s ? (o = new hS(), Object.assign(o.j, s.j), o.jr.push.apply(o.jr, s.jr), o.jd = s.jd, o.t = s.t) : o = new hS(), a && (r && (o.t && typeof o.t == "string" ? pS(a, Object.assign(mS(o.t, r), n), r) : n && pS(a, n, r)), o.t = a), i.j[e] = o, o;
	}
};
var X = (e, t, n, r, i) => e.ta(t, n, r, i), Z = (e, t, n, r, i) => e.tr(t, n, r, i), gS = (e, t, n, r, i) => e.ts(t, n, r, i), Q = (e, t, n, r, i) => e.tt(t, n, r, i), _S = "WORD", vS = "UWORD", yS = "ASCIINUMERICAL", bS = "ALPHANUMERICAL", xS = "LOCALHOST", SS = "TLD", CS = "UTLD", wS = "SCHEME", TS = "SLASH_SCHEME", ES = "NUM", DS = "WS", OS = "NL", kS = "OPENBRACE", AS = "CLOSEBRACE", jS = "OPENBRACKET", MS = "CLOSEBRACKET", NS = "OPENPAREN", PS = "CLOSEPAREN", FS = "OPENANGLEBRACKET", IS = "CLOSEANGLEBRACKET", LS = "FULLWIDTHLEFTPAREN", RS = "FULLWIDTHRIGHTPAREN", zS = "LEFTCORNERBRACKET", BS = "RIGHTCORNERBRACKET", VS = "LEFTWHITECORNERBRACKET", HS = "RIGHTWHITECORNERBRACKET", US = "FULLWIDTHLESSTHAN", WS = "FULLWIDTHGREATERTHAN", GS = "AMPERSAND", KS = "APOSTROPHE", qS = "ASTERISK", JS = "AT", YS = "BACKSLASH", XS = "BACKTICK", ZS = "CARET", QS = "COLON", $S = "COMMA", eC = "DOLLAR", tC = "DOT", nC = "EQUALS", rC = "EXCLAMATION", iC = "HYPHEN", aC = "PERCENT", oC = "PIPE", sC = "PLUS", cC = "POUND", lC = "QUERY", uC = "QUOTE", dC = "FULLWIDTHMIDDLEDOT", fC = "SEMI", pC = "SLASH", mC = "TILDE", hC = "UNDERSCORE", gC = "EMOJI", _C = "SYM", vC = /* @__PURE__ */ Object.freeze({
	__proto__: null,
	ALPHANUMERICAL: bS,
	AMPERSAND: GS,
	APOSTROPHE: KS,
	ASCIINUMERICAL: yS,
	ASTERISK: qS,
	AT: JS,
	BACKSLASH: YS,
	BACKTICK: XS,
	CARET: ZS,
	CLOSEANGLEBRACKET: IS,
	CLOSEBRACE: AS,
	CLOSEBRACKET: MS,
	CLOSEPAREN: PS,
	COLON: QS,
	COMMA: $S,
	DOLLAR: eC,
	DOT: tC,
	EMOJI: gC,
	EQUALS: nC,
	EXCLAMATION: rC,
	FULLWIDTHGREATERTHAN: WS,
	FULLWIDTHLEFTPAREN: LS,
	FULLWIDTHLESSTHAN: US,
	FULLWIDTHMIDDLEDOT: dC,
	FULLWIDTHRIGHTPAREN: RS,
	HYPHEN: iC,
	LEFTCORNERBRACKET: zS,
	LEFTWHITECORNERBRACKET: VS,
	LOCALHOST: xS,
	NL: OS,
	NUM: ES,
	OPENANGLEBRACKET: FS,
	OPENBRACE: kS,
	OPENBRACKET: jS,
	OPENPAREN: NS,
	PERCENT: aC,
	PIPE: oC,
	PLUS: sC,
	POUND: cC,
	QUERY: lC,
	QUOTE: uC,
	RIGHTCORNERBRACKET: BS,
	RIGHTWHITECORNERBRACKET: HS,
	SCHEME: wS,
	SEMI: fC,
	SLASH: pC,
	SLASH_SCHEME: TS,
	SYM: _C,
	TILDE: mC,
	TLD: SS,
	UNDERSCORE: hC,
	UTLD: CS,
	UWORD: vS,
	WORD: _S,
	WS: DS
}), yC = /[a-z]/, bC = /\p{L}/u, xC = /\p{Emoji}/u, SC = /\d/, CC = /\s/, wC = "\r", TC = "\n", EC = "️", DC = "‍", OC = "￼", kC = null, AC = null;
function jC(e = []) {
	let t = {};
	hS.groups = t;
	let n = new hS();
	kC ??= FC(eS), AC ??= FC(tS), Q(n, "'", KS), Q(n, "{", kS), Q(n, "}", AS), Q(n, "[", jS), Q(n, "]", MS), Q(n, "(", NS), Q(n, ")", PS), Q(n, "<", FS), Q(n, ">", IS), Q(n, "（", LS), Q(n, "）", RS), Q(n, "「", zS), Q(n, "」", BS), Q(n, "『", VS), Q(n, "』", HS), Q(n, "＜", US), Q(n, "＞", WS), Q(n, "&", GS), Q(n, "*", qS), Q(n, "@", JS), Q(n, "`", XS), Q(n, "^", ZS), Q(n, ":", QS), Q(n, ",", $S), Q(n, "$", eC), Q(n, ".", tC), Q(n, "=", nC), Q(n, "!", rC), Q(n, "-", iC), Q(n, "%", aC), Q(n, "|", oC), Q(n, "+", sC), Q(n, "#", cC), Q(n, "?", lC), Q(n, "\"", uC), Q(n, "/", pC), Q(n, ";", fC), Q(n, "~", mC), Q(n, "_", hC), Q(n, "\\", YS), Q(n, "・", dC);
	let r = Z(n, SC, ES, { [nS]: !0 });
	Z(r, SC, r);
	let i = Z(r, yC, yS, { [aS]: !0 }), a = Z(r, bC, bS, { [oS]: !0 }), o = Z(n, yC, _S, { [rS]: !0 });
	Z(o, SC, i), Z(o, yC, o), Z(i, SC, i), Z(i, yC, i);
	let s = Z(n, bC, vS, { [iS]: !0 });
	Z(s, yC), Z(s, SC, a), Z(s, bC, s), Z(a, SC, a), Z(a, yC), Z(a, bC, a);
	let c = Q(n, TC, OS, { [dS]: !0 }), l = Q(n, wC, DS, { [dS]: !0 }), u = Z(n, CC, DS, { [dS]: !0 });
	Q(n, OC, u), Q(l, TC, c), Q(l, OC, u), Z(l, CC, u), Q(u, wC), Q(u, TC), Z(u, CC, u), Q(u, OC, u);
	let d = Z(n, xC, gC, { [cS]: !0 });
	Q(d, "#"), Z(d, xC, d), Q(d, EC, d);
	let f = Q(d, DC);
	Q(f, "#"), Z(f, xC, d);
	let p = [[yC, o], [SC, i]], m = [
		[yC, null],
		[bC, s],
		[SC, a]
	];
	for (let e = 0; e < kC.length; e++) PC(n, kC[e], SS, _S, p);
	for (let e = 0; e < AC.length; e++) PC(n, AC[e], CS, vS, m);
	pS(SS, {
		tld: !0,
		ascii: !0
	}, t), pS(CS, {
		utld: !0,
		alpha: !0
	}, t), PC(n, "file", wS, _S, p), PC(n, "mailto", wS, _S, p), PC(n, "http", TS, _S, p), PC(n, "https", TS, _S, p), PC(n, "ftp", TS, _S, p), PC(n, "ftps", TS, _S, p), pS(wS, {
		scheme: !0,
		ascii: !0
	}, t), pS(TS, {
		slashscheme: !0,
		ascii: !0
	}, t), e = e.sort((e, t) => e[0] > t[0] ? 1 : -1);
	for (let t = 0; t < e.length; t++) {
		let r = e[t][0], i = e[t][1] ? { [lS]: !0 } : { [uS]: !0 };
		r.indexOf("-") >= 0 ? i[sS] = !0 : yC.test(r) ? SC.test(r) ? i[aS] = !0 : i[rS] = !0 : i[nS] = !0, gS(n, r, r, i);
	}
	return gS(n, "localhost", xS, { ascii: !0 }), n.jd = new hS(_C), {
		start: n,
		tokens: Object.assign({ groups: t }, vC)
	};
}
function MC(e, t) {
	let n = NC(t.replace(/[A-Z]/g, (e) => e.toLowerCase())), r = n.length, i = [], a = 0, o = 0;
	for (; o < r;) {
		let s = e, c = null, l = 0, u = null, d = -1, f = -1;
		for (; o < r && (c = s.go(n[o]));) s = c, s.accepts() ? (d = 0, f = 0, u = s) : d >= 0 && (d += n[o].length, f++), l += n[o].length, a += n[o].length, o++;
		a -= d, o -= f, l -= d, i.push({
			t: u.t,
			v: t.slice(a - l, a),
			s: a - l,
			e: a
		});
	}
	return i;
}
function NC(e) {
	let t = [], n = e.length, r = 0;
	for (; r < n;) {
		let i = e.charCodeAt(r), a, o = i < 55296 || i > 56319 || r + 1 === n || (a = e.charCodeAt(r + 1)) < 56320 || a > 57343 ? e[r] : e.slice(r, r + 2);
		t.push(o), r += o.length;
	}
	return t;
}
function PC(e, t, n, r, i) {
	let a, o = t.length;
	for (let n = 0; n < o - 1; n++) {
		let o = t[n];
		e.j[o] ? a = e.j[o] : (a = new hS(r), a.jr = i.slice(), e.j[o] = a), e = a;
	}
	return a = new hS(n), a.jr = i.slice(), e.j[t[o - 1]] = a, a;
}
function FC(e) {
	let t = [], n = [], r = 0;
	for (; r < e.length;) {
		let i = 0;
		for (; "0123456789".indexOf(e[r + i]) >= 0;) i++;
		if (i > 0) {
			t.push(n.join(""));
			for (let t = parseInt(e.substring(r, r + i), 10); t > 0; t--) n.pop();
			r += i;
		} else n.push(e[r]), r++;
	}
	return t;
}
var IC = {
	defaultProtocol: "http",
	events: null,
	format: RC,
	formatHref: RC,
	nl2br: !1,
	tagName: "a",
	target: null,
	rel: null,
	validate: !0,
	truncate: Infinity,
	className: null,
	attributes: null,
	ignoreTags: [],
	render: null
};
function LC(e, t = null) {
	let n = Object.assign({}, IC);
	e && (n = Object.assign(n, e instanceof LC ? e.o : e));
	let r = n.ignoreTags, i = [];
	for (let e = 0; e < r.length; e++) i.push(r[e].toUpperCase());
	this.o = n, t && (this.defaultRender = t), this.ignoreTags = i;
}
LC.prototype = {
	o: IC,
	ignoreTags: [],
	defaultRender(e) {
		return e;
	},
	check(e) {
		return this.get("validate", e.toString(), e);
	},
	get(e, t, n) {
		let r = t != null, i = this.o[e];
		return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : IC[e], typeof i == "function" && r && (i = i(t, n))) : typeof i == "function" && r && (i = i(t, n.t, n)), i);
	},
	getObj(e, t, n) {
		let r = this.o[e];
		return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
	},
	render(e) {
		let t = e.render(this);
		return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
	}
};
function RC(e) {
	return e;
}
function zC(e, t) {
	this.t = "token", this.v = e, this.tk = t;
}
zC.prototype = {
	isLink: !1,
	toString() {
		return this.v;
	},
	toHref(e) {
		return this.toString();
	},
	toFormattedString(e) {
		let t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
		return n && r.length > n ? r.substring(0, n) + "…" : r;
	},
	toFormattedHref(e) {
		return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
	},
	startIndex() {
		return this.tk[0].s;
	},
	endIndex() {
		return this.tk[this.tk.length - 1].e;
	},
	toObject(e = IC.defaultProtocol) {
		return {
			type: this.t,
			value: this.toString(),
			isLink: this.isLink,
			href: this.toHref(e),
			start: this.startIndex(),
			end: this.endIndex()
		};
	},
	toFormattedObject(e) {
		return {
			type: this.t,
			value: this.toFormattedString(e),
			isLink: this.isLink,
			href: this.toFormattedHref(e),
			start: this.startIndex(),
			end: this.endIndex()
		};
	},
	validate(e) {
		return e.get("validate", this.toString(), this);
	},
	render(e) {
		let t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), i = e.get("tagName", n, t), a = this.toFormattedString(e), o = {}, s = e.get("className", n, t), c = e.get("target", n, t), l = e.get("rel", n, t), u = e.getObj("attributes", n, t), d = e.getObj("events", n, t);
		return o.href = r, s && (o.class = s), c && (o.target = c), l && (o.rel = l), u && Object.assign(o, u), {
			tagName: i,
			attributes: o,
			content: a,
			eventListeners: d
		};
	}
};
function BC(e, t) {
	class n extends zC {
		constructor(t, n) {
			super(t, n), this.t = e;
		}
	}
	for (let e in t) n.prototype[e] = t[e];
	return n.t = e, n;
}
var VC = BC("email", {
	isLink: !0,
	toHref() {
		return "mailto:" + this.toString();
	}
}), HC = BC("text"), UC = BC("nl"), WC = BC("url", {
	isLink: !0,
	toHref(e = IC.defaultProtocol) {
		return this.hasProtocol() ? this.v : `${e}://${this.v}`;
	},
	hasProtocol() {
		let e = this.tk;
		return e.length >= 2 && e[0].t !== xS && e[1].t === QS;
	}
}), GC = (e) => new hS(e);
function KC({ groups: e }) {
	let t = e.domain.concat([
		GS,
		qS,
		JS,
		YS,
		XS,
		ZS,
		eC,
		nC,
		iC,
		ES,
		aC,
		oC,
		sC,
		cC,
		pC,
		_C,
		mC,
		hC
	]), n = [
		KS,
		QS,
		$S,
		tC,
		rC,
		aC,
		lC,
		uC,
		fC,
		FS,
		IS,
		kS,
		AS,
		MS,
		jS,
		NS,
		PS,
		LS,
		RS,
		zS,
		BS,
		VS,
		HS,
		US,
		WS
	], r = [
		GS,
		KS,
		qS,
		YS,
		XS,
		ZS,
		eC,
		nC,
		iC,
		kS,
		AS,
		aC,
		oC,
		sC,
		cC,
		lC,
		pC,
		_C,
		mC,
		hC
	], i = GC(), a = Q(i, mC);
	X(a, r, a), X(a, e.domain, a);
	let o = GC(), s = GC(), c = GC();
	X(i, e.domain, o), X(i, e.scheme, s), X(i, e.slashscheme, c), X(o, r, a), X(o, e.domain, o);
	let l = Q(o, JS);
	Q(a, JS, l), Q(s, JS, l), Q(c, JS, l);
	let u = Q(a, tC);
	X(u, r, a), X(u, e.domain, a);
	let d = GC();
	X(l, e.domain, d), X(d, e.domain, d);
	let f = Q(d, tC);
	X(f, e.domain, d);
	let p = GC(VC);
	X(f, e.tld, p), X(f, e.utld, p), Q(l, xS, p);
	let m = Q(d, iC);
	Q(m, iC, m), X(m, e.domain, d), X(p, e.domain, d), Q(p, tC, f), Q(p, iC, m), X(Q(p, QS), e.numeric, VC);
	let h = Q(o, iC), g = Q(o, tC);
	Q(h, iC, h), X(h, e.domain, o), X(g, r, a), X(g, e.domain, o);
	let _ = GC(WC);
	X(g, e.tld, _), X(g, e.utld, _), X(_, e.domain, o), X(_, r, a), Q(_, tC, g), Q(_, iC, h), Q(_, JS, l);
	let v = Q(_, QS), y = GC(WC);
	X(v, e.numeric, y);
	let b = GC(WC), x = GC();
	X(b, t, b), X(b, n, x), X(x, t, b), X(x, n, x), Q(_, pC, b), Q(y, pC, b);
	let S = Q(s, QS), C = Q(Q(Q(c, QS), pC), pC);
	X(s, e.domain, o), Q(s, tC, g), Q(s, iC, h), X(c, e.domain, o), Q(c, tC, g), Q(c, iC, h), X(S, e.domain, b), Q(S, pC, b), Q(S, lC, b), X(C, e.domain, b), X(C, t, b), Q(C, pC, b);
	let w = [
		[kS, AS],
		[jS, MS],
		[NS, PS],
		[FS, IS],
		[LS, RS],
		[zS, BS],
		[VS, HS],
		[US, WS]
	];
	for (let e = 0; e < w.length; e++) {
		let [r, i] = w[e], a = Q(b, r);
		Q(x, r, a), Q(a, i, b);
		let o = GC(WC);
		X(a, t, o);
		let s = GC();
		X(a, n), X(o, t, o), X(o, n, s), X(s, t, o), X(s, n, s), Q(o, i, b), Q(s, i, b);
	}
	return Q(i, xS, _), Q(i, OS, UC), {
		start: i,
		tokens: vC
	};
}
function qC(e, t, n) {
	let r = n.length, i = 0, a = [], o = [];
	for (; i < r;) {
		let s = e, c = null, l = null, u = 0, d = null, f = -1;
		for (; i < r && !(c = s.go(n[i].t));) o.push(n[i++]);
		for (; i < r && (l = c || s.go(n[i].t));) c = null, s = l, s.accepts() ? (f = 0, d = s) : f >= 0 && f++, i++, u++;
		if (f < 0) i -= u, i < r && (o.push(n[i]), i++);
		else {
			o.length > 0 && (a.push(JC(HC, t, o)), o = []), i -= f, u -= f;
			let e = d.t, r = n.slice(i - u, i);
			a.push(JC(e, t, r));
		}
	}
	return o.length > 0 && a.push(JC(HC, t, o)), a;
}
function JC(e, t, n) {
	let r = n[0].s, i = n[n.length - 1].e;
	return new e(t.slice(r, i), n);
}
var YC = typeof console < "u" && console && console.warn || (() => {}), XC = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", $ = {
	scanner: null,
	parser: null,
	tokenQueue: [],
	pluginQueue: [],
	customSchemes: [],
	initialized: !1
};
function ZC(e, t) {
	if (typeof t != "function") throw Error(`linkifyjs: Invalid plugin ${t} (expects function)`);
	for (let n = 0; n < $.pluginQueue.length; n++) if (e === $.pluginQueue[n][0]) {
		YC(`linkifyjs: plugin "${e}" already registered - will be overwritten`), $.pluginQueue[n] = [e, t];
		return;
	}
	$.pluginQueue.push([e, t]), $.initialized && YC(`linkifyjs: already initialized - will not register plugin "${e}" ${XC}`);
}
function QC(e, t = !1) {
	if ($.initialized && YC(`linkifyjs: already initialized - will not register custom scheme "${e}" ${XC}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e)) throw Error("linkifyjs: incorrect scheme format.\n1. Must only contain digits, lowercase ASCII letters or \"-\"\n2. Cannot start or end with \"-\"\n3. \"-\" cannot repeat");
	$.customSchemes.push([e, t]);
}
function $C() {
	$.scanner = jC($.customSchemes);
	for (let e = 0; e < $.tokenQueue.length; e++) $.tokenQueue[e][1]({ scanner: $.scanner });
	$.parser = KC($.scanner.tokens);
	for (let e = 0; e < $.pluginQueue.length; e++) $.pluginQueue[e][1]({
		scanner: $.scanner,
		parser: $.parser
	});
	return $.initialized = !0, $;
}
function ew(e) {
	return $.initialized || $C(), qC($.parser.start, e, MC($.scanner.start, e));
}
ew.scan = MC;
function tw(e, t = null, n = null) {
	if (t && typeof t == "object") {
		if (n) throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
		n = t, t = null;
	}
	let r = new LC(n), i = ew(e), a = [];
	for (let e = 0; e < i.length; e++) {
		let n = i[e];
		n.isLink && (!t || n.t === t) && r.check(n) && a.push(n.toFormattedObject(r));
	}
	return a;
}
function nw(e, t = null) {
	let n = ew(e);
	return n.length === 1 && n[0].isLink && (!t || n[0].t === t);
}
//#endregion
//#region ../../node_modules/linkify-react/dist/linkify-react.mjs
function rw(t, n, r) {
	let i = ew(t), a = [];
	for (let t = 0; t < i.length; t++) {
		let o = i[t];
		if (o.t === "nl" && n.get("nl2br")) {
			let t = `__linkify-el-${r.elementId++}`;
			a.push(e.createElement("br", { key: t }));
		} else if (!o.isLink || !n.check(o)) a.push(o.toString());
		else {
			let t = n.render(o);
			if (!("key" in t.props)) {
				let n = `__linkify-el-${r.elementId++}`, i = Object.assign({ key: n }, t.props);
				t = e.cloneElement(t, i);
			}
			a.push(t);
		}
	}
	return a;
}
function iw(t, n, r) {
	if (e.Children.count(t.props.children) === 0) return t;
	let i = [];
	e.Children.forEach(t.props.children, (t) => {
		typeof t == "string" ? i.push.apply(i, rw(t, n, r)) : e.isValidElement(t) ? typeof t.type == "string" && n.ignoreTags.indexOf(t.type.toUpperCase()) >= 0 ? i.push(t) : i.push(iw(t, n, r)) : i.push(t);
	});
	let a = `__linkify-el-${r.elementId++}`, o = Object.assign({ key: a }, t.props);
	return e.cloneElement(t, o, i);
}
var aw = (t) => {
	let n = 0, r = ({ tagName: t, attributes: r, content: i }) => (r.key = `__linkify-lnk-${n++}`, r.class && (r.className = r.class, delete r.class), e.createElement(t, r, i)), i = { key: "__linkify-wrapper" };
	for (let e in t) e !== "options" && e !== "as" && e !== "tagName" && e !== "children" && (i[e] = t[e]);
	let a = new LC(t.options, r), o = t.as || t.tagName || e.Fragment || "span", s = t.children;
	return iw(e.createElement(o, i, s), a, { elementId: 0 });
}, ow = { container: "_container_15awj_8" };
//#endregion
//#region ../../node_modules/linkify-string/dist/linkify-string.mjs
function sw(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function cw(e) {
	return e.replace(/"/g, "&quot;");
}
function lw(e) {
	let t = [];
	for (let n in e) {
		let r = e[n] + "";
		t.push(`${n}="${cw(r)}"`);
	}
	return t.join(" ");
}
function uw({ tagName: e, attributes: t, content: n }) {
	return `<${e} ${lw(t)}>${sw(n)}</${e}>`;
}
function dw(e, t = {}) {
	t = new LC(t, uw);
	let n = ew(e), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = n[e];
		i.t === "nl" && t.get("nl2br") ? r.push("<br>\n") : !i.isLink || !t.check(i) ? r.push(sw(i.toString())) : r.push(t.render(i));
	}
	return r.join("");
}
String.prototype.linkify || Object.defineProperty(String.prototype, "linkify", {
	writable: !1,
	value: function(e) {
		return dw(this, e);
	}
});
//#endregion
//#region ../../node_modules/linkify-html/dist/linkify-html.mjs
var fw = {
	amp: "&",
	gt: ">",
	lt: "<",
	nbsp: "\xA0",
	quot: "\""
}, pw = /^#[xX]([A-Fa-f0-9]+)$/, mw = /^#([0-9]+)$/, hw = /^([A-Za-z0-9]+)$/, gw = function() {
	function e(e) {
		this.named = e;
	}
	return e.prototype.parse = function(e) {
		if (e) {
			var t = e.match(pw);
			if (t) return String.fromCharCode(parseInt(t[1], 16));
			if (t = e.match(mw), t) return String.fromCharCode(parseInt(t[1], 10));
			if (t = e.match(hw), t) return this.named[t[1]] || "&" + t[1] + ";";
		}
	}, e;
}(), _w = /[\t\n\f ]/, vw = /[A-Za-z]/, yw = /\r\n?/g;
function bw(e) {
	return _w.test(e);
}
function xw(e) {
	return vw.test(e);
}
function Sw(e) {
	return e.replace(yw, "\n");
}
var Cw = function() {
	function e(e, t, n) {
		n === void 0 && (n = "precompile"), this.delegate = e, this.entityParser = t, this.mode = n, this.state = "beforeData", this.line = -1, this.column = -1, this.input = "", this.index = -1, this.tagNameBuffer = "", this.states = {
			beforeData: function() {
				var e = this.peek();
				if (e === "<" && !this.isIgnoredEndTag()) this.transitionTo("tagOpen"), this.markTagStart(), this.consume();
				else {
					if (this.mode === "precompile" && e === "\n") {
						var t = this.tagNameBuffer.toLowerCase();
						(t === "pre" || t === "textarea") && this.consume();
					}
					this.transitionTo("data"), this.delegate.beginData();
				}
			},
			data: function() {
				var e = this.peek(), t = this.tagNameBuffer;
				e === "<" && !this.isIgnoredEndTag() ? (this.delegate.finishData(), this.transitionTo("tagOpen"), this.markTagStart(), this.consume()) : e === "&" && t !== "script" && t !== "style" ? (this.consume(), this.delegate.appendToData(this.consumeCharRef() || "&")) : (this.consume(), this.delegate.appendToData(e));
			},
			tagOpen: function() {
				var e = this.consume();
				e === "!" ? this.transitionTo("markupDeclarationOpen") : e === "/" ? this.transitionTo("endTagOpen") : (e === "@" || e === ":" || xw(e)) && (this.transitionTo("tagName"), this.tagNameBuffer = "", this.delegate.beginStartTag(), this.appendToTagName(e));
			},
			markupDeclarationOpen: function() {
				var e = this.consume();
				e === "-" && this.peek() === "-" ? (this.consume(), this.transitionTo("commentStart"), this.delegate.beginComment()) : e.toUpperCase() + this.input.substring(this.index, this.index + 6).toUpperCase() === "DOCTYPE" && (this.consume(), this.consume(), this.consume(), this.consume(), this.consume(), this.consume(), this.transitionTo("doctype"), this.delegate.beginDoctype && this.delegate.beginDoctype());
			},
			doctype: function() {
				bw(this.consume()) && this.transitionTo("beforeDoctypeName");
			},
			beforeDoctypeName: function() {
				var e = this.consume();
				bw(e) || (this.transitionTo("doctypeName"), this.delegate.appendToDoctypeName && this.delegate.appendToDoctypeName(e.toLowerCase()));
			},
			doctypeName: function() {
				var e = this.consume();
				bw(e) ? this.transitionTo("afterDoctypeName") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : this.delegate.appendToDoctypeName && this.delegate.appendToDoctypeName(e.toLowerCase());
			},
			afterDoctypeName: function() {
				var e = this.consume();
				if (!bw(e)) if (e === ">") this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData");
				else {
					var t = e.toUpperCase() + this.input.substring(this.index, this.index + 5).toUpperCase(), n = t.toUpperCase() === "PUBLIC", r = t.toUpperCase() === "SYSTEM";
					(n || r) && (this.consume(), this.consume(), this.consume(), this.consume(), this.consume(), this.consume()), n ? this.transitionTo("afterDoctypePublicKeyword") : r && this.transitionTo("afterDoctypeSystemKeyword");
				}
			},
			afterDoctypePublicKeyword: function() {
				var e = this.peek();
				if (bw(e)) this.transitionTo("beforeDoctypePublicIdentifier"), this.consume();
				else if (e === "\"") this.transitionTo("doctypePublicIdentifierDoubleQuoted"), this.consume();
				else if (e === "'") this.transitionTo("doctypePublicIdentifierSingleQuoted"), this.consume();
				else if (e === ">") this.consume(), this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData");
				else throw Error("Unexpected token");
			},
			doctypePublicIdentifierDoubleQuoted: function() {
				var e = this.consume();
				e === "\"" ? this.transitionTo("afterDoctypePublicIdentifier") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : this.delegate.appendToDoctypePublicIdentifier && this.delegate.appendToDoctypePublicIdentifier(e);
			},
			doctypePublicIdentifierSingleQuoted: function() {
				var e = this.consume();
				e === "'" ? this.transitionTo("afterDoctypePublicIdentifier") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : this.delegate.appendToDoctypePublicIdentifier && this.delegate.appendToDoctypePublicIdentifier(e);
			},
			afterDoctypePublicIdentifier: function() {
				var e = this.consume();
				bw(e) ? this.transitionTo("betweenDoctypePublicAndSystemIdentifiers") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : e === "\"" ? this.transitionTo("doctypeSystemIdentifierDoubleQuoted") : e === "'" && this.transitionTo("doctypeSystemIdentifierSingleQuoted");
			},
			betweenDoctypePublicAndSystemIdentifiers: function() {
				var e = this.consume();
				bw(e) || (e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : e === "\"" ? this.transitionTo("doctypeSystemIdentifierDoubleQuoted") : e === "'" && this.transitionTo("doctypeSystemIdentifierSingleQuoted"));
			},
			doctypeSystemIdentifierDoubleQuoted: function() {
				var e = this.consume();
				e === "\"" ? this.transitionTo("afterDoctypeSystemIdentifier") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : this.delegate.appendToDoctypeSystemIdentifier && this.delegate.appendToDoctypeSystemIdentifier(e);
			},
			doctypeSystemIdentifierSingleQuoted: function() {
				var e = this.consume();
				e === "'" ? this.transitionTo("afterDoctypeSystemIdentifier") : e === ">" ? (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData")) : this.delegate.appendToDoctypeSystemIdentifier && this.delegate.appendToDoctypeSystemIdentifier(e);
			},
			afterDoctypeSystemIdentifier: function() {
				var e = this.consume();
				bw(e) || e === ">" && (this.delegate.endDoctype && this.delegate.endDoctype(), this.transitionTo("beforeData"));
			},
			commentStart: function() {
				var e = this.consume();
				e === "-" && this.peek() === "-" ? this.transitionTo("commentStartDash") : e === ">" ? (this.delegate.finishComment(), this.transitionTo("beforeData")) : (this.delegate.appendToCommentData(e), this.transitionTo("comment"));
			},
			commentStartDash: function() {
				var e = this.consume();
				e === "-" ? this.transitionTo("commentEnd") : e === ">" ? (this.delegate.finishComment(), this.transitionTo("beforeData")) : (this.delegate.appendToCommentData("-"), this.transitionTo("comment"));
			},
			comment: function() {
				var e = this.consume();
				e === "-" ? this.transitionTo("commentEndDash") : this.delegate.appendToCommentData(e);
			},
			commentEndDash: function() {
				var e = this.consume();
				e === "-" && this.peek() === "-" ? this.delegate.appendToCommentData(e) : e === "-" ? this.transitionTo("commentEnd") : (this.delegate.appendToCommentData("-" + e), this.transitionTo("comment"));
			},
			commentEnd: function() {
				var e = this.consume();
				e === ">" ? (this.delegate.finishComment(), this.transitionTo("beforeData")) : (this.delegate.appendToCommentData("--" + e), this.transitionTo("comment"));
			},
			tagName: function() {
				var e = this.consume();
				bw(e) ? this.transitionTo("beforeAttributeName") : e === "/" ? this.transitionTo("selfClosingStartTag") : e === ">" ? (this.delegate.finishTag(), this.transitionTo("beforeData")) : this.appendToTagName(e);
			},
			endTagName: function() {
				var e = this.consume();
				bw(e) ? (this.transitionTo("beforeAttributeName"), this.tagNameBuffer = "") : e === "/" ? (this.transitionTo("selfClosingStartTag"), this.tagNameBuffer = "") : e === ">" ? (this.delegate.finishTag(), this.transitionTo("beforeData"), this.tagNameBuffer = "") : this.appendToTagName(e);
			},
			beforeAttributeName: function() {
				var e = this.peek();
				if (bw(e)) {
					this.consume();
					return;
				} else e === "/" ? (this.transitionTo("selfClosingStartTag"), this.consume()) : e === ">" ? (this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : e === "=" ? (this.delegate.reportSyntaxError("attribute name cannot start with equals sign"), this.transitionTo("attributeName"), this.delegate.beginAttribute(), this.consume(), this.delegate.appendToAttributeName(e)) : (this.transitionTo("attributeName"), this.delegate.beginAttribute());
			},
			attributeName: function() {
				var e = this.peek();
				bw(e) ? (this.transitionTo("afterAttributeName"), this.consume()) : e === "/" ? (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.consume(), this.transitionTo("selfClosingStartTag")) : e === "=" ? (this.transitionTo("beforeAttributeValue"), this.consume()) : e === ">" ? (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : e === "\"" || e === "'" || e === "<" ? (this.delegate.reportSyntaxError(e + " is not a valid character within attribute names"), this.consume(), this.delegate.appendToAttributeName(e)) : (this.consume(), this.delegate.appendToAttributeName(e));
			},
			afterAttributeName: function() {
				var e = this.peek();
				if (bw(e)) {
					this.consume();
					return;
				} else e === "/" ? (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.consume(), this.transitionTo("selfClosingStartTag")) : e === "=" ? (this.consume(), this.transitionTo("beforeAttributeValue")) : e === ">" ? (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.transitionTo("attributeName"), this.delegate.beginAttribute(), this.consume(), this.delegate.appendToAttributeName(e));
			},
			beforeAttributeValue: function() {
				var e = this.peek();
				bw(e) ? this.consume() : e === "\"" ? (this.transitionTo("attributeValueDoubleQuoted"), this.delegate.beginAttributeValue(!0), this.consume()) : e === "'" ? (this.transitionTo("attributeValueSingleQuoted"), this.delegate.beginAttributeValue(!0), this.consume()) : e === ">" ? (this.delegate.beginAttributeValue(!1), this.delegate.finishAttributeValue(), this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : (this.transitionTo("attributeValueUnquoted"), this.delegate.beginAttributeValue(!1), this.consume(), this.delegate.appendToAttributeValue(e));
			},
			attributeValueDoubleQuoted: function() {
				var e = this.consume();
				e === "\"" ? (this.delegate.finishAttributeValue(), this.transitionTo("afterAttributeValueQuoted")) : e === "&" ? this.delegate.appendToAttributeValue(this.consumeCharRef() || "&") : this.delegate.appendToAttributeValue(e);
			},
			attributeValueSingleQuoted: function() {
				var e = this.consume();
				e === "'" ? (this.delegate.finishAttributeValue(), this.transitionTo("afterAttributeValueQuoted")) : e === "&" ? this.delegate.appendToAttributeValue(this.consumeCharRef() || "&") : this.delegate.appendToAttributeValue(e);
			},
			attributeValueUnquoted: function() {
				var e = this.peek();
				bw(e) ? (this.delegate.finishAttributeValue(), this.consume(), this.transitionTo("beforeAttributeName")) : e === "/" ? (this.delegate.finishAttributeValue(), this.consume(), this.transitionTo("selfClosingStartTag")) : e === "&" ? (this.consume(), this.delegate.appendToAttributeValue(this.consumeCharRef() || "&")) : e === ">" ? (this.delegate.finishAttributeValue(), this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : (this.consume(), this.delegate.appendToAttributeValue(e));
			},
			afterAttributeValueQuoted: function() {
				var e = this.peek();
				bw(e) ? (this.consume(), this.transitionTo("beforeAttributeName")) : e === "/" ? (this.consume(), this.transitionTo("selfClosingStartTag")) : e === ">" ? (this.consume(), this.delegate.finishTag(), this.transitionTo("beforeData")) : this.transitionTo("beforeAttributeName");
			},
			selfClosingStartTag: function() {
				this.peek() === ">" ? (this.consume(), this.delegate.markTagAsSelfClosing(), this.delegate.finishTag(), this.transitionTo("beforeData")) : this.transitionTo("beforeAttributeName");
			},
			endTagOpen: function() {
				var e = this.consume();
				(e === "@" || e === ":" || xw(e)) && (this.transitionTo("endTagName"), this.tagNameBuffer = "", this.delegate.beginEndTag(), this.appendToTagName(e));
			}
		}, this.reset();
	}
	return e.prototype.reset = function() {
		this.transitionTo("beforeData"), this.input = "", this.tagNameBuffer = "", this.index = 0, this.line = 1, this.column = 0, this.delegate.reset();
	}, e.prototype.transitionTo = function(e) {
		this.state = e;
	}, e.prototype.tokenize = function(e) {
		this.reset(), this.tokenizePart(e), this.tokenizeEOF();
	}, e.prototype.tokenizePart = function(e) {
		for (this.input += Sw(e); this.index < this.input.length;) {
			var t = this.states[this.state];
			if (t !== void 0) t.call(this);
			else throw Error("unhandled state " + this.state);
		}
	}, e.prototype.tokenizeEOF = function() {
		this.flushData();
	}, e.prototype.flushData = function() {
		this.state === "data" && (this.delegate.finishData(), this.transitionTo("beforeData"));
	}, e.prototype.peek = function() {
		return this.input.charAt(this.index);
	}, e.prototype.consume = function() {
		var e = this.peek();
		return this.index++, e === "\n" ? (this.line++, this.column = 0) : this.column++, e;
	}, e.prototype.consumeCharRef = function() {
		var e = this.input.indexOf(";", this.index);
		if (e !== -1) {
			var t = this.input.slice(this.index, e), n = this.entityParser.parse(t);
			if (n) {
				for (var r = t.length; r;) this.consume(), r--;
				return this.consume(), n;
			}
		}
	}, e.prototype.markTagStart = function() {
		this.delegate.tagOpen();
	}, e.prototype.appendToTagName = function(e) {
		this.tagNameBuffer += e, this.delegate.appendToTagName(e);
	}, e.prototype.isIgnoredEndTag = function() {
		var e = this.tagNameBuffer;
		return e === "title" && this.input.substring(this.index, this.index + 8) !== "</title>" || e === "style" && this.input.substring(this.index, this.index + 8) !== "</style>" || e === "script" && this.input.substring(this.index, this.index + 9) !== "<\/script>";
	}, e;
}(), ww = function() {
	function e(e, t) {
		t === void 0 && (t = {}), this.options = t, this.token = null, this.startLine = 1, this.startColumn = 0, this.tokens = [], this.tokenizer = new Cw(this, e, t.mode), this._currentAttribute = void 0;
	}
	return e.prototype.tokenize = function(e) {
		return this.tokens = [], this.tokenizer.tokenize(e), this.tokens;
	}, e.prototype.tokenizePart = function(e) {
		return this.tokens = [], this.tokenizer.tokenizePart(e), this.tokens;
	}, e.prototype.tokenizeEOF = function() {
		return this.tokens = [], this.tokenizer.tokenizeEOF(), this.tokens[0];
	}, e.prototype.reset = function() {
		this.token = null, this.startLine = 1, this.startColumn = 0;
	}, e.prototype.current = function() {
		var e = this.token;
		if (e === null) throw Error("token was unexpectedly null");
		if (arguments.length === 0) return e;
		for (var t = 0; t < arguments.length; t++) if (e.type === arguments[t]) return e;
		throw Error("token type was unexpectedly " + e.type);
	}, e.prototype.push = function(e) {
		this.token = e, this.tokens.push(e);
	}, e.prototype.currentAttribute = function() {
		return this._currentAttribute;
	}, e.prototype.addLocInfo = function() {
		this.options.loc && (this.current().loc = {
			start: {
				line: this.startLine,
				column: this.startColumn
			},
			end: {
				line: this.tokenizer.line,
				column: this.tokenizer.column
			}
		}), this.startLine = this.tokenizer.line, this.startColumn = this.tokenizer.column;
	}, e.prototype.beginDoctype = function() {
		this.push({
			type: "Doctype",
			name: ""
		});
	}, e.prototype.appendToDoctypeName = function(e) {
		this.current("Doctype").name += e;
	}, e.prototype.appendToDoctypePublicIdentifier = function(e) {
		var t = this.current("Doctype");
		t.publicIdentifier === void 0 ? t.publicIdentifier = e : t.publicIdentifier += e;
	}, e.prototype.appendToDoctypeSystemIdentifier = function(e) {
		var t = this.current("Doctype");
		t.systemIdentifier === void 0 ? t.systemIdentifier = e : t.systemIdentifier += e;
	}, e.prototype.endDoctype = function() {
		this.addLocInfo();
	}, e.prototype.beginData = function() {
		this.push({
			type: "Chars",
			chars: ""
		});
	}, e.prototype.appendToData = function(e) {
		this.current("Chars").chars += e;
	}, e.prototype.finishData = function() {
		this.addLocInfo();
	}, e.prototype.beginComment = function() {
		this.push({
			type: "Comment",
			chars: ""
		});
	}, e.prototype.appendToCommentData = function(e) {
		this.current("Comment").chars += e;
	}, e.prototype.finishComment = function() {
		this.addLocInfo();
	}, e.prototype.tagOpen = function() {}, e.prototype.beginStartTag = function() {
		this.push({
			type: "StartTag",
			tagName: "",
			attributes: [],
			selfClosing: !1
		});
	}, e.prototype.beginEndTag = function() {
		this.push({
			type: "EndTag",
			tagName: ""
		});
	}, e.prototype.finishTag = function() {
		this.addLocInfo();
	}, e.prototype.markTagAsSelfClosing = function() {
		this.current("StartTag").selfClosing = !0;
	}, e.prototype.appendToTagName = function(e) {
		this.current("StartTag", "EndTag").tagName += e;
	}, e.prototype.beginAttribute = function() {
		this._currentAttribute = [
			"",
			"",
			!1
		];
	}, e.prototype.appendToAttributeName = function(e) {
		this.currentAttribute()[0] += e;
	}, e.prototype.beginAttributeValue = function(e) {
		this.currentAttribute()[2] = e;
	}, e.prototype.appendToAttributeValue = function(e) {
		this.currentAttribute()[1] += e;
	}, e.prototype.finishAttributeValue = function() {
		this.current("StartTag").attributes.push(this._currentAttribute);
	}, e.prototype.reportSyntaxError = function(e) {
		this.current().syntaxError = e;
	}, e;
}();
function Tw(e, t) {
	return new ww(new gw(fw), t).tokenize(e);
}
var Ew = "LinkifyResult", Dw = "StartTag", Ow = "EndTag", kw = "Chars", Aw = "Comment", jw = "Doctype";
function Mw(e, t = {}) {
	let n = Tw(e), r = [], i = [], a = new LC(t, Fw);
	for (let e = 0; e < n.length; e++) {
		let t = n[e];
		if (t.type === Dw) {
			r.push(t);
			let i = t.tagName.toUpperCase();
			if (!(i === "A" || a.ignoreTags.indexOf(i) >= 0)) continue;
			let o = r.length;
			Pw(i, n, ++e, r), e += r.length - o - 1;
		} else if (t.type !== kw) r.push(t);
		else {
			let e = Nw(t.chars, a);
			r.push.apply(r, e);
		}
	}
	for (let e = 0; e < r.length; e++) {
		let t = r[e];
		switch (t.type) {
			case Ew:
				i.push(t.rendered);
				break;
			case Dw: {
				let e = "<" + t.tagName;
				t.attributes.length > 0 && (e += " " + zw(t.attributes).join(" ")), t.selfClosing && (e += " /"), e += ">", i.push(e);
				break;
			}
			case Ow:
				i.push(`</${t.tagName}>`);
				break;
			case kw:
				i.push(Iw(t.chars));
				break;
			case Aw:
				i.push(`<!--${Iw(t.chars)}-->`);
				break;
			case jw: {
				let e = `<!DOCTYPE ${t.name}`;
				t.publicIdentifier && (e += ` PUBLIC "${t.publicIdentifier}"`), t.systemIdentifier && (e += ` "${t.systemIdentifier}"`), e += ">", i.push(e);
				break;
			}
		}
	}
	return i.join("");
}
function Nw(e, t) {
	let n = ew(e), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = n[e];
		i.t === "nl" && t.get("nl2br") ? r.push({
			type: Dw,
			tagName: "br",
			attributes: [],
			selfClosing: !0
		}) : !i.isLink || !t.check(i) ? r.push({
			type: kw,
			chars: i.toString()
		}) : r.push({
			type: Ew,
			rendered: t.render(i)
		});
	}
	return r;
}
function Pw(e, t, n, r) {
	let i = 1;
	for (; n < t.length && i > 0;) {
		let a = t[n];
		a.type === Dw && a.tagName.toUpperCase() === e ? i++ : a.type === Ow && a.tagName.toUpperCase() === e && i--, r.push(a), n++;
	}
	return r;
}
function Fw({ tagName: e, attributes: t, content: n }) {
	return `<${e} ${Rw(t)}>${Iw(n)}</${e}>`;
}
function Iw(e) {
	return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Lw(e) {
	return e.replace(/"/g, "&quot;");
}
function Rw(e) {
	let t = [];
	for (let n in e) {
		let r = e[n] + "";
		t.push(`${n}="${Lw(r)}"`);
	}
	return t.join(" ");
}
function zw(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n][0], i = e[n][1] + "";
		t.push(`${r}="${Lw(i)}"`);
	}
	return t;
}
//#endregion
//#region src/core/utils/linkify.ts
var Bw = [
	"file",
	"mailto",
	"http",
	"https",
	"ftp",
	"ftps"
], Vw = [
	"bitcoin",
	"geo",
	"im",
	"magnet",
	"mailto",
	"matrix",
	"news",
	"openpgp4fpr",
	"sip",
	"sms",
	"smsto",
	"tel",
	"urn",
	"xmpp"
], Hw = [...Bw, ...Vw], Uw = /* @__PURE__ */ function(e) {
	return e.URL = "url", e.UserId = "userid", e.RoomAlias = "roomalias", e;
}({});
function Ww({ scanner: e, parser: t, token: n, name: r }) {
	let { DOT: i, NUM: a, COLON: o, SYM: s, SLASH: c, EQUALS: l, HYPHEN: u, UNDERSCORE: d } = e.tokens, { domain: f } = e.tokens.groups, p = [
		i,
		s,
		c,
		l,
		d,
		u
	], m = [u], h = new hS(BC(r, { isLink: !0 })), g = new hS(BC(r, { isLink: !0 })), _ = t.start.tt(n), v = new hS();
	_.ta(f, v), _.ta(p, v), v.ta(f, v), v.ta(p, v);
	let y = v.tt(o);
	y.ta(f, h), y.ta(m, h), h.ta(f, h), h.ta(m, h), h.tt(i, y), h.tt(o).tt(a, g);
}
function Gw({ urlListener: e, roomAliasListener: t, userIdListener: n, urlTargetTransformer: r, hrefTransformer: i, onLinkClick: a }) {
	let o = (r, i) => {
		switch (i) {
			case Uw.URL:
				if (e) return e(r);
				break;
			case Uw.UserId:
				if (n) return n(r);
				break;
			case Uw.RoomAlias:
				if (t) return t(r);
				break;
		}
		return {};
	};
	return {
		rel: "noreferrer noopener",
		ignoreTags: [
			"a",
			"pre",
			"code"
		],
		defaultProtocol: "https",
		events: o,
		attributes: (e, t) => {
			let n = { [`data-${Jw}`]: "true" }, r = o(e, t);
			return r?.click && (n.onClick = r.click), a && (n.onClick = (e) => {
				a(e), r?.click?.(e);
			}), n;
		},
		target(e, t) {
			return t === Uw.URL && r ? r(e) : "_blank";
		},
		...i ? { formatHref: (e, t) => i(e, t) } : void 0,
		validate: (e, r) => !!(r === Uw.UserId && n) || !!(r === Uw.RoomAlias && t) || r === Uw.URL
	};
}
function Kw(e) {
	return tw(e);
}
function qw(e) {
	return nw(e);
}
var Jw = "linkified", Yw = !1;
function Xw() {
	Yw ||= (ZC(Uw.RoomAlias, ({ scanner: e, parser: t }) => {
		let n = e.tokens.POUND;
		Ww({
			scanner: e,
			parser: t,
			token: n,
			name: Uw.RoomAlias
		});
	}), ZC(Uw.UserId, ({ scanner: e, parser: t }) => {
		let n = e.tokens.AT;
		Ww({
			scanner: e,
			parser: t,
			token: n,
			name: Uw.UserId
		});
	}), QC("mxc", !1), Hw.forEach((e) => {
		Bw.includes(e) || QC(e, Vw.includes(e));
	}), !0);
}
Xw();
//#endregion
//#region src/core/utils/LinkedText/LinkedTextContext.tsx
var Zw = r(null);
Zw.displayName = "LinkedTextContext";
function Qw() {
	let e = s(Zw);
	if (!e) throw Error("useLinkedTextContextOpts must be used within an LinkedTextContext.Provider");
	return e;
}
//#endregion
//#region src/core/utils/LinkedText/LinkedText.tsx
function $w({ children: e, className: n, onLinkClick: r, ...i }) {
	let a = Gw({
		...Qw(),
		onLinkClick: r
	});
	return /* @__PURE__ */ t.createElement(aw, {
		className: (0, H.default)(ow.container, n),
		as: O,
		options: {
			...a,
			render: w
		},
		...i
	}, e);
}
//#endregion
//#region src/event-tiles/UrlPreviewGroupView/LinkPreview/LinkPreview.tsx
function eT({ onImageClick: e, ...n }) {
	let { translate: r } = W(), i = u(() => n.showTooltipOnLink ? new URL(n.link, window.location.href).toString() : null, [n.link, n.showTooltipOnLink]), a = o((t) => {
		t.button != 0 || t.metaKey || (t.preventDefault(), n.image?.imageFull && e());
	}, [n.image?.imageFull, e]), s;
	n.image?.imageThumb && (s = /* @__PURE__ */ t.createElement("button", {
		"aria-label": r("timeline|url_preview|view_image"),
		className: $x.image,
		onClick: a
	}, /* @__PURE__ */ t.createElement("img", {
		className: $x.thumbnail,
		src: n.image.imageThumb,
		alt: ""
	})));
	let c = /* @__PURE__ */ t.createElement("a", {
		className: $x.link,
		href: n.link,
		target: "_blank",
		rel: "noreferrer noopener"
	}, n.title);
	return /* @__PURE__ */ t.createElement("div", { className: (0, H.default)($x.container) }, /* @__PURE__ */ t.createElement("div", { className: $x.wrapImageCaption }, s, /* @__PURE__ */ t.createElement("div", { className: $x.caption }, /* @__PURE__ */ t.createElement(O, {
		type: "body",
		size: "md",
		className: $x.title
	}, i ? /* @__PURE__ */ t.createElement(k, { label: i }, c) : c, n.siteName && /* @__PURE__ */ t.createElement(O, {
		as: "span",
		size: "md",
		weight: "regular"
	}, " - " + n.siteName)), n.description && /* @__PURE__ */ t.createElement($w, { className: $x.description }, n.description))));
}
var tT = {
	previewGroup: "_previewGroup_vzeae_8",
	compactLayout: "_compactLayout_vzeae_15",
	toggleButton: "_toggleButton_vzeae_20",
	wrapper: "_wrapper_vzeae_29"
};
//#endregion
//#region src/event-tiles/UrlPreviewGroupView/UrlPreviewGroupView.tsx
function nT({ vm: e }) {
	let { translate: n } = W(), { previews: r, totalPreviewCount: i, previewsLimited: a, overPreviewLimit: o, compactLayout: s } = Y(e);
	if (r.length === 0) return null;
	let c;
	return o && (c = /* @__PURE__ */ t.createElement(g, {
		className: tT.toggleButton,
		kind: "tertiary",
		size: "sm",
		onClick: e.onTogglePreviewLimit
	}, a ? n("timeline|url_preview|show_n_more", { count: i - r.length }) : n("action|collapse"))), /* @__PURE__ */ t.createElement("div", { className: tT.wrapper }, /* @__PURE__ */ t.createElement("div", { className: (0, H.default)(tT.previewGroup, s && tT.compactLayout) }, r.map((n) => /* @__PURE__ */ t.createElement(eT, {
		key: n.link,
		onImageClick: () => e.onImageClick(n),
		...n
	})), c), /* @__PURE__ */ t.createElement(S, {
		size: "20px",
		onClick: e.onHideClick,
		"aria-label": n("timeline|url_preview|close")
	}, /* @__PURE__ */ t.createElement(Gx, null)));
}
//#endregion
//#region ../../node_modules/domelementtype/lib/index.js
var rT = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
	var t;
	(function(e) {
		e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
	})(t = e.ElementType ||= {});
	function n(e) {
		return e.type === t.Tag || e.type === t.Script || e.type === t.Style;
	}
	e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})), iT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__extends || (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
			}, e(t, n);
		};
		return function(t, n) {
			if (typeof n != "function" && n !== null) throw TypeError("Class extends value " + String(n) + " is not a constructor or null");
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		};
	})(), n = e && e.__assign || function() {
		return n = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}, n.apply(this, arguments);
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.cloneNode = e.hasChildren = e.isDocument = e.isDirective = e.isComment = e.isText = e.isCDATA = e.isTag = e.Element = e.Document = e.CDATA = e.NodeWithChildren = e.ProcessingInstruction = e.Comment = e.Text = e.DataNode = e.Node = void 0;
	var r = rT(), i = function() {
		function e() {
			this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
		}
		return Object.defineProperty(e.prototype, "parentNode", {
			get: function() {
				return this.parent;
			},
			set: function(e) {
				this.parent = e;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(e.prototype, "previousSibling", {
			get: function() {
				return this.prev;
			},
			set: function(e) {
				this.prev = e;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(e.prototype, "nextSibling", {
			get: function() {
				return this.next;
			},
			set: function(e) {
				this.next = e;
			},
			enumerable: !1,
			configurable: !0
		}), e.prototype.cloneNode = function(e) {
			return e === void 0 && (e = !1), b(this, e);
		}, e;
	}();
	e.Node = i;
	var a = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.data = t, n;
		}
		return Object.defineProperty(n.prototype, "nodeValue", {
			get: function() {
				return this.data;
			},
			set: function(e) {
				this.data = e;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(i);
	e.DataNode = a;
	var o = function(e) {
		t(n, e);
		function n() {
			var t = e !== null && e.apply(this, arguments) || this;
			return t.type = r.ElementType.Text, t;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 3;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(a);
	e.Text = o;
	var s = function(e) {
		t(n, e);
		function n() {
			var t = e !== null && e.apply(this, arguments) || this;
			return t.type = r.ElementType.Comment, t;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 8;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(a);
	e.Comment = s;
	var c = function(e) {
		t(n, e);
		function n(t, n) {
			var i = e.call(this, n) || this;
			return i.name = t, i.type = r.ElementType.Directive, i;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 1;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(a);
	e.ProcessingInstruction = c;
	var l = function(e) {
		t(n, e);
		function n(t) {
			var n = e.call(this) || this;
			return n.children = t, n;
		}
		return Object.defineProperty(n.prototype, "firstChild", {
			get: function() {
				return this.children[0] ?? null;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(n.prototype, "lastChild", {
			get: function() {
				return this.children.length > 0 ? this.children[this.children.length - 1] : null;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(n.prototype, "childNodes", {
			get: function() {
				return this.children;
			},
			set: function(e) {
				this.children = e;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(i);
	e.NodeWithChildren = l;
	var u = function(e) {
		t(n, e);
		function n() {
			var t = e !== null && e.apply(this, arguments) || this;
			return t.type = r.ElementType.CDATA, t;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 4;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(l);
	e.CDATA = u;
	var d = function(e) {
		t(n, e);
		function n() {
			var t = e !== null && e.apply(this, arguments) || this;
			return t.type = r.ElementType.Root, t;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 9;
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(l);
	e.Document = d;
	var f = function(e) {
		t(n, e);
		function n(t, n, i, a) {
			i === void 0 && (i = []), a === void 0 && (a = t === "script" ? r.ElementType.Script : t === "style" ? r.ElementType.Style : r.ElementType.Tag);
			var o = e.call(this, i) || this;
			return o.name = t, o.attribs = n, o.type = a, o;
		}
		return Object.defineProperty(n.prototype, "nodeType", {
			get: function() {
				return 1;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(n.prototype, "tagName", {
			get: function() {
				return this.name;
			},
			set: function(e) {
				this.name = e;
			},
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(n.prototype, "attributes", {
			get: function() {
				var e = this;
				return Object.keys(this.attribs).map(function(t) {
					return {
						name: t,
						value: e.attribs[t],
						namespace: e["x-attribsNamespace"]?.[t],
						prefix: e["x-attribsPrefix"]?.[t]
					};
				});
			},
			enumerable: !1,
			configurable: !0
		}), n;
	}(l);
	e.Element = f;
	function p(e) {
		return (0, r.isTag)(e);
	}
	e.isTag = p;
	function m(e) {
		return e.type === r.ElementType.CDATA;
	}
	e.isCDATA = m;
	function h(e) {
		return e.type === r.ElementType.Text;
	}
	e.isText = h;
	function g(e) {
		return e.type === r.ElementType.Comment;
	}
	e.isComment = g;
	function _(e) {
		return e.type === r.ElementType.Directive;
	}
	e.isDirective = _;
	function v(e) {
		return e.type === r.ElementType.Root;
	}
	e.isDocument = v;
	function y(e) {
		return Object.prototype.hasOwnProperty.call(e, "children");
	}
	e.hasChildren = y;
	function b(e, t) {
		t === void 0 && (t = !1);
		var r;
		if (h(e)) r = new o(e.data);
		else if (g(e)) r = new s(e.data);
		else if (p(e)) {
			var i = t ? x(e.children) : [], a = new f(e.name, n({}, e.attribs), i);
			i.forEach(function(e) {
				return e.parent = a;
			}), e.namespace != null && (a.namespace = e.namespace), e["x-attribsNamespace"] && (a["x-attribsNamespace"] = n({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (a["x-attribsPrefix"] = n({}, e["x-attribsPrefix"])), r = a;
		} else if (m(e)) {
			var i = t ? x(e.children) : [], l = new u(i);
			i.forEach(function(e) {
				return e.parent = l;
			}), r = l;
		} else if (v(e)) {
			var i = t ? x(e.children) : [], y = new d(i);
			i.forEach(function(e) {
				return e.parent = y;
			}), e["x-mode"] && (y["x-mode"] = e["x-mode"]), r = y;
		} else if (_(e)) {
			var b = new c(e.name, e.data);
			e["x-name"] != null && (b["x-name"] = e["x-name"], b["x-publicId"] = e["x-publicId"], b["x-systemId"] = e["x-systemId"]), r = b;
		} else throw Error(`Not implemented yet: ${e.type}`);
		return r.startIndex = e.startIndex, r.endIndex = e.endIndex, e.sourceCodeLocation != null && (r.sourceCodeLocation = e.sourceCodeLocation), r;
	}
	e.cloneNode = b;
	function x(e) {
		for (var t = e.map(function(e) {
			return b(e, !0);
		}), n = 1; n < t.length; n++) t[n].prev = t[n - 1], t[n - 1].next = t[n];
		return t;
	}
})), aT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__createBinding || (Object.create ? (function(e, t, n, r) {
		r === void 0 && (r = n);
		var i = Object.getOwnPropertyDescriptor(t, n);
		(!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = {
			enumerable: !0,
			get: function() {
				return t[n];
			}
		}), Object.defineProperty(e, r, i);
	}) : (function(e, t, n, r) {
		r === void 0 && (r = n), e[r] = t[n];
	})), n = e && e.__exportStar || function(e, n) {
		for (var r in e) r !== "default" && !Object.prototype.hasOwnProperty.call(n, r) && t(n, e, r);
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
	var r = rT(), i = iT();
	n(iT(), e);
	var a = {
		withStartIndices: !1,
		withEndIndices: !1,
		xmlMode: !1
	}, o = function() {
		function e(e, t, n) {
			this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof t == "function" && (n = t, t = a), typeof e == "object" && (t = e, e = void 0), this.callback = e ?? null, this.options = t ?? a, this.elementCB = n ?? null;
		}
		return e.prototype.onparserinit = function(e) {
			this.parser = e;
		}, e.prototype.onreset = function() {
			this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
		}, e.prototype.onend = function() {
			this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
		}, e.prototype.onerror = function(e) {
			this.handleCallback(e);
		}, e.prototype.onclosetag = function() {
			this.lastNode = null;
			var e = this.tagStack.pop();
			this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
		}, e.prototype.onopentag = function(e, t) {
			var n = this.options.xmlMode ? r.ElementType.Tag : void 0, a = new i.Element(e, t, void 0, n);
			this.addNode(a), this.tagStack.push(a);
		}, e.prototype.ontext = function(e) {
			var t = this.lastNode;
			if (t && t.type === r.ElementType.Text) t.data += e, this.options.withEndIndices && (t.endIndex = this.parser.endIndex);
			else {
				var n = new i.Text(e);
				this.addNode(n), this.lastNode = n;
			}
		}, e.prototype.oncomment = function(e) {
			if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
				this.lastNode.data += e;
				return;
			}
			var t = new i.Comment(e);
			this.addNode(t), this.lastNode = t;
		}, e.prototype.oncommentend = function() {
			this.lastNode = null;
		}, e.prototype.oncdatastart = function() {
			var e = new i.Text(""), t = new i.CDATA([e]);
			this.addNode(t), e.parent = t, this.lastNode = e;
		}, e.prototype.oncdataend = function() {
			this.lastNode = null;
		}, e.prototype.onprocessinginstruction = function(e, t) {
			var n = new i.ProcessingInstruction(e, t);
			this.addNode(n);
		}, e.prototype.handleCallback = function(e) {
			if (typeof this.callback == "function") this.callback(e, this.dom);
			else if (e) throw e;
		}, e.prototype.addNode = function(e) {
			var t = this.tagStack[this.tagStack.length - 1], n = t.children[t.children.length - 1];
			this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), n && (e.prev = n, n.next = e), e.parent = t, this.lastNode = null;
		}, e;
	}();
	e.DomHandler = o, e.default = o;
})), oT = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = e.CARRIAGE_RETURN_PLACEHOLDER = e.CARRIAGE_RETURN_REGEX = e.CARRIAGE_RETURN = e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES = void 0, e.CASE_SENSITIVE_TAG_NAMES = /* @__PURE__ */ "animateMotion.animateTransform.clipPath.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feDropShadow.feFlood.feFuncA.feFuncB.feFuncG.feFuncR.feGaussianBlur.feImage.feMerge.feMergeNode.feMorphology.feOffset.fePointLight.feSpecularLighting.feSpotLight.feTile.feTurbulence.foreignObject.linearGradient.radialGradient.textPath".split("."), e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES.reduce(function(e, t) {
		return e[t.toLowerCase()] = t, e;
	}, {}), e.CARRIAGE_RETURN = "\r", e.CARRIAGE_RETURN_REGEX = new RegExp(e.CARRIAGE_RETURN, "g"), e.CARRIAGE_RETURN_PLACEHOLDER = `__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_${Date.now().toString()}__`, e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(e.CARRIAGE_RETURN_PLACEHOLDER, "g");
})), sT = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.formatAttributes = i, e.hasOpenTag = o, e.escapeSpecialCharacters = s, e.revertEscapedCharacters = c, e.formatDOM = l;
	var t = aT(), n = oT();
	function r(e) {
		return n.CASE_SENSITIVE_TAG_NAMES_MAP[e];
	}
	function i(e) {
		for (var t = {}, n = 0, r = e.length; n < r; n++) {
			var i = e[n];
			t[i.name] = i.value;
		}
		return t;
	}
	function a(e) {
		return e = e.toLowerCase(), r(e) || e;
	}
	function o(e, t) {
		var n = "<" + t, r = e.toLowerCase().indexOf(n);
		if (r === -1) return !1;
		var i = e[r + n.length];
		return i === ">" || i === " " || i === "	" || i === "\n" || i === "\r" || i === "/";
	}
	function s(e) {
		return e.replace(n.CARRIAGE_RETURN_REGEX, n.CARRIAGE_RETURN_PLACEHOLDER);
	}
	function c(e) {
		return e.replace(n.CARRIAGE_RETURN_PLACEHOLDER_REGEX, n.CARRIAGE_RETURN);
	}
	function l(e, n, r) {
		n === void 0 && (n = null);
		for (var o = [], s, u = 0, d = e.length; u < d; u++) {
			var f = e[u];
			switch (f.nodeType) {
				case 1:
					var p = a(f.nodeName);
					s = new t.Element(p, i(f.attributes)), s.children = l(p === "template" ? f.content.childNodes : f.childNodes, s);
					break;
				case 3:
					s = new t.Text(c(f.nodeValue ?? ""));
					break;
				case 8:
					s = new t.Comment(f.nodeValue ?? "");
					break;
				default: continue;
			}
			var m = o[u - 1] ?? null;
			m && (m.next = s), s.parent = n, s.prev = m, s.next = null, o.push(s);
		}
		return r && (s = new t.ProcessingInstruction(r.substring(0, r.indexOf(" ")).toLowerCase(), r), s.next = o[0] ?? null, s.parent = n, o.unshift(s), o[1] && (o[1].prev = o[0])), o;
	}
})), cT = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = h;
	var t = sT(), n = "html", r = "head", i = "body", a = /<([a-zA-Z]+[0-9]?)/, o = function(e, t) {
		throw Error("This browser does not support `document.implementation.createHTMLDocument`");
	}, s = function(e, t) {
		throw Error("This browser does not support `DOMParser.prototype.parseFromString`");
	}, c = typeof window == "object" && window.DOMParser;
	if (typeof c == "function") {
		var l = new c(), u = "text/html";
		s = function(e, t) {
			/* istanbul ignore stop */
			return t && (e = `<${t}>${e}</${t}>`), l.parseFromString(e, u);
		}, o = s;
	}
	if (typeof document == "object" && document.implementation) {
		var d = document.implementation.createHTMLDocument();
		o = function(e, t) {
			/* istanbul ignore start */
			if (t) {
				var n = d.documentElement.querySelector(t);
				return n && (n.innerHTML = e), d;
			}
			return d.documentElement.innerHTML = e, d;
		};
	}
	var f = typeof document == "object" && document.createElement("template"), p;
	f && f.content && (p = function(e) {
		return f.innerHTML = e, f.content.childNodes;
	});
	var m = function() {
		return document.createDocumentFragment().childNodes;
	};
	function h(e) {
		var c, l;
		e = (0, t.escapeSpecialCharacters)(e);
		var u = (a.exec(e)?.[1])?.toLowerCase();
		switch (u) {
			case n:
				var d = s(e);
				if (!(0, t.hasOpenTag)(e, r)) {
					var f = d.querySelector(r);
					/* istanbul ignore next */
					(c = f?.parentNode) == null || c.removeChild(f);
				}
				if (!(0, t.hasOpenTag)(e, i)) {
					var f = d.querySelector(i);
					/* istanbul ignore next */
					(l = f?.parentNode) == null || l.removeChild(f);
				}
				return d.querySelectorAll(n);
			case r:
			case i:
				var h = o(e).querySelectorAll(u);
				return (0, t.hasOpenTag)(e, i) && (0, t.hasOpenTag)(e, r) ? h[0].parentNode?.childNodes ?? m() : h;
			default:
				if (p) return p(e);
				/* istanbul ignore start */
				var f = o(e, i).querySelector(i);
				return f?.childNodes ?? m();
		}
	}
})), lT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = a;
	var n = t(cT()), r = sT(), i = /<(![a-zA-Z\s]+)>/;
	function a(e) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (!e) return [];
		var t = i.exec(e), a = t ? t[1] : void 0;
		return (0, r.formatDOM)((0, n.default)(e), null, a);
	}
})), uT = /* @__PURE__ */ A(((e) => {
	e.SAME = 0, e.CAMELCASE = 1, e.possibleStandardNames = {
		accept: 0,
		acceptCharset: 1,
		"accept-charset": "acceptCharset",
		accessKey: 1,
		action: 0,
		allowFullScreen: 1,
		alt: 0,
		as: 0,
		async: 0,
		autoCapitalize: 1,
		autoComplete: 1,
		autoCorrect: 1,
		autoFocus: 1,
		autoPlay: 1,
		autoSave: 1,
		capture: 0,
		cellPadding: 1,
		cellSpacing: 1,
		challenge: 0,
		charSet: 1,
		checked: 0,
		children: 0,
		cite: 0,
		class: "className",
		classID: 1,
		className: 1,
		cols: 0,
		colSpan: 1,
		content: 0,
		contentEditable: 1,
		contextMenu: 1,
		controls: 0,
		controlsList: 1,
		coords: 0,
		crossOrigin: 1,
		dangerouslySetInnerHTML: 1,
		data: 0,
		dateTime: 1,
		default: 0,
		defaultChecked: 1,
		defaultValue: 1,
		defer: 0,
		dir: 0,
		disabled: 0,
		disablePictureInPicture: 1,
		disableRemotePlayback: 1,
		download: 0,
		draggable: 0,
		encType: 1,
		enterKeyHint: 1,
		for: "htmlFor",
		form: 0,
		formMethod: 1,
		formAction: 1,
		formEncType: 1,
		formNoValidate: 1,
		formTarget: 1,
		frameBorder: 1,
		headers: 0,
		height: 0,
		hidden: 0,
		high: 0,
		href: 0,
		hrefLang: 1,
		htmlFor: 1,
		httpEquiv: 1,
		"http-equiv": "httpEquiv",
		icon: 0,
		id: 0,
		innerHTML: 1,
		inputMode: 1,
		integrity: 0,
		is: 0,
		itemID: 1,
		itemProp: 1,
		itemRef: 1,
		itemScope: 1,
		itemType: 1,
		keyParams: 1,
		keyType: 1,
		kind: 0,
		label: 0,
		lang: 0,
		list: 0,
		loop: 0,
		low: 0,
		manifest: 0,
		marginWidth: 1,
		marginHeight: 1,
		max: 0,
		maxLength: 1,
		media: 0,
		mediaGroup: 1,
		method: 0,
		min: 0,
		minLength: 1,
		multiple: 0,
		muted: 0,
		name: 0,
		noModule: 1,
		nonce: 0,
		noValidate: 1,
		open: 0,
		optimum: 0,
		pattern: 0,
		placeholder: 0,
		playsInline: 1,
		poster: 0,
		preload: 0,
		profile: 0,
		radioGroup: 1,
		readOnly: 1,
		referrerPolicy: 1,
		rel: 0,
		required: 0,
		reversed: 0,
		role: 0,
		rows: 0,
		rowSpan: 1,
		sandbox: 0,
		scope: 0,
		scoped: 0,
		scrolling: 0,
		seamless: 0,
		selected: 0,
		shape: 0,
		size: 0,
		sizes: 0,
		span: 0,
		spellCheck: 1,
		src: 0,
		srcDoc: 1,
		srcLang: 1,
		srcSet: 1,
		start: 0,
		step: 0,
		style: 0,
		summary: 0,
		tabIndex: 1,
		target: 0,
		title: 0,
		type: 0,
		useMap: 1,
		value: 0,
		width: 0,
		wmode: 0,
		wrap: 0,
		about: 0,
		accentHeight: 1,
		"accent-height": "accentHeight",
		accumulate: 0,
		additive: 0,
		alignmentBaseline: 1,
		"alignment-baseline": "alignmentBaseline",
		allowReorder: 1,
		alphabetic: 0,
		amplitude: 0,
		arabicForm: 1,
		"arabic-form": "arabicForm",
		ascent: 0,
		attributeName: 1,
		attributeType: 1,
		autoReverse: 1,
		azimuth: 0,
		baseFrequency: 1,
		baselineShift: 1,
		"baseline-shift": "baselineShift",
		baseProfile: 1,
		bbox: 0,
		begin: 0,
		bias: 0,
		by: 0,
		calcMode: 1,
		capHeight: 1,
		"cap-height": "capHeight",
		clip: 0,
		clipPath: 1,
		"clip-path": "clipPath",
		clipPathUnits: 1,
		clipRule: 1,
		"clip-rule": "clipRule",
		color: 0,
		colorInterpolation: 1,
		"color-interpolation": "colorInterpolation",
		colorInterpolationFilters: 1,
		"color-interpolation-filters": "colorInterpolationFilters",
		colorProfile: 1,
		"color-profile": "colorProfile",
		colorRendering: 1,
		"color-rendering": "colorRendering",
		contentScriptType: 1,
		contentStyleType: 1,
		cursor: 0,
		cx: 0,
		cy: 0,
		d: 0,
		datatype: 0,
		decelerate: 0,
		descent: 0,
		diffuseConstant: 1,
		direction: 0,
		display: 0,
		divisor: 0,
		dominantBaseline: 1,
		"dominant-baseline": "dominantBaseline",
		dur: 0,
		dx: 0,
		dy: 0,
		edgeMode: 1,
		elevation: 0,
		enableBackground: 1,
		"enable-background": "enableBackground",
		end: 0,
		exponent: 0,
		externalResourcesRequired: 1,
		fill: 0,
		fillOpacity: 1,
		"fill-opacity": "fillOpacity",
		fillRule: 1,
		"fill-rule": "fillRule",
		filter: 0,
		filterRes: 1,
		filterUnits: 1,
		floodOpacity: 1,
		"flood-opacity": "floodOpacity",
		floodColor: 1,
		"flood-color": "floodColor",
		focusable: 0,
		fontFamily: 1,
		"font-family": "fontFamily",
		fontSize: 1,
		"font-size": "fontSize",
		fontSizeAdjust: 1,
		"font-size-adjust": "fontSizeAdjust",
		fontStretch: 1,
		"font-stretch": "fontStretch",
		fontStyle: 1,
		"font-style": "fontStyle",
		fontVariant: 1,
		"font-variant": "fontVariant",
		fontWeight: 1,
		"font-weight": "fontWeight",
		format: 0,
		from: 0,
		fx: 0,
		fy: 0,
		g1: 0,
		g2: 0,
		glyphName: 1,
		"glyph-name": "glyphName",
		glyphOrientationHorizontal: 1,
		"glyph-orientation-horizontal": "glyphOrientationHorizontal",
		glyphOrientationVertical: 1,
		"glyph-orientation-vertical": "glyphOrientationVertical",
		glyphRef: 1,
		gradientTransform: 1,
		gradientUnits: 1,
		hanging: 0,
		horizAdvX: 1,
		"horiz-adv-x": "horizAdvX",
		horizOriginX: 1,
		"horiz-origin-x": "horizOriginX",
		ideographic: 0,
		imageRendering: 1,
		"image-rendering": "imageRendering",
		in2: 0,
		in: 0,
		inlist: 0,
		intercept: 0,
		k1: 0,
		k2: 0,
		k3: 0,
		k4: 0,
		k: 0,
		kernelMatrix: 1,
		kernelUnitLength: 1,
		kerning: 0,
		keyPoints: 1,
		keySplines: 1,
		keyTimes: 1,
		lengthAdjust: 1,
		letterSpacing: 1,
		"letter-spacing": "letterSpacing",
		lightingColor: 1,
		"lighting-color": "lightingColor",
		limitingConeAngle: 1,
		local: 0,
		markerEnd: 1,
		"marker-end": "markerEnd",
		markerHeight: 1,
		markerMid: 1,
		"marker-mid": "markerMid",
		markerStart: 1,
		"marker-start": "markerStart",
		markerUnits: 1,
		markerWidth: 1,
		mask: 0,
		maskContentUnits: 1,
		maskUnits: 1,
		mathematical: 0,
		mode: 0,
		numOctaves: 1,
		offset: 0,
		opacity: 0,
		operator: 0,
		order: 0,
		orient: 0,
		orientation: 0,
		origin: 0,
		overflow: 0,
		overlinePosition: 1,
		"overline-position": "overlinePosition",
		overlineThickness: 1,
		"overline-thickness": "overlineThickness",
		paintOrder: 1,
		"paint-order": "paintOrder",
		panose1: 0,
		"panose-1": "panose1",
		pathLength: 1,
		patternContentUnits: 1,
		patternTransform: 1,
		patternUnits: 1,
		pointerEvents: 1,
		"pointer-events": "pointerEvents",
		points: 0,
		pointsAtX: 1,
		pointsAtY: 1,
		pointsAtZ: 1,
		prefix: 0,
		preserveAlpha: 1,
		preserveAspectRatio: 1,
		primitiveUnits: 1,
		property: 0,
		r: 0,
		radius: 0,
		refX: 1,
		refY: 1,
		renderingIntent: 1,
		"rendering-intent": "renderingIntent",
		repeatCount: 1,
		repeatDur: 1,
		requiredExtensions: 1,
		requiredFeatures: 1,
		resource: 0,
		restart: 0,
		result: 0,
		results: 0,
		rotate: 0,
		rx: 0,
		ry: 0,
		scale: 0,
		security: 0,
		seed: 0,
		shapeRendering: 1,
		"shape-rendering": "shapeRendering",
		slope: 0,
		spacing: 0,
		specularConstant: 1,
		specularExponent: 1,
		speed: 0,
		spreadMethod: 1,
		startOffset: 1,
		stdDeviation: 1,
		stemh: 0,
		stemv: 0,
		stitchTiles: 1,
		stopColor: 1,
		"stop-color": "stopColor",
		stopOpacity: 1,
		"stop-opacity": "stopOpacity",
		strikethroughPosition: 1,
		"strikethrough-position": "strikethroughPosition",
		strikethroughThickness: 1,
		"strikethrough-thickness": "strikethroughThickness",
		string: 0,
		stroke: 0,
		strokeDasharray: 1,
		"stroke-dasharray": "strokeDasharray",
		strokeDashoffset: 1,
		"stroke-dashoffset": "strokeDashoffset",
		strokeLinecap: 1,
		"stroke-linecap": "strokeLinecap",
		strokeLinejoin: 1,
		"stroke-linejoin": "strokeLinejoin",
		strokeMiterlimit: 1,
		"stroke-miterlimit": "strokeMiterlimit",
		strokeWidth: 1,
		"stroke-width": "strokeWidth",
		strokeOpacity: 1,
		"stroke-opacity": "strokeOpacity",
		suppressContentEditableWarning: 1,
		suppressHydrationWarning: 1,
		surfaceScale: 1,
		systemLanguage: 1,
		tableValues: 1,
		targetX: 1,
		targetY: 1,
		textAnchor: 1,
		"text-anchor": "textAnchor",
		textDecoration: 1,
		"text-decoration": "textDecoration",
		textLength: 1,
		textRendering: 1,
		"text-rendering": "textRendering",
		to: 0,
		transform: 0,
		typeof: 0,
		u1: 0,
		u2: 0,
		underlinePosition: 1,
		"underline-position": "underlinePosition",
		underlineThickness: 1,
		"underline-thickness": "underlineThickness",
		unicode: 0,
		unicodeBidi: 1,
		"unicode-bidi": "unicodeBidi",
		unicodeRange: 1,
		"unicode-range": "unicodeRange",
		unitsPerEm: 1,
		"units-per-em": "unitsPerEm",
		unselectable: 0,
		vAlphabetic: 1,
		"v-alphabetic": "vAlphabetic",
		values: 0,
		vectorEffect: 1,
		"vector-effect": "vectorEffect",
		version: 0,
		vertAdvY: 1,
		"vert-adv-y": "vertAdvY",
		vertOriginX: 1,
		"vert-origin-x": "vertOriginX",
		vertOriginY: 1,
		"vert-origin-y": "vertOriginY",
		vHanging: 1,
		"v-hanging": "vHanging",
		vIdeographic: 1,
		"v-ideographic": "vIdeographic",
		viewBox: 1,
		viewTarget: 1,
		visibility: 0,
		vMathematical: 1,
		"v-mathematical": "vMathematical",
		vocab: 0,
		widths: 0,
		wordSpacing: 1,
		"word-spacing": "wordSpacing",
		writingMode: 1,
		"writing-mode": "writingMode",
		x1: 0,
		x2: 0,
		x: 0,
		xChannelSelector: 1,
		xHeight: 1,
		"x-height": "xHeight",
		xlinkActuate: 1,
		"xlink:actuate": "xlinkActuate",
		xlinkArcrole: 1,
		"xlink:arcrole": "xlinkArcrole",
		xlinkHref: 1,
		"xlink:href": "xlinkHref",
		xlinkRole: 1,
		"xlink:role": "xlinkRole",
		xlinkShow: 1,
		"xlink:show": "xlinkShow",
		xlinkTitle: 1,
		"xlink:title": "xlinkTitle",
		xlinkType: 1,
		"xlink:type": "xlinkType",
		xmlBase: 1,
		"xml:base": "xmlBase",
		xmlLang: 1,
		"xml:lang": "xmlLang",
		xmlns: 0,
		"xml:space": "xmlSpace",
		xmlnsXlink: 1,
		"xmlns:xlink": "xmlnsXlink",
		xmlSpace: 1,
		y1: 0,
		y2: 0,
		y: 0,
		yChannelSelector: 1,
		z: 0,
		zoomAndPan: 1
	};
})), dT = /* @__PURE__ */ A(((e) => {
	var t = 0, n = 1, r = 2, i = 3, a = 4, o = 5, s = 6;
	function c(e) {
		return u.hasOwnProperty(e) ? u[e] : null;
	}
	function l(e, t, n, o, s, c, l) {
		this.acceptsBooleans = t === r || t === i || t === a, this.attributeName = o, this.attributeNamespace = s, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = c, this.removeEmptyString = l;
	}
	var u = {};
	[
		"children",
		"dangerouslySetInnerHTML",
		"defaultValue",
		"defaultChecked",
		"innerHTML",
		"suppressContentEditableWarning",
		"suppressHydrationWarning",
		"style"
	].forEach((e) => {
		u[e] = new l(e, t, !1, e, null, !1, !1);
	}), [
		["acceptCharset", "accept-charset"],
		["className", "class"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"]
	].forEach(([e, t]) => {
		u[e] = new l(e, n, !1, t, null, !1, !1);
	}), [
		"contentEditable",
		"draggable",
		"spellCheck",
		"value"
	].forEach((e) => {
		u[e] = new l(e, r, !1, e.toLowerCase(), null, !1, !1);
	}), [
		"autoReverse",
		"externalResourcesRequired",
		"focusable",
		"preserveAlpha"
	].forEach((e) => {
		u[e] = new l(e, r, !1, e, null, !1, !1);
	}), [
		"allowFullScreen",
		"async",
		"autoFocus",
		"autoPlay",
		"controls",
		"default",
		"defer",
		"disabled",
		"disablePictureInPicture",
		"disableRemotePlayback",
		"formNoValidate",
		"hidden",
		"loop",
		"noModule",
		"noValidate",
		"open",
		"playsInline",
		"readOnly",
		"required",
		"reversed",
		"scoped",
		"seamless",
		"itemScope"
	].forEach((e) => {
		u[e] = new l(e, i, !1, e.toLowerCase(), null, !1, !1);
	}), [
		"checked",
		"multiple",
		"muted",
		"selected"
	].forEach((e) => {
		u[e] = new l(e, i, !0, e, null, !1, !1);
	}), ["capture", "download"].forEach((e) => {
		u[e] = new l(e, a, !1, e, null, !1, !1);
	}), [
		"cols",
		"rows",
		"size",
		"span"
	].forEach((e) => {
		u[e] = new l(e, s, !1, e, null, !1, !1);
	}), ["rowSpan", "start"].forEach((e) => {
		u[e] = new l(e, o, !1, e.toLowerCase(), null, !1, !1);
	});
	var d = /[\-\:]([a-z])/g, f = (e) => e[1].toUpperCase();
	(/* @__PURE__ */ "accent-height.alignment-baseline.arabic-form.baseline-shift.cap-height.clip-path.clip-rule.color-interpolation.color-interpolation-filters.color-profile.color-rendering.dominant-baseline.enable-background.fill-opacity.fill-rule.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.glyph-name.glyph-orientation-horizontal.glyph-orientation-vertical.horiz-adv-x.horiz-origin-x.image-rendering.letter-spacing.lighting-color.marker-end.marker-mid.marker-start.overline-position.overline-thickness.paint-order.panose-1.pointer-events.rendering-intent.shape-rendering.stop-color.stop-opacity.strikethrough-position.strikethrough-thickness.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.text-anchor.text-decoration.text-rendering.underline-position.underline-thickness.unicode-bidi.unicode-range.units-per-em.v-alphabetic.v-hanging.v-ideographic.v-mathematical.vector-effect.vert-adv-y.vert-origin-x.vert-origin-y.word-spacing.writing-mode.xmlns:xlink.x-height".split(".")).forEach((e) => {
		let t = e.replace(d, f);
		u[t] = new l(t, n, !1, e, null, !1, !1);
	}), [
		"xlink:actuate",
		"xlink:arcrole",
		"xlink:role",
		"xlink:show",
		"xlink:title",
		"xlink:type"
	].forEach((e) => {
		let t = e.replace(d, f);
		u[t] = new l(t, n, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
	}), [
		"xml:base",
		"xml:lang",
		"xml:space"
	].forEach((e) => {
		let t = e.replace(d, f);
		u[t] = new l(t, n, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
	}), ["tabIndex", "crossOrigin"].forEach((e) => {
		u[e] = new l(e, n, !1, e.toLowerCase(), null, !1, !1);
	});
	var p = "xlinkHref";
	u[p] = new l("xlinkHref", n, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
		"src",
		"href",
		"action",
		"formAction"
	].forEach((e) => {
		u[e] = new l(e, n, !1, e.toLowerCase(), null, !0, !0);
	});
	var { CAMELCASE: m, SAME: h, possibleStandardNames: g } = uT(), _ = RegExp.prototype.test.bind(/* @__PURE__ */ RegExp("^(data|aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$")), v = Object.keys(g).reduce((e, t) => {
		let n = g[t];
		return n === h ? e[t] = t : n === m ? e[t.toLowerCase()] = t : e[t] = n, e;
	}, {});
	e.BOOLEAN = i, e.BOOLEANISH_STRING = r, e.NUMERIC = o, e.OVERLOADED_BOOLEAN = a, e.POSITIVE_NUMERIC = s, e.RESERVED = t, e.STRING = n, e.getPropertyInfo = c, e.isCustomAttribute = _, e.possibleStandardNames = v;
})), fT = /* @__PURE__ */ A(((e, t) => {
	var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, r = /\n/g, i = /^\s*/, a = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, o = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, c = /^[;\s]*/, l = /^\s+|\s+$/g, u = "\n", d = "/", f = "*", p = "", m = "comment", h = "declaration";
	function g(e, t) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (!e) return [];
		t ||= {};
		var l = 1, g = 1;
		function v(e) {
			var t = e.match(r);
			t && (l += t.length);
			var n = e.lastIndexOf(u);
			g = ~n ? e.length - n : g + e.length;
		}
		function y() {
			var e = {
				line: l,
				column: g
			};
			return function(t) {
				return t.position = new b(e), C(), t;
			};
		}
		function b(e) {
			this.start = e, this.end = {
				line: l,
				column: g
			}, this.source = t.source;
		}
		b.prototype.content = e;
		function x(n) {
			var r = /* @__PURE__ */ Error(t.source + ":" + l + ":" + g + ": " + n);
			if (r.reason = n, r.filename = t.source, r.line = l, r.column = g, r.source = e, !t.silent) throw r;
		}
		function S(t) {
			var n = t.exec(e);
			if (n) {
				var r = n[0];
				return v(r), e = e.slice(r.length), n;
			}
		}
		function C() {
			S(i);
		}
		function w(e) {
			var t;
			for (e ||= []; t = T();) t !== !1 && e.push(t);
			return e;
		}
		function T() {
			var t = y();
			if (!(d != e.charAt(0) || f != e.charAt(1))) {
				for (var n = 2; p != e.charAt(n) && (f != e.charAt(n) || d != e.charAt(n + 1));) ++n;
				if (n += 2, p === e.charAt(n - 1)) return x("End of comment missing");
				var r = e.slice(2, n - 2);
				return g += 2, v(r), e = e.slice(n), g += 2, t({
					type: m,
					comment: r
				});
			}
		}
		function E() {
			var e = y(), t = S(a);
			if (t) {
				if (T(), !S(o)) return x("property missing ':'");
				var r = S(s), i = e({
					type: h,
					property: _(t[0].replace(n, p)),
					value: r ? _(r[0].replace(n, p)) : p
				});
				return S(c), i;
			}
		}
		function ee() {
			var e = [];
			w(e);
			for (var t; t = E();) t !== !1 && (e.push(t), w(e));
			return e;
		}
		return C(), ee();
	}
	function _(e) {
		return e ? e.replace(l, p) : p;
	}
	t.exports = g;
})), pT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
	var n = t(fT());
	function r(e, t) {
		let r = null;
		if (!e || typeof e != "string") return r;
		let i = (0, n.default)(e), a = typeof t == "function";
		return i.forEach((e) => {
			if (e.type !== "declaration") return;
			let { property: n, value: i } = e;
			a ? t(n, i, e) : i && (r ||= {}, r[n] = i);
		}), r;
	}
})), mT = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.camelCase = void 0;
	var t = /^--[a-zA-Z0-9_-]+$/, n = /-([a-z])/g, r = /^[^-]+$/, i = /^-(webkit|moz|ms|o|khtml)-/, a = /^-(ms)-/, o = function(e) {
		return !e || r.test(e) || t.test(e);
	}, s = function(e, t) {
		return t.toUpperCase();
	}, c = function(e, t) {
		return `${t}-`;
	};
	e.camelCase = function(e, t) {
		return t === void 0 && (t = {}), o(e) ? e : (e = e.toLowerCase(), e = t.reactCompat ? e.replace(a, c) : e.replace(i, c), e.replace(n, s));
	};
})), hT = /* @__PURE__ */ A(((e, t) => {
	var n = (e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	})(pT()), r = mT();
	function i(e, t) {
		var i = {};
		return !e || typeof e != "string" || (0, n.default)(e, function(e, n) {
			e && n && (i[(0, r.camelCase)(e, t)] = n);
		}), i;
	}
	i.default = i, t.exports = i;
})), gT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = a, e.setStyleProp = s;
	var n = Df(), r = t(hT()), i = new Set([
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-src",
		"font-face-uri",
		"font-face-format",
		"font-face-name",
		"missing-glyph"
	]);
	function a(e, t) {
		return e.includes("-") ? !i.has(e) : !!(t && typeof t.is == "string");
	}
	var o = { reactCompat: !0 };
	function s(e, t) {
		if (typeof e == "string") {
			if (!e.trim()) {
				t.style = {};
				return;
			}
			try {
				t.style = (0, r.default)(e, o);
			} catch {
				t.style = {};
			}
		}
	}
	e.PRESERVE_CUSTOM_ATTRIBUTES = Number(n.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
		"tr",
		"tbody",
		"thead",
		"tfoot",
		"colgroup",
		"table",
		"head",
		"html",
		"frameset"
	]), e.canTextBeChildOfNode = function(t) {
		return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(t.name);
	}, e.returnFirstArg = function(e) {
		return e;
	};
})), _T = /* @__PURE__ */ A(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
	var t = dT(), n = gT(), r = ["checked", "value"], i = [
		"input",
		"select",
		"textarea"
	], a = {
		reset: !0,
		submit: !0
	};
	function o(e, o) {
		e === void 0 && (e = {});
		var c = {}, l = !!(e.type && a[e.type]);
		for (var u in e) {
			var d = e[u];
			if ((0, t.isCustomAttribute)(u)) {
				c[u] = d;
				continue;
			}
			var f = u.toLowerCase(), p = s(f);
			if (p) {
				var m = (0, t.getPropertyInfo)(p);
				switch (r.includes(p) && i.includes(o) && !l && (p = s("default" + f)), c[p] = d, m?.type) {
					case t.BOOLEAN:
						c[p] = !0;
						break;
					case t.OVERLOADED_BOOLEAN:
						d === "" && (c[p] = !0);
						break;
				}
				continue;
			}
			n.PRESERVE_CUSTOM_ATTRIBUTES && (c[u] = d);
		}
		return (0, n.setStyleProp)(e.style, c), c;
	}
	function s(e) {
		return t.possibleStandardNames[e];
	}
})), vT = /* @__PURE__ */ A(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
	var n = Df(), r = t(_T()), i = gT(), a = {
		cloneElement: n.cloneElement,
		createElement: n.createElement,
		isValidElement: n.isValidElement
	};
	function o(e, t) {
		t === void 0 && (t = {});
		for (var n = [], c = typeof t.replace == "function", l = t.transform ?? i.returnFirstArg, u = t.library ?? a, d = u.cloneElement, f = u.createElement, p = u.isValidElement, m = e.length, h = 0; h < m; h++) {
			var g = e[h];
			if (c) {
				var _ = t.replace?.call(t, g, h);
				if (p(_)) {
					m > 1 && (_ = d(_, { key: _.key ?? h })), n.push(l(_, g, h));
					continue;
				}
			}
			if (g.type === "text") {
				var v = !g.data.trim().length;
				if (v && g.parent && !(0, i.canTextBeChildOfNode)(g.parent) || t.trim && v) continue;
				n.push(l(g.data, g, h));
				continue;
			}
			var y = g, b = {};
			s(y) ? ((0, i.setStyleProp)(y.attribs.style, y.attribs), b = y.attribs) : y.attribs && (b = (0, r.default)(y.attribs, y.name));
			var x = void 0;
			switch (g.type) {
				case "script":
				case "style":
					g.children[0] && (b.dangerouslySetInnerHTML = { __html: g.children[0].data });
					break;
				case "tag":
					g.name === "textarea" && g.children[0] ? b.defaultValue = g.children[0].data : g.children?.length && (x = o(g.children, t));
					break;
				default: continue;
			}
			m > 1 && (b.key = h), n.push(l(f(g.name, b, x), g, h));
		}
		return n.length === 1 ? n[0] : n;
	}
	function s(e) {
		return i.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && (0, i.isCustomComponent)(e.name, e.attribs);
	}
})), yT = /* @__PURE__ */ we((/* @__PURE__ */ A(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = o;
	var n = t(lT());
	e.htmlToDOM = n.default, e.attributesToProps = t(_T()).default;
	var r = t(vT());
	e.domToReact = r.default;
	var i = aT();
	Object.defineProperty(e, "Comment", {
		enumerable: !0,
		get: function() {
			return i.Comment;
		}
	}), Object.defineProperty(e, "Element", {
		enumerable: !0,
		get: function() {
			return i.Element;
		}
	}), Object.defineProperty(e, "ProcessingInstruction", {
		enumerable: !0,
		get: function() {
			return i.ProcessingInstruction;
		}
	}), Object.defineProperty(e, "Text", {
		enumerable: !0,
		get: function() {
			return i.Text;
		}
	});
	var a = { lowerCaseAttributeNames: !1 };
	function o(e, t) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		return e ? (0, r.default)((0, n.default)(e, t?.htmlparser2 ?? a), t) : [];
	}
})))(), 1), bT = yT.default.default || yT.default;
//#endregion
//#region src/core/utils/applyReplacerOnString.tsx
function xT(e, n) {
	return n ? (Array.isArray(e) ? e : [e]).map((e, r) => typeof e == "string" ? /* @__PURE__ */ t.createElement(t.Fragment, { key: r }, n(new yT.Text(e), 0) || e) : e) : e;
}
//#endregion
//#region src/message-body/EventContentBody/EventContentBodyView.tsx
var ST = a(function({ vm: e, as: n, ref: r }) {
	let { body: i, formattedBody: a, replacer: o, className: s, dir: c, parseFormattedBody: l } = Y(e), u = a ? (l ?? ((e, t) => bT(e, t ? { replace: t } : void 0)))(a, o) : xT(i, o);
	return n === "span" ? /* @__PURE__ */ t.createElement("span", {
		ref: r,
		className: s,
		dir: c
	}, u) : /* @__PURE__ */ t.createElement("div", {
		ref: r,
		className: s,
		dir: c
	}, u);
});
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/arrow-down.js
function CT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 4.5a1 1 0 0 1 1 1v10.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.086V5.5a1 1 0 0 1 1-1" })
	});
}
CT.displayName = "ArrowDownIcon";
var wT = i(CT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/attachment.js
function TT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M11.5 22q-2.3 0-3.9-1.6T6 16.5V6q0-1.65 1.175-2.825T10 2t2.825 1.175T14 6v9.5q0 1.05-.725 1.775T11.5 18t-1.775-.725T9 15.5V6.75A.73.73 0 0 1 9.75 6a.73.73 0 0 1 .75.75v8.75q0 .424.287.712.288.288.713.288.424 0 .713-.288a.97.97 0 0 0 .287-.712V6q0-1.05-.725-1.775T10 3.5t-1.775.725T7.5 6v10.5q0 1.65 1.175 2.825T11.5 20.5t2.825-1.175T15.5 16.5V6.75a.73.73 0 0 1 .75-.75.73.73 0 0 1 .75.75v9.75q0 2.3-1.6 3.9T11.5 22" })
	});
}
TT.displayName = "AttachmentIcon";
var ET = i(TT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/block.js
function DT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12q0-1.35-.437-2.6A8 8 0 0 0 18.3 7.1L7.1 18.3q1.05.825 2.3 1.262T12 20m-6.3-3.1L16.9 5.7a8 8 0 0 0-2.3-1.263A7.8 7.8 0 0 0 12 4Q8.65 4 6.325 6.325T4 12q0 1.35.438 2.6A8 8 0 0 0 5.7 16.9" })
	});
}
DT.displayName = "BlockIcon";
var OT = i(DT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/chat.js
function kT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m1.5 21.25 1.45-4.95a10.2 10.2 0 0 1-.712-2.1A10.2 10.2 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22q-1.125 0-2.2-.238a10.2 10.2 0 0 1-2.1-.712L2.75 22.5a.94.94 0 0 1-1-.25.94.94 0 0 1-.25-1m2.45-1.2 3.2-.95a1 1 0 0 1 .275-.062q.15-.013.275-.013.225 0 .438.038.212.036.412.137a7.4 7.4 0 0 0 1.675.6Q11.1 20 12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12q0 .9.2 1.775t.6 1.675q.176.325.188.688t-.088.712z" })
	});
}
kT.displayName = "ChatIcon";
var AT = i(kT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/check.js
function jT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M9.55 17.575q-.2 0-.375-.062a.9.9 0 0 1-.325-.213L4.55 13q-.274-.274-.262-.713.012-.437.287-.712a.95.95 0 0 1 .7-.275q.425 0 .7.275L9.55 15.15l8.475-8.475q.274-.275.713-.275.437 0 .712.275.275.274.275.713 0 .437-.275.712l-9.2 9.2q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" })
	});
}
jT.displayName = "CheckIcon";
var MT = i(jT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/chevron-down.js
function NT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 14.95q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-4.6-4.6a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l3.9 3.9 3.9-3.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" })
	});
}
NT.displayName = "ChevronDownIcon";
var PT = i(NT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/chevron-left.js
function FT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m13.3 17.3-4.6-4.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 8.425 12q0-.2.062-.375A.9.9 0 0 1 8.7 11.3l4.6-4.6a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L10.8 12l3.9 3.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275" })
	});
}
FT.displayName = "ChevronLeftIcon";
var IT = i(FT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/chevron-right.js
function LT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M8.7 17.3a.95.95 0 0 1-.275-.7q0-.425.275-.7l3.9-3.9-3.9-3.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l4.6 4.6q.15.15.213.325.062.175.062.375t-.062.375a.9.9 0 0 1-.213.325l-4.6 4.6a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275" })
	});
}
LT.displayName = "ChevronRightIcon";
var RT = i(LT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/compose.js
function zT(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", {
			fillRule: "evenodd",
			d: "M16.937 2.82a2 2 0 0 1 2.828 0l1.415 1.414a2 2 0 0 1 0 2.829l-7.071 7.07c-.195.196-.42.342-.66.44a1 1 0 0 1-.168.072l-3.993 1.331a1 1 0 0 1-1.265-1.265l1.331-3.992q.03-.09.073-.168m10.338-4.903-6.717 6.718-1.414-1.414 6.717-6.718z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ (0, U.jsx)("path", { d: "M3 5a2 2 0 0 1 2-2h6a1 1 0 1 1 0 2H5v14h14v-6a1 1 0 1 1 2 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" })]
	});
}
zT.displayName = "ComposeIcon";
var BT = i(zT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/delete.js
function VT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M7 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19V6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 5q0-.424.287-.713A.97.97 0 0 1 5 4h4q0-.424.287-.712A.97.97 0 0 1 10 3h4q.424 0 .713.288Q15 3.575 15 4h4q.424 0 .712.287Q20 4.576 20 5t-.288.713A.97.97 0 0 1 19 6v13q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21zM7 6v13h10V6zm2 10q0 .424.287.712Q9.576 17 10 17t.713-.288A.97.97 0 0 0 11 16V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 10 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 9 9zm4 0q0 .424.287.712.288.288.713.288.424 0 .713-.288A.97.97 0 0 0 15 16V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 13 9z" })
	});
}
VT.displayName = "DeleteIcon";
var HT = i(VT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/dial-pad.js
function UT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 18.6c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8M6.6 2.4c-.99 0-1.8.81-1.8 1.8S5.61 6 6.6 6s1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m0 5.4c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m0 5.4c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8M17.4 6c.99 0 1.8-.81 1.8-1.8s-.81-1.8-1.8-1.8-1.8.81-1.8 1.8.81 1.8 1.8 1.8M12 13.2c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m5.4 0c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m0-5.4c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m-5.4 0c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8m0-5.4c-.99 0-1.8.81-1.8 1.8S11.01 6 12 6s1.8-.81 1.8-1.8-.81-1.8-1.8-1.8" })
	});
}
UT.displayName = "DialPadIcon";
var WT = i(UT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/download.js
function GT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 15.575q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-3.6-3.6a.95.95 0 0 1-.275-.7q0-.425.275-.7.274-.275.712-.288t.713.263L11 12.15V5q0-.424.287-.713A.97.97 0 0 1 12 4q.424 0 .713.287Q13 4.576 13 5v7.15l1.875-1.875q.274-.274.713-.263.437.014.712.288a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-3.6 3.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063M6 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-2q0-.424.287-.713A.97.97 0 0 1 5 15q.424 0 .713.287Q6 15.576 6 16v2h12v-2q0-.424.288-.713A.97.97 0 0 1 19 15q.424 0 .712.287.288.288.288.713v2q0 .824-.587 1.413A1.93 1.93 0 0 1 18 20z" })
	});
}
GT.displayName = "DownloadIcon";
var KT = i(GT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/drag-list.js
function qT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M5 15a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 14q0-.424.287-.713A.97.97 0 0 1 5 13h14q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 19 15zm0-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 10q0-.424.287-.713A.97.97 0 0 1 5 9h14q.424 0 .712.287Q20 9.576 20 10t-.288.713A.97.97 0 0 1 19 11z" })
	});
}
qT.displayName = "DragListIcon";
var JT = i(qT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/email-solid.js
function YT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 5.111a1 1 0 0 0 .514.874l7 3.89a1 1 0 0 0 .972 0l7-3.89a1 1 0 1 0-.972-1.748L12 11.856 5.486 8.237A1 1 0 0 0 4 9.111" })
	});
}
YT.displayName = "EmailSolidIcon";
var XT = i(YT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/error-solid.js
function ZT(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 17q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m0 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22" })
	});
}
ZT.displayName = "ErrorSolidIcon";
var QT = i(ZT);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/explore.js
function $T(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 13a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12q0-.424.287-.713A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 12 13m0 9a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20m0 0q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4t5.675 2.325T20 12t-2.325 5.675T12 20m1.675-5.85q.15-.075.275-.2t.2-.275l2.925-6.25q.125-.25-.062-.437-.188-.188-.438-.063l-6.25 2.925q-.15.075-.275.2t-.2.275l-2.925 6.25q-.125.25.063.438.186.186.437.062z" })
	});
}
$T.displayName = "ExploreIcon";
var eE = i($T);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/favourite.js
function tE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M13.905 9.378 12 5.52l-1.905 3.86-4.259.618 3.082 3.004-.727 4.242L12 15.24l3.81 2.003-.728-4.242 3.082-3.004zM8.767 7.55l2.336-4.733a1 1 0 0 1 1.794 0l2.336 4.733 5.223.76a1 1 0 0 1 .555 1.705L17.23 13.7l.892 5.202a1 1 0 0 1-1.45 1.054L12 17.5l-4.672 2.456a1 1 0 0 1-1.451-1.054l.892-5.202-3.78-3.685a1 1 0 0 1 .555-1.706z" })
	});
}
tE.displayName = "FavouriteIcon";
var nE = i(tE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/history.js
function rE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M18.93 8A8 8 0 1 1 4 12a1 1 0 1 0-2 0c0 5.523 4.477 10 10 10s10-4.477 10-10a10 10 0 0 0-.832-4A10 10 0 0 0 12 2a9.99 9.99 0 0 0-8 3.999V4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2H5.755A7.99 7.99 0 0 1 12 4a8 8 0 0 1 6.93 4" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M13 8a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.83 2.83a1 1 0 0 0 1.414-1.414L13 11.586z" })]
	});
}
rE.displayName = "HistoryIcon";
var iE = i(rE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/home.js
function aE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", {
			fillRule: "evenodd",
			d: "M16 11v8h3V9.177l-7-3.889-7 3.889V19h3v-8zm-6 10H5a2 2 0 0 1-2-2V9.177a2 2 0 0 1 1.029-1.748l7-3.89a2 2 0 0 1 1.942 0l7 3.89A2 2 0 0 1 21 9.177V19a2 2 0 0 1-2 2h-5v-8h-4z",
			clipRule: "evenodd"
		})
	});
}
aE.displayName = "HomeIcon";
var oE = i(aE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/leave.js
function sE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M14 13q.424 0 .713-.287A.97.97 0 0 0 15 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 13 12q0 .424.287.713.288.287.713.287" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M10.385 21.788A1 1 0 0 1 10 21V3a1.003 1.003 0 0 1 1.242-.97l8 2A1 1 0 0 1 20 5v14a1 1 0 0 1-.758.97l-8 2a1 1 0 0 1-.857-.182M18 5.781l-6-1.5v15.438l6-1.5zM9 6H7v12h2v2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2z" })]
	});
}
sE.displayName = "LeaveIcon";
var cE = i(sE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/link.js
function lE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 19.071q-1.467 1.467-3.536 1.467-2.067 0-3.535-1.467t-1.467-3.535q0-2.07 1.467-3.536L7.05 9.879q.3-.3.707-.3t.707.3.301.707-.3.707l-2.122 2.121a2.9 2.9 0 0 0-.884 2.122q0 1.237.884 2.12.884.885 2.121.885t2.122-.884l2.121-2.121q.3-.3.707-.3t.707.3.3.707q0 .405-.3.707zm-1.414-4.243q-.3.3-.707.301a.97.97 0 0 1-.707-.3q-.3-.3-.301-.708 0-.405.3-.707l4.243-4.242q.3-.3.707-.3t.707.3.3.707-.3.707zm6.364-.707q-.3.3-.707.3a.97.97 0 0 1-.707-.3q-.3-.3-.301-.707 0-.405.3-.707l2.122-2.121q.884-.885.884-2.121 0-1.238-.884-2.122a2.9 2.9 0 0 0-2.121-.884q-1.237 0-2.122.884l-2.121 2.122q-.3.3-.707.3a.97.97 0 0 1-.707-.3q-.3-.3-.3-.708 0-.405.3-.707L12 4.93q1.467-1.467 3.536-1.467t3.535 1.467 1.467 3.536T19.071 12z" })
	});
}
lE.displayName = "LinkIcon";
var uE = i(lE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/lock-solid.js
function dE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M6 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V10q0-.825.588-1.412A1.93 1.93 0 0 1 6 8h1V6q0-2.075 1.463-3.537Q9.926 1 12 1q2.075 0 3.537 1.463Q17 3.925 17 6v2h1q.824 0 1.413.588Q20 9.175 20 10v10q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zM9 8h6V6q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6z" })
	});
}
dE.displayName = "LockSolidIcon";
var fE = i(dE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/mark-as-read.js
function pE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M21.324 9.13c0-.66-.339-1.237-.862-1.558l-7.37-4.318a1.81 1.81 0 0 0-1.851 0L3.87 7.572C3.348 7.892 3 8.47 3 9.13v9.167c0 1.008.825 1.833 1.833 1.833H19.5a1.84 1.84 0 0 0 1.833-1.833zm-10.129 3.978-6.6-4.124 6.646-3.896a1.81 1.81 0 0 1 1.851 0l6.646 3.896-6.6 4.124a1.85 1.85 0 0 1-1.943 0" })
	});
}
pE.displayName = "MarkAsReadIcon";
var mE = i(pE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/mark-as-unread.js
function hE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M20 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }), /* @__PURE__ */ (0, U.jsx)("path", {
			fillRule: "evenodd",
			d: "M17 5H5a2 2 0 0 0-2 2v10.4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7.83a3 3 0 0 1-2 0q-.316-.113-.595-.288L12 11.89 5 7.138V7h12.764A3 3 0 0 1 17 5m-4.438 8.927L19 9.555V17.4H5V9.555l6.438 4.372a1 1 0 0 0 1.124 0",
			clipRule: "evenodd"
		})]
	});
}
hE.displayName = "MarkAsUnreadIcon";
var gE = i(hE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/mention.js
function _E(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M12 4a8 8 0 1 0 0 16 1 1 0 1 1 0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 17 12v1.5a1.5 1.5 0 0 0 3 0V12a8 8 0 0 0-8-8m3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0" })
	});
}
_E.displayName = "MentionIcon";
var vE = i(_E);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/notifications-off-solid.js
function yE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "m4.917 2.083 17 17a1 1 0 0 1-1.414 1.414L19.006 19H4.414c-.89 0-1.337-1.077-.707-1.707L5 16v-6s0-2.034 1.096-3.91L3.504 3.498a1 1 0 0 1 1.414-1.414M19 13.35 9.136 3.484C9.93 3.181 10.874 3 12 3c7 0 7 7 7 7z" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M10 20h4a2 2 0 0 1-4 0" })]
	});
}
yE.displayName = "NotificationsOffSolidIcon";
var bE = i(yE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/notifications-solid.js
function xE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M20.293 17.293c.63.63.184 1.707-.707 1.707H4.414c-.89 0-1.337-1.077-.707-1.707L5 16v-6s0-7 7-7 7 7 7 7v6zM12 22a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2" })
	});
}
xE.displayName = "NotificationsSolidIcon";
var SE = i(xE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/overflow-horizontal.js
function CE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M6 14q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 12q0-.825.588-1.412A1.93 1.93 0 0 1 6 10q.824 0 1.412.588Q8 11.175 8 12t-.588 1.412A1.93 1.93 0 0 1 6 14m6 0q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 12q0-.825.588-1.412A1.93 1.93 0 0 1 12 10q.825 0 1.412.588Q14 11.175 14 12t-.588 1.412A1.93 1.93 0 0 1 12 14m6 0q-.824 0-1.413-.588A1.93 1.93 0 0 1 16 12q0-.825.587-1.412A1.93 1.93 0 0 1 18 10q.824 0 1.413.588Q20 11.175 20 12t-.587 1.412A1.93 1.93 0 0 1 18 14" })
	});
}
CE.displayName = "OverflowHorizontalIcon";
var wE = i(CE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/pin-solid.js
function TE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M5.769 2.857A.5.5 0 0 1 6.119 2h11.762a.5.5 0 0 1 .35.857L16.15 4.9a.5.5 0 0 0-.15.357v4.487a.5.5 0 0 0 .15.356l3.7 3.644a.5.5 0 0 1 .15.356v1.4a.5.5 0 0 1-.5.5H13v6a1 1 0 1 1-2 0v-6H4.5a.5.5 0 0 1-.5-.5v-1.4a.5.5 0 0 1 .15-.356l3.7-3.644A.5.5 0 0 0 8 9.744V5.257a.5.5 0 0 0-.15-.357z" })
	});
}
TE.displayName = "PinSolidIcon";
var EE = i(TE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/preferences.js
function DE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", {
			fillRule: "evenodd",
			d: "M6.5 2h11a4.5 4.5 0 1 1 0 9h-11a4.5 4.5 0 0 1 0-9m0 2h7.258A4.5 4.5 0 0 0 13 6.5c0 .925.28 1.785.758 2.5H6.5a2.5 2.5 0 0 1 0-5M15 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-13 11A4.5 4.5 0 0 1 6.5 13h11a4.5 4.5 0 1 1 0 9h-11q-.233 0-.46-.023A4.5 4.5 0 0 1 2 17.5m8.242-2.5H17.5a2.5 2.5 0 0 1 0 5h-7.258A4.5 4.5 0 0 0 11 17.5c0-.925-.28-1.785-.758-2.5M6.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
			clipRule: "evenodd"
		})
	});
}
DE.displayName = "PreferencesIcon";
var OE = i(DE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/reaction-add.js
function kE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M14.74 2.38C13.87 2.133 12.95 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.95-.133-1.87-.38-2.74a5 5 0 0 1-1.886.687 8 8 0 1 1-5.68-5.68c.1-.684.339-1.323.687-1.887" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M15.536 14.121a1 1 0 0 1 0 1.415A5 5 0 0 1 12 17c-1.38 0-2.632-.56-3.535-1.464a1 1 0 1 1 1.414-1.415A3 3 0 0 0 12 15c.829 0 1.577-.335 2.121-.879a1 1 0 0 1 1.415 0M8.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m8.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M18 6h-1a.97.97 0 0 1-.712-.287A.97.97 0 0 1 16 5q0-.424.288-.713A.97.97 0 0 1 17 4h1V3q0-.424.288-.712A.97.97 0 0 1 19 2q.424 0 .712.288Q20 2.575 20 3v1h1q.424 0 .712.287Q22 4.576 22 5t-.288.713A.97.97 0 0 1 21 6h-1v1q0 .424-.288.713A.97.97 0 0 1 19 8a.97.97 0 0 1-.712-.287A.97.97 0 0 1 18 7z" })]
	});
}
kE.displayName = "ReactionAddIcon";
var AE = i(kE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/restart.js
function jE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M18.93 8A8 8 0 1 1 4 12a1 1 0 1 0-2 0c0 5.523 4.477 10 10 10s10-4.477 10-10a10 10 0 0 0-.832-4A10 10 0 0 0 12 2a9.99 9.99 0 0 0-8 3.999V4a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2H5.755A7.99 7.99 0 0 1 12 4a8 8 0 0 1 6.93 4" })
	});
}
jE.displayName = "RestartIcon";
var ME = i(jE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/room.js
function NE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m8.566 17-.944 4.094q-.086.406-.372.656t-.687.25q-.543 0-.887-.469a1.18 1.18 0 0 1-.2-1.031l.801-3.5H3.158q-.572 0-.916-.484a1.27 1.27 0 0 1-.2-1.078 1.12 1.12 0 0 1 1.116-.938H6.85l1.145-5h-3.12q-.57 0-.915-.484a1.27 1.27 0 0 1-.2-1.078A1.12 1.12 0 0 1 4.875 7h3.691l.945-4.094q.085-.406.372-.656.286-.25.686-.25.544 0 .887.469.345.468.2 1.031l-.8 3.5h4.578l.944-4.094q.085-.406.372-.656.286-.25.687-.25.543 0 .887.469t.2 1.031L17.723 7h3.119q.573 0 .916.484.343.485.2 1.079a1.12 1.12 0 0 1-1.116.937H17.15l-1.145 5h3.12q.57 0 .915.484.343.485.2 1.079a1.12 1.12 0 0 1-1.116.937h-3.691l-.944 4.094q-.087.406-.373.656t-.686.25q-.544 0-.887-.469a1.18 1.18 0 0 1-.2-1.031l.8-3.5zm.573-2.5h4.578l1.144-5h-4.578z" })
	});
}
NE.displayName = "RoomIcon";
var PE = i(NE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/search.js
function FE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M15.05 16.463a7.5 7.5 0 1 1 1.414-1.414l3.243 3.244a1 1 0 0 1-1.414 1.414zM16 10.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0" })
	});
}
FE.displayName = "SearchIcon";
var IE = i(FE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/settings.js
function LE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M11.312 2h1.376A2.31 2.31 0 0 1 15 4.312v.247l.002.003c.01.014.031.033.064.047.03.013.056.013.07.01h.002l.177-.177a2.31 2.31 0 0 1 3.27 0l.973.974a2.31 2.31 0 0 1 0 3.269l-.177.177v.003a.13.13 0 0 0 .01.07.15.15 0 0 0 .047.063l.003.002h.247A2.31 2.31 0 0 1 22 11.312v1.376A2.31 2.31 0 0 1 19.688 15h-.247l-.003.002a.15.15 0 0 0-.047.064.13.13 0 0 0-.01.07v.002l.177.177a2.31 2.31 0 0 1 0 3.27l-.974.973a2.31 2.31 0 0 1-3.269 0l-.177-.177h-.003a.13.13 0 0 0-.07.01.15.15 0 0 0-.063.047l-.002.003v.247A2.31 2.31 0 0 1 12.688 22h-1.376A2.31 2.31 0 0 1 9 19.688v-.247l-.002-.003a.15.15 0 0 0-.064-.047.13.13 0 0 0-.07-.01h-.002l-.177.177a2.31 2.31 0 0 1-3.27 0l-.973-.974a2.31 2.31 0 0 1 0-3.269l.177-.177v-.003a.14.14 0 0 0-.01-.07.15.15 0 0 0-.047-.063L4.559 15h-.247A2.31 2.31 0 0 1 2 12.688v-1.376A2.31 2.31 0 0 1 4.312 9h.247l.003-.002a.15.15 0 0 0 .047-.064.14.14 0 0 0 .01-.07v-.002l-.177-.177a2.31 2.31 0 0 1 0-3.27l.974-.973a2.31 2.31 0 0 1 3.269 0l.177.177h.003a.14.14 0 0 0 .07-.01.15.15 0 0 0 .063-.047L9 4.559v-.247A2.31 2.31 0 0 1 11.312 2M11 4.312v.257c0 .893-.59 1.593-1.299 1.887-.716.297-1.622.21-2.248-.418l-.182-.182a.31.31 0 0 0-.441 0l-.974.974a.31.31 0 0 0 0 .44l.182.183c.627.626.715 1.531.418 2.248C6.162 10.41 5.462 11 4.569 11h-.257a.31.31 0 0 0-.312.312v1.376c0 .172.14.312.312.312h.257c.893 0 1.593.59 1.887 1.299.297.716.21 1.622-.418 2.248l-.182.182a.31.31 0 0 0 0 .441l.974.973a.31.31 0 0 0 .44 0l.183-.181c.626-.627 1.532-.715 2.248-.418.709.294 1.299.994 1.299 1.887v.257c0 .172.14.312.312.312h1.376c.172 0 .312-.14.312-.312v-.257c0-.893.59-1.593 1.299-1.887.716-.297 1.622-.21 2.249.418l.181.181c.122.122.32.122.441 0l.973-.973a.31.31 0 0 0 0-.44l-.181-.183c-.627-.626-.715-1.532-.418-2.248.294-.709.994-1.299 1.887-1.299h.257c.172 0 .312-.14.312-.312v-1.376a.31.31 0 0 0-.312-.312h-.257c-.893 0-1.593-.59-1.887-1.299-.297-.717-.21-1.622.418-2.248l.181-.182a.31.31 0 0 0 0-.441l-.973-.974a.31.31 0 0 0-.44 0l-.183.182c-.626.627-1.532.715-2.248.418C13.59 6.162 13 5.462 13 4.569v-.257A.31.31 0 0 0 12.688 4h-1.376a.31.31 0 0 0-.312.312" })]
	});
}
LE.displayName = "SettingsIcon";
var RE = i(LE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/user-add.js
function zE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M10 12q-1.65 0-2.825-1.175T6 8t1.175-2.825T10 4t2.825 1.175T14 8t-1.175 2.825T10 12m-8 6v-.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 10 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.163 1.087Q18 16.35 18 17.2v.8q0 .824-.587 1.413A1.93 1.93 0 0 1 16 20H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18m2 0h12v-.8a.97.97 0 0 0-.5-.85q-1.35-.675-2.725-1.012a11.6 11.6 0 0 0-5.55 0Q5.85 15.675 4.5 16.35a.97.97 0 0 0-.5.85zm6-8q.825 0 1.412-.588Q12 8.826 12 8q0-.824-.588-1.412A1.93 1.93 0 0 0 10 6q-.825 0-1.412.588A1.93 1.93 0 0 0 8 8q0 .825.588 1.412Q9.175 10 10 10m7 1h2v2q0 .424.288.713.287.287.712.287.424 0 .712-.287A.97.97 0 0 0 21 13v-2h2q.424 0 .712-.287A.97.97 0 0 0 24 10a.97.97 0 0 0-.288-.713A.97.97 0 0 0 23 9h-2V7a.97.97 0 0 0-.288-.713A.97.97 0 0 0 20 6a.97.97 0 0 0-.712.287A.97.97 0 0 0 19 7v2h-2a.97.97 0 0 0-.712.287A.97.97 0 0 0 16 10q0 .424.288.713.287.287.712.287" })
	});
}
zE.displayName = "UserAddIcon";
var BE = i(zE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/user-profile-solid.js
function VE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M12 15q-1.65 0-2.825-1.175T8 11t1.175-2.825T12 7t2.825 1.175T16 11t-1.175 2.825T12 15" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M19.528 18.583A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 2.52.933 4.824 2.472 6.583A9.98 9.98 0 0 0 12 22a9.98 9.98 0 0 0 7.528-3.417M8.75 16.388q-1.373.332-2.709.95a8 8 0 1 1 11.918 0 14.7 14.7 0 0 0-2.709-.95A13.8 13.8 0 0 0 12 16q-1.65 0-3.25.387" })]
	});
}
VE.displayName = "UserProfileSolidIcon";
var HE = i(VE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/video-call-solid.js
function UE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M6 4h10a2 2 0 0 1 2 2v4.286l3.35-2.871a1 1 0 0 1 1.65.76v7.65a1 1 0 0 1-1.65.76L18 13.715V18a2 2 0 0 1-2 2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4" })
	});
}
UE.displayName = "VideoCallSolidIcon";
var WE = i(UE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/video-call.js
function GE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "M2 8a4 4 0 0 1 4-4h10a2 2 0 0 1 2 2v4.286l3.35-2.871a1 1 0 0 1 1.65.76v7.65a1 1 0 0 1-1.65.76L18 13.715V18a2 2 0 0 1-2 2H6a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10V6zm15 7.652v-3.303L19.073 12z" })
	});
}
GE.displayName = "VideoCallIcon";
var KE = i(GE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/visibility-off.js
function qE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m16.1 13.3-1.45-1.45q.225-1.175-.675-2.2t-2.325-.8L10.2 7.4q.424-.2.863-.3A4.2 4.2 0 0 1 12 7q1.875 0 3.188 1.312Q16.5 9.625 16.5 11.5q0 .5-.1.938t-.3.862m3.2 3.15-1.45-1.4a11 11 0 0 0 1.688-1.588A9 9 0 0 0 20.8 11.5q-1.25-2.524-3.588-4.013Q14.875 6 12 6q-.724 0-1.425.1a10 10 0 0 0-1.375.3L7.65 4.85A11.1 11.1 0 0 1 12 4q3.575 0 6.425 1.887T22.7 10.8a.8.8 0 0 1 .1.313q.025.188.025.387a2 2 0 0 1-.125.7 10.9 10.9 0 0 1-3.4 4.25m-.2 5.45-3.5-3.45q-.874.274-1.762.413Q12.95 19 12 19q-3.575 0-6.425-1.887T1.3 12.2a.8.8 0 0 1-.1-.312 3 3 0 0 1 0-.763.8.8 0 0 1 .1-.3Q1.825 9.7 2.55 8.75A13.3 13.3 0 0 1 4.15 7L2.075 4.9a.93.93 0 0 1-.275-.688q0-.412.3-.712a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M5.55 8.4q-.725.65-1.325 1.425A9 9 0 0 0 3.2 11.5q1.25 2.524 3.588 4.012T12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.274.075-.525.113A3.5 3.5 0 0 1 12 16q-1.875 0-3.187-1.312Q7.5 13.375 7.5 11.5q0-.274.038-.525.037-.25.112-.525z" })
	});
}
qE.displayName = "VisibilityOffIcon";
var JE = i(qE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/voice-call-solid.js
function YE(e, t) {
	return /* @__PURE__ */ (0, U.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: /* @__PURE__ */ (0, U.jsx)("path", { d: "m20.958 16.374.039 3.527q0 .427-.33.756-.33.33-.756.33a16 16 0 0 1-6.57-1.105 16.2 16.2 0 0 1-5.563-3.663 16.1 16.1 0 0 1-3.653-5.573 16.3 16.3 0 0 1-1.115-6.56q0-.427.33-.757T4.095 3l3.528.039a1.07 1.07 0 0 1 1.085.93l.543 3.954q.039.271-.039.504a1.1 1.1 0 0 1-.271.426l-1.64 1.64q.505 1.008 1.154 1.909c.433.6 1.444 1.696 1.444 1.696s1.095 1.01 1.696 1.444q.9.65 1.909 1.153l1.64-1.64q.193-.193.426-.27t.504-.04l3.954.543q.406.059.668.359t.262.727" })
	});
}
YE.displayName = "VoiceCallSolidIcon";
var XE = i(YE);
//#endregion
//#region ../../node_modules/@vector-im/compound-design-tokens/assets/web/icons/volume-on-solid.js
function ZE(e, t) {
	return /* @__PURE__ */ (0, U.jsxs)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "currentColor",
		viewBox: "0 0 24 24",
		ref: t,
		...e,
		children: [/* @__PURE__ */ (0, U.jsx)("path", { d: "M3 14v-4a2 2 0 0 1 2-2h2l3.293-3.293c.63-.63 1.707-.184 1.707.707v13.172c0 .89-1.077 1.337-1.707.707L7 16H5a2 2 0 0 1-2-2m11.122-5.536a1 1 0 0 1 1.414 0A5 5 0 0 1 17 12c0 1.38-.56 2.632-1.464 3.536a1 1 0 0 1-1.415-1.415 3 3 0 0 0 .88-2.121c0-.829-.335-1.577-.88-2.121a1 1 0 0 1 0-1.415" }), /* @__PURE__ */ (0, U.jsx)("path", { d: "M16.95 5.636a1 1 0 0 1 1.414 0A8.98 8.98 0 0 1 21 12a8.98 8.98 0 0 1-2.636 6.364 1 1 0 0 1-1.414-1.414A6.98 6.98 0 0 0 19 12a6.98 6.98 0 0 0-2.05-4.95 1 1 0 0 1 0-1.414" })]
	});
}
ZE.displayName = "VolumeOnSolidIcon";
var QE = i(ZE), $E = {
	content: "_content_1xhpr_8",
	icon: "_icon_1xhpr_17"
};
//#endregion
//#region src/message-body/RedactedBodyView/RedactedBodyView.tsx
function eD({ vm: e, className: n, ref: r }) {
	let { text: i, tooltip: a } = Y(e), o = /* @__PURE__ */ t.createElement("span", {
		className: (0, H.default)($E.content, n),
		ref: r
	}, /* @__PURE__ */ t.createElement(HT, {
		className: $E.icon,
		"aria-hidden": "true"
	}), /* @__PURE__ */ t.createElement("span", null, i));
	return a ? /* @__PURE__ */ t.createElement(k, { description: a }, o) : o;
}
var tD = {
	content: "_content_f1s5h_8",
	invalid: "_invalid_f1s5h_70"
}, nD = { mediaBody: "_mediaBody_rgndh_8" };
//#endregion
//#region src/room/timeline/event-tile/body/MediaBody/MediaBody.tsx
function rD({ as: e, className: n, children: r, ...i }) {
	let a = e || "div";
	return /* @__PURE__ */ t.createElement(a, {
		className: (0, H.default)("mx_MediaBody", nD.mediaBody, n),
		...i
	}, r);
}
//#endregion
//#region src/message-body/FileBodyView/FileBodyView.tsx
var iD = /* @__PURE__ */ function(e) {
	return e.EXPORT = "EXPORT", e.DECRYPTION_PENDING = "DECRYPTION_PENDING", e.ENCRYPTED = "ENCRYPTED", e.UNENCRYPTED = "UNENCRYPTED", e.INVALID = "INVALID", e;
}({}), aD = /* @__PURE__ */ function(e) {
	return e.ATTACHMENT = "ATTACHMENT", e.AUDIO = "AUDIO", e.DOWNLOAD = "DOWNLOAD", e.VIDEO = "VIDEO", e;
}({});
function oD(e) {
	return e === aD.AUDIO ? QE : e === aD.DOWNLOAD ? KT : e === aD.VIDEO ? WE : ET;
}
function sD({ vm: e, refIFrame: n, refLink: r, className: i }) {
	let { translate: a } = W(), { state: o, showInfo: s, infoLabel: c, infoTooltip: l, infoIcon: u, infoHref: d, showDownload: f, downloadLabel: p, downloadTitle: m, downloadHref: h } = Y(e), _ = c ?? a("common|attachment"), v = l ?? _, y = oD(u), b = s ? /* @__PURE__ */ t.createElement(k, {
		description: v,
		placement: "right"
	}, /* @__PURE__ */ t.createElement(rD, { "data-type": "info" }, /* @__PURE__ */ t.createElement(g, {
		as: "button",
		size: "sm",
		kind: "secondary",
		"aria-label": _,
		Icon: y,
		onClick: e.onInfoClick
	}, /* @__PURE__ */ t.createElement("span", null, _)))) : null, x = (0, H.default)(tD.content, i), S = p ?? a("action|download"), C = m ?? S;
	switch (o) {
		case iD.EXPORT: return /* @__PURE__ */ t.createElement("span", { className: x }, /* @__PURE__ */ t.createElement("a", { href: d }, b));
		case iD.DECRYPTION_PENDING: return /* @__PURE__ */ t.createElement("span", { className: x }, b, f && /* @__PURE__ */ t.createElement("div", { "data-type": "download" }, /* @__PURE__ */ t.createElement(g, {
			size: "sm",
			kind: "secondary",
			Icon: KT,
			onClick: e.onDownloadClick
		}, S)));
		case iD.ENCRYPTED: return /* @__PURE__ */ t.createElement("span", { className: x }, b, f && /* @__PURE__ */ t.createElement("div", { "data-type": "download" }, /* @__PURE__ */ t.createElement("div", {
			"aria-hidden": !0,
			style: { display: "none" }
		}, /* @__PURE__ */ t.createElement(g, {
			size: "sm",
			kind: "secondary",
			Icon: KT,
			as: "a",
			ref: r
		})), /* @__PURE__ */ t.createElement("iframe", {
			"aria-hidden": !0,
			title: C,
			src: "usercontent/",
			onLoad: e.onDownloadIframeLoad,
			ref: n,
			sandbox: "allow-scripts allow-downloads"
		})));
		case iD.UNENCRYPTED: return /* @__PURE__ */ t.createElement("span", { className: x }, b, f && /* @__PURE__ */ t.createElement("div", { "data-type": "download" }, /* @__PURE__ */ t.createElement(g, {
			size: "sm",
			kind: "secondary",
			Icon: KT,
			as: "a",
			href: h,
			target: "_blank",
			rel: "noreferrer noopener",
			onClick: e.onDownloadLinkClick
		}, S)));
		case iD.INVALID:
		default: return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: x }, b), /* @__PURE__ */ t.createElement("span", { className: (0, H.default)(x, tD.invalid) }, a("timeline|m.file|error_invalid")));
	}
}
var cD = {
	pill: "_pill_1i8jm_8",
	label: "_label_1i8jm_14"
};
//#endregion
//#region src/core/pill-input/Pill/Pill.tsx
function lD({ className: e, children: n, label: r, onClick: i, ...a }) {
	let o = l(), { translate: s } = W();
	return /* @__PURE__ */ t.createElement(q, {
		display: "inline-flex",
		gap: "var(--cpd-space-1-5x)",
		align: "center",
		className: (0, H.default)(cD.pill, e),
		...a
	}, n, /* @__PURE__ */ t.createElement("span", {
		id: o,
		className: cD.label
	}, r), i && /* @__PURE__ */ t.createElement(S, {
		"aria-describedby": o,
		size: "16px",
		onClick: i,
		"aria-label": s("action|delete"),
		className: "mx_Dialog_nonDialogButton"
	}, /* @__PURE__ */ t.createElement(Gx, null)));
}
//#endregion
//#region ../../node_modules/react-merge-refs/dist/index.js
function uD(e) {
	return (t) => {
		for (let n of e) fD(n, t);
	};
}
function dD(e) {
	return (t) => {
		let n = [];
		for (let r of e) {
			let e = fD(r, t), i = typeof e == "function";
			n.push(i ? e : () => fD(r, null));
		}
		return () => {
			for (let e of n) e();
		};
	};
}
function fD(e, t) {
	if (typeof e == "function") return e(t);
	e && (e.current = t);
}
var pD = parseInt(m.split(".")[0], 10) >= 19 ? dD : uD;
function mD(e) {
	return u(() => pD(e), e);
}
var hD = {
	pillInput: "_pillInput_1yam9_8",
	input: "_input_1yam9_16",
	largerInput: "_largerInput_1yam9_32"
};
//#endregion
//#region src/core/pill-input/PillInput/PillInput.tsx
function gD({ className: e, children: r, onRemoveChildren: i, inputProps: a, ...o }) {
	let s = d(null), c = Uy(a, ["onKeyDown", "ref"]), l = mD([s, a?.ref]), u = n.toArray(r).length > 0;
	return /* @__PURE__ */ t.createElement(q, {
		...o,
		gap: "var(--cpd-space-1x)",
		direction: "column",
		className: (0, H.default)(hD.pillInput, e),
		onClick: (e) => {
			e.preventDefault(), e.stopPropagation(), s.current?.focus();
		}
	}, u && /* @__PURE__ */ t.createElement(q, {
		gap: "var(--cpd-space-1x)",
		wrap: "wrap",
		align: "center"
	}, r), /* @__PURE__ */ t.createElement("input", {
		ref: l,
		autoComplete: "off",
		className: (0, H.default)(hD.input, { [hD.largerInput]: u }),
		onKeyDown: (e) => {
			let t = e.currentTarget.value.trim();
			if (e.key === "Backspace" && !t) {
				e.preventDefault(), i?.(e);
				return;
			}
			a?.onKeyDown?.(e);
		},
		...c
	}));
}
var _D = {
	container: "_container_1xryk_8",
	secondaryAction: "_secondaryAction_1xryk_16",
	primaryAction: "_primaryAction_1xryk_20",
	title: "_title_1xryk_24",
	description: "_description_1xryk_28"
}, vD = {
	ConnectionLost: "ConnectionLost",
	NeedsConsent: "NeedsConsent",
	ResourceLimited: "ResourceLimited",
	UnsentMessages: "UnsentMessages",
	LocalRoomFailed: "LocalRoomFailed"
};
function yD({ vm: e }) {
	let { translate: n } = W(), r = Y(e), i = l(), a = o((t) => {
		t.preventDefault(), e.onDeleteAllClick?.();
	}, [e]), s = o((t) => {
		t.preventDefault(), e.onResendAllClick?.();
	}, [e]), c = o((t) => {
		t.preventDefault(), e.onRetryRoomCreationClick?.();
	}, [e]), u = o(() => {
		e.onTermsAndConditionsClicked?.();
	}, [e]);
	if (r.state === null) return null;
	switch (r.state) {
		case vD.ConnectionLost: return /* @__PURE__ */ t.createElement(zx, {
			type: "critical",
			role: "status",
			"aria-labelledby": i
		}, /* @__PURE__ */ t.createElement("div", { className: _D.container }, /* @__PURE__ */ t.createElement(O, {
			className: _D.title,
			id: i,
			weight: "medium"
		}, n("room|status_bar|server_connectivity_lost_title")), /* @__PURE__ */ t.createElement(O, { className: _D.description }, n("room|status_bar|server_connectivity_lost_description"))));
		case vD.NeedsConsent: return /* @__PURE__ */ t.createElement(zx, {
			type: "critical",
			role: "status",
			"aria-labelledby": i,
			actions: /* @__PURE__ */ t.createElement(g, {
				onClick: u,
				className: _D.primaryAction,
				kind: "primary",
				size: "sm",
				as: "a",
				href: r.consentUri,
				target: "_blank",
				rel: "noreferrer noopener"
			}, n("terms|tac_button"))
		}, /* @__PURE__ */ t.createElement("div", { className: _D.container }, /* @__PURE__ */ t.createElement(O, {
			className: _D.title,
			id: i,
			weight: "medium"
		}, n("room|status_bar|requires_consent_agreement_title"))));
		case vD.ResourceLimited: return /* @__PURE__ */ t.createElement(zx, {
			type: "critical",
			role: "status",
			"aria-labelledby": i,
			actions: r.adminContactHref && /* @__PURE__ */ t.createElement(g, {
				kind: "secondary",
				size: "sm",
				as: "a",
				href: r.adminContactHref,
				target: "_blank",
				rel: "noreferrer noopener"
			}, "Contact admin")
		}, /* @__PURE__ */ t.createElement("div", { className: _D.container }, /* @__PURE__ */ t.createElement(O, {
			className: _D.title,
			id: i,
			weight: "medium"
		}, {
			monthly_active_user: n("room|status_bar|monthly_user_limit_reached_title"),
			hs_disabled: n("room|status_bar|homeserver_blocked_title")
		}[r.resourceLimit] || n("room|status_bar|exceeded_resource_limit_title")), /* @__PURE__ */ t.createElement(O, { className: _D.description }, n("room|status_bar|exceeded_resource_limit_description"))));
		case vD.LocalRoomFailed: return /* @__PURE__ */ t.createElement(zx, {
			role: "status",
			type: "critical",
			"aria-labelledby": i,
			actions: /* @__PURE__ */ t.createElement(g, {
				size: "sm",
				kind: "primary",
				className: _D.primaryAction,
				Icon: ME,
				onClick: c
			}, n("action|retry"))
		}, /* @__PURE__ */ t.createElement(O, {
			className: _D.title,
			id: i,
			weight: "medium"
		}, n("room|status_bar|failed_to_create_room_title")));
		case vD.UnsentMessages: return /* @__PURE__ */ t.createElement(zx, {
			role: "status",
			type: "critical",
			actions: r.isResending ? /* @__PURE__ */ t.createElement(C, null) : /* @__PURE__ */ t.createElement(t.Fragment, null, e.onDeleteAllClick && /* @__PURE__ */ t.createElement(g, {
				size: "sm",
				kind: "secondary",
				Icon: HT,
				disabled: r.isResending,
				className: _D.secondaryAction,
				onClick: a
			}, n("room|status_bar|delete_all")), e.onResendAllClick && /* @__PURE__ */ t.createElement(g, {
				size: "sm",
				kind: "primary",
				Icon: ME,
				disabled: r.isResending,
				onClick: s,
				className: _D.primaryAction
			}, n("room|status_bar|retry_all"))),
			"aria-labelledby": i
		}, /* @__PURE__ */ t.createElement("div", { className: _D.container }, /* @__PURE__ */ t.createElement(O, {
			className: _D.title,
			id: i,
			weight: "medium"
		}, n("room|status_bar|some_messages_not_sent")), /* @__PURE__ */ t.createElement(O, { className: _D.description }, n("room|status_bar|select_messages_to_retry"))));
		default: return null;
	}
}
var bD = {
	container: "_container_19tks_8",
	header: "_header_19tks_22",
	roundedCornerContainer: "_roundedCornerContainer_19tks_30"
}, xD = ({ vm: e, RoomAvatar: n }) => {
	let r = Y(e), { translate: i } = W();
	return /* @__PURE__ */ t.createElement("div", {
		"data-testid": "widget-pip-container",
		className: bD.container,
		onMouseDown: e.onStartMoving
	}, /* @__PURE__ */ t.createElement("div", { className: bD.header }, /* @__PURE__ */ t.createElement(S, {
		size: "28px",
		"data-testid": "base-card-back-button",
		onClick: (t) => e.onBackClick(t),
		tooltip: i("action|back"),
		kind: "secondary"
	}, /* @__PURE__ */ t.createElement(IT, null)), /* @__PURE__ */ t.createElement(n, { size: "20px" }), r.roomName), /* @__PURE__ */ t.createElement("div", { className: bD.roundedCornerContainer }, /* @__PURE__ */ t.createElement(e.persistentAppComponent, {
		persistentWidgetId: r.widgetId,
		persistentRoomId: r.roomId
	})));
};
//#endregion
//#region src/room/HistoryVisibilityBadge/HistoryVisibilityBadge.tsx
function SD({ historyVisibility: e }) {
	let n = {
		color: "var(--cpd-color-icon-info-primary)",
		width: "1rem",
		height: "1rem"
	};
	switch (e) {
		case "invited":
		case "joined": return /* @__PURE__ */ t.createElement(h, { kind: "blue" }, /* @__PURE__ */ t.createElement(JE, n), J("room|history_visibility_badge|private"));
		case "shared": return /* @__PURE__ */ t.createElement(h, { kind: "blue" }, /* @__PURE__ */ t.createElement(iE, n), J("room|history_visibility_badge|shared"));
		case "world_readable": return /* @__PURE__ */ t.createElement(h, { kind: "blue" }, /* @__PURE__ */ t.createElement(HE, n), J("room|history_visibility_badge|world_readable"));
		default: return null;
	}
}
var CD = { content: "_content_5dcky_8" }, wD = { timelineSeparator: "_timelineSeparator_yq5ye_8" }, TD = ({ label: e, className: n, children: r, role: i = "separator" }) => /* @__PURE__ */ t.createElement(q, {
	className: (0, H.default)(n, wD.timelineSeparator),
	role: i,
	"aria-label": i === "separator" ? e : void 0,
	align: "center"
}, /* @__PURE__ */ t.createElement("hr", { role: "none" }), r, /* @__PURE__ */ t.createElement("hr", { role: "none" })), ED = 15e3, DD = 75e3, OD = 45, kD = 75, AD = 23, jD = 26;
function MD(e, t) {
	let n = Date.now() - e, r = Math.abs(Math.ceil(n / 6e4)), i = Math.ceil(r / 60), a = Math.ceil(i / 24), o = t?.translate ?? J;
	return n >= 0 ? n <= ED ? o("time|few_seconds_ago") : n <= DD ? o("time|about_minute_ago") : r <= OD ? o("time|n_minutes_ago", { num: r }) : r <= kD ? o("time|about_hour_ago") : i <= AD ? o("time|n_hours_ago", { num: i }) : i <= jD ? o("time|about_day_ago") : o("time|n_days_ago", { num: a }) : (n = Math.abs(n), n <= ED ? o("time|in_few_seconds") : n <= DD ? o("time|in_about_minute") : r <= OD ? o("time|in_n_minutes", { num: r }) : r <= kD ? o("time|in_about_hour") : i <= AD ? o("time|in_n_hours", { num: i }) : i <= jD ? o("time|in_about_day") : o("time|in_n_days", { num: a }));
}
function ND(e) {
	return new Intl.RelativeTimeFormat(e?.language, {
		style: "long",
		numeric: "auto"
	});
}
var PD = {
	picker_menu_item: "_picker_menu_item_1tj52_8",
	picker_form: "_picker_form_1tj52_12",
	picker_input: "_picker_input_1tj52_22",
	picker_input_date: "_picker_input_date_1tj52_28"
}, FD = ({ vm: e, inputRef: n, onSubmitted: r, onDismissed: i }) => {
	let a = Y(e), o = Cf(a.jumpFromDate ? new Date(a.jumpFromDate) : /* @__PURE__ */ new Date()), { translate: s } = W(), c = l(), [u, p] = f(o), m = d(null), h = n ?? m, g = d(null), _ = (e) => {
		e.key === "Tab" && (e.shiftKey ? i?.() : (e.preventDefault(), g.current?.focus()));
	}, v = (e) => {
		p(e.currentTarget.value);
	}, y = () => {
		e.onDatePicked?.(u), r?.();
	}, x = (e) => {
		e.preventDefault(), y();
	}, S = (e) => {
		e.key === "Tab" && (e.shiftKey ? (e.preventDefault(), h.current?.focus()) : i?.()), (e.key == "Enter" || e.key == " " || e.key == "Spacebar") && (e.preventDefault(), y());
	}, C = (e) => {
		e.preventDefault();
	};
	return /* @__PURE__ */ t.createElement(E, {
		as: "div",
		"data-testid": "jump-to-date-picker",
		label: s("room|jump_to_date"),
		onSelect: C,
		hideChevron: !0,
		className: PD.picker_menu_item
	}, /* @__PURE__ */ t.createElement(ne, {
		className: PD.picker_form,
		onSubmit: x
	}, /* @__PURE__ */ t.createElement(b, {
		name: "jump-to-date-field",
		className: PD.picker_input
	}, /* @__PURE__ */ t.createElement(ie, {
		ref: h,
		id: c,
		type: "date",
		"aria-label": s("room|jump_to_date_prompt"),
		onInput: v,
		onKeyDown: _,
		value: u,
		max: Cf(/* @__PURE__ */ new Date()),
		className: PD.picker_input_date
	})), /* @__PURE__ */ t.createElement(re, {
		ref: g,
		className: PD.picker_button,
		type: "submit",
		kind: "primary",
		size: "sm",
		onKeyDown: S
	}, s("action|go"))));
}, ID = {
	picker_menu: "_picker_menu_158c5_8",
	picker_menu_item: "_picker_menu_item_158c5_14",
	picker_separator: "_picker_separator_158c5_18"
}, LD = ({ vm: e, open: n, trigger: r, onOpenChange: i }) => {
	let a = W(), { translate: o } = W(), s = d(null), c = (e) => {
		e.key === "ArrowDown" && (e.preventDefault(), s.current?.focus());
	};
	return /* @__PURE__ */ t.createElement(T, {
		open: n,
		onOpenChange: (e) => {
			i?.(e);
		},
		title: o("room|jump_to_date"),
		showTitle: !1,
		trigger: r,
		align: "start",
		className: ID.picker_menu
	}, /* @__PURE__ */ t.createElement(E, {
		label: Hg(ND(a).format(-1, "week")),
		onSelect: () => e.onLastWeekPicked?.(),
		"data-testid": "jump-to-date-last-week",
		hideChevron: !0,
		className: ID.picker_menu_item
	}), /* @__PURE__ */ t.createElement(E, {
		label: Hg(ND(a).format(-1, "month")),
		onSelect: () => e.onLastMonthPicked?.(),
		"data-testid": "jump-to-date-last-month",
		hideChevron: !0,
		className: ID.picker_menu_item
	}), /* @__PURE__ */ t.createElement(E, {
		label: o("room|jump_to_date_beginning"),
		onSelect: () => e.onBeginningPicked?.(),
		"data-testid": "jump-to-date-beginning",
		hideChevron: !0,
		className: ID.picker_menu_item,
		onKeyDown: c
	}), /* @__PURE__ */ t.createElement(D, {
		decorative: !0,
		className: ID.picker_separator
	}), /* @__PURE__ */ t.createElement(FD, {
		vm: e,
		inputRef: s,
		onSubmitted: () => i?.(!1),
		onDismissed: () => i?.(!1)
	}));
};
//#endregion
//#region src/room/timeline/DateSeparatorView/DateSeparatorButton.tsx
function RD({ label: e, tooltipOpen: n, className: r, buttonRef: i, ...a }) {
	let { translate: o } = W();
	return /* @__PURE__ */ t.createElement(k, {
		description: o("room|jump_to_date"),
		placement: "right",
		open: n
	}, /* @__PURE__ */ t.createElement(q, {
		ref: i,
		"data-testid": "jump-to-date-separator-button",
		className: r,
		"aria-live": "off",
		"aria-label": o("room|jump_to_date"),
		role: "button",
		tabIndex: 0,
		...a
	}, /* @__PURE__ */ t.createElement("h2", { "aria-hidden": "true" }, e), /* @__PURE__ */ t.createElement(PT, null)));
}
//#endregion
//#region src/room/timeline/DateSeparatorView/DateSeparatorView.tsx
function zD({ vm: e, className: n }) {
	let { label: r, jumpToEnabled: i } = Y(e), [a, o] = f(!1), [s, c] = f(!1), [l, u] = f(!1);
	return i ? /* @__PURE__ */ t.createElement(TD, {
		label: r,
		className: (0, H.default)(n),
		role: "none"
	}, /* @__PURE__ */ t.createElement(LD, {
		vm: e,
		open: a,
		onOpenChange: (e) => {
			o(e), e && (c(!1), u(!1));
		},
		trigger: /* @__PURE__ */ t.createElement(RD, {
			label: r,
			tooltipOpen: !a && (s || l),
			className: CD.content,
			onMouseEnter: () => c(!0),
			onMouseLeave: () => c(!1),
			onFocus: (e) => u(e.currentTarget.matches(":focus-visible")),
			onBlur: () => u(!1)
		})
	})) : /* @__PURE__ */ t.createElement(TD, {
		label: r,
		className: (0, H.default)(n)
	}, /* @__PURE__ */ t.createElement(q, { className: CD.content }, /* @__PURE__ */ t.createElement("h2", { "aria-hidden": "true" }, r)));
}
var BD = {
	disambiguatedProfile: "_disambiguatedProfile_oa3at_8",
	disambiguatedProfile_displayName: "_disambiguatedProfile_displayName_oa3at_14",
	disambiguatedProfile_mxid: "_disambiguatedProfile_mxid_oa3at_22"
};
//#endregion
//#region src/room/timeline/event-tile/EventTileView/DisambiguatedProfile/DisambiguatedProfileView.tsx
function VD({ vm: e, className: n }) {
	let { displayName: r, colorClass: i, displayIdentifier: a, title: o, emphasizeDisplayName: s } = Y(e), c = (0, H.default)(i, {
		[BD.disambiguatedProfile_displayName]: s,
		mx_DisambiguatedProfile_displayName: s
	}), l = e.onClick ? (t) => {
		(t.key === "Enter" || t.key === " ") && (t.preventDefault(), e.onClick?.(t));
	} : void 0;
	return /* @__PURE__ */ t.createElement("div", {
		className: (0, H.default)(n, BD.disambiguatedProfile),
		title: o,
		onClick: e.onClick,
		onKeyDown: l,
		role: e.onClick ? "button" : void 0,
		tabIndex: e.onClick ? 0 : void 0
	}, /* @__PURE__ */ t.createElement("span", {
		className: c,
		dir: "auto"
	}, r), a && /* @__PURE__ */ t.createElement("span", { className: (0, H.default)("mx_DisambiguatedProfile_mxid", BD.disambiguatedProfile_mxid) }, a));
}
var HD = { content: "_content_m88ar_8" }, UD = {
	container: "_container_sq5fu_8",
	title: "_title_sq5fu_34",
	subtitle: "_subtitle_sq5fu_35"
};
//#endregion
//#region src/room/timeline/event-tile/EventTileView/EventTileBubble/EventTileBubble.tsx
function WD({ icon: e, title: n, subtitle: r, className: i, children: a, ref: o }) {
	return /* @__PURE__ */ t.createElement("div", {
		className: (0, H.default)(UD.container, i),
		ref: o
	}, e, /* @__PURE__ */ t.createElement("div", { className: UD.title }, n), r && /* @__PURE__ */ t.createElement("div", { className: UD.subtitle }, r), a);
}
//#endregion
//#region src/room/timeline/event-tile/EventTileView/EncryptionEventView/EncryptionEventView.tsx
var GD = /* @__PURE__ */ function(e) {
	return e.CHANGED = "CHANGED", e.DISABLE_ATTEMPT = "DISABLE_ATTEMPT", e.ENABLED = "ENABLED", e.ENABLED_DM = "ENABLED_DM", e.ENABLED_LOCAL = "ENABLED_LOCAL", e.UNSUPPORTED = "UNSUPPORTED", e;
}({});
function KD({ vm: e, ref: n, className: r }) {
	let { translate: i } = W(), { state: a, encryptedStateEvents: o, userName: s, timestamp: c } = Y(e), l = /* @__PURE__ */ t.createElement(fE, { "data-state": "supported" }), u = i(o ? "common|state_encryption_enabled" : "common|encryption_enabled"), d = "";
	switch (a) {
		case GD.CHANGED:
			d = i("timeline|m.room.encryption|parameters_changed");
			break;
		case GD.DISABLE_ATTEMPT:
			u = i("common|encryption_enabled"), d = i("timeline|m.room.encryption|disable_attempt");
			break;
		case GD.ENABLED:
			d = i(o ? "timeline|m.room.encryption|state_enabled" : "timeline|m.room.encryption|enabled");
			break;
		case GD.ENABLED_DM:
			d = i("timeline|m.room.encryption|enabled_dm", { displayName: s });
			break;
		case GD.ENABLED_LOCAL:
			d = i("timeline|m.room.encryption|enabled_local");
			break;
		case GD.UNSUPPORTED:
		default:
			l = /* @__PURE__ */ t.createElement(QT, { "data-state": "unsupported" }), u = i("timeline|m.room.encryption|disabled"), d = i("timeline|m.room.encryption|unsupported");
			break;
	}
	return /* @__PURE__ */ t.createElement(WD, {
		icon: l,
		className: (0, H.default)(r, HD.content),
		title: u,
		subtitle: d,
		ref: n
	}, c);
}
var qD = { pinnedMessageBadge: "_pinnedMessageBadge_10mi2_8" };
//#endregion
//#region src/room/timeline/event-tile/EventTileView/PinnedMessageBadge/PinnedMessageBadge.tsx
function JD({ className: e, children: n, ...r }) {
	return /* @__PURE__ */ t.createElement("div", {
		...r,
		className: (0, H.default)(qD.pinnedMessageBadge, e)
	}, /* @__PURE__ */ t.createElement(EE, {
		width: "16px",
		height: "16px"
	}), n ?? J("room|pinned_message_badge"));
}
//#endregion
//#region src/room/timeline/event-tile/EventTileView/TextualEventView/TextualEventView.tsx
function YD({ vm: e }) {
	let n = Y(e);
	return /* @__PURE__ */ t.createElement("div", { className: "mx_TextualEvent" }, n.content);
}
var XD = {
	audioPlayer: "_audioPlayer_1eyxr_8",
	mediaInfo: "_mediaInfo_1eyxr_13",
	mediaName: "_mediaName_1eyxr_18",
	byline: "_byline_1eyxr_27",
	clock: "_clock_1eyxr_31",
	error: "_error_1eyxr_35"
};
//#endregion
//#region src/core/utils/FormattingUtils.ts
function ZD(e, t = 2) {
	if (e === 0) return "0 Bytes";
	let n = 1024, r = t < 0 ? 0 : t, i = [
		"Bytes",
		"KB",
		"MB",
		"GB",
		"TB",
		"PB",
		"EB",
		"ZB",
		"YB"
	], a = Math.floor(Math.log(e) / Math.log(n));
	return parseFloat((e / n ** +a).toFixed(r)) + " " + i[a];
}
//#endregion
//#region src/room/timeline/event-tile/body/AudioPlayerView/AudioPlayerView.tsx
function QD({ vm: e }) {
	let { translate: n } = W(), { playbackState: r, mediaName: i = n("timeline|m.audio|unnamed_audio"), sizeBytes: a, durationSeconds: o, playedSeconds: s, percentComplete: c, error: l } = Y(e), u = a ? `(${ZD(a)})` : null, d = r === "decoding";
	return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(rD, {
		className: XD.audioPlayer,
		tabIndex: 0,
		onKeyDown: e.onKeyDown,
		"aria-label": n("timeline|m.audio|audio_player"),
		role: "region"
	}, /* @__PURE__ */ t.createElement(q, {
		gap: "var(--cpd-space-2x)",
		align: "center"
	}, /* @__PURE__ */ t.createElement(Ff, {
		tabIndex: -1,
		disabled: d,
		playing: r === "playing",
		togglePlay: e.togglePlay
	}), /* @__PURE__ */ t.createElement(q, {
		direction: "column",
		className: XD.mediaInfo
	}, /* @__PURE__ */ t.createElement("span", {
		className: XD.mediaName,
		"data-testid": "audio-player-name"
	}, i), /* @__PURE__ */ t.createElement(q, {
		className: XD.byline,
		gap: "var(--cpd-space-1-5x)"
	}, /* @__PURE__ */ t.createElement(wf, { seconds: o }), u))), /* @__PURE__ */ t.createElement(q, {
		align: "center",
		gap: "var(--cpd-space-1x)",
		"data-testid": "audio-player-seek"
	}, /* @__PURE__ */ t.createElement(qy, {
		tabIndex: -1,
		disabled: d,
		value: c,
		onChange: e.onSeekbarChange
	}), /* @__PURE__ */ t.createElement(wf, {
		className: XD.clock,
		seconds: s,
		role: "timer"
	}))), l && /* @__PURE__ */ t.createElement("span", { className: XD.error }, n("timeline|m.audio|error_downloading_audio")));
}
var $D = {
	content: "_content_1uqu1_8",
	error: "_error_1uqu1_14",
	icon: "_icon_1uqu1_23"
}, eO = /* @__PURE__ */ function(e) {
	return e.MEGOLM_KEY_WITHHELD_FOR_UNVERIFIED_DEVICE = "MEGOLM_KEY_WITHHELD_FOR_UNVERIFIED_DEVICE", e.HISTORICAL_MESSAGE_NO_KEY_BACKUP = "HISTORICAL_MESSAGE_NO_KEY_BACKUP", e.HISTORICAL_MESSAGE_BACKUP_UNCONFIGURED = "HISTORICAL_MESSAGE_BACKUP_UNCONFIGURED", e.HISTORICAL_MESSAGE_USER_NOT_JOINED = "HISTORICAL_MESSAGE_USER_NOT_JOINED", e.SENDER_IDENTITY_PREVIOUSLY_VERIFIED = "SENDER_IDENTITY_PREVIOUSLY_VERIFIED", e.UNSIGNED_SENDER_DEVICE = "UNSIGNED_SENDER_DEVICE", e.UNABLE_TO_DECRYPT = "UNABLE_TO_DECRYPT", e;
}({});
function tO(e, n, r) {
	let i = e.translate;
	switch (n) {
		case eO.MEGOLM_KEY_WITHHELD_FOR_UNVERIFIED_DEVICE: return i("timeline|decryption_failure|blocked");
		case eO.HISTORICAL_MESSAGE_NO_KEY_BACKUP: return i("timeline|decryption_failure|historical_event_no_key_backup");
		case eO.HISTORICAL_MESSAGE_BACKUP_UNCONFIGURED:
			if (r === !1) return i("timeline|decryption_failure|historical_event_unverified_device");
			break;
		case eO.HISTORICAL_MESSAGE_USER_NOT_JOINED: return i("timeline|decryption_failure|historical_event_user_not_joined");
		case eO.SENDER_IDENTITY_PREVIOUSLY_VERIFIED: return /* @__PURE__ */ t.createElement("span", null, /* @__PURE__ */ t.createElement(OT, {
			className: $D.icon,
			width: "16px",
			height: "16px"
		}), i("timeline|decryption_failure|sender_identity_previously_verified"));
		case eO.UNSIGNED_SENDER_DEVICE: return /* @__PURE__ */ t.createElement("span", null, /* @__PURE__ */ t.createElement(OT, {
			className: $D.icon,
			width: "16px",
			height: "16px"
		}), i("timeline|decryption_failure|sender_unsigned_device"));
	}
	return i("timeline|decryption_failure|unable_to_decrypt");
}
function nO(e) {
	switch (e) {
		case eO.SENDER_IDENTITY_PREVIOUSLY_VERIFIED:
		case eO.UNSIGNED_SENDER_DEVICE: return $D.error;
	}
	return null;
}
function rO({ vm: e, ref: n, className: r }) {
	let i = W(), { decryptionFailureReason: a, isLocalDeviceVerified: o } = Y(e), s = (0, H.default)($D.content, nO(a), r);
	return /* @__PURE__ */ t.createElement("div", {
		className: s,
		ref: n
	}, tO(i, a, o));
}
var iO = {
	reactionsRow: "_reactionsRow_1lcz2_8",
	showAllButton: "_showAllButton_1lcz2_16",
	addReactionButton: "_addReactionButton_1lcz2_29",
	addReactionButtonVisible: "_addReactionButtonVisible_1lcz2_48",
	addReactionButtonActive: "_addReactionButtonActive_1lcz2_52",
	addReactionButtonDisabled: "_addReactionButtonDisabled_1lcz2_56"
};
//#endregion
//#region src/room/timeline/event-tile/reactions/ReactionsRow/ReactionsRowView.tsx
function aO({ vm: e, className: n, children: r }) {
	let { ariaLabel: i, isVisible: a, showAllButtonVisible: o, showAllButtonLabel: s, showAddReactionButton: c, addReactionButtonLabel: l, addReactionButtonVisible: u, addReactionButtonActive: d, addReactionButtonDisabled: f } = Y(e);
	if (!a) return /* @__PURE__ */ t.createElement(t.Fragment, null);
	let p = (0, H.default)(iO.addReactionButton, {
		[iO.addReactionButtonVisible]: u,
		[iO.addReactionButtonActive]: d,
		[iO.addReactionButtonDisabled]: f
	}), m = e.onAddReactionContextMenu ? (t) => {
		t.preventDefault(), e.onAddReactionContextMenu?.(t);
	} : void 0, h = /* @__PURE__ */ t.createElement("button", {
		type: "button",
		className: p,
		"aria-label": l,
		disabled: f,
		onClick: e.onAddReactionClick,
		onContextMenu: m
	}, /* @__PURE__ */ t.createElement(AE, null));
	return /* @__PURE__ */ t.createElement("div", {
		className: (0, H.default)(n, iO.reactionsRow),
		role: "toolbar",
		"aria-label": i
	}, r, o && /* @__PURE__ */ t.createElement("button", {
		type: "button",
		className: iO.showAllButton,
		onClick: e.onShowAllClick
	}, s), c && /* @__PURE__ */ t.createElement(k, {
		description: l,
		placement: "right"
	}, h));
}
//#endregion
//#region src/room/timeline/event-tile/reactions/ReactionsRowButtonTooltip/ReactionsRowButtonTooltipView.tsx
function oO({ vm: e, children: n }) {
	let { formattedSenders: r, caption: i, tooltipOpen: a } = Y(e);
	return r ? /* @__PURE__ */ t.createElement(k, {
		description: r,
		caption: i,
		placement: "right",
		open: a
	}, n) : /* @__PURE__ */ t.createElement(t.Fragment, null, n);
}
var sO = {
	reactionsRowButton: "_reactionsRowButton_5v4c1_8",
	reactionsRowButtonSelected: "_reactionsRowButtonSelected_5v4c1_21",
	reactionsRowButtonDisabled: "_reactionsRowButtonDisabled_5v4c1_26",
	reactionsRowButtonContent: "_reactionsRowButtonContent_5v4c1_30",
	reactionsRowButtonCount: "_reactionsRowButtonCount_5v4c1_38"
};
//#endregion
//#region src/room/timeline/event-tile/reactions/ReactionsRowButton/ReactionsRowButtonView.tsx
function cO({ vm: e }) {
	let n = Y(e), { content: r, count: i, className: a, isSelected: o, isDisabled: s, imageSrc: c, imageAlt: l, tooltipVm: u } = n, d = n["aria-label"] ?? n.ariaLabel, f = s ? !0 : void 0, p = (0, H.default)(a, sO.reactionsRowButton, {
		[sO.reactionsRowButtonSelected]: o,
		[sO.reactionsRowButtonDisabled]: s
	}), m = c ? /* @__PURE__ */ t.createElement("img", {
		className: sO.reactionsRowButtonContent,
		alt: l ?? "",
		src: c,
		width: "16",
		height: "16"
	}) : /* @__PURE__ */ t.createElement("span", {
		className: sO.reactionsRowButtonContent,
		"aria-hidden": "true"
	}, r ?? "");
	return /* @__PURE__ */ t.createElement(oO, { vm: u }, /* @__PURE__ */ t.createElement("button", {
		type: "button",
		className: p,
		tabIndex: 0,
		"aria-label": d,
		"aria-disabled": f,
		onClick: s ? void 0 : e.onClick
	}, m, /* @__PURE__ */ t.createElement("span", {
		className: sO.reactionsRowButtonCount,
		"aria-hidden": "true"
	}, i)));
}
var lO = { content: "_content_kc5mt_8" };
//#endregion
//#region src/room/timeline/event-tile/timestamp/MessageTimestampView/MessageTimestampView.tsx
function uO({ vm: e, className: n }) {
	let { translate: r } = W(), { ts: i, tsSentAt: a, tsReceivedAt: o, inhibitTooltip: s, href: c } = Y(e), l = (t) => {
		e.onClick && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), e.onClick?.(t));
	}, u = a, d;
	o && o?.length > 0 && (u = r("timeline|message_timestamp_sent_at", { dateTime: u }), d = r("timeline|message_timestamp_received_at", { dateTime: o }));
	let f;
	return f = c ? /* @__PURE__ */ t.createElement("a", {
		href: c,
		onClick: e.onClick,
		onKeyDown: l,
		onContextMenu: e.onContextMenu,
		className: (0, H.default)(n, lO.content),
		"aria-live": "off"
	}, i) : /* @__PURE__ */ t.createElement("span", {
		onClick: e.onClick,
		onKeyDown: l,
		onContextMenu: e.onContextMenu,
		className: (0, H.default)(n, lO.content),
		role: e.onClick ? "link" : void 0,
		"aria-live": "off",
		tabIndex: e.onClick || !s ? 0 : void 0
	}, i), s ? f : /* @__PURE__ */ t.createElement(k, {
		description: u,
		caption: d
	}, f);
}
var dO = {
	richItem: "_richItem_1c0uo_8",
	avatar: "_avatar_1c0uo_36",
	title: "_title_1c0uo_41",
	description: "_description_1c0uo_47",
	timestamp: "_timestamp_1c0uo_51",
	checkmark: "_checkmark_1c0uo_69"
}, fO = a(function({ avatar: e, title: n, description: r, timestamp: i, selected: a, ...o }) {
	let s = W();
	return /* @__PURE__ */ t.createElement("li", {
		className: dO.richItem,
		role: "option",
		tabIndex: -1,
		"aria-selected": a,
		"aria-label": n,
		...o
	}, a ? /* @__PURE__ */ t.createElement(pO, null) : /* @__PURE__ */ t.createElement(q, { className: dO.avatar }, e), /* @__PURE__ */ t.createElement("span", { className: dO.title }, n), /* @__PURE__ */ t.createElement("span", { className: dO.description }, r), i && /* @__PURE__ */ t.createElement("span", {
		role: "timer",
		className: dO.timestamp
	}, s.humanizeTime(i)));
});
function pO() {
	return /* @__PURE__ */ t.createElement(q, {
		align: "center",
		justify: "center",
		"aria-hidden": "true",
		className: dO.checkmark
	}, /* @__PURE__ */ t.createElement(MT, {
		width: "24px",
		height: "24px",
		color: "var(--cpd-color-icon-on-solid-primary)"
	}));
}
var mO = {
	richList: "_richList_1mcas_8",
	title: "_title_1mcas_12",
	content: "_content_1mcas_18",
	empty: "_empty_1mcas_26"
};
//#endregion
//#region src/core/hooks/useListKeyboardNavigation.ts
function hO() {
	let e = d(null), t = o((t) => {
		if (e.current && t.target === e.current) {
			let t = e.current?.firstElementChild;
			for (let n of e.current.children) if (n.getAttribute("aria-selected") === "true") {
				t = n;
				break;
			}
			t?.focus();
		}
	}, []);
	return {
		listRef: e,
		onKeyDown: o((t) => {
			let { key: n } = t, r = !1;
			switch (n) {
				case "Enter":
				case " ":
					r = !0, document.activeElement.click();
					break;
				case "ArrowDown": {
					r = !0;
					let t = document.activeElement;
					e.current?.contains(t) && t && t.nextElementSibling?.focus();
					break;
				}
				case "ArrowUp": {
					r = !0;
					let t = document.activeElement;
					e.current?.contains(t) && t && t.previousElementSibling?.focus();
					break;
				}
				case "Home":
					r = !0, (e.current?.firstElementChild)?.focus();
					break;
				case "End":
					r = !0, (e.current?.lastElementChild)?.focus();
					break;
			}
			r && t.preventDefault();
		}, []),
		onFocus: t
	};
}
//#endregion
//#region src/core/rich-list/RichList/RichList.tsx
function gO({ children: e, title: n, className: r, titleAttributes: i, isEmpty: a = !1, ...o }) {
	let s = l(), { listRef: c, onKeyDown: u, onFocus: d } = hO();
	return /* @__PURE__ */ t.createElement(q, {
		className: (0, H.default)(mO.richList, r),
		direction: "column",
		...o
	}, /* @__PURE__ */ t.createElement("span", {
		id: s,
		className: mO.title,
		...i
	}, n), a ? /* @__PURE__ */ t.createElement("span", { className: mO.empty }, e) : /* @__PURE__ */ t.createElement("ul", {
		ref: c,
		role: "listbox",
		className: mO.content,
		"aria-labelledby": s,
		tabIndex: 0,
		onKeyDown: u,
		onFocus: d
	}, e));
}
var _O = { title: "_title_1qyi3_8" };
//#endregion
//#region src/room-list/RoomListHeaderView/menu/OptionMenuView.tsx
function vO({ vm: e }) {
	let { translate: n } = W(), [r, i] = f(!1), { activeSortOption: a, isMessagePreviewEnabled: o } = Y(e);
	return /* @__PURE__ */ t.createElement(T, {
		open: r,
		onOpenChange: i,
		title: n("room_list|room_options"),
		showTitle: !1,
		align: "start",
		trigger: /* @__PURE__ */ t.createElement(S, {
			tooltip: n("room_list|room_options"),
			"aria-label": n("room_list|room_options"),
			size: "28px",
			style: { padding: "4px" }
		}, /* @__PURE__ */ t.createElement(wE, null))
	}, /* @__PURE__ */ t.createElement(ee, {
		title: n("room_list|sort"),
		className: _O.title
	}), /* @__PURE__ */ t.createElement(te, {
		label: n("room_list|sort_type|activity"),
		checked: a === "recent",
		onSelect: () => e.sort("recent")
	}), /* @__PURE__ */ t.createElement(te, {
		label: n("room_list|sort_type|unread_first"),
		checked: a === "unread-first",
		onSelect: () => e.sort("unread-first")
	}), /* @__PURE__ */ t.createElement(te, {
		label: n("room_list|sort_type|atoz"),
		checked: a === "alphabetical",
		onSelect: () => e.sort("alphabetical")
	}), /* @__PURE__ */ t.createElement(ee, { title: n("room_list|appearance") }), /* @__PURE__ */ t.createElement(v, {
		label: n("room_list|show_message_previews"),
		onSelect: e.toggleMessagePreview,
		checked: o
	}));
}
var yO = { button: "_button_1veqf_8" };
//#endregion
//#region src/room-list/RoomListHeaderView/menu/SpaceMenuView.tsx
function bO({ vm: e }) {
	let { translate: n } = W(), { canInviteInSpace: r, canAccessSpaceSettings: i, title: a } = Y(e), [o, s] = f(!1);
	return /* @__PURE__ */ t.createElement(T, {
		open: o,
		onOpenChange: s,
		title: a,
		align: "start",
		trigger: /* @__PURE__ */ t.createElement(S, {
			className: yO.button,
			"aria-label": n("room_list|open_space_menu"),
			size: "24px",
			style: { padding: "2px" }
		}, /* @__PURE__ */ t.createElement(PT, null))
	}, /* @__PURE__ */ t.createElement(E, {
		Icon: oE,
		label: n("room_list|space_menu|home"),
		onSelect: e.openSpaceHome,
		hideChevron: !0
	}), r && /* @__PURE__ */ t.createElement(E, {
		Icon: BE,
		label: n("action|invite"),
		onSelect: e.inviteInSpace,
		hideChevron: !0
	}), /* @__PURE__ */ t.createElement(E, {
		Icon: OE,
		label: n("common|preferences"),
		onSelect: e.openSpacePreferences,
		hideChevron: !0
	}), i && /* @__PURE__ */ t.createElement(E, {
		Icon: RE,
		label: n("room_list|space_menu|space_settings"),
		onSelect: e.openSpaceSettings,
		hideChevron: !0
	}));
}
//#endregion
//#region src/room-list/RoomListHeaderView/menu/ComposeMenuView.tsx
function xO({ vm: e }) {
	let { translate: n } = W(), [r, i] = f(!1), { canCreateRoom: a, canCreateVideoRoom: o } = Y(e);
	return /* @__PURE__ */ t.createElement(T, {
		open: r,
		onOpenChange: i,
		showTitle: !1,
		title: n("action|open_menu"),
		align: "start",
		trigger: /* @__PURE__ */ t.createElement(S, {
			size: "28px",
			style: { padding: "4px" },
			tooltip: n("action|new_conversation")
		}, /* @__PURE__ */ t.createElement(BT, { "aria-hidden": !0 }))
	}, /* @__PURE__ */ t.createElement(E, {
		Icon: AT,
		label: n("action|start_chat"),
		onSelect: e.createChatRoom,
		hideChevron: !0
	}), a && /* @__PURE__ */ t.createElement(E, {
		Icon: PE,
		label: n("action|new_room"),
		onSelect: e.createRoom,
		hideChevron: !0
	}), o && /* @__PURE__ */ t.createElement(E, {
		Icon: KE,
		label: n("action|new_video_room"),
		onSelect: e.createVideoRoom,
		hideChevron: !0
	}));
}
var SO = {
	header: "_header_18yeb_8",
	container: "_container_18yeb_13",
	title: "_title_18yeb_19"
};
//#endregion
//#region src/room-list/RoomListHeaderView/RoomListHeaderView.tsx
function CO({ vm: e }) {
	let { translate: n } = W(), { title: r, displaySpaceMenu: i, displayComposeMenu: a } = Y(e);
	return /* @__PURE__ */ t.createElement(q, {
		as: "header",
		className: SO.header,
		"aria-label": n("room|context_menu|title"),
		align: "end",
		"data-testid": "room-list-header"
	}, /* @__PURE__ */ t.createElement(q, {
		className: SO.container,
		justify: "space-between",
		align: "center",
		gap: "var(--cpd-space-3x)"
	}, /* @__PURE__ */ t.createElement(q, {
		className: SO.title,
		align: "center",
		gap: "var(--cpd-space-1x)"
	}, /* @__PURE__ */ t.createElement(x, {
		size: "sm",
		title: r
	}, r), i && /* @__PURE__ */ t.createElement(bO, { vm: e })), /* @__PURE__ */ t.createElement(q, {
		align: "center",
		gap: "var(--cpd-space-2x)"
	}, /* @__PURE__ */ t.createElement(vO, { vm: e }), a ? /* @__PURE__ */ t.createElement(xO, { vm: e }) : /* @__PURE__ */ t.createElement(S, {
		size: "28px",
		style: { padding: "4px" },
		onClick: (t) => e.createChatRoom(t.nativeEvent),
		tooltip: n("action|new_conversation")
	}, /* @__PURE__ */ t.createElement(BT, {
		color: "var(--cpd-color-icon-secondary)",
		"aria-hidden": !0
	})))));
}
var wO = {
	view: "_view_z7ks9_8",
	search: "_search_z7ks9_16",
	search_container: "_search_container_z7ks9_29",
	search_text: "_search_text_z7ks9_41"
};
//#endregion
//#region src/room-list/RoomListSearchView/RoomListSearchView.tsx
function TO({ vm: e }) {
	let { translate: n } = W(), { displayExploreButton: r, displayDialButton: i, searchShortcut: a } = Y(e);
	return /* @__PURE__ */ t.createElement(q, {
		"data-testid": "room-list-search",
		className: wO.view,
		role: "search",
		gap: "var(--cpd-space-2x)",
		align: "center"
	}, /* @__PURE__ */ t.createElement(g, {
		id: "room-list-search-button",
		className: wO.search,
		kind: "secondary",
		size: "sm",
		Icon: IE,
		onClick: e.onSearchClick
	}, /* @__PURE__ */ t.createElement(q, {
		className: wO.search_container,
		as: "span",
		justify: "space-between"
	}, /* @__PURE__ */ t.createElement("span", { className: wO.search_text }, n("action|search")), /* @__PURE__ */ t.createElement("kbd", null, a))), i && /* @__PURE__ */ t.createElement(g, {
		kind: "secondary",
		size: "sm",
		Icon: WT,
		iconOnly: !0,
		"aria-label": n("left_panel|open_dial_pad"),
		onClick: e.onDialPadClick
	}), r && /* @__PURE__ */ t.createElement(g, {
		kind: "secondary",
		size: "sm",
		Icon: eE,
		iconOnly: !0,
		"aria-label": n("action|explore_rooms"),
		onClick: e.onExploreClick
	}));
}
var EO = {
	header: "_header_11ed4_8",
	container: "_container_11ed4_29",
	title: "_title_11ed4_61",
	firstHeader: "_firstHeader_11ed4_68",
	lastHeader: "_lastHeader_11ed4_72"
}, DO = {
	ARROW_UP: "ArrowUp",
	ARROW_DOWN: "ArrowDown",
	HOME: "Home",
	END: "End",
	PAGE_UP: "PageUp",
	PAGE_DOWN: "PageDown",
	ENTER: "Enter",
	SPACE: "Space"
};
function OO(e) {
	return e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;
}
function kO(e) {
	let { items: t, isItemFocusable: n, getItemKey: r, context: i, onKeyDown: a, totalCount: s, rangeChanged: l, mapScrollIndex: p, mapRangeIndex: m, ...h } = e, g = d(null), _ = d(null), [v, y] = f(e.items[0] ? r(e.items[0]) : void 0), [b, x] = f(void 0), S = u(() => {
		let e = /* @__PURE__ */ new Map();
		return t.forEach((t, n) => e.set(r(t), n)), e;
	}, [t, r]), [C, w] = f(!1);
	c(() => {
		t.length && (!v || S.get(v) === void 0) && y(r(t[0]));
	}, [
		t,
		r,
		v,
		S
	]);
	let T = o((e, n) => {
		let i = Math.max(0, Math.min(e, t.length - 1));
		if (t[i]) {
			y(r(t[i]));
			let e = p ? p(i) : i;
			g.current?.scrollIntoView({
				index: e,
				align: n,
				behavior: "auto"
			});
		}
	}, [
		t,
		r,
		p
	]), E = o((e, r, i) => {
		let a = t.length, o;
		for (let i = e; r ? i < a : i >= 0; i += r ? 1 : -1) if (n(t[i])) {
			o = i;
			break;
		}
		o !== void 0 && T(o, i);
	}, [
		T,
		t,
		n
	]), ee = o((e) => {
		let n = v ? S.get(v) : void 0, r = !1;
		if (!e || OO(e)) {
			a?.(e);
			return;
		}
		if (e.code === DO.ARROW_UP && n !== void 0) E(n - 1, !1), r = !0;
		else if (e.code === DO.ARROW_DOWN && n !== void 0) E(n + 1, !0), r = !0;
		else if (e.code === DO.HOME) T(0), r = !0;
		else if (e.code === DO.END) T(t.length - 1), r = !0;
		else if (e.code === DO.PAGE_DOWN && b && n !== void 0) {
			let e = b.endIndex - b.startIndex;
			E(Math.min(n + e, t.length - 1), !0, "start"), r = !0;
		} else if (e.code === DO.PAGE_UP && b && n !== void 0) {
			let e = b.endIndex - b.startIndex;
			E(Math.max(n - e, 0), !1, "start"), r = !0;
		}
		if (r) {
			if (_.current instanceof HTMLElement) {
				let e = document.activeElement;
				e && e !== _.current && _.current.contains(e) && _.current.focus({ preventScroll: !0 });
			}
			e.stopPropagation(), e.preventDefault();
		} else a?.(e);
	}, [
		T,
		E,
		v,
		S,
		b,
		t,
		a
	]), te = o((e) => {
		_.current = e;
	}, []), ne = o((e, t) => {
		let n = r(e);
		w(!0), y(n), t.stopPropagation();
	}, [r]), D = o((e) => {
		if (e?.currentTarget !== _.current || typeof v != "string") return;
		w(!0);
		let t = S.get(v);
		t !== void 0 && b && (t < b.startIndex || t > b.endIndex) && T(t), e.stopPropagation(), e.preventDefault();
	}, [
		S,
		b,
		T,
		v
	]), re = o((e) => {
		e.currentTarget.contains(e.relatedTarget) || w(!1);
	}, []), O = u(() => ({
		tabIndexKey: v,
		focused: C,
		context: e.context || {}
	}), [
		v,
		C,
		e.context
	]), ie = o((e) => {
		x(m ? {
			startIndex: m(e.startIndex),
			endIndex: m(e.endIndex)
		} : e), l?.(e);
	}, [l, m]);
	return {
		...h,
		ref: g,
		scrollerRef: te,
		onKeyDown: ee,
		onFocus: D,
		onBlur: re,
		rangeChanged: ie,
		onFocusForGetItemComponent: ne,
		context: O
	};
}
//#endregion
//#region src/core/VirtualizedList/FlatVirtualizedList/FlatVirtualizedList.tsx
function AO(e) {
	let { getItemComponent: n, ...r } = e, { onFocusForGetItemComponent: i, ...a } = kO(r), s = o((e, t, r) => n(e, t, r, i), [n, i]);
	return /* @__PURE__ */ t.createElement(ce, {
		itemContent: s,
		data: e.items,
		...a
	});
}
//#endregion
//#region src/core/VirtualizedList/GroupedVirtualizedList/GroupedVirtualizedList.tsx
function jO(e) {
	let { getItemComponent: n, groups: r, getGroupHeaderComponent: i, isItemFocusable: a, isGroupHeaderFocusable: s, getItemKey: c, getHeaderKey: l, ...d } = e, f = u(() => r.flatMap((e) => [{ header: e.header }, ...e.items.map((e) => ({ item: e }))]), [r]), p = u(() => r.flatMap((e, t) => Array(1 + e.items.length).fill(t)), [r]), m = o((e) => "header" in e ? l(e.header) : c(e.item), [l, c]), h = o((e) => "header" in e ? s(e.header) : a(e.item), [s, a]), { onFocusForGetItemComponent: g, ..._ } = kO({
		...d,
		items: f,
		isItemFocusable: h,
		getItemKey: m
	}), v = o((e, t) => {
		g({ item: e }, t);
	}, [g]), y = o((e, t) => {
		g({ header: e }, t);
	}, [g]), b = o((e, t, r) => {
		let a = f[e], o = p[e];
		return "header" in a ? i(o, a.header, r, y) : n(e - (o + 1), a.item, r, v, o);
	}, [
		f,
		p,
		i,
		n,
		v,
		y
	]);
	return /* @__PURE__ */ t.createElement(ce, {
		itemContent: b,
		data: f,
		..._
	});
}
//#endregion
//#region src/core/VirtualizedList/accessbility.ts
function MO(e, t) {
	switch (e) {
		case "listbox": return { role: "listbox" };
		case "treegrid": return {
			role: "treegrid",
			"aria-rowcount": t
		};
	}
}
function NO(e, t, n) {
	switch (e) {
		case "listbox": return {
			role: "option",
			"aria-posinset": t + 1,
			"aria-setsize": n
		};
		case "treegrid": return {
			role: "row",
			"aria-level": 2,
			"aria-rowindex": t + 1,
			"aria-posinset": n + 1
		};
	}
}
function PO(e, t, n) {
	return {
		role: "row",
		"aria-level": 1,
		"aria-posinset": t + 1,
		"aria-rowindex": e + 1,
		"aria-setsize": n
	};
}
//#endregion
//#region src/room-list/RoomListSectionHeaderView/RoomListSectionHeaderView.tsx
var FO = a(function({ vm: e, isFocused: n, onFocus: r, indexInList: i, sectionIndex: a, sectionCount: o, roomCountInSection: s }) {
	let { translate: c } = W(), { id: l, title: u, isExpanded: d } = Y(e), f = a === o - 1;
	return /* @__PURE__ */ t.createElement("div", {
		"aria-expanded": d,
		...PO(i, a, s)
	}, /* @__PURE__ */ t.createElement("button", {
		type: "button",
		role: "gridcell",
		className: (0, H.default)(EO.header, {
			[EO.firstHeader]: a === 0,
			[EO.lastHeader]: !d && f
		}),
		onClick: e.onClick,
		"aria-expanded": d,
		onFocus: (e) => r(l, e),
		tabIndex: n ? 0 : -1,
		"aria-label": c("room_list|section_header|toggle", { section: u })
	}, /* @__PURE__ */ t.createElement(q, {
		className: EO.container,
		align: "center",
		gap: "var(--cpd-space-0-5x)"
	}, /* @__PURE__ */ t.createElement(RT, {
		width: "24px",
		height: "24px",
		fill: "var(--cpd-color-icon-secondary)"
	}), /* @__PURE__ */ t.createElement("span", { className: EO.title }, u))));
});
//#endregion
//#region src/room-list/RoomListPrimaryFilters/useCollapseFilters.ts
function IO(e, t) {
	let n = d(null), [r, i] = f(!1), [a, o] = f(-1);
	return c(() => {
		if (!n.current) return;
		let r = (n) => {
			let r = !1;
			Array.from(n.children).forEach((n, i) => {
				let a = n;
				if (a.setAttribute("aria-hidden", "false"), a.classList.remove(t), e) return;
				let s = a.previousElementSibling;
				s && a.offsetLeft <= s.offsetLeft && (r || o(i), r = !0), a.classList.toggle(t, r), a.setAttribute("aria-hidden", r.toString());
			}), r || o(-1), i(e || r);
		};
		r(n.current);
		let a = new ResizeObserver((e) => e.forEach((e) => r(e.target)));
		return a.observe(n.current), () => {
			a.disconnect();
		};
	}, [e, t]), {
		ref: n,
		isWrapping: r,
		wrappingIndex: a
	};
}
//#endregion
//#region src/room-list/RoomListPrimaryFilters/useVisibleFilters.ts
function LO(e, t, n) {
	let [r, i] = f(e);
	return c(() => {
		if (!((t ? e.indexOf(t) : -1) >= n) || n === -1) {
			i(e);
			return;
		}
		i(e.slice().sort((e, n) => e === t && n !== t ? -1 : e !== t && n === t ? 1 : 0));
	}, [
		e,
		t,
		n
	]), r;
}
var RO = {
	roomListPrimaryFilters: "_roomListPrimaryFilters_1dmi7_8",
	list: "_list_1dmi7_17",
	iconButton: "_iconButton_1dmi7_26"
}, zO = (e) => {
	switch (e) {
		case "unread": return J("room_list|filters|unread");
		case "people": return J("room_list|filters|people");
		case "rooms": return J("room_list|filters|rooms");
		case "favourite": return J("room_list|filters|favourite");
		case "mentions": return J("room_list|filters|mentions");
		case "invites": return J("room_list|filters|invites");
		case "low_priority": return J("room_list|filters|low_priority");
	}
}, BO = a(function({ filterIds: e, activeFilterId: n, onToggleFilter: r }) {
	let i = l(), [a, o] = f(!1), { ref: s, isWrapping: c, wrappingIndex: u } = IO(a, "wrapping"), d = LO(e, n, u);
	return /* @__PURE__ */ t.createElement(q, {
		className: RO.roomListPrimaryFilters,
		"data-testid": "primary-filters",
		gap: "var(--cpd-space-3x)",
		direction: "row-reverse",
		justify: "space-between"
	}, c && /* @__PURE__ */ t.createElement(S, {
		kind: "secondary",
		"aria-expanded": a,
		"aria-controls": i,
		className: RO.iconButton,
		"aria-label": J(a ? "room_list|collapse_filters" : "room_list|expand_filters"),
		size: "28px",
		onClick: () => o((e) => !e)
	}, /* @__PURE__ */ t.createElement(PT, null)), /* @__PURE__ */ t.createElement(q, {
		id: i,
		as: "div",
		role: "listbox",
		"aria-label": J("room_list|primary_filters"),
		align: "center",
		gap: "var(--cpd-space-2x)",
		wrap: "wrap",
		className: RO.list,
		ref: s
	}, d.map((e, i) => /* @__PURE__ */ t.createElement(_, {
		key: `${e}-${i}`,
		role: "option",
		selected: e === n,
		onClick: () => r(e)
	}, zO(e)))));
}), VO = { skeleton: "_skeleton_1h0mx_8" }, HO = () => /* @__PURE__ */ t.createElement("div", { className: VO.skeleton }), UO = {
	genericPlaceholder: "_genericPlaceholder_1sxid_8",
	title: "_title_1sxid_16",
	description: "_description_1sxid_21",
	defaultPlaceholder: "_defaultPlaceholder_1sxid_27"
}, WO = ({ vm: e }) => {
	let n = Y(e);
	if (!n.activeFilterId) return /* @__PURE__ */ t.createElement(GO, {
		title: J("room_list|empty|no_chats"),
		description: n.canCreateRoom ? J("room_list|empty|no_chats_description") : J("room_list|empty|no_chats_description_no_room_rights")
	}, /* @__PURE__ */ t.createElement(q, {
		className: UO.defaultPlaceholder,
		align: "center",
		justify: "center",
		direction: "column",
		gap: "var(--cpd-space-4x)"
	}, /* @__PURE__ */ t.createElement(g, {
		size: "sm",
		kind: "secondary",
		Icon: AT,
		onClick: e.createChatRoom
	}, J("action|start_chat")), n.canCreateRoom && /* @__PURE__ */ t.createElement(g, {
		size: "sm",
		kind: "secondary",
		Icon: PE,
		onClick: e.createRoom
	}, J("action|new_room"))));
	switch (n.activeFilterId) {
		case "favourite": return /* @__PURE__ */ t.createElement(GO, {
			title: J("room_list|empty|no_favourites"),
			description: J("room_list|empty|no_favourites_description")
		});
		case "people": return /* @__PURE__ */ t.createElement(GO, {
			title: J("room_list|empty|no_people"),
			description: J("room_list|empty|no_people_description")
		});
		case "rooms": return /* @__PURE__ */ t.createElement(GO, {
			title: J("room_list|empty|no_rooms"),
			description: J("room_list|empty|no_rooms_description")
		});
		case "unread": return /* @__PURE__ */ t.createElement(KO, {
			title: J("room_list|empty|no_unread"),
			action: J("room_list|empty|show_chats"),
			onAction: () => e.onToggleFilter(n.activeFilterId)
		});
		case "invites": return /* @__PURE__ */ t.createElement(KO, {
			title: J("room_list|empty|no_invites"),
			action: J("room_list|empty|show_activity"),
			onAction: () => e.onToggleFilter(n.activeFilterId)
		});
		case "mentions": return /* @__PURE__ */ t.createElement(KO, {
			title: J("room_list|empty|no_mentions"),
			action: J("room_list|empty|show_activity"),
			onAction: () => e.onToggleFilter(n.activeFilterId)
		});
		case "low_priority": return /* @__PURE__ */ t.createElement(KO, {
			title: J("room_list|empty|no_lowpriority"),
			action: J("room_list|empty|show_activity"),
			onAction: () => e.onToggleFilter(n.activeFilterId)
		});
		default: return /* @__PURE__ */ t.createElement(GO, {
			title: J("room_list|empty|no_chats"),
			description: J("room_list|empty|no_chats_description")
		});
	}
};
function GO({ title: e, description: n, children: r }) {
	return /* @__PURE__ */ t.createElement(q, {
		"data-testid": "empty-room-list",
		className: UO.genericPlaceholder,
		direction: "column",
		align: "stretch",
		justify: "center",
		gap: "var(--cpd-space-2x)"
	}, /* @__PURE__ */ t.createElement("span", { className: UO.title }, e), n && /* @__PURE__ */ t.createElement("span", { className: UO.description }, n), r);
}
function KO({ title: e, action: n, onAction: r }) {
	return /* @__PURE__ */ t.createElement(GO, { title: e }, r && /* @__PURE__ */ t.createElement(g, {
		kind: "tertiary",
		onClick: r
	}, n));
}
//#endregion
//#region src/room-list/RoomListItemView/NotificationDecoration/NotificationDecoration.tsx
var qO = ({ hasAnyNotificationOrActivity: e, muted: n, callType: r, isUnsentMessage: i, invited: a, isMention: o, isNotification: s, isActivityNotification: c, count: l }) => !e && !n && !r ? null : /* @__PURE__ */ t.createElement(q, {
	align: "center",
	justify: "center",
	gap: "var(--cpd-space-1x)",
	"data-testid": "notification-decoration"
}, i && /* @__PURE__ */ t.createElement(QT, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-critical-primary)"
}), r === "video" && /* @__PURE__ */ t.createElement(WE, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-accent-primary)"
}), r === "voice" && /* @__PURE__ */ t.createElement(XE, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-accent-primary)"
}), a && /* @__PURE__ */ t.createElement(XT, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-accent-primary)"
}), o && /* @__PURE__ */ t.createElement(vE, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-accent-primary)"
}), (o || s) && /* @__PURE__ */ t.createElement(se, { count: l || null }), c && /* @__PURE__ */ t.createElement(oe, null), n && /* @__PURE__ */ t.createElement(bE, {
	width: "20px",
	height: "20px",
	fill: "var(--cpd-color-icon-tertiary)"
}));
//#endregion
//#region src/room-list/RoomListItemView/RoomListItemMoreOptionsMenu.tsx
function JO({ vm: e }) {
	let [n, r] = f(!1);
	return /* @__PURE__ */ t.createElement(T, {
		open: n,
		onOpenChange: r,
		title: J("room_list|room|more_options"),
		showTitle: !1,
		align: "start",
		trigger: /* @__PURE__ */ t.createElement(S, {
			tooltip: J("room_list|room|more_options"),
			"aria-label": J("room_list|room|more_options"),
			size: "24px",
			style: { padding: "2px" }
		}, /* @__PURE__ */ t.createElement(wE, null))
	}, /* @__PURE__ */ t.createElement(YO, { vm: e }));
}
function YO({ vm: e }) {
	let n = Y(e);
	return /* @__PURE__ */ t.createElement("div", { onKeyDown: (e) => e.stopPropagation() }, n.canMarkAsRead && /* @__PURE__ */ t.createElement(E, {
		Icon: mE,
		label: J("room_list|more_options|mark_read"),
		onSelect: e.onMarkAsRead,
		onClick: (e) => e.stopPropagation(),
		hideChevron: !0
	}), n.canMarkAsUnread && /* @__PURE__ */ t.createElement(E, {
		Icon: gE,
		label: J("room_list|more_options|mark_unread"),
		onSelect: e.onMarkAsUnread,
		onClick: (e) => e.stopPropagation(),
		hideChevron: !0
	}), /* @__PURE__ */ t.createElement(ae, {
		checked: n.isFavourite,
		Icon: nE,
		label: J("room_list|more_options|favourited"),
		onSelect: e.onToggleFavorite,
		onClick: (e) => e.stopPropagation()
	}), /* @__PURE__ */ t.createElement(ae, {
		checked: n.isLowPriority,
		Icon: wT,
		label: J("room_list|more_options|low_priority"),
		onSelect: e.onToggleLowPriority,
		onClick: (e) => e.stopPropagation()
	}), n.canInvite && /* @__PURE__ */ t.createElement(E, {
		Icon: BE,
		label: J("action|invite"),
		onSelect: e.onInvite,
		onClick: (e) => e.stopPropagation(),
		hideChevron: !0
	}), n.canCopyRoomLink && /* @__PURE__ */ t.createElement(E, {
		Icon: uE,
		label: J("room_list|more_options|copy_link"),
		onSelect: e.onCopyRoomLink,
		onClick: (e) => e.stopPropagation(),
		hideChevron: !0
	}), /* @__PURE__ */ t.createElement(D, null), /* @__PURE__ */ t.createElement(E, {
		kind: "critical",
		Icon: cE,
		label: J("room_list|more_options|leave_room"),
		onSelect: e.onLeaveRoom,
		onClick: (e) => e.stopPropagation(),
		hideChevron: !0
	}));
}
//#endregion
//#region src/room-list/RoomListItemView/RoomNotifs.ts
var XO = /* @__PURE__ */ function(e) {
	return e.AllMessages = "all_messages", e.AllMessagesLoud = "all_messages_loud", e.MentionsOnly = "mentions_only", e.Mute = "mute", e;
}({});
//#endregion
//#region src/room-list/RoomListItemView/RoomListItemNotificationMenu.tsx
function ZO({ vm: e }) {
	let n = Y(e), [r, i] = f(!1), a = n.roomNotifState === XO.Mute, o = /* @__PURE__ */ t.createElement(MT, {
		width: "24px",
		height: "24px",
		color: "var(--cpd-color-icon-primary)"
	});
	return /* @__PURE__ */ t.createElement(T, {
		open: r,
		onOpenChange: i,
		title: J("room_list|notification_options"),
		showTitle: !1,
		align: "start",
		trigger: /* @__PURE__ */ t.createElement(S, {
			size: "24px",
			style: { padding: "2px" },
			tooltip: J("room_list|notification_options"),
			"aria-label": J("room_list|notification_options")
		}, a ? /* @__PURE__ */ t.createElement(bE, null) : /* @__PURE__ */ t.createElement(SE, null))
	}, /* @__PURE__ */ t.createElement("div", { onKeyDown: (e) => e.stopPropagation() }, /* @__PURE__ */ t.createElement(E, {
		"aria-selected": n.roomNotifState === XO.AllMessages,
		hideChevron: !0,
		label: J("notifications|default_settings"),
		onSelect: () => e.onSetRoomNotifState(XO.AllMessages),
		onClick: (e) => e.stopPropagation()
	}, n.roomNotifState === XO.AllMessages && o), /* @__PURE__ */ t.createElement(E, {
		"aria-selected": n.roomNotifState === XO.AllMessagesLoud,
		hideChevron: !0,
		label: J("notifications|all_messages"),
		onSelect: () => e.onSetRoomNotifState(XO.AllMessagesLoud),
		onClick: (e) => e.stopPropagation()
	}, n.roomNotifState === XO.AllMessagesLoud && o), /* @__PURE__ */ t.createElement(E, {
		"aria-selected": n.roomNotifState === XO.MentionsOnly,
		hideChevron: !0,
		label: J("notifications|mentions_keywords"),
		onSelect: () => e.onSetRoomNotifState(XO.MentionsOnly),
		onClick: (e) => e.stopPropagation()
	}, n.roomNotifState === XO.MentionsOnly && o), /* @__PURE__ */ t.createElement(E, {
		"aria-selected": n.roomNotifState === XO.Mute,
		hideChevron: !0,
		label: J("notifications|mute_room"),
		onSelect: () => e.onSetRoomNotifState(XO.Mute),
		onClick: (e) => e.stopPropagation()
	}, n.roomNotifState === XO.Mute && o)));
}
var QO = {
	roomListItem: "_roomListItem_rtaba_8",
	hoverMenu: "_hoverMenu_rtaba_32",
	container: "_container_rtaba_46",
	selected: "_selected_rtaba_51",
	notificationDecoration: "_notificationDecoration_rtaba_60",
	content: "_content_rtaba_73",
	text: "_text_rtaba_78",
	ellipsis: "_ellipsis_rtaba_82",
	roomName: "_roomName_rtaba_83",
	bold: "_bold_rtaba_109",
	firstItem: "_firstItem_rtaba_123",
	lastItem: "_lastItem_rtaba_127"
}, $O = ({ showMoreOptionsMenu: e, showNotificationMenu: n, vm: r }) => /* @__PURE__ */ t.createElement(q, {
	className: QO.hoverMenu,
	align: "center",
	gap: "var(--cpd-space-1x)"
}, e && /* @__PURE__ */ t.createElement(JO, { vm: r }), n && /* @__PURE__ */ t.createElement(ZO, { vm: r })), ek = ({ vm: e, children: n }) => /* @__PURE__ */ t.createElement(y, {
	title: J("room_list|room|more_options"),
	showTitle: !1,
	hasAccessibleAlternative: !0,
	trigger: n
}, /* @__PURE__ */ t.createElement(YO, { vm: e }));
//#endregion
//#region src/room-list/RoomListItemView/RoomListItemView.tsx
function tk(e, t) {
	return t.isUnsentMessage ? J("room_list|a11y|unsent_message", { roomName: e }) : t.invited ? J("room_list|a11y|invitation", { roomName: e }) : t.isMention && t.count ? J("room_list|a11y|mention", {
		roomName: e,
		count: t.count
	}) : t.hasUnreadCount && t.count ? J("room_list|a11y|unread", {
		roomName: e,
		count: t.count
	}) : t.callType === "voice" ? J("room_list|a11y|voice_call", { roomName: e }) : t.callType === "video" ? J("room_list|a11y|video_call", { roomName: e }) : J("room_list|a11y|default", { roomName: e });
}
var nk = a(function({ vm: e, isSelected: n, isFocused: r, onFocus: i, isFirstItem: a, isLastItem: o, renderAvatar: s, ...l }) {
	let u = d(null), f = Y(e);
	c(() => {
		r && u.current?.focus({
			preventScroll: !0,
			focusVisible: !0
		});
	}, [r]);
	let p = tk(f.name, f.notification);
	return /* @__PURE__ */ t.createElement(ek, { vm: e }, /* @__PURE__ */ t.createElement(q, {
		as: "button",
		ref: u,
		className: (0, H.default)(QO.roomListItem, "mx_RoomListItemView", {
			[QO.selected]: n,
			[QO.bold]: f.isBold,
			[QO.firstItem]: a,
			[QO.lastItem]: o,
			mx_RoomListItemView_selected: n
		}),
		gap: "var(--cpd-space-3x)",
		align: "stretch",
		type: "button",
		"aria-selected": n,
		"aria-label": p,
		onClick: e.onOpenRoom,
		onFocus: (e) => i(f.id, e),
		tabIndex: r ? 0 : -1,
		...l
	}, /* @__PURE__ */ t.createElement(q, {
		className: QO.container,
		gap: "var(--cpd-space-3x)",
		align: "center"
	}, s(f.room), /* @__PURE__ */ t.createElement(q, {
		className: QO.content,
		gap: "var(--cpd-space-2x)",
		align: "center",
		justify: "space-between"
	}, /* @__PURE__ */ t.createElement("div", { className: QO.ellipsis }, /* @__PURE__ */ t.createElement("div", {
		className: QO.roomName,
		title: f.name,
		"data-testid": "room-name"
	}, f.name), f.messagePreview && /* @__PURE__ */ t.createElement(O, {
		as: "div",
		size: "sm",
		className: QO.ellipsis,
		title: f.messagePreview
	}, f.messagePreview)), (f.showMoreOptionsMenu || f.showNotificationMenu) && /* @__PURE__ */ t.createElement($O, {
		showMoreOptionsMenu: f.showMoreOptionsMenu,
		showNotificationMenu: f.showNotificationMenu,
		vm: e
	}), /* @__PURE__ */ t.createElement("div", {
		className: QO.notificationDecoration,
		"aria-hidden": !0
	}, /* @__PURE__ */ t.createElement(qO, f.notification))))));
}), rk = a(function({ roomIndex: e, roomCount: n, roomIndexInSection: r, isInFlatList: i, ...a }) {
	let o = i ? NO("listbox", e, n) : { role: "gridcell" }, s = /* @__PURE__ */ t.createElement(nk, {
		...a,
		...o
	});
	return i ? s : /* @__PURE__ */ t.createElement("div", NO("treegrid", e, r), s);
}), ik = 1300;
function ak({ vm: e, renderAvatar: n, onKeyDown: r }) {
	let { roomListState: i, sections: a, isFlatList: s } = Y(e), c = i.activeRoomIndex, l = d(void 0), f = d(void 0), p = u(() => a.flatMap((e) => e.roomIds), [a]), m = p.length, h = a.length, g = m + h, _ = u(() => a.map((e) => ({
		header: e.id,
		items: e.roomIds
	})), [a]), v = o((t) => {
		e.updateVisibleRooms(t.startIndex, t.endIndex);
	}, [e]), y = o((e, r, i, a, o) => {
		let { activeRoomIndex: s, roomCount: c, vm: l, isFlatList: u } = i.context, d = s === e, f = l.getRoomItemViewModel(r), p = i.focused && i.tabIndexKey === r, m = e === 0, h = e === c - 1;
		return /* @__PURE__ */ t.createElement(rk, {
			key: r,
			vm: f,
			renderAvatar: n,
			isSelected: d,
			isFocused: p,
			onFocus: a,
			roomIndex: e,
			roomIndexInSection: o,
			roomCount: c,
			isFirstItem: m,
			isLastItem: h,
			isInFlatList: u
		});
	}, [n]), b = o((e, t, n, r, i) => {
		let { sections: a } = n.context;
		return y(e, t, n, r, a[i].roomIds.findIndex((e) => e === t));
	}, [y]), x = o((e, t, n, r) => y(e, t, n, r, 0), [y]), S = o((e, n, r, i) => {
		let { vm: a, sectionCount: o, sections: s } = r.context, c = a.getSectionHeaderViewModel(n), l = s.slice(0, e).reduce((e, t) => e + t.roomIds.length + 1, 0), u = s[e].roomIds.length, d = r.focused && r.tabIndexKey === n;
		return /* @__PURE__ */ t.createElement(FO, {
			vm: c,
			isFocused: d,
			onFocus: i,
			indexInList: l,
			sectionIndex: e,
			sectionCount: o,
			roomCountInSection: u
		});
	}, []), C = o((e) => e, []), w = o((e) => e, []), T = u(() => ({
		spaceId: i.spaceId || "",
		filterKeys: i.filterKeys,
		sections: a,
		activeRoomIndex: c,
		roomCount: m,
		sectionCount: h,
		vm: e,
		isFlatList: s
	}), [
		i.spaceId,
		i.filterKeys,
		a,
		c,
		m,
		h,
		e,
		s
	]), E = o((e) => {
		let { spaceId: t, filterKeys: n } = e.context.context, r = l.current !== t || !Iy(f.current, n);
		return f.current = n, l.current = t, r ? {
			align: "start",
			index: c || 0,
			behavior: "auto"
		} : !1;
	}, [c]), ee = o(() => !0, []), te = o(() => !0, []), ne = u(() => ({
		top: ik,
		bottom: ik
	}), []), D = {
		context: T,
		scrollIntoViewOnChange: E,
		...c === void 0 ? {} : { initialTopMostItemIndex: c },
		"data-testid": "room-list",
		"aria-label": J("room_list|list_title"),
		getItemKey: C,
		isItemFocusable: ee,
		rangeChanged: v,
		onKeyDown: r,
		increaseViewportBy: ne
	};
	return s ? /* @__PURE__ */ t.createElement(AO, {
		...D,
		...MO("listbox"),
		items: p,
		getItemComponent: x
	}) : /* @__PURE__ */ t.createElement(jO, {
		...D,
		...MO("treegrid", g),
		groups: _,
		getHeaderKey: w,
		getGroupHeaderComponent: S,
		getItemComponent: b,
		isGroupHeaderFocusable: te
	});
}
//#endregion
//#region src/room-list/RoomListView/RoomListView.tsx
var ok = ({ vm: e, renderAvatar: n, onKeyDown: r }) => {
	let i = Y(e), a;
	return a = i.isLoadingRooms ? /* @__PURE__ */ t.createElement(HO, null) : i.isRoomListEmpty ? /* @__PURE__ */ t.createElement(WO, { vm: e }) : /* @__PURE__ */ t.createElement(ak, {
		vm: e,
		renderAvatar: n,
		onKeyDown: r
	}), /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(BO, {
		filterIds: i.filterIds,
		activeFilterId: i.activeFilterId,
		onToggleFilter: e.onToggleFilter
	})), a);
}, sk = {
	"box-flex": "_box-flex_1odfs_9",
	"box-shrink": "_box-shrink_1odfs_13",
	"box-grow": "_box-grow_1odfs_17"
};
//#endregion
//#region src/core/utils/Box/Box.tsx
function ck({ as: e = "div", flex: n = null, shrink: r = null, grow: i = null, className: a, children: o, ...s }) {
	let c = u(() => {
		let e = {};
		return n && (e["--mx-box-flex"] = n), r && (e["--mx-box-shrink"] = r), i && (e["--mx-box-grow"] = i), e;
	}, [
		n,
		i,
		r
	]);
	return t.createElement(e, {
		...s,
		className: (0, H.default)(a, {
			[sk["box-flex"]]: !!n,
			[sk["box-shrink"]]: !!r,
			[sk["box-grow"]]: !!i
		}),
		style: c
	}, o);
}
//#endregion
//#region src/right-panel/WidgetContextMenu/WidgetContextMenuView.tsx
var lk = ({ vm: e }) => {
	let { translate: n } = W(), { showStreamAudioStreamButton: r, showEditButton: i, showSnapshotButton: a, showDeleteButton: o, showRevokeButton: s, showMoveButtons: c, isMenuOpened: l, userWidget: u, trigger: d } = Y(e), f;
	r && (f = /* @__PURE__ */ t.createElement(E, {
		onSelect: e.onStreamAudioClick,
		label: n("widget|context_menu|start_audio_stream")
	}));
	let p;
	i && (p = /* @__PURE__ */ t.createElement(E, {
		onSelect: e.onEditClick,
		label: n("action|edit")
	}));
	let m;
	a && (m = /* @__PURE__ */ t.createElement(E, {
		onSelect: e.onSnapshotClick,
		label: n("widget|context_menu|screenshot")
	}));
	let h;
	o && (h = /* @__PURE__ */ t.createElement(E, {
		onSelect: e.onDeleteClick,
		label: n(u ? "action|remove" : "widget|context_menu|remove")
	}));
	let g;
	s && (g = /* @__PURE__ */ t.createElement(E, {
		onSelect: e.onRevokeClick,
		label: n("widget|context_menu|revoke")
	}));
	let [_, v] = c, y;
	_ && (y = /* @__PURE__ */ t.createElement(E, {
		onSelect: () => e.onMoveButton(-1),
		label: n("widget|context_menu|move_left")
	}));
	let b;
	v && (b = /* @__PURE__ */ t.createElement(E, {
		onSelect: () => e.onMoveButton(1),
		label: n("widget|context_menu|move_right")
	}));
	let x = () => l ? /* @__PURE__ */ t.createElement(t.Fragment, null, f, p, g, h, m, y, b) : null, C = t.isValidElement(d) ? d : /* @__PURE__ */ t.createElement(S, {
		size: "24px",
		"aria-label": "context menu trigger button",
		inert: !0,
		tabIndex: -1
	}, /* @__PURE__ */ t.createElement(wE, null));
	return /* @__PURE__ */ t.createElement(T, {
		title: "Widget context menu",
		open: l,
		showTitle: !1,
		side: "right",
		align: "start",
		trigger: C,
		onOpenChange: e.onFinished
	}, x());
};
//#endregion
//#region src/resize/group/GroupView.tsx
function uk({ vm: e, children: n }) {
	return Y(e), /* @__PURE__ */ t.createElement(ue, { onLayoutChanged: (t) => {
		let n = t[mk];
		e.onLeftPanelResized(n);
	} }, n);
}
var dk = {
	separator: "_separator_ctw94_8",
	visible: "_visible_ctw94_20"
};
//#endregion
//#region src/resize/separator/SeparatorView.tsx
function fk({ vm: e, className: n }) {
	let { translate: r } = W(), { isCollapsed: i, isFocusedViaKeyboard: a } = Y(e), o = (0, H.default)(dk.separator, n, { [dk.visible]: i || a });
	return /* @__PURE__ */ t.createElement(he, {
		className: o,
		onClick: e.onSeparatorClick,
		onFocus: e.onFocus,
		onBlur: e.onBlur,
		"aria-label": r("left_panel|separator_label")
	}, /* @__PURE__ */ t.createElement(k, {
		description: r("left_panel|separator_label"),
		placement: "right"
	}, /* @__PURE__ */ t.createElement(JT, {
		width: "20px",
		height: "12px",
		viewBox: "3.999704360961914 8.999704360961914 16.000295639038086 6.000591278076172",
		transform: "rotate(90)"
	})));
}
//#endregion
//#region src/resize/panel/LeftResizablePanelView.tsx
function pk({ vm: e, className: n, children: r, ...i }) {
	let { initialSize: a, isCollapsed: o } = Y(e), [s, l] = ge();
	c(() => {
		s && e.setPanelHandle(s);
	}, [e, s]);
	let u = a === void 0 ? i.defaultSize : `${a}%`;
	return /* @__PURE__ */ t.createElement(pe, {
		inert: o,
		id: mk,
		className: n,
		collapsible: !0,
		minSize: i.minSize,
		maxSize: i.maxSize,
		defaultSize: u,
		onResize: e.onLeftPanelResize,
		panelRef: l
	}, r);
}
//#endregion
//#region src/resize/index.ts
var mk = "left-panel";
//#endregion
//#region src/core/utils/numbers.ts
function hk(e, t) {
	return Number.isFinite(e) ? Number(e) : t;
}
function gk(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function _k(...e) {
	return [...e].reduce((e, t) => t + e, 0);
}
function vk(e, t, n) {
	return e * (n - t) + t;
}
function yk(e, t, n) {
	let r = (e - t) / (n - t);
	return Number.isNaN(r) ? 0 : r;
}
//#endregion
//#region src/core/i18n/I18nApi.ts
var bk = class {
	get language() {
		return wx();
	}
	register(e) {
		let t = {};
		for (let n in e) for (let r in e[n]) t[r] = t[r] || {}, t[r][n] = e[n][r];
		for (let e in t) Sx(e, t[e]);
	}
	translate(e, t) {
		return J(e, t);
	}
	humanizeTime = (e) => MD(e, this);
};
//#endregion
export { QD as AudioPlayerView, Xy as AvatarWithDetails, zx as Banner, Yx as BaseViewModel, ck as Box, wf as Clock, zD as DateSeparatorView, rO as DecryptionFailureBodyView, eO as DecryptionFailureReason, VD as DisambiguatedProfileView, Kx as Disposables, GD as EncryptionEventState, KD as EncryptionEventView, ST as EventContentBodyView, WD as EventTileBubble, sD as FileBodyView, aD as FileBodyViewInfoIcon, iD as FileBodyViewState, AO as FlatVirtualizedList, q as Flex, uk as GroupView, jO as GroupedVirtualizedList, SD as HistoryVisibilityBadge, bk as I18nApi, Pf as I18nContext, ob as KEY_SEPARATOR, mk as LEFT_PANEL_ID, Jw as LINKIFIED_DATA_ATTRIBUTE, pk as LeftResizablePanelView, $w as LinkedText, Zw as LinkedTextContext, Uw as LinkifyMatrixOpaqueIdType, Vw as LinkifyOptionalSlashProtocols, Bw as LinkifySupportedProtocols, rD as MediaBody, uO as MessageTimestampView, Xx as MockViewModel, YO as MoreOptionContent, qO as NotificationDecoration, Hw as PERMITTED_URL_SCHEMES, fe as Panel, lD as Pill, gD as PillInput, JD as PinnedMessageBadge, Ff as PlayPauseButton, oO as ReactionsRowButtonTooltipView, cO as ReactionsRowButtonView, aO as ReactionsRowView, eD as RedactedBodyView, de as ResizableGroup, fO as RichItem, gO as RichList, WO as RoomListEmptyStateView, CO as RoomListHeaderView, rk as RoomListItemAccessibilityWrapper, ek as RoomListItemContextMenu, $O as RoomListItemHoverMenu, JO as RoomListItemMoreOptionsMenu, ZO as RoomListItemNotificationMenu, nk as RoomListItemView, HO as RoomListLoadingSkeleton, BO as RoomListPrimaryFilters, TO as RoomListSearchView, FO as RoomListSectionHeaderView, ok as RoomListView, XO as RoomNotifState, vD as RoomStatusBarState, yD as RoomStatusBarView, Ux as SasEmoji, qy as SeekBar, me as Separator, fk as SeparatorView, qx as Snapshot, YD as TextualEventView, TD as TimelineSeparator, nT as UrlPreviewGroupView, Jx as ViewModelSubscriptions, ak as VirtualizedRoomListView, le as VirtuosoMockContext, lk as WidgetContextMenuView, xD as WidgetPipView, J as _t, Mx as _tDom, Ex as _td, gk as clamp, hk as defaultNumber, Kw as findLinksInString, ZD as formatBytes, Cf as formatDateForInput, Sf as formatSeconds, Gw as generateLinkedTextOptions, MO as getContainerAccessibleProps, PO as getGroupHeaderAccessibleProps, NO as getItemAccessibleProps, Rx as getLangsJson, wx as getLocale, ab as getNormalizedLanguageKeys, ND as humanizeRelativeTime, MD as humanizeTime, qw as isLinkable, Mw as linkifyHtml, dw as linkifyString, jx as lookupString, ib as normalizeLanguageKey, yk as percentageOf, vk as percentageWithin, Sx as registerTranslations, Fx as replaceByRegexes, Nx as sanitizeForTranslation, Ix as setLanguage, Tx as setLocale, Cx as setMissingEntryGenerator, Px as substitute, _k as sum, IO as useCollapseFilters, Zx as useCreateAutoDisposedViewModel, W as useI18n, Qw as useLinkedTextContext, Qx as useMockedViewModel, Y as useViewModel, LO as useVisibleFilters };
